var _g, _path, _g2, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _g3, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _g4, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _g5, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _path452, _path453, _path454, _path455, _path456, _path457, _path458, _path459, _path460, _path461, _path462, _path463, _path464, _path465, _path466, _path467, _path468, _path469, _path470, _path471, _path472, _path473, _path474, _path475, _path476, _path477, _g6, _path478, _path479, _path480, _path481, _path482, _path483, _path484, _path485, _path486, _path487, _path488, _path489, _path490, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCrmMangement(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 713,
    height: 684,
    viewBox: "0 0 713 684",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2253_1261)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 55,
    width: 603,
    height: 574,
    rx: 50,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55.5,
    y: 55.5,
    width: 602,
    height: 573,
    rx: 49.5,
    stroke: "#F1F1F1"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2253_1261)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M412.909 518.29C412.697 518.29 412.499 518.237 412.301 518.118L367.91 491.748C367.54 491.537 367.328 491.141 367.328 490.718C367.328 490.295 367.566 489.899 367.936 489.701L406.603 467.823L385.968 456.633C385.386 456.316 385.174 455.603 385.492 455.021C385.809 454.44 386.523 454.229 387.104 454.546L409.63 466.766C410.014 466.977 410.252 467.374 410.252 467.797C410.252 468.232 410.027 468.629 409.644 468.84L370.897 490.771L413.53 516.083C414.099 516.414 414.284 517.153 413.94 517.708C413.715 518.078 413.319 518.29 412.922 518.29H412.909Z",
    fill: "url(#paint0_linear_2253_1261)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M278.559 312.909C281.81 311.033 286.252 309.87 290.39 309.751C294.105 309.646 297.542 310.425 300.265 311.918C300.384 311.918 306.703 315.498 306.782 315.551L425.229 383.536L433.306 388.173L550.166 455.246C553.603 457.228 555.93 460.623 556.009 464.124C556.102 468.074 553.801 471.826 549.426 474.349L539.987 479.224C539.881 479.29 531.831 483.359 531.699 483.372C528.301 485.262 524.084 486.266 519.841 486.213C516.245 486.213 512.61 485.209 510.032 483.729L393.264 415.665L386.258 411.583L276.496 347.601C273.059 345.62 270.68 342.238 270.68 338.737C270.68 334.905 272.597 331.074 276.734 328.683L276.946 326.133C276.747 326.028 278.334 313.041 278.559 312.909Z",
    fill: "#ABB2E2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M278.649 313.979C281.742 312.196 286.343 310.941 290.269 310.716C293.93 310.505 297.354 311.244 300.104 312.671C300.342 312.671 306.463 316.106 306.634 316.199L424.605 383.932L432.643 388.556L549.027 455.378C552.292 457.267 554.87 460.755 555.029 464.071C555.227 467.942 553.112 471.707 548.723 474.244L539.377 479.145C539.165 479.264 531.379 483.174 531.115 483.188C527.73 484.984 523.579 485.922 519.455 485.803C516.031 485.803 512.198 484.628 509.752 483.214L393.698 415.586L386.731 411.53L277.644 347.971C274.379 346.082 271.695 342.634 271.695 339.305C271.695 335.672 273.03 331.735 276.97 329.463L277.076 326.992C276.692 326.768 278.213 314.23 278.662 313.979H278.649Z",
    fill: "#A7ADDF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.14,
    d: "M278.728 315.049C281.663 313.358 286.422 312.011 290.137 311.68C293.851 311.35 297.156 312.064 299.932 313.411C300.289 313.411 306.212 316.687 306.476 316.846L423.958 384.329L431.969 388.926L547.877 455.497C550.97 457.281 553.799 460.861 554.037 464.005C554.328 467.823 552.398 471.575 548.009 474.112L538.756 479.026C538.438 479.211 530.916 482.95 530.533 482.976C527.175 484.694 523.09 485.552 519.059 485.381C515.82 485.381 511.775 484.033 509.461 482.699L394.121 415.52L387.207 411.491L278.808 348.355C275.714 346.571 272.727 343.031 272.727 339.886C272.727 336.438 273.48 332.422 277.208 330.269V327.864C276.626 327.534 278.094 315.446 278.755 315.063L278.728 315.049Z",
    fill: "#A3A9DC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.19,
    d: "M278.803 316.106C281.566 314.508 286.51 313.054 290 312.632C293.49 312.209 296.967 312.869 299.756 314.138C300.232 314.138 305.956 317.269 306.3 317.467L423.306 384.699L431.29 389.283L546.723 455.603C549.644 457.294 552.738 460.967 553.042 463.926C553.425 467.678 551.693 471.43 547.278 473.979L538.117 478.92C537.694 479.158 530.436 482.738 529.921 482.778C526.576 484.416 522.558 485.196 518.631 484.958C515.578 484.958 511.321 483.439 509.127 482.17L394.5 415.441L387.626 411.438L279.901 348.725C276.979 347.034 273.674 343.427 273.688 340.454C273.688 337.204 273.859 333.096 277.376 331.061L277.257 328.723C276.49 328.274 277.905 316.635 278.79 316.119L278.803 316.106Z",
    fill: "#9FA4D8"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.24,
    d: "M278.888 317.176C281.492 315.67 286.595 314.098 289.873 313.596C293.35 313.068 296.774 313.689 299.589 314.891C300.184 314.891 305.71 317.863 306.146 318.114L422.676 385.082L430.621 389.653L545.578 455.722C548.327 457.307 551.685 461.085 552.055 463.86C552.544 467.572 550.998 471.298 546.569 473.861L537.501 478.815C536.972 479.119 529.979 482.527 529.331 482.567C526.013 484.112 522.047 484.826 518.227 484.535C515.345 484.535 510.89 482.844 508.828 481.655L394.928 415.362L388.094 411.385L281.056 349.094C278.306 347.509 274.697 343.823 274.697 341.022C274.697 337.957 274.274 333.756 277.592 331.854L277.367 329.595C276.402 329.04 277.777 317.837 278.888 317.203V317.176Z",
    fill: "#9BA0D5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M278.966 318.246C281.412 316.833 286.686 315.129 289.74 314.56C293.151 313.926 296.588 314.508 299.417 315.631C300.131 315.631 305.471 318.458 305.974 318.748L422.028 385.465L429.946 390.023L544.427 455.84C547.005 457.333 550.653 461.204 551.063 463.794C551.645 467.466 550.283 471.165 545.841 473.728L536.865 478.709C536.231 479.079 529.502 482.316 528.735 482.369C525.43 483.835 521.531 484.469 517.829 484.112C515.132 484.112 510.479 482.25 508.536 481.127L395.351 415.282L388.556 411.332L282.192 349.451C279.614 347.958 275.701 344.206 275.701 341.577C275.701 338.71 274.696 334.417 277.816 332.62L277.472 330.427C276.322 329.766 277.631 319.013 278.966 318.246Z",
    fill: "#979BD2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M279.048 319.303C281.321 317.982 286.781 316.146 289.61 315.512C292.954 314.772 296.391 315.313 299.247 316.357C300.08 316.357 305.222 319.026 305.817 319.369L421.395 385.835L429.287 390.366L543.292 455.933C545.698 457.32 550.087 461.257 550.087 463.701C551.435 467.162 549.598 471.007 545.143 473.583L536.259 478.577C535.519 479 529.054 482.078 528.156 482.131C524.877 483.505 521.044 484.073 517.435 483.663C514.91 483.663 510.058 481.629 508.247 480.585L395.776 415.176L389.02 411.253L283.344 349.794C280.938 348.407 276.721 344.576 276.721 342.119C276.721 339.437 275.135 335.064 278.043 333.386L277.593 331.259C276.245 330.48 277.501 320.175 279.061 319.277L279.048 319.303Z",
    fill: "#9397CF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.38,
    d: "M279.124 320.373C281.24 319.158 286.871 317.15 289.475 316.476C292.74 315.63 296.204 316.132 299.073 317.11C300.024 317.11 304.969 319.633 305.643 320.03L420.745 386.244L428.597 390.762L542.126 456.078C544.36 457.373 549.066 461.389 549.066 463.661C550.6 467.043 548.868 470.914 544.4 473.49L535.609 478.511C534.763 479 528.576 481.906 527.532 481.972C524.267 483.267 520.499 483.742 516.996 483.28C514.656 483.28 509.593 481.06 507.914 480.096L396.157 415.137L389.441 411.24L284.439 350.204C282.205 348.909 277.683 344.999 277.683 342.726C277.683 340.243 275.515 335.777 278.212 334.219L277.657 332.158C276.124 331.272 277.327 321.404 279.098 320.386L279.124 320.373Z",
    fill: "#8F92CC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M279.217 321.443C281.173 320.32 286.977 318.154 289.356 317.44C292.555 316.489 296.019 316.952 298.914 317.85C299.985 317.85 304.731 320.215 305.497 320.664L420.124 386.627L427.949 391.132L541.003 456.184C543.065 457.373 548.101 461.495 548.101 463.582C549.833 466.885 548.194 470.769 543.699 473.358L535.001 478.392C534.049 478.934 528.127 481.681 526.963 481.748C523.725 482.963 520.01 483.359 516.626 482.844C514.471 482.844 509.197 480.453 507.65 479.568L396.619 415.058L389.943 411.187L285.628 350.574C283.566 349.385 278.741 345.395 278.741 343.295C278.741 340.996 275.991 336.438 278.477 335.011L277.816 333.03C276.084 332.026 277.234 322.619 279.23 321.457L279.217 321.443Z",
    fill: "#8B8EC9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.48,
    d: "M279.296 322.513C281.081 321.483 287.07 319.131 289.224 318.405C292.344 317.348 295.821 317.771 298.742 318.603C299.932 318.603 304.48 320.822 305.326 321.311L419.476 387.024L427.275 391.515L539.853 456.316C541.743 457.413 547.11 461.614 547.11 463.529C549.027 466.74 547.48 470.65 542.986 473.24L534.38 478.286C533.322 478.894 527.664 481.47 526.369 481.549C523.143 482.672 519.495 483.003 516.216 482.421C514.233 482.421 508.76 479.858 507.346 479.039L397.029 414.965L390.393 411.121L286.752 350.931C284.862 349.834 279.733 345.778 279.733 343.849C279.733 341.749 276.401 337.099 278.688 335.791L277.908 333.875C275.992 332.765 277.089 323.795 279.31 322.513H279.296Z",
    fill: "#8789C6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.52,
    d: "M279.371 323.571C280.997 322.633 287.157 320.096 289.087 319.356C292.128 318.194 295.631 318.564 298.566 319.33C299.875 319.33 304.224 321.391 305.162 321.932L418.824 387.38L426.583 391.846L538.685 456.395C540.403 457.386 546.101 461.68 546.101 463.424C548.216 466.555 546.762 470.479 542.241 473.081L533.727 478.154C532.564 478.828 527.17 481.232 525.743 481.325C522.544 482.369 518.961 482.62 515.775 481.972C513.977 481.972 508.293 479.238 506.997 478.498L397.395 414.873L390.811 411.042L287.858 351.274C286.14 350.283 280.706 346.148 280.706 344.391C280.706 342.476 276.793 337.746 278.869 336.544L277.983 334.694C275.868 333.479 276.912 324.944 279.358 323.544L279.371 323.571Z",
    fill: "#8385C2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.57,
    d: "M279.451 324.641C280.919 323.795 287.238 321.06 288.956 320.32C291.917 319.052 295.434 319.382 298.395 320.069C299.823 320.083 303.973 321.985 304.991 322.566L418.177 387.763L425.91 392.216L537.535 456.514C539.082 457.413 545.11 461.785 545.11 463.358C547.424 466.409 546.062 470.346 541.528 472.962L533.094 478.048C531.825 478.775 526.695 481.021 525.149 481.113C521.963 482.065 518.446 482.25 515.366 481.549C513.754 481.549 507.858 478.643 506.694 477.969L397.805 414.78L391.262 410.975L288.983 351.631C287.436 350.733 281.699 346.518 281.699 344.946C281.699 343.229 277.204 338.407 279.068 337.323L278.076 335.553C275.763 334.219 276.755 326.147 279.425 324.601L279.451 324.641Z",
    fill: "#7F80BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.62,
    d: "M279.537 325.711C280.846 324.957 287.337 321.998 288.83 321.285C291.712 319.924 295.255 320.201 298.229 320.822C299.776 320.836 303.729 322.579 304.839 323.214L417.548 388.16L425.255 392.599L536.405 456.646C537.78 457.439 544.138 461.918 544.138 463.318C546.637 466.29 545.368 470.241 540.833 472.856L532.492 477.969C531.117 478.762 526.252 480.836 524.573 480.942C521.414 481.814 517.951 481.919 514.989 481.153C513.548 481.153 507.454 478.075 506.423 477.48L398.248 414.74L391.744 410.962L290.152 352.04C288.777 351.248 282.736 346.954 282.736 345.554C282.736 344.021 277.66 339.107 279.312 338.155L278.202 336.451C275.703 335.011 276.642 327.375 279.524 325.711H279.537Z",
    fill: "#7B7CBC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.67,
    d: "M279.614 326.768C280.751 326.107 287.413 322.91 288.696 322.236C291.485 320.77 295.054 321.007 298.055 321.549C299.721 321.562 303.475 323.161 304.665 323.848L416.898 388.543L424.565 392.969L535.239 456.765C536.442 457.465 543.131 462.023 543.131 463.252C545.828 466.145 544.651 470.109 540.091 472.738L531.842 477.863C530.361 478.709 525.761 480.625 523.95 480.73C520.803 481.51 517.406 481.549 514.551 480.73C513.295 480.73 506.989 477.48 506.09 476.952L398.642 414.648L392.178 410.896L291.26 352.397C290.057 351.697 283.712 347.337 283.712 346.109C283.712 344.774 278.054 339.767 279.508 338.935L278.292 337.297C275.595 335.738 276.481 328.551 279.587 326.768H279.614Z",
    fill: "#7777B9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.71,
    d: "M279.708 327.838C280.686 327.27 287.507 323.822 288.578 323.201C291.288 321.642 294.884 321.827 297.898 322.289C299.682 322.302 303.238 323.742 304.521 324.482L416.278 388.926L423.919 393.325L534.13 456.871C535.161 457.466 542.181 462.116 542.181 463.173C545.062 465.987 543.992 469.963 539.418 472.606L531.261 477.758C529.688 478.669 525.339 480.413 523.409 480.532C520.289 481.232 516.958 481.18 514.195 480.308C513.111 480.308 506.62 476.886 505.84 476.437L399.106 414.582L392.681 410.857L292.451 352.767C291.42 352.173 284.771 347.734 284.771 346.677C284.771 345.527 278.531 340.441 279.774 339.715L278.452 338.156C275.57 336.491 276.403 329.753 279.721 327.825L279.708 327.838Z",
    fill: "#7373B6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M279.784 328.908C280.604 328.432 287.412 324.165 288.443 324.165C291.325 323.029 294.682 322.646 297.723 323.042C299.626 323.055 302.997 324.35 304.359 325.129L415.641 389.322L423.255 393.708L532.99 457.003C533.849 457.505 541.186 462.248 541.186 463.12C544.266 465.855 543.288 469.844 538.688 472.487L530.624 477.652C528.945 478.63 524.86 480.202 522.798 480.334C519.691 480.955 516.426 480.823 513.769 479.898C512.87 479.898 506.168 476.291 505.52 475.921L399.5 414.516L393.115 410.817L293.572 353.15C292.713 352.648 285.759 348.13 285.759 347.258C285.759 346.307 278.938 341.115 279.969 340.52L278.528 339.027C275.448 337.257 276.228 330.955 279.784 328.908Z",
    fill: "#6F6EB3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.81,
    d: "M279.867 329.978C280.515 329.608 287.481 325.129 288.314 325.129C291.143 323.914 294.501 323.465 297.555 323.782C299.577 323.795 302.75 324.931 304.191 325.763L414.997 389.692L422.571 394.065L531.83 457.109C532.518 457.505 540.185 462.34 540.185 463.041C543.45 465.696 542.565 469.699 537.964 472.354L529.993 477.546C528.208 478.577 524.388 479.977 522.193 480.123C519.113 480.651 515.901 480.453 513.363 479.462C512.649 479.462 505.735 475.684 505.22 475.393L399.913 414.423L393.568 410.751L294.699 353.507C294.012 353.111 286.754 348.513 286.754 347.813C286.754 347.047 279.351 341.775 280.171 341.3L278.624 339.873C275.359 337.984 276.073 332.131 279.854 329.965L279.867 329.978Z",
    fill: "#6B6AB0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.86,
    d: "M279.946 331.035C280.435 330.757 287.561 326.081 288.182 326.081C290.945 324.799 294.303 324.271 297.383 324.522C299.524 324.548 302.499 325.526 304.032 326.398L414.349 390.075L421.897 394.435L530.68 457.228C531.196 457.532 539.194 462.446 539.194 462.975C542.657 465.551 541.864 469.567 537.25 472.236L529.372 477.441C527.481 478.537 523.925 479.766 521.612 479.924C518.545 480.374 515.399 480.096 512.966 479.053C512.424 479.053 505.312 475.102 504.929 474.878L400.349 414.358L394.044 410.711L295.863 353.89C295.347 353.586 287.785 348.923 287.785 348.394C287.785 347.826 279.788 342.462 280.422 342.106L278.77 340.745C275.306 338.75 275.98 333.347 279.973 331.035H279.946Z",
    fill: "#6765AC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M280.026 332.105C280.357 331.92 287.641 327.058 288.051 327.058C290.761 325.697 294.105 325.103 297.212 325.275C299.472 325.301 302.248 326.12 303.861 327.058L413.702 390.485L421.211 394.818L529.518 457.36C529.862 457.558 538.19 462.578 538.19 462.922C541.838 465.419 541.151 469.448 536.511 472.13L528.725 477.348C526.729 478.498 523.45 479.568 520.991 479.726C517.951 480.083 514.871 479.726 512.531 478.63C512.174 478.63 504.85 474.508 504.586 474.363L400.72 414.278L394.468 410.658L296.961 354.26C296.617 354.062 288.751 349.319 288.751 348.962C288.751 348.579 280.172 343.136 280.595 342.885L278.837 341.604C275.188 339.49 275.796 334.536 280.013 332.105H280.026Z",
    fill: "#6361A9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.95,
    d: "M280.1 333.175C280.259 333.082 287.701 328.023 287.913 328.023C290.57 326.596 293.914 325.922 297.034 326.014C299.414 326.041 301.991 326.701 303.697 327.692L413.062 390.868L420.544 395.188L528.375 457.479C528.547 457.584 537.206 462.684 537.206 462.856C541.053 465.26 540.445 469.316 535.805 471.998L528.111 477.243C526.009 478.458 522.995 479.356 520.404 479.528C517.377 479.806 514.362 479.383 512.128 478.22C511.943 478.22 504.421 473.927 504.289 473.847L401.138 414.212L394.924 410.619L298.105 354.643C297.933 354.537 289.763 349.715 289.763 349.544C289.763 349.359 280.602 343.81 280.814 343.691L278.937 342.476C275.09 340.256 275.658 335.738 280.087 333.175H280.1Z",
    fill: "#5F5CA6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.748 477.784L395.403 410.553L279.058 343.321C275.026 340.996 275.529 336.927 280.195 334.232L287.796 328.974C292.463 326.279 299.509 325.988 303.554 328.326L419.899 395.558L536.244 462.789C540.275 465.115 539.773 469.184 535.107 471.879L527.505 477.137C522.839 479.832 515.793 480.122 511.748 477.784Z",
    fill: "#5B58A3"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M512.399 476.225L285.077 344.959C273.457 338.248 264.031 320.268 264.031 304.784V131.044C264.031 115.561 273.457 108.44 285.077 115.151L512.399 246.417C524.019 253.129 533.444 271.109 533.444 286.592V460.332C533.444 475.816 524.019 482.937 512.399 476.225Z",
    fill: "url(#paint1_linear_2253_1261)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M518.534 469.395L287.537 336.029C277.899 329.912 271.938 317.678 271.938 305.154V124.901C271.938 121.929 275.163 120.092 277.728 121.585C278.032 121.757 278.256 121.902 278.402 121.982L509.637 255.52C521.112 262.125 525.236 273.883 525.236 286.394V466.079C525.236 469.263 521.799 471.258 519.023 469.673C518.798 469.554 518.626 469.448 518.521 469.382L518.534 469.395Z",
    fill: "url(#paint2_linear_2253_1261)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M509.653 255.52L278.417 121.982C278.272 121.902 278.034 121.757 277.743 121.585C275.179 120.092 271.953 121.929 271.953 124.901V305.154C271.953 317.678 277.915 329.912 287.552 336.029L518.549 469.395C518.668 469.461 518.84 469.567 519.052 469.686C521.815 471.258 525.265 469.263 525.265 466.092V286.408C525.265 273.883 521.141 262.139 509.666 255.533L509.653 255.52ZM522.819 466.079C522.819 467.136 521.92 467.797 521.101 467.797C520.81 467.797 520.532 467.717 520.255 467.572L288.768 333.915C280.07 328.379 274.386 317.071 274.386 305.154V124.901C274.386 124.029 275.126 123.488 275.8 123.488C276.038 123.488 276.276 123.554 276.501 123.686L508.437 257.634C520.321 264.477 522.819 277.054 522.819 286.408V466.092V466.079Z",
    fill: "#AFB6E5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M522.092 240.789L294.769 109.523C290.169 106.868 285.912 106.379 282.462 107.713C282.026 107.885 272.428 113.447 272.019 113.685C272.019 113.685 272.005 113.685 271.992 113.698C275.588 111.954 280.135 112.271 285.093 115.138L512.415 246.404C524.035 253.115 533.46 271.096 533.46 286.579V460.319C533.46 469.99 529.785 476.384 524.207 478.207C524.656 478.233 525.225 478.049 526.044 477.586C526.309 477.428 536.395 471.39 536.66 471.205C540.652 468.404 543.15 462.658 543.15 454.704V280.965C543.15 265.481 533.725 247.487 522.105 240.789H522.092Z",
    fill: "url(#paint3_linear_2253_1261)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M521.907 240.908L294.598 109.642C289.997 106.987 285.74 106.498 282.29 107.832C281.854 108.004 272.442 113.46 272.019 113.685C272.019 113.685 272.005 113.685 271.992 113.698C275.588 111.954 280.135 112.271 285.093 115.138L512.415 246.404C524.035 253.115 533.46 271.096 533.46 286.579V460.319C533.46 469.99 529.785 476.384 524.207 478.207C524.656 478.234 525.225 478.049 526.044 477.586C526.309 477.428 536.223 471.509 536.475 471.324C540.467 468.523 542.965 462.776 542.965 454.823V281.083C542.965 265.6 533.54 247.606 521.92 240.908H521.907Z",
    fill: "url(#paint4_linear_2253_1261)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M521.735 241.027L294.412 109.761C289.812 107.106 285.555 106.617 282.105 107.951C281.669 108.123 272.428 113.46 272.019 113.685C272.019 113.685 272.005 113.685 271.992 113.698C275.588 111.954 280.135 112.271 285.093 115.138L512.415 246.404C524.035 253.115 533.46 271.096 533.46 286.579V460.319C533.46 469.99 529.785 476.384 524.207 478.207C524.656 478.233 525.225 478.048 526.044 477.586C526.309 477.428 536.051 471.628 536.303 471.443C540.295 468.642 542.793 462.895 542.793 454.942V281.202C542.793 265.719 533.368 247.725 521.748 241.027H521.735Z",
    fill: "url(#paint5_linear_2253_1261)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M521.563 241.146L294.241 109.88C289.64 107.225 285.384 106.736 281.933 108.07C281.497 108.242 272.442 113.46 272.019 113.685C272.019 113.685 272.005 113.685 271.992 113.698C275.588 111.954 280.135 112.271 285.093 115.138L512.415 246.404C524.035 253.115 533.46 271.096 533.46 286.579V460.319C533.46 469.99 529.785 476.384 524.207 478.207C524.656 478.233 525.225 478.049 526.044 477.586C526.309 477.428 535.866 471.734 536.118 471.562C540.11 468.761 542.608 463.014 542.608 455.061V281.321C542.608 265.838 533.183 247.844 521.563 241.146Z",
    fill: "url(#paint6_linear_2253_1261)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M521.38 241.252L294.071 109.986C289.471 107.33 285.214 106.842 281.764 108.176C281.328 108.348 272.444 113.447 272.034 113.672C272.034 113.672 272.021 113.672 272.008 113.685C275.604 111.941 280.151 112.258 285.108 115.125L512.431 246.391C524.051 253.102 533.476 271.083 533.476 286.566V460.306C533.476 469.977 529.801 476.371 524.222 478.194C524.672 478.22 525.24 478.035 526.06 477.573C526.324 477.414 535.71 471.839 535.961 471.668C539.954 468.867 542.452 463.12 542.452 455.167V281.427C542.452 265.943 533.027 247.95 521.407 241.252H521.38Z",
    fill: "url(#paint7_linear_2253_1261)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M521.206 241.371L293.884 110.105C289.283 107.449 285.027 106.96 281.576 108.295C281.14 108.467 272.428 113.447 272.019 113.672C272.019 113.672 272.005 113.672 271.992 113.685C275.588 111.941 280.135 112.258 285.093 115.125L512.415 246.391C524.035 253.102 533.46 271.083 533.46 286.566V460.306C533.46 469.977 529.785 476.371 524.207 478.194C524.656 478.22 525.225 478.035 526.044 477.573C526.309 477.414 535.51 471.958 535.774 471.786C539.766 468.986 542.265 463.239 542.265 455.286V281.546C542.265 266.062 532.839 248.069 521.219 241.371H521.206Z",
    fill: "url(#paint8_linear_2253_1261)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M521.021 241.49L293.712 110.224C289.111 107.568 284.855 107.079 281.404 108.414C280.968 108.585 272.442 113.447 272.019 113.685C272.019 113.685 272.005 113.685 271.992 113.698C275.588 111.954 280.135 112.271 285.093 115.138L512.415 246.404C524.035 253.115 533.46 271.096 533.46 286.579V460.319C533.46 469.99 529.785 476.384 524.207 478.207C524.656 478.234 525.225 478.049 526.044 477.586C526.309 477.428 535.338 472.09 535.589 471.919C539.581 469.118 542.08 463.371 542.08 455.418V281.678C542.08 266.194 532.654 248.201 521.034 241.503L521.021 241.49Z",
    fill: "url(#paint9_linear_2253_1261)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M520.849 241.609L293.527 110.343C288.926 107.687 284.67 107.198 281.219 108.533C280.783 108.704 272.428 113.447 272.019 113.685C272.019 113.685 272.005 113.685 271.992 113.698C275.588 111.954 280.135 112.271 285.093 115.138L512.415 246.404C524.035 253.115 533.46 271.096 533.46 286.579V460.319C533.46 469.99 529.785 476.384 524.207 478.207C524.656 478.233 525.225 478.049 526.044 477.586C526.309 477.428 535.166 472.209 535.417 472.024C539.409 469.223 541.908 463.477 541.908 455.523V281.784C541.908 266.3 532.482 248.307 520.862 241.609H520.849Z",
    fill: "url(#paint10_linear_2253_1261)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M520.677 241.727L293.355 110.461C288.755 107.806 284.498 107.317 281.048 108.651C280.611 108.823 272.442 113.46 272.019 113.685C272.019 113.685 272.005 113.685 271.992 113.698C275.588 111.954 280.135 112.271 285.093 115.138L512.415 246.404C524.035 253.115 533.46 271.096 533.46 286.579V460.319C533.46 469.99 529.785 476.384 524.207 478.207C524.656 478.233 525.225 478.048 526.044 477.586C526.309 477.428 534.981 472.328 535.232 472.143C539.224 469.342 541.723 463.595 541.723 455.642V281.903C541.723 266.419 532.297 248.425 520.677 241.727Z",
    fill: "url(#paint11_linear_2253_1261)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M520.492 241.846L293.17 110.58C288.569 107.925 284.313 107.436 280.862 108.77C280.426 108.942 272.428 113.46 272.019 113.685C272.019 113.685 272.005 113.685 271.992 113.698C275.588 111.954 280.135 112.271 285.093 115.138L512.415 246.404C524.035 253.115 533.46 271.096 533.46 286.579V460.319C533.46 469.99 529.785 476.384 524.207 478.207C524.656 478.233 525.225 478.049 526.044 477.586C526.309 477.428 534.809 472.447 535.06 472.262C539.052 469.461 541.551 463.714 541.551 455.761V282.021C541.551 266.538 532.125 248.544 520.505 241.846H520.492Z",
    fill: "url(#paint12_linear_2253_1261)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M520.32 241.952L292.998 110.686C288.398 108.031 284.141 107.542 280.691 108.876C280.254 109.048 272.428 113.447 272.019 113.672C272.019 113.672 272.005 113.672 271.992 113.685C275.588 111.941 280.135 112.258 285.093 115.125L512.415 246.391C524.035 253.102 533.46 271.083 533.46 286.566V460.306C533.46 469.977 529.785 476.371 524.207 478.194C524.656 478.22 525.225 478.035 526.044 477.573C526.309 477.414 534.624 472.54 534.888 472.368C538.88 469.567 541.379 463.82 541.379 455.867V282.127C541.379 266.644 531.953 248.65 520.334 241.952H520.32Z",
    fill: "url(#paint13_linear_2253_1261)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M520.138 242.071L292.829 110.805C288.228 108.149 283.971 107.661 280.521 108.995C280.085 109.167 272.444 113.447 272.034 113.672C272.034 113.672 272.021 113.672 272.008 113.685C275.604 111.941 280.151 112.258 285.108 115.125L512.431 246.391C524.051 253.102 533.476 271.083 533.476 286.566V460.306C533.476 469.977 529.801 476.371 524.222 478.194C524.672 478.22 525.24 478.035 526.06 477.573C526.324 477.414 534.468 472.658 534.719 472.487C538.711 469.686 541.21 463.939 541.21 455.986V282.246C541.21 266.763 531.784 248.769 520.164 242.071H520.138Z",
    fill: "url(#paint14_linear_2253_1261)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M519.963 242.19L292.641 110.924C288.041 108.268 283.784 107.78 280.334 109.114C279.897 109.286 272.428 113.447 272.019 113.685C272.019 113.685 272.005 113.685 271.992 113.698C275.588 111.954 280.135 112.271 285.093 115.138L512.415 246.404C524.035 253.115 533.46 271.096 533.46 286.579V460.319C533.46 469.99 529.785 476.384 524.207 478.207C524.656 478.234 525.225 478.049 526.044 477.586C526.309 477.428 534.267 472.791 534.531 472.619C538.524 469.818 541.022 464.071 541.022 456.118V282.378C541.022 266.895 531.597 248.901 519.977 242.203L519.963 242.19Z",
    fill: "url(#paint15_linear_2253_1261)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M519.792 242.309L292.469 111.043C287.869 108.387 283.612 107.898 280.162 109.233C279.726 109.405 272.442 113.447 272.019 113.685C272.019 113.685 272.005 113.685 271.992 113.698C275.588 111.954 280.135 112.271 285.093 115.138L512.415 246.404C524.035 253.115 533.46 271.096 533.46 286.579V460.319C533.46 469.99 529.785 476.384 524.207 478.207C524.656 478.233 525.225 478.049 526.044 477.586C526.309 477.428 534.095 472.909 534.346 472.724C538.339 469.924 540.837 464.177 540.837 456.224V282.484C540.837 267 531.411 249.007 519.792 242.309Z",
    fill: "url(#paint16_linear_2253_1261)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M519.606 242.428L292.284 111.162C287.684 108.506 283.427 108.017 279.977 109.352C279.541 109.523 272.428 113.46 272.019 113.685C272.019 113.685 272.005 113.685 271.992 113.698C275.588 111.954 280.135 112.271 285.093 115.138L512.415 246.404C524.035 253.115 533.46 271.096 533.46 286.579V460.319C533.46 469.99 529.785 476.384 524.207 478.207C524.656 478.233 525.225 478.049 526.044 477.586C526.309 477.428 533.923 473.028 534.174 472.843C538.167 470.043 540.665 464.296 540.665 456.343V282.603C540.665 267.119 531.24 249.126 519.62 242.428H519.606Z",
    fill: "url(#paint17_linear_2253_1261)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M519.435 242.547L292.112 111.28C287.512 108.625 283.255 108.136 279.805 109.471C279.369 109.642 272.428 113.46 272.019 113.685C272.019 113.685 272.005 113.685 271.992 113.698C275.588 111.954 280.135 112.271 285.093 115.138L512.415 246.404C524.035 253.115 533.46 271.096 533.46 286.579V460.319C533.46 469.99 529.785 476.384 524.207 478.207C524.656 478.233 525.225 478.049 526.044 477.586C526.309 477.428 533.738 473.147 533.989 472.962C537.982 470.161 540.48 464.415 540.48 456.461V282.722C540.48 267.238 531.055 249.245 519.435 242.547Z",
    fill: "url(#paint18_linear_2253_1261)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M519.252 242.665L291.943 111.399C287.342 108.744 283.086 108.255 279.635 109.589C279.199 109.761 272.444 113.46 272.034 113.685C272.034 113.685 272.021 113.685 272.008 113.698C275.604 111.954 280.151 112.271 285.108 115.138L512.431 246.404C524.051 253.115 533.476 271.096 533.476 286.579V460.319C533.476 469.99 529.801 476.384 524.222 478.207C524.672 478.233 525.24 478.049 526.06 477.586C526.324 477.428 533.582 473.253 533.833 473.081C537.825 470.28 540.324 464.534 540.324 456.58V282.841C540.324 267.357 530.898 249.363 519.278 242.665H519.252Z",
    fill: "url(#paint19_linear_2253_1261)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M519.078 242.771L291.755 111.505C287.155 108.85 282.898 108.361 279.448 109.695C279.012 109.867 272.428 113.447 272.019 113.672C272.019 113.672 272.005 113.672 271.992 113.685C275.588 111.941 280.135 112.258 285.093 115.125L512.415 246.391C524.035 253.102 533.46 271.083 533.46 286.566V460.306C533.46 469.977 529.785 476.371 524.207 478.194C524.656 478.22 525.225 478.035 526.044 477.573C526.309 477.414 533.381 473.359 533.646 473.187C537.638 470.386 540.136 464.639 540.136 456.686V282.946C540.136 267.463 530.711 249.469 519.091 242.771H519.078Z",
    fill: "url(#paint20_linear_2253_1261)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M518.906 242.89L291.583 111.624C286.983 108.969 282.726 108.48 279.276 109.814C278.84 109.986 272.442 113.447 272.019 113.685C272.019 113.685 272.005 113.685 271.992 113.698C275.588 111.954 280.135 112.271 285.093 115.138L512.415 246.404C524.035 253.115 533.46 271.096 533.46 286.579V460.319C533.46 469.99 529.785 476.384 524.207 478.207C524.656 478.234 525.225 478.049 526.044 477.586C526.309 477.428 533.209 473.491 533.46 473.319C537.453 470.518 539.951 464.771 539.951 456.818V283.078C539.951 267.595 530.526 249.601 518.906 242.903V242.89Z",
    fill: "url(#paint21_linear_2253_1261)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M518.721 243.009L291.398 111.743C286.798 109.087 282.541 108.599 279.091 109.933C278.655 110.105 272.428 113.447 272.019 113.685C272.019 113.685 272.005 113.685 271.992 113.698C275.588 111.954 280.135 112.271 285.093 115.138L512.415 246.404C524.035 253.115 533.46 271.096 533.46 286.579V460.319C533.46 469.99 529.785 476.384 524.207 478.207C524.656 478.234 525.225 478.049 526.044 477.586C526.309 477.428 533.037 473.61 533.289 473.425C537.281 470.624 539.779 464.877 539.779 456.924V283.184C539.779 267.701 530.354 249.707 518.734 243.009H518.721Z",
    fill: "url(#paint22_linear_2253_1261)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M518.549 243.128L291.227 111.862C286.626 109.206 282.369 108.718 278.919 110.052C278.483 110.224 272.428 113.46 272.019 113.685C272.019 113.685 272.005 113.685 271.992 113.698C275.588 111.954 280.135 112.271 285.093 115.138L512.415 246.404C524.035 253.115 533.46 271.096 533.46 286.579V460.319C533.46 469.99 529.785 476.384 524.207 478.207C524.656 478.234 525.225 478.049 526.044 477.586C526.309 477.428 532.852 473.729 533.104 473.544C537.096 470.743 539.594 464.996 539.594 457.043V283.303C539.594 267.819 530.169 249.826 518.549 243.128Z",
    fill: "url(#paint23_linear_2253_1261)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M518.366 243.247L291.057 111.981C286.457 109.325 282.2 108.836 278.75 110.171C278.314 110.343 272.444 113.46 272.034 113.685C272.034 113.685 272.021 113.685 272.008 113.698C275.604 111.954 280.151 112.271 285.108 115.138L512.431 246.404C524.051 253.115 533.476 271.096 533.476 286.579V460.319C533.476 469.99 529.801 476.384 524.222 478.207C524.672 478.234 525.24 478.049 526.06 477.586C526.324 477.428 532.696 473.847 532.947 473.662C536.94 470.862 539.438 465.115 539.438 457.162V283.422C539.438 267.938 530.013 249.945 518.393 243.247H518.366Z",
    fill: "url(#paint24_linear_2253_1261)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M513.414 245.902L286.092 114.636C281.319 111.888 276.944 111.492 273.414 113.011C276.428 112.536 279.878 113.262 283.567 115.389L510.889 246.655C522.509 253.367 531.934 271.347 531.934 286.83V460.57C531.934 469.699 528.643 475.895 523.566 478.088C530.057 477.058 534.459 470.399 534.459 459.817V286.077C534.459 270.594 525.034 252.6 513.414 245.902Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M177.599 323.293V355.792C177.599 359.267 180.084 360.681 183.112 358.937L200.019 349.174C203.047 347.43 205.532 343.149 205.532 339.662V307.162C205.532 304.652 201.275 298.284 200.76 297.373C199.372 294.876 195.776 294.598 191.559 297.029C187.329 299.46 183.746 303.899 182.358 307.994C181.856 309.501 177.586 320.783 177.586 323.293H177.599Z",
    fill: "url(#paint25_linear_2253_1261)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M198.314 350.667V319.594C198.314 316.119 195.829 314.706 192.802 316.45C189.774 318.194 187.289 322.474 187.289 325.962V357.034L198.314 350.667Z",
    fill: "#AFB6E5"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M185.969 307.426C185.969 310.161 189.036 306.911 192.803 304.731C196.571 302.551 199.638 302.261 199.638 299.539C199.638 296.818 196.571 296.369 192.803 298.548C189.036 300.728 185.969 304.705 185.969 307.439V307.426Z",
    fill: "#AFB6E5"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M177.599 323.293V355.792C177.599 359.267 180.084 360.681 183.112 358.937L200.019 349.174C203.047 347.43 205.532 343.149 205.532 339.662V307.162C205.532 304.652 201.275 298.284 200.76 297.373C199.372 294.876 195.776 294.598 191.559 297.029C187.329 299.46 183.746 303.899 182.358 307.994C181.856 309.501 177.586 320.783 177.586 323.293H177.599Z",
    fill: "url(#paint26_linear_2253_1261)"
  }), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M179.016 355.092V322.593C179.016 320.083 183.273 308.8 183.788 307.294C185.176 303.199 188.772 298.773 192.989 296.329C193.068 296.289 193.134 296.263 193.201 296.223C192.672 296.448 192.13 296.725 191.575 297.042C187.344 299.473 183.762 303.912 182.374 308.008C181.871 309.514 177.602 320.796 177.602 323.306V355.806C177.602 359.28 180.087 360.694 183.114 358.95L183.59 358.673C180.999 359.65 179.016 358.21 179.016 355.092Z",
    fill: "#AFB6E5"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M222.69 351.499V357.166L220.984 358.131V352.556L222.69 351.499Z",
    fill: "url(#paint27_linear_2253_1261)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M212.127 344.695V350.363L210.422 351.314V345.752L212.127 344.695Z",
    fill: "url(#paint28_linear_2253_1261)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M213.978 357.893L212.127 350.363L210.422 351.314L212.273 358.95L213.978 357.893Z",
    fill: "url(#paint29_linear_2253_1261)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M213.973 357.893L216.895 359.597L215.071 360.482L212.281 358.924L213.973 357.893Z",
    fill: "url(#paint30_linear_2253_1261)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M209.813 346.056L209.773 351.724L211.822 359.637L215.008 361.407L220.984 358.131V352.556L220.058 352.027V357.523L215.074 360.482L212.285 358.924L210.487 351.38L210.646 346.307L209.813 346.056Z",
    fill: "url(#paint31_linear_2253_1261)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M227.659 355.132C226.522 355.806 225.107 355.806 223.97 355.132C220.956 353.348 211.425 347.813 209.693 346.875C207.327 345.58 206.309 345.712 204.723 345.395C204.445 345.342 204.326 345.223 204.326 345.052C204.326 344.906 204.26 344.774 204.419 344.576C205.106 343.717 207.208 343.691 208.398 343.347C209.469 343.044 210.857 342.74 212.258 343.347C213.329 343.81 224.605 349.187 228.134 351.287C228.518 351.525 228.967 351.657 228.967 352.067C228.967 352.093 228.967 353.784 228.967 353.811C228.941 354.167 228.743 354.524 228.386 354.735L227.685 355.145L227.659 355.132Z",
    fill: "url(#paint32_linear_2253_1261)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M227.662 353.718C226.525 354.392 225.111 354.392 223.974 353.718C220.96 351.935 211.429 346.399 209.697 345.461C207.331 344.167 206.313 345.554 204.726 345.223C203.153 344.893 206.63 342.436 208.401 341.934C209.472 341.63 210.86 341.326 212.261 341.934C213.332 342.396 224.86 349.174 228.389 351.274C229.156 351.737 229.156 352.859 228.389 353.309L227.689 353.718H227.662Z",
    fill: "url(#paint33_linear_2253_1261)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M204.674 345.171C206.247 345.501 207.278 344.101 209.644 345.408C211.376 346.36 220.907 351.895 223.921 353.665C225.058 354.339 226.472 354.339 227.609 353.665L228.31 353.256C228.693 353.031 228.892 352.648 228.892 352.252C229.037 352.741 228.852 353.309 228.363 353.613L227.662 354.022C226.525 354.696 225.111 354.696 223.974 354.022C220.96 352.239 211.429 346.703 209.697 345.765C207.331 344.47 206.313 345.554 204.726 345.237C204.369 345.157 204.277 345.276 204.369 345.025C204.436 345.091 204.528 345.157 204.687 345.184L204.674 345.171Z",
    fill: "url(#paint34_radial_2253_1261)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M202.305 414.859C221.842 414.859 237.68 407.259 237.68 397.883C237.68 388.507 221.842 380.907 202.305 380.907C182.768 380.907 166.93 388.507 166.93 397.883C166.93 407.259 182.768 414.859 202.305 414.859Z",
    fill: "url(#paint35_radial_2253_1261)"
  }), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M219.935 407.303C219.935 407.712 220.081 408.016 220.305 408.148L221.535 408.848C221.773 408.98 221.627 408.677 221.984 408.465C222.724 408.042 223.333 406.999 223.333 406.153C223.333 405.73 223.716 405.73 223.478 405.585L222.209 404.885C221.958 404.753 221.627 404.779 221.27 404.991C220.53 405.413 219.922 406.457 219.922 407.303H219.935Z",
    fill: "url(#paint36_linear_2253_1261)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M221.203 408.016C221.203 408.861 221.798 409.205 222.552 408.782C223.292 408.359 223.9 407.316 223.9 406.47C223.9 405.625 223.305 405.281 222.552 405.704C221.811 406.127 221.203 407.17 221.203 408.016Z",
    fill: "url(#paint37_linear_2253_1261)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M219.594 407.355C219.594 406.365 220.294 405.149 221.167 404.66C221.59 404.409 221.973 404.383 222.264 404.541L223.679 405.321C223.679 405.321 223.745 405.374 223.758 405.4C223.467 405.176 223.044 405.176 222.568 405.453C221.709 405.955 220.995 407.157 220.995 408.148L219.594 407.369V407.355Z",
    fill: "url(#paint38_linear_2253_1261)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M222.487 405.664C222.844 405.453 223.161 405.427 223.399 405.546C223.174 405.479 222.896 405.532 222.592 405.704C221.852 406.127 221.244 407.171 221.244 408.016C221.244 408.465 221.403 408.769 221.667 408.888C221.337 408.795 221.125 408.465 221.125 407.963C221.125 407.118 221.72 406.074 222.473 405.651L222.487 405.664Z",
    fill: "url(#paint39_radial_2253_1261)"
  }), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M191.214 410.354C191.214 410.764 191.359 411.068 191.584 411.2L192.813 411.887C193.051 412.019 192.906 411.715 193.263 411.504C194.003 411.081 194.611 410.037 194.611 409.192C194.611 408.769 194.995 408.769 194.757 408.624L193.474 407.924C193.237 407.791 192.906 407.818 192.536 408.029C191.796 408.452 191.188 409.496 191.188 410.341L191.214 410.354Z",
    fill: "url(#paint40_linear_2253_1261)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M192.477 411.068C192.477 411.913 193.071 412.257 193.825 411.834C194.565 411.411 195.173 410.367 195.173 409.522C195.173 408.676 194.578 408.333 193.825 408.756C193.085 409.178 192.477 410.222 192.477 411.068Z",
    fill: "url(#paint41_linear_2253_1261)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M190.867 410.407C190.867 409.416 191.568 408.201 192.44 407.712C192.863 407.461 193.247 407.435 193.538 407.593L194.952 408.373C194.952 408.373 195.018 408.425 195.031 408.452C194.741 408.227 194.317 408.227 193.842 408.505C192.982 409.007 192.268 410.209 192.268 411.2L190.867 410.42V410.407Z",
    fill: "url(#paint42_linear_2253_1261)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M193.76 408.716C194.117 408.505 194.434 408.478 194.672 408.597C194.447 408.531 194.17 408.584 193.866 408.756C193.126 409.179 192.517 410.222 192.517 411.068C192.517 411.517 192.676 411.821 192.94 411.94C192.61 411.847 192.398 411.517 192.398 411.015C192.398 410.169 192.993 409.126 193.747 408.703L193.76 408.716Z",
    fill: "url(#paint43_radial_2253_1261)"
  }), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M178.328 394.395C178.328 394.805 178.474 395.109 178.698 395.241L179.928 395.928C180.179 396.073 180.02 395.756 180.39 395.545C181.131 395.122 181.739 394.078 181.739 393.233C181.739 392.81 182.122 392.81 181.884 392.665L180.615 391.965C180.364 391.832 180.033 391.859 179.677 392.07C178.936 392.493 178.328 393.537 178.328 394.382V394.395Z",
    fill: "url(#paint44_linear_2253_1261)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M179.594 395.095C179.594 395.941 180.189 396.284 180.942 395.862C181.682 395.439 182.291 394.395 182.291 393.55C182.291 392.704 181.696 392.361 180.942 392.783C180.202 393.206 179.594 394.25 179.594 395.095Z",
    fill: "url(#paint45_linear_2253_1261)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M177.984 394.448C177.984 393.457 178.685 392.242 179.557 391.753C179.981 391.502 180.364 391.476 180.655 391.634L182.056 392.4C182.109 392.44 182.135 392.466 182.149 392.48C181.858 392.255 181.435 392.255 180.959 392.533C180.099 393.035 179.386 394.237 179.386 395.228L177.984 394.448Z",
    fill: "url(#paint46_linear_2253_1261)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M180.869 392.757C181.226 392.546 181.544 392.519 181.782 392.638C181.557 392.572 181.279 392.625 180.975 392.797C180.235 393.22 179.627 394.263 179.627 395.109C179.627 395.545 179.785 395.862 180.05 395.981C179.719 395.888 179.508 395.558 179.508 395.056C179.508 394.21 180.103 393.167 180.856 392.744L180.869 392.757Z",
    fill: "url(#paint47_radial_2253_1261)"
  }), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M198.669 380.391C198.669 380.801 198.815 381.105 199.04 381.237L200.269 381.937C200.507 382.069 200.362 381.765 200.718 381.554C201.459 381.131 202.067 380.088 202.067 379.242C202.067 378.819 202.45 378.819 202.212 378.674L200.943 377.974C200.692 377.842 200.362 377.868 200.005 378.08C199.264 378.502 198.656 379.546 198.656 380.391H198.669Z",
    fill: "url(#paint48_linear_2253_1261)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M199.938 381.105C199.938 381.95 200.532 382.294 201.286 381.871C202.026 381.448 202.634 380.404 202.634 379.559C202.634 378.713 202.039 378.37 201.286 378.793C200.546 379.215 199.938 380.259 199.938 381.105Z",
    fill: "url(#paint49_linear_2253_1261)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M198.328 380.444C198.328 379.453 199.029 378.238 199.901 377.749C200.324 377.498 200.708 377.472 200.998 377.63L202.413 378.41C202.413 378.41 202.479 378.463 202.492 378.489C202.201 378.264 201.778 378.264 201.303 378.542C200.443 379.044 199.729 380.246 199.729 381.237L198.328 380.457V380.444Z",
    fill: "url(#paint50_linear_2253_1261)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M201.221 378.753C201.578 378.542 201.895 378.516 202.133 378.634C201.908 378.568 201.631 378.621 201.327 378.793C200.586 379.216 199.978 380.259 199.978 381.105C199.978 381.541 200.137 381.858 200.401 381.977C200.071 381.884 199.859 381.554 199.859 381.052C199.859 380.207 200.454 379.163 201.208 378.74L201.221 378.753Z",
    fill: "url(#paint51_radial_2253_1261)"
  }), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M224.154 389.904C224.154 390.313 224.299 390.617 224.524 390.749L225.753 391.449C225.991 391.581 225.846 391.278 226.203 391.066C226.943 390.643 227.551 389.6 227.551 388.754C227.551 388.332 227.935 388.332 227.697 388.186L226.428 387.486C226.176 387.354 225.846 387.38 225.489 387.592C224.749 388.014 224.141 389.058 224.141 389.904H224.154Z",
    fill: "url(#paint52_linear_2253_1261)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M225.422 390.604C225.422 391.449 226.017 391.793 226.77 391.37C227.511 390.947 228.119 389.904 228.119 389.058C228.119 388.212 227.524 387.869 226.77 388.292C226.03 388.715 225.422 389.758 225.422 390.604Z",
    fill: "url(#paint53_linear_2253_1261)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M223.812 389.956C223.812 388.966 224.513 387.75 225.386 387.261C225.809 387.01 226.192 386.984 226.483 387.142L227.884 387.909C227.884 387.909 227.963 387.975 227.977 387.988C227.686 387.763 227.263 387.763 226.787 388.041C225.928 388.543 225.214 389.745 225.214 390.736L223.812 389.956Z",
    fill: "url(#paint54_linear_2253_1261)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M226.698 388.252C227.054 388.041 227.372 388.015 227.61 388.133C227.385 388.067 227.107 388.12 226.803 388.292C226.063 388.715 225.455 389.758 225.455 390.604C225.455 391.04 225.614 391.357 225.878 391.476C225.547 391.383 225.336 391.053 225.336 390.551C225.336 389.706 225.931 388.662 226.684 388.239L226.698 388.252Z",
    fill: "url(#paint55_radial_2253_1261)"
  }), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M221 403.881H223.009V405.096C223.009 405.427 222.56 405.691 222.005 405.691C221.449 405.691 221 405.427 221 405.109V403.894V403.881Z",
    fill: "url(#paint56_linear_2253_1261)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M221 403.881C221 404.211 221.449 404.462 222.005 404.462C222.56 404.462 223.009 404.198 223.009 403.881C223.009 403.564 222.56 403.3 222.005 403.3C221.449 403.3 221 403.564 221 403.881Z",
    fill: "url(#paint57_linear_2253_1261)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M224.914 386.786H226.923V388.001C226.923 388.331 226.474 388.596 225.919 388.596C225.364 388.596 224.914 388.331 224.914 388.014V386.799V386.786Z",
    fill: "url(#paint58_linear_2253_1261)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M224.914 386.786C224.914 387.116 225.364 387.367 225.919 387.367C226.474 387.367 226.923 387.103 226.923 386.786C226.923 386.469 226.474 386.204 225.919 386.204C225.364 386.204 224.914 386.469 224.914 386.786Z",
    fill: "url(#paint59_linear_2253_1261)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M199.578 377.538H201.587V378.753C201.587 379.084 201.138 379.348 200.583 379.348C200.028 379.348 199.578 379.084 199.578 378.766V377.551V377.538Z",
    fill: "url(#paint60_linear_2253_1261)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M200.583 378.119C201.138 378.119 201.587 377.859 201.587 377.538C201.587 377.217 201.138 376.957 200.583 376.957C200.028 376.957 199.578 377.217 199.578 377.538C199.578 377.859 200.028 378.119 200.583 378.119Z",
    fill: "url(#paint61_linear_2253_1261)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M179 391.238H181.009V392.453C181.009 392.784 180.56 393.048 180.005 393.048C179.449 393.048 179 392.784 179 392.466V391.251V391.238Z",
    fill: "url(#paint62_linear_2253_1261)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M180.005 391.819C180.56 391.819 181.009 391.559 181.009 391.238C181.009 390.917 180.56 390.657 180.005 390.657C179.45 390.657 179 390.917 179 391.238C179 391.559 179.45 391.819 180.005 391.819Z",
    fill: "url(#paint63_linear_2253_1261)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M191.93 407.052H193.939V408.267C193.939 408.597 193.49 408.862 192.934 408.862C192.379 408.862 191.93 408.597 191.93 408.28V407.065V407.052Z",
    fill: "url(#paint64_linear_2253_1261)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M191.93 407.052C191.93 407.382 192.379 407.633 192.934 407.633C193.49 407.633 193.939 407.369 193.939 407.052C193.939 406.734 193.49 406.47 192.934 406.47C192.379 406.47 191.93 406.734 191.93 407.052Z",
    fill: "url(#paint65_linear_2253_1261)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M201.707 390.472L183.398 389.573C181.878 389.573 180.424 390.207 179.366 391.304C179.049 391.595 178.745 392.057 179.115 392.215L179.208 392.123C180.305 391.132 181.746 390.617 183.227 390.683L201.602 393.233L194.516 401.675C193.617 402.956 192.916 404.37 192.414 405.849L192.057 406.933C191.991 407.831 193.234 408.082 193.485 407.342C194.159 405.413 195.19 403.973 196.512 402.428L204.748 394.157L217.161 400.459C219.038 401.622 220.638 402.85 221.827 404.713C222.237 405.44 223.215 404.991 222.964 404.053L222.726 403.656C221.695 401.926 220.334 400.433 218.708 399.257L207.26 392.704L223.876 386.891C224.696 386.693 225.542 386.746 226.322 387.023C226.719 387.169 227.168 387.222 226.824 386.878C225.846 385.98 224.511 385.61 223.202 385.848L205.66 390.075L201.298 377.696C201.086 377.128 199.632 377.26 199.711 377.842L201.707 390.458V390.472Z",
    fill: "#979ED1"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M202.162 389.085L183.391 389.151C181.87 389.151 180.416 389.772 179.359 390.881C179.041 391.172 178.737 391.634 179.107 391.793L179.2 391.7C180.297 390.71 181.738 390.194 183.219 390.26L201.594 391.093L194.508 401.252C193.609 402.533 192.909 403.947 192.406 405.427L192.049 406.51C191.983 407.408 193.226 407.659 193.477 406.92C194.151 404.991 195.182 403.22 196.504 401.662L204.74 392.017L217.153 399.693C219.03 400.856 220.63 402.428 221.82 404.291C222.229 405.017 223.208 404.568 222.957 403.63L222.719 403.234C221.687 401.503 220.326 400.01 218.7 398.834L207.252 390.564L223.869 386.456C224.728 386.244 225.614 386.31 226.407 386.627C226.764 386.773 227.147 386.786 226.817 386.442C225.838 385.544 224.503 385.174 223.194 385.412L205.652 388.741L201.726 378.384L201.303 377.261C201.091 376.693 199.637 376.825 199.717 377.406L200.007 378.78L202.175 389.071L202.162 389.085Z",
    fill: "url(#paint66_linear_2253_1261)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M201.656 386.746H207.79V390.445V390.472C207.79 391.462 206.415 392.255 204.723 392.255C203.031 392.255 201.656 391.449 201.656 390.472V390.445V386.746Z",
    fill: "url(#paint67_linear_2253_1261)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M201.656 386.759C201.656 387.75 203.031 388.543 204.723 388.543C206.415 388.543 207.79 387.737 207.79 386.759C207.79 385.781 206.415 384.976 204.723 384.976C203.031 384.976 201.656 385.781 201.656 386.759Z",
    fill: "#E5E9FF"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M202.109 373.641H207.344V386.046V386.072C207.344 386.918 206.168 387.592 204.727 387.592C203.286 387.592 202.109 386.905 202.109 386.072V386.046V373.641Z",
    fill: "url(#paint68_linear_2253_1261)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M202.109 367.801H207.344V380.207V380.233C207.344 381.078 206.168 381.752 204.727 381.752C203.286 381.752 202.109 381.065 202.109 380.233V380.207V367.801Z",
    fill: "url(#paint69_linear_2253_1261)"
  }), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M228.081 366.665C224.856 368.581 214.399 374.83 211.306 376.468C203.506 380.577 195.337 374.354 189.771 371.17C184.206 367.986 176.776 362.345 182.884 358.58C187.616 355.673 196.011 350.627 199.712 349.041C203.414 347.456 212.178 350.23 221.049 355C229.932 359.769 232.312 364.142 228.068 366.652L228.081 366.665Z",
    fill: "url(#paint70_linear_2253_1261)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M227.868 366.533C224.669 368.435 214.318 374.631 211.238 376.243C203.518 380.312 195.414 374.143 189.902 370.998C184.389 367.854 177.026 362.253 183.067 358.527C187.747 355.647 196.075 350.653 199.75 349.081C203.425 347.509 212.097 350.257 220.902 354.986C229.706 359.716 232.072 364.049 227.868 366.533Z",
    fill: "url(#paint71_linear_2253_1261)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M227.645 366.401C224.472 368.277 214.214 374.42 211.173 376.019C203.519 380.048 195.495 373.944 190.035 370.813C184.575 367.696 177.278 362.147 183.267 358.461C187.907 355.607 196.156 350.653 199.791 349.094C203.44 347.535 212.019 350.27 220.744 354.947C229.469 359.624 231.809 363.917 227.645 366.388V366.401Z",
    fill: "url(#paint72_linear_2253_1261)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M227.421 366.269C224.287 368.131 214.108 374.209 211.094 375.807C203.506 379.81 195.562 373.746 190.155 370.655C184.735 367.563 177.517 362.068 183.452 358.408C188.053 355.581 196.223 350.68 199.831 349.134C203.44 347.588 211.954 350.296 220.586 354.934C229.218 359.571 231.545 363.825 227.421 366.269Z",
    fill: "url(#paint73_linear_2253_1261)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M227.197 366.137C224.09 367.986 214.017 374.011 211.029 375.583C203.521 379.546 195.642 373.548 190.288 370.483C184.921 367.418 177.769 361.975 183.652 358.355C188.213 355.555 196.303 350.693 199.872 349.16C203.455 347.628 211.875 350.31 220.442 354.907C228.995 359.505 231.295 363.719 227.21 366.137H227.197Z",
    fill: "url(#paint74_linear_2253_1261)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M226.968 366.005C223.888 367.828 213.907 373.799 210.959 375.358C203.517 379.282 195.717 373.337 190.403 370.298C185.089 367.26 178.003 361.87 183.82 358.289C188.328 355.515 196.352 350.706 199.895 349.187C203.437 347.668 211.792 350.323 220.266 354.881C228.74 359.439 231.027 363.6 226.968 366.005Z",
    fill: "url(#paint75_linear_2253_1261)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M226.75 365.859C223.696 367.669 213.821 373.575 210.886 375.12C203.51 379.004 195.79 373.125 190.528 370.113C185.267 367.101 178.248 361.764 184.011 358.21C188.479 355.462 196.424 350.693 199.927 349.187C203.431 347.681 211.706 350.31 220.1 354.828C228.495 359.333 230.755 363.468 226.737 365.846L226.75 365.859Z",
    fill: "url(#paint76_linear_2253_1261)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M226.518 365.727C223.504 367.524 213.709 373.376 210.814 374.909C203.516 378.753 195.862 372.927 190.654 369.955C185.445 366.982 178.492 361.685 184.203 358.17C188.631 355.449 196.484 350.733 199.96 349.24C203.437 347.747 211.633 350.349 219.948 354.815C228.263 359.28 230.497 363.376 226.532 365.727H226.518Z",
    fill: "url(#paint77_linear_2253_1261)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M226.3 365.595C223.312 367.365 213.609 373.165 210.741 374.684C203.51 378.489 195.935 372.716 190.779 369.77C185.624 366.824 178.736 361.579 184.394 358.104C188.783 355.409 196.556 350.733 200.006 349.266C203.444 347.786 211.56 350.376 219.796 354.788C228.032 359.214 230.239 363.27 226.313 365.595H226.3Z",
    fill: "url(#paint78_linear_2253_1261)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M226.076 365.463C223.115 367.22 213.517 372.967 210.675 374.46C203.523 378.238 196.015 372.518 190.912 369.598C185.796 366.679 178.988 361.487 184.58 358.038C188.916 355.37 196.623 350.746 200.033 349.279C203.444 347.826 211.468 350.376 219.625 354.749C227.781 359.122 229.976 363.138 226.076 365.45V365.463Z",
    fill: "url(#paint79_linear_2253_1261)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M225.847 365.331C222.913 367.075 213.408 372.756 210.592 374.235C203.506 377.974 196.077 372.306 191.014 369.426C185.951 366.533 179.209 361.394 184.748 357.985C189.044 355.343 196.672 350.759 200.056 349.319C203.427 347.879 211.385 350.402 219.449 354.736C227.526 359.069 229.694 363.045 225.834 365.331H225.847Z",
    fill: "url(#paint80_linear_2253_1261)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M225.639 365.199C222.731 366.916 213.332 372.544 210.543 374.024C203.523 377.723 196.173 372.121 191.163 369.255C186.153 366.388 179.477 361.315 184.963 357.933C189.219 355.317 196.768 350.785 200.112 349.345C203.457 347.919 211.322 350.415 219.32 354.709C227.318 359.003 229.46 362.94 225.639 365.199Z",
    fill: "url(#paint81_linear_2253_1261)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M225.411 365.067C222.542 366.771 213.223 372.346 210.46 373.799C203.519 377.459 196.236 371.91 191.278 369.083C186.321 366.256 179.698 361.222 185.144 357.866C189.361 355.277 196.83 350.785 200.135 349.372C203.44 347.958 211.24 350.429 219.145 354.683C227.05 358.937 229.179 362.821 225.398 365.067H225.411Z",
    fill: "url(#paint82_linear_2253_1261)"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M225.185 364.934C222.342 366.625 213.128 372.135 210.392 373.575C203.518 377.194 196.313 371.712 191.409 368.911C186.504 366.11 179.948 361.13 185.328 357.814C189.492 355.251 196.895 350.812 200.173 349.398C203.452 347.998 211.159 350.455 218.985 354.656C226.811 358.857 228.913 362.715 225.185 364.934Z",
    fill: "url(#paint83_linear_2253_1261)"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M224.961 364.789C222.145 366.454 213.024 371.91 210.327 373.337C203.519 376.917 196.394 371.487 191.542 368.713C186.691 365.939 180.2 361.011 185.527 357.735C189.652 355.198 196.975 350.799 200.214 349.412C203.453 348.024 211.08 350.455 218.84 354.617C226.587 358.778 228.676 362.596 224.974 364.789H224.961Z",
    fill: "url(#paint84_linear_2253_1261)"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M224.737 364.657C221.948 366.309 212.919 371.712 210.248 373.126C203.52 376.679 196.46 371.302 191.662 368.554C186.85 365.807 180.438 360.932 185.713 357.682C189.798 355.172 197.042 350.812 200.254 349.451C203.454 348.077 211.015 350.482 218.682 354.603C226.35 358.725 228.412 362.491 224.75 364.67L224.737 364.657Z",
    fill: "url(#paint85_linear_2253_1261)"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M224.511 364.525C221.761 366.163 212.825 371.501 210.181 372.901C203.518 376.415 196.538 371.091 191.779 368.369C187.02 365.648 180.675 360.826 185.897 357.616C189.929 355.132 197.107 350.825 200.279 349.464C203.452 348.104 210.921 350.482 218.509 354.564C226.097 358.633 228.133 362.372 224.511 364.525Z",
    fill: "url(#paint86_linear_2253_1261)"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M224.29 364.393C221.567 366.005 212.723 371.302 210.105 372.676C203.522 376.151 196.608 370.893 191.902 368.198C187.196 365.516 180.917 360.733 186.072 357.563C190.065 355.105 197.164 350.838 200.297 349.504C203.43 348.156 210.832 350.508 218.341 354.537C225.85 358.567 227.859 362.266 224.277 364.393H224.29Z",
    fill: "url(#paint87_linear_2253_1261)"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M224.066 364.261C221.369 365.859 212.631 371.091 210.04 372.452C203.523 375.887 196.689 370.681 192.035 368.026C187.382 365.371 181.169 360.641 186.272 357.497C190.224 355.066 197.244 350.851 200.35 349.517C203.457 348.183 210.767 350.508 218.197 354.498C225.626 358.488 227.622 362.147 224.066 364.248V364.261Z",
    fill: "url(#paint88_linear_2253_1261)"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M223.84 364.129C221.17 365.714 212.524 370.88 209.96 372.24C203.509 375.636 196.753 370.483 192.153 367.854C187.553 365.225 181.406 360.548 186.455 357.444C190.368 355.039 197.309 350.865 200.376 349.557C203.442 348.236 210.687 350.548 218.024 354.484C225.374 358.435 227.343 362.041 223.84 364.129Z",
    fill: "url(#paint89_linear_2253_1261)"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M223.629 363.997C220.986 365.569 212.433 370.681 209.908 372.016C203.536 375.371 196.847 370.285 192.299 367.683C187.752 365.08 181.671 360.456 186.655 357.391C190.515 355.013 197.389 350.891 200.429 349.583C203.47 348.289 210.621 350.561 217.892 354.458C225.163 358.355 227.106 361.936 223.643 363.997H223.629Z",
    fill: "url(#paint90_linear_2253_1261)"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M223.405 363.864C220.801 365.41 212.341 370.47 209.829 371.791C203.523 375.12 196.914 370.074 192.419 367.511C187.911 364.935 181.909 360.364 186.84 357.325C190.661 354.973 197.456 350.891 200.456 349.61C203.457 348.328 210.53 350.574 217.721 354.432C224.899 358.289 226.829 361.83 223.405 363.864Z",
    fill: "url(#paint91_linear_2253_1261)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M228.081 366.665C224.856 368.581 214.399 374.83 211.306 376.468C203.506 380.577 195.337 374.354 189.771 371.17C184.206 367.986 176.776 362.345 182.884 358.58C187.616 355.673 196.011 350.627 199.712 349.041C203.414 347.456 212.178 350.23 221.049 355C229.932 359.769 232.312 364.142 228.068 366.652L228.081 366.665Z",
    fill: "url(#paint92_linear_2253_1261)"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M228.081 366.665C224.856 368.581 214.399 374.83 211.306 376.468C203.506 380.577 195.337 374.354 189.771 371.17C184.206 367.986 176.776 362.345 182.884 358.58C187.616 355.673 196.011 350.627 199.712 349.041C203.414 347.456 212.178 350.23 221.049 355C229.932 359.769 232.312 364.142 228.068 366.652L228.081 366.665Z",
    fill: "url(#paint93_linear_2253_1261)"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M212.697 373.733C226.824 373.733 238.277 368.398 238.277 361.817C238.277 355.235 226.824 349.9 212.697 349.9C198.57 349.9 187.117 355.235 187.117 361.817C187.117 368.398 198.57 373.733 212.697 373.733Z",
    fill: "url(#paint94_radial_2253_1261)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M228.341 372.531C228.064 372.689 228.302 379.189 228.619 385.715C228.923 392.242 229.32 398.795 229.32 399.072C229.333 399.653 229.676 400.182 230.298 400.538L233.735 402.454L234.515 402.89C234.541 402.89 238.719 405.228 238.745 405.215C239.221 405.479 239.803 405.625 240.397 405.638C240.424 405.638 240.45 405.638 240.49 405.638C241.032 405.638 241.534 405.506 241.931 405.281L243.372 404.356C243.887 404.053 244.191 403.577 244.191 403.062C244.191 402.48 243.835 401.952 243.226 401.582C243.226 401.569 236.868 396.8 236.841 396.786L236.392 396.456C235.903 396.179 235.282 396.007 234.66 396.007C234.488 396.007 234.118 393.523 233.708 390.141C233.457 388.12 233.18 385.795 232.915 383.456C232.532 380.167 232.148 376.89 231.858 374.552C231.593 372.438 231.382 371.091 231.289 371.144L228.355 372.504L228.341 372.531Z",
    fill: "#ABB2E2"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M228.837 374.024C228.56 374.182 228.785 380.365 229.075 386.574C229.366 392.784 229.75 399.033 229.763 399.297C229.789 399.838 230.106 400.354 230.701 400.697L234.019 402.547C234.019 402.547 234.76 402.969 234.773 402.969C234.826 402.983 238.818 405.202 238.871 405.189C239.334 405.44 239.889 405.572 240.471 405.585C240.497 405.585 240.523 405.585 240.55 405.585C241.065 405.585 241.568 405.453 241.938 405.242L243.339 404.343C243.842 404.053 244.119 403.604 244.132 403.102C244.132 402.547 243.802 402.031 243.22 401.688C243.22 401.662 237.179 397.117 237.126 397.091L236.703 396.773C236.24 396.509 235.632 396.351 235.051 396.351C234.892 396.351 234.509 393.973 234.112 390.762C233.874 388.834 233.583 386.614 233.306 384.395C232.922 381.264 232.512 378.159 232.235 375.939C231.97 373.931 231.759 372.663 231.666 372.716L228.851 374.024H228.837Z",
    fill: "#A7ADDF"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.14,
    d: "M229.341 375.516C229.064 375.675 229.275 381.541 229.553 387.446C229.83 393.338 230.2 399.27 230.227 399.534C230.267 400.05 230.557 400.538 231.126 400.869L234.338 402.652C234.338 402.652 235.052 403.049 235.065 403.062C235.131 403.088 238.952 405.189 239.031 405.175C239.481 405.413 240.023 405.532 240.578 405.545C240.604 405.545 240.631 405.545 240.657 405.545C241.146 405.545 241.635 405.413 241.992 405.202L243.341 404.343C243.817 404.066 244.094 403.63 244.107 403.154C244.107 402.626 243.803 402.137 243.248 401.807C243.261 401.767 237.511 397.434 237.445 397.394L237.035 397.09C236.599 396.839 236.004 396.681 235.449 396.681C235.29 396.681 234.907 394.395 234.51 391.37C234.272 389.533 233.968 387.42 233.69 385.319C233.294 382.347 232.884 379.414 232.606 377.326C232.355 375.424 232.13 374.235 232.051 374.288L229.368 375.53L229.341 375.516Z",
    fill: "#A3A9DC"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.19,
    d: "M229.857 377.009C229.579 377.168 229.764 382.73 230.028 388.305C230.293 393.893 230.663 399.495 230.689 399.759C230.742 400.248 231.007 400.71 231.549 401.027L234.642 402.745C234.642 402.745 235.33 403.128 235.343 403.141C235.435 403.181 239.084 405.162 239.176 405.149C239.613 405.374 240.128 405.466 240.657 405.479C240.683 405.479 240.71 405.479 240.736 405.479C241.199 405.479 241.688 405.334 242.019 405.149L243.314 404.317C243.764 404.053 244.028 403.643 244.041 403.181C244.041 402.679 243.764 402.216 243.235 401.886C243.261 401.82 237.815 397.724 237.722 397.658L237.339 397.368C236.929 397.13 236.361 396.971 235.832 396.971C235.686 396.971 235.277 394.792 234.906 391.925C234.669 390.181 234.364 388.186 234.074 386.204C233.677 383.404 233.241 380.629 232.963 378.661C232.712 376.864 232.487 375.754 232.408 375.794L229.843 376.983L229.857 377.009Z",
    fill: "#9FA4D8"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.24,
    d: "M230.362 378.502C230.084 378.661 230.256 383.906 230.494 389.177C230.745 394.448 231.102 399.733 231.142 399.997C231.208 400.459 231.446 400.895 231.948 401.186L234.922 402.837C234.922 402.837 235.583 403.207 235.597 403.207C235.716 403.26 239.179 405.123 239.298 405.097C239.721 405.308 240.223 405.374 240.726 405.4C240.752 405.4 240.779 405.4 240.792 405.4C241.228 405.4 241.717 405.255 242.021 405.083L243.277 404.291C243.713 404.04 243.965 403.656 243.978 403.221C243.991 402.745 243.727 402.296 243.238 401.992C243.264 401.913 238.135 398.029 238.016 397.962L237.646 397.698C237.249 397.474 236.707 397.315 236.205 397.315C236.073 397.315 235.65 395.241 235.279 392.546C235.055 390.895 234.724 389.005 234.433 387.143C234.024 384.5 233.587 381.898 233.31 380.061C233.072 378.384 232.834 377.34 232.754 377.38L230.322 378.516L230.362 378.502Z",
    fill: "#9BA0D5"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M230.862 379.995C230.585 380.154 230.73 385.081 230.968 390.036C231.206 394.99 231.563 399.957 231.603 400.221C231.682 400.657 231.893 401.067 232.369 401.344L235.238 402.917C235.238 402.917 235.859 403.26 235.886 403.273C236.031 403.326 239.31 405.083 239.455 405.057C239.852 405.242 240.341 405.308 240.83 405.334C240.856 405.334 240.869 405.334 240.896 405.334C241.306 405.334 241.782 405.189 242.072 405.017L243.275 404.251C243.685 404.013 243.923 403.643 243.95 403.234C243.963 402.784 243.712 402.362 243.262 402.071C243.302 401.979 238.477 398.306 238.345 398.227L238.001 397.976C237.631 397.764 237.102 397.606 236.639 397.606C236.507 397.606 236.084 395.637 235.714 393.114C235.489 391.555 235.159 389.785 234.855 388.028C234.445 385.544 233.982 383.113 233.718 381.396C233.48 379.823 233.242 378.859 233.176 378.899L230.862 379.969V379.995Z",
    fill: "#979BD2"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M231.369 381.488C231.091 381.647 231.223 386.257 231.435 390.894C231.646 395.531 232.003 400.182 232.056 400.446C232.135 400.856 232.334 401.239 232.783 401.503L235.533 403.009C235.533 403.009 236.128 403.339 236.154 403.352C236.313 403.419 239.419 405.07 239.591 405.03C239.974 405.202 240.437 405.242 240.9 405.268C240.926 405.268 240.939 405.268 240.966 405.268C241.349 405.268 241.825 405.11 242.09 404.964L243.253 404.238C243.636 404.013 243.874 403.67 243.887 403.273C243.914 402.85 243.676 402.454 243.253 402.177C243.293 402.071 238.785 398.623 238.626 398.53L238.296 398.293C237.952 398.094 237.436 397.949 237.013 397.949C236.894 397.949 236.445 396.073 236.101 393.722C235.876 392.255 235.533 390.591 235.229 388.952C234.819 386.64 234.343 384.368 234.079 382.783C233.841 381.316 233.603 380.431 233.537 380.471L231.355 381.488H231.369Z",
    fill: "#9397CF"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.38,
    d: "M231.871 382.981C231.593 383.139 231.699 387.446 231.91 391.766C232.109 396.086 232.413 400.433 232.518 400.684C232.532 401.067 232.783 401.424 233.206 401.675L235.837 403.115C235.837 403.115 236.405 403.432 236.431 403.445C236.616 403.524 239.551 405.057 239.736 405.017C240.106 405.176 240.556 405.202 240.992 405.228C241.005 405.228 241.032 405.228 241.045 405.228C241.402 405.228 241.865 405.07 242.116 404.925L243.226 404.224C243.596 404.013 243.808 403.683 243.834 403.326C243.861 402.93 243.649 402.547 243.253 402.296C243.306 402.177 239.102 398.94 238.917 398.834L238.613 398.61C238.295 398.425 237.806 398.279 237.396 398.279C237.291 398.279 236.828 396.509 236.484 394.329C236.273 392.955 235.916 391.41 235.612 389.877C235.189 387.724 234.7 385.623 234.448 384.17C234.224 382.809 233.973 382.003 233.906 382.043L231.844 383.007L231.871 382.981Z",
    fill: "#8F92CC"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M232.371 384.46C232.093 384.619 232.185 388.609 232.371 392.612C232.556 396.615 232.846 400.657 232.965 400.895C232.979 401.252 233.217 401.582 233.613 401.807L236.125 403.181C236.125 403.181 236.654 403.471 236.693 403.498C236.905 403.59 239.654 405.004 239.866 404.964C240.223 405.109 240.646 405.123 241.069 405.149C241.082 405.149 241.109 405.149 241.122 405.149C241.439 405.149 241.915 404.991 242.153 404.858L243.224 404.198C243.567 404 243.779 403.696 243.805 403.352C243.832 402.983 243.647 402.626 243.277 402.375C243.329 402.243 239.443 399.231 239.231 399.112L238.941 398.9C238.65 398.728 238.174 398.583 237.804 398.583C237.698 398.583 237.235 396.919 236.905 394.897C236.693 393.603 236.323 392.176 236.019 390.762C235.583 388.767 235.094 386.852 234.843 385.504C234.618 384.249 234.367 383.522 234.314 383.562L232.384 384.46H232.371Z",
    fill: "#8B8EC9"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.48,
    d: "M232.884 385.953C232.606 386.112 232.672 389.785 232.844 393.484C233.016 397.183 233.294 400.895 233.426 401.133C233.439 401.463 233.664 401.767 234.021 401.979L236.427 403.287C236.427 403.287 236.929 403.564 236.969 403.59C237.207 403.683 239.771 404.991 240.009 404.938C240.353 405.07 240.749 405.057 241.146 405.083C241.159 405.083 241.172 405.083 241.199 405.083C241.49 405.083 241.966 404.911 242.177 404.793L243.195 404.158C243.526 403.973 243.711 403.683 243.75 403.366C243.777 403.022 243.605 402.692 243.288 402.454C243.354 402.296 239.771 399.508 239.533 399.376L239.269 399.178C239.004 399.019 238.542 398.874 238.198 398.874C238.106 398.874 237.616 397.315 237.299 395.466C237.088 394.263 236.704 392.942 236.4 391.647C235.964 389.811 235.448 388.067 235.21 386.852C234.986 385.702 234.735 385.055 234.682 385.095L232.871 385.94L232.884 385.953Z",
    fill: "#8789C6"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.52,
    d: "M233.384 387.446C233.107 387.605 233.159 390.96 233.318 394.342C233.477 397.724 233.741 401.12 233.9 401.358C233.926 401.661 234.124 401.939 234.455 402.137L236.742 403.379C236.742 403.379 237.218 403.643 237.257 403.656C237.522 403.762 239.901 404.951 240.166 404.898C240.496 405.017 240.88 404.991 241.25 405.017C241.263 405.017 241.276 405.017 241.289 405.017C241.554 405.017 242.017 404.845 242.215 404.74L243.193 404.145C243.497 403.973 243.682 403.709 243.709 403.418C243.748 403.101 243.59 402.784 243.299 402.573C243.365 402.401 240.086 399.838 239.835 399.68L239.597 399.508C239.359 399.363 238.91 399.217 238.606 399.217C238.527 399.217 238.024 397.751 237.72 396.086C237.522 394.977 237.125 393.774 236.808 392.585C236.359 390.921 235.843 389.335 235.605 388.239C235.367 387.142 235.129 386.64 235.076 386.667L233.397 387.459L233.384 387.446Z",
    fill: "#8385C2"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.57,
    d: "M233.887 388.939C233.61 389.098 233.649 392.149 233.782 395.201C233.927 398.266 234.178 401.344 234.35 401.582C234.376 401.86 234.561 402.111 234.865 402.282L237.033 403.458C237.033 403.458 237.483 403.709 237.523 403.722C237.8 403.841 240.021 404.911 240.299 404.859C240.616 404.951 240.973 404.911 241.33 404.951C241.33 404.951 241.356 404.951 241.369 404.951C241.607 404.951 242.07 404.779 242.242 404.674L243.167 404.105C243.445 403.947 243.617 403.696 243.656 403.432C243.696 403.128 243.564 402.85 243.3 402.652C243.379 402.467 240.404 400.116 240.127 399.957L239.902 399.799C239.677 399.667 239.254 399.534 238.977 399.534C238.897 399.534 238.382 398.174 238.091 396.668C237.893 395.65 237.483 394.554 237.166 393.484C236.716 391.978 236.174 390.564 235.949 389.6C235.725 388.635 235.474 388.186 235.421 388.199L233.861 388.939H233.887Z",
    fill: "#7F80BF"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.62,
    d: "M234.395 390.432C234.117 390.591 234.131 393.325 234.263 396.073C234.395 398.821 234.633 401.595 234.818 401.82C234.844 402.071 235.016 402.296 235.294 402.454L237.356 403.551C237.356 403.551 237.766 403.775 237.832 403.802C238.136 403.934 240.172 404.885 240.476 404.832C240.78 404.911 241.11 404.859 241.441 404.885C241.441 404.885 241.467 404.885 241.481 404.885C241.692 404.885 242.142 404.7 242.3 404.621L243.186 404.092C243.45 403.947 243.609 403.722 243.649 403.471C243.688 403.194 243.583 402.943 243.345 402.745C243.424 402.547 240.767 400.406 240.463 400.235L240.264 400.089C240.066 399.97 239.67 399.838 239.418 399.838C239.352 399.838 238.823 398.583 238.533 397.249C238.334 396.324 237.925 395.347 237.594 394.382C237.145 393.035 236.589 391.806 236.365 390.947C236.14 390.088 235.876 389.719 235.849 389.732L234.421 390.406L234.395 390.432Z",
    fill: "#7B7CBC"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.67,
    d: "M234.893 391.925C234.616 392.083 234.616 394.501 234.722 396.932C234.841 399.363 235.065 401.82 235.264 402.045C235.29 402.269 235.449 402.467 235.687 402.613L237.63 403.643C237.63 403.643 238.013 403.854 238.079 403.881C238.41 404.013 240.261 404.872 240.591 404.792C240.882 404.859 241.199 404.792 241.503 404.819H241.53C241.715 404.819 242.164 404.634 242.296 404.555L243.129 404.053C243.367 403.921 243.513 403.709 243.552 403.498C243.592 403.247 243.513 403.022 243.314 402.837C243.407 402.626 241.054 400.71 240.736 400.525L240.551 400.393C240.38 400.301 239.996 400.155 239.785 400.155C239.732 400.155 239.177 398.993 238.912 397.843C238.714 396.998 238.291 396.139 237.96 395.294C237.498 394.105 236.929 393.048 236.718 392.321C236.506 391.595 236.229 391.277 236.202 391.291L234.893 391.912V391.925Z",
    fill: "#7777B9"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.71,
    d: "M235.396 393.418C235.119 393.576 235.092 395.677 235.198 397.804C235.291 399.918 235.515 402.058 235.727 402.282C235.753 402.481 235.899 402.652 236.11 402.784L237.934 403.749C237.934 403.749 238.291 403.947 238.357 403.973C238.714 404.119 240.38 404.859 240.737 404.779C241.015 404.832 241.305 404.74 241.596 404.779C241.596 404.779 241.609 404.779 241.623 404.779C241.781 404.779 242.231 404.594 242.337 404.528L243.13 404.066C243.341 403.947 243.487 403.762 243.526 403.564C243.579 403.339 243.5 403.128 243.341 402.969C243.434 402.745 241.398 401.041 241.054 400.842L240.896 400.724C240.75 400.644 240.38 400.499 240.195 400.499C240.142 400.499 239.574 399.442 239.322 398.451C239.137 397.698 238.701 396.958 238.371 396.219C237.908 395.201 237.445 394.263 237.115 393.695C237.036 393.061 236.626 392.836 236.599 392.85L235.41 393.418H235.396Z",
    fill: "#7373B6"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M235.899 394.91C235.621 395.069 235.582 396.866 235.661 398.662C235.74 400.472 235.952 402.282 236.177 402.507C236.203 402.665 236.335 402.824 236.52 402.93L238.239 403.828C238.239 403.828 238.556 404 238.635 404.039C239.006 404.198 240.499 404.819 240.883 404.74C241.147 404.779 241.412 404.674 241.676 404.713C241.676 404.713 241.689 404.713 241.702 404.713C241.835 404.713 242.271 404.515 242.363 404.462L243.104 404.039C243.302 403.934 243.421 403.762 243.474 403.59C243.527 403.392 243.474 403.207 243.342 403.062C243.447 402.811 241.716 401.344 241.345 401.133L241.2 401.04C241.081 400.974 240.724 400.829 240.579 400.829C240.539 400.829 239.944 399.878 239.719 399.059C239.534 398.385 239.085 397.764 238.754 397.156C238.279 396.298 237.829 395.531 237.485 395.095C237.419 394.567 236.996 394.422 236.983 394.435L235.925 394.937L235.899 394.91Z",
    fill: "#6F6EB3"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.81,
    d: "M236.411 396.403C236.133 396.562 236.067 398.041 236.133 399.521C236.199 401.014 236.397 402.52 236.635 402.731C236.662 402.864 236.768 402.996 236.939 403.088L238.539 403.92C238.605 403.96 238.83 404.079 238.909 404.105C239.306 404.264 240.628 404.779 241.024 404.7C241.275 404.726 241.527 404.594 241.765 404.634H241.778C241.884 404.634 242.32 404.436 242.399 404.396L243.086 404C243.258 403.894 243.377 403.762 243.417 403.617C243.47 403.445 243.443 403.286 243.338 403.141C243.443 402.877 242.029 401.622 241.632 401.397L241.513 401.318C241.421 401.265 241.09 401.133 240.958 401.133C240.918 401.133 240.178 400.314 240.099 399.64C239.808 399.098 239.464 398.544 239.121 398.055C238.645 397.355 238.182 396.76 237.838 396.443C237.785 396.02 237.349 395.954 237.336 395.967L236.397 396.417L236.411 396.403Z",
    fill: "#6B6AB0"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.86,
    d: "M236.913 397.896C236.636 398.055 236.556 399.217 236.609 400.393C236.662 401.569 236.847 402.758 237.098 402.969C237.138 403.075 237.217 403.181 237.349 403.26L238.83 404.026C238.896 404.066 239.094 404.172 239.174 404.198C239.597 404.37 240.734 404.766 241.157 404.674C241.395 404.674 241.619 404.541 241.844 404.581C241.844 404.581 241.844 404.581 241.857 404.581C241.937 404.581 242.36 404.383 242.426 404.343L243.073 403.987C243.219 403.894 243.325 403.788 243.377 403.656C243.43 403.511 243.43 403.366 243.364 403.247C243.483 402.969 242.373 401.939 241.95 401.688L241.844 401.622C241.765 401.582 241.461 401.45 241.368 401.45C241.342 401.45 240.575 400.723 240.509 400.221C240.218 399.772 239.861 399.336 239.517 398.953C239.042 398.425 238.566 397.989 238.222 397.804C238.182 397.487 237.733 397.5 237.72 397.513L236.913 397.909V397.896Z",
    fill: "#6765AC"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M237.422 399.389C237.144 399.548 237.039 400.393 237.078 401.252C237.118 402.11 237.29 402.982 237.554 403.194C237.594 403.273 237.66 403.352 237.766 403.418L239.141 404.105C239.22 404.145 239.365 404.224 239.458 404.264C239.907 404.449 240.859 404.726 241.309 404.634C241.52 404.634 241.745 404.581 241.93 404.515C241.983 404.515 242.406 404.317 242.445 404.29L243.04 403.96C243.173 403.881 243.265 403.788 243.318 403.683C243.384 403.564 243.384 403.445 243.358 403.339C243.477 403.048 242.67 402.229 242.234 401.978L242.155 401.926C242.155 401.926 241.811 401.767 241.745 401.767C241.732 401.767 240.938 401.146 240.899 400.816C240.608 400.459 240.251 400.129 239.894 399.865C239.405 399.495 238.929 399.23 238.585 399.178C238.559 398.966 238.096 399.059 238.083 399.059L237.396 399.389H237.422Z",
    fill: "#6361A9"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.95,
    d: "M237.921 400.882C237.643 401.041 237.524 401.582 237.55 402.124C237.577 402.666 237.775 403.181 238.013 403.432C238.066 403.485 238.106 403.538 238.185 403.577L239.441 404.198C239.52 404.238 239.639 404.304 239.732 404.343C240.208 404.542 240.974 404.7 241.45 404.608C241.649 404.581 241.847 404.528 242.019 404.449C242.045 404.449 242.468 404.238 242.481 404.224L243.037 403.934C243.142 403.868 243.222 403.802 243.288 403.709C243.354 403.617 243.38 403.524 243.38 403.432C243.512 403.128 243.01 402.52 242.547 402.256L242.481 402.216C242.481 402.216 242.177 402.071 242.151 402.071C242.151 402.071 241.331 401.556 241.305 401.384C241.014 401.12 240.644 400.909 240.287 400.75C239.798 400.539 239.309 400.446 238.965 400.512C238.965 400.406 238.476 400.578 238.476 400.578L237.921 400.856V400.882Z",
    fill: "#5F5CA6"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M242.1 404.383L243.025 403.907C243.633 403.564 243.554 402.943 242.854 402.547L241.717 401.992C241.016 401.582 239.958 401.543 239.35 401.899L238.425 402.375C237.817 402.718 237.896 403.339 238.597 403.736L239.734 404.29C240.434 404.7 241.492 404.74 242.1 404.383Z",
    fill: "#5B58A3"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M209.127 380.339C208.836 380.51 208.994 387.658 209.219 394.831C209.444 402.005 209.761 409.218 209.774 409.509C209.788 410.13 210.158 410.698 210.832 411.094L214.52 413.155C214.52 413.155 215.353 413.618 215.366 413.618C215.393 413.618 219.874 416.128 219.901 416.115C220.416 416.405 221.037 416.564 221.672 416.577C221.698 416.577 221.738 416.577 221.765 416.577C222.346 416.577 222.888 416.445 223.311 416.194L224.858 415.19C225.413 414.873 225.744 414.357 225.744 413.789C225.744 413.168 225.373 412.587 224.699 412.204C224.699 412.191 217.719 406.959 217.693 406.946L217.362 406.695C216.834 406.391 216.173 406.219 215.498 406.219C215.313 406.219 214.943 403.366 214.547 399.521C214.322 397.355 214.071 394.884 213.82 392.414C213.463 388.781 213.093 385.161 212.815 382.585C212.564 380.273 212.365 378.793 212.26 378.859L209.1 380.312L209.127 380.339Z",
    fill: "#ABB2E2"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M209.652 381.977C209.361 382.149 209.493 388.939 209.718 395.769C209.942 402.599 210.246 409.456 210.26 409.747C210.286 410.328 210.63 410.883 211.264 411.253L214.834 413.234L215.64 413.684C215.693 413.71 219.989 416.075 220.042 416.075C220.531 416.339 221.139 416.484 221.761 416.498C221.787 416.498 221.827 416.498 221.853 416.498C222.408 416.498 222.95 416.352 223.334 416.128L224.828 415.163C225.356 414.859 225.674 414.371 225.674 413.829C225.674 413.234 225.317 412.68 224.695 412.31C224.709 412.27 218.072 407.289 218.019 407.263L217.702 407.025C217.2 406.735 216.552 406.563 215.918 406.563C215.746 406.563 215.362 403.828 214.966 400.182C214.741 398.121 214.477 395.769 214.225 393.418C213.855 389.97 213.472 386.535 213.208 384.091C212.97 381.898 212.758 380.51 212.666 380.563L209.652 381.964V381.977Z",
    fill: "#A7ADDF"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.14,
    d: "M210.165 383.602C209.874 383.774 209.993 390.221 210.205 396.707C210.416 403.194 210.721 409.694 210.747 409.985C210.8 410.539 211.104 411.068 211.712 411.411L215.162 413.327C215.162 413.327 215.929 413.763 215.942 413.763C216.022 413.789 220.12 416.049 220.199 416.035C220.675 416.286 221.256 416.418 221.851 416.432C221.878 416.432 221.904 416.432 221.931 416.432C222.446 416.432 222.988 416.286 223.358 416.075L224.812 415.15C225.328 414.86 225.619 414.397 225.632 413.882C225.632 413.314 225.302 412.785 224.707 412.429C224.733 412.376 218.427 407.633 218.348 407.593L218.044 407.369C217.568 407.091 216.947 406.933 216.339 406.933C216.167 406.933 215.77 404.317 215.387 400.856C215.175 398.887 214.885 396.655 214.633 394.435C214.25 391.159 213.854 387.922 213.589 385.61C213.351 383.536 213.126 382.228 213.047 382.281L210.165 383.615V383.602Z",
    fill: "#A3A9DC"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.19,
    d: "M210.696 385.24C210.405 385.412 210.511 391.515 210.696 397.659C210.895 403.802 211.199 409.958 211.238 410.236C211.291 410.764 211.582 411.253 212.15 411.596L215.468 413.433C215.468 413.433 216.209 413.842 216.222 413.856C216.328 413.895 220.241 416.022 220.333 416.009C220.796 416.247 221.364 416.352 221.933 416.366C221.959 416.366 221.986 416.366 222.012 416.366C222.501 416.366 223.03 416.22 223.387 416.009L224.788 415.124C225.277 414.846 225.555 414.397 225.568 413.908C225.581 413.367 225.264 412.865 224.709 412.521C224.735 412.455 218.773 407.95 218.668 407.897L218.377 407.686C217.927 407.435 217.319 407.263 216.751 407.263C216.592 407.263 216.182 404.766 215.799 401.503C215.587 399.64 215.283 397.513 215.019 395.413C214.636 392.321 214.213 389.256 213.948 387.09C213.71 385.134 213.486 383.906 213.406 383.959L210.657 385.24H210.696Z",
    fill: "#9FA4D8"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.24,
    d: "M211.21 386.878C210.919 387.05 211.011 392.81 211.197 398.596C211.382 404.383 211.699 410.196 211.739 410.486C211.805 410.975 212.069 411.451 212.611 411.768L215.81 413.538C215.81 413.538 216.511 413.935 216.537 413.935C216.669 413.987 220.384 415.995 220.516 415.969C220.966 416.194 221.508 416.273 222.05 416.299C222.076 416.299 222.103 416.299 222.129 416.299C222.592 416.299 223.12 416.141 223.451 415.956L224.799 415.097C225.262 414.833 225.54 414.41 225.553 413.948C225.566 413.433 225.275 412.957 224.746 412.627C224.786 412.547 219.155 408.28 219.036 408.214L218.771 408.016C218.348 407.778 217.767 407.606 217.225 407.606C217.079 407.606 216.643 405.228 216.273 402.15C216.061 400.38 215.757 398.385 215.48 396.403C215.083 393.484 214.647 390.617 214.382 388.582C214.144 386.733 213.92 385.61 213.84 385.649L211.223 386.865L211.21 386.878Z",
    fill: "#9BA0D5"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M211.725 388.516C211.434 388.688 211.513 394.105 211.685 399.548C211.857 404.991 212.174 410.447 212.214 410.737C212.293 411.2 212.531 411.649 213.034 411.94L216.114 413.631C216.114 413.631 216.788 414.001 216.814 414.014C216.96 414.08 220.489 415.969 220.648 415.929C221.084 416.128 221.6 416.194 222.115 416.22C222.142 416.22 222.168 416.22 222.182 416.22C222.618 416.22 223.133 416.062 223.451 415.877L224.746 415.057C225.182 414.806 225.447 414.41 225.46 413.961C225.486 413.472 225.209 413.023 224.72 412.719C224.759 412.613 219.472 408.597 219.326 408.518L219.075 408.333C218.678 408.108 218.11 407.95 217.608 407.95C217.462 407.95 217.013 405.691 216.656 402.811C216.444 401.133 216.127 399.257 215.849 397.394C215.44 394.659 214.99 391.964 214.739 390.075C214.514 388.345 214.263 387.301 214.197 387.34L211.712 388.49L211.725 388.516Z",
    fill: "#979BD2"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M212.256 390.155C211.965 390.326 212.032 395.399 212.19 400.499C212.349 405.598 212.666 410.711 212.719 410.988C212.812 411.424 213.01 411.847 213.499 412.125L216.447 413.75C216.447 413.75 217.081 414.106 217.121 414.12C217.293 414.186 220.637 415.956 220.809 415.916C221.232 416.101 221.721 416.154 222.224 416.18C222.25 416.18 222.263 416.18 222.29 416.18C222.7 416.18 223.215 416.022 223.506 415.85L224.749 415.071C225.172 414.833 225.41 414.45 225.436 414.04C225.463 413.591 225.211 413.155 224.749 412.864C224.802 412.746 219.857 408.967 219.672 408.875L219.434 408.703C219.064 408.492 218.522 408.333 218.046 408.333C217.914 408.333 217.452 406.193 217.095 403.511C216.883 401.939 216.553 400.182 216.262 398.438C215.852 395.875 215.376 393.378 215.125 391.634C214.9 390.022 214.649 389.071 214.583 389.111L212.243 390.207L212.256 390.155Z",
    fill: "#9397CF"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.38,
    d: "M212.77 391.78C212.479 391.951 212.519 396.681 212.678 401.424C212.823 406.18 213.087 410.949 213.206 411.213C213.22 411.623 213.484 412.006 213.947 412.27L216.776 413.816C216.776 413.816 217.384 414.159 217.423 414.172C217.622 414.252 220.768 415.903 220.966 415.863C221.363 416.035 221.839 416.062 222.315 416.088C222.341 416.088 222.354 416.088 222.381 416.088C222.751 416.088 223.266 415.916 223.531 415.758L224.734 415.005C225.13 414.78 225.368 414.423 225.381 414.04C225.408 413.618 225.183 413.208 224.76 412.931C224.813 412.799 220.213 409.258 220.014 409.139L219.79 408.98C219.446 408.782 218.917 408.624 218.481 408.624C218.362 408.624 217.873 406.589 217.529 404.106C217.331 402.626 216.974 400.988 216.683 399.376C216.26 396.998 215.771 394.686 215.52 393.074C215.295 391.581 215.044 390.709 214.978 390.749L212.77 391.78Z",
    fill: "#8F92CC"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M213.303 393.418C213.012 393.589 213.039 397.975 213.184 402.375C213.33 406.774 213.567 411.213 213.713 411.464C213.726 411.847 213.977 412.204 214.4 412.442L217.11 413.921C217.11 413.921 217.679 414.238 217.732 414.252C217.956 414.344 220.904 415.863 221.142 415.824C221.526 415.982 221.975 415.982 222.425 416.022C222.438 416.022 222.464 416.022 222.477 416.022C222.821 416.022 223.323 415.85 223.575 415.705L224.725 414.991C225.095 414.78 225.32 414.45 225.346 414.08C225.372 413.683 225.174 413.3 224.791 413.036C224.857 412.891 220.587 409.588 220.362 409.456L220.164 409.311C219.847 409.126 219.344 408.967 218.935 408.967C218.829 408.967 218.326 407.051 217.983 404.766C217.784 403.392 217.414 401.873 217.124 400.367C216.687 398.16 216.185 396.033 215.947 394.567C215.722 393.193 215.471 392.4 215.405 392.44L213.33 393.404L213.303 393.418Z",
    fill: "#8B8EC9"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.48,
    d: "M213.813 395.056C213.523 395.228 213.536 399.257 213.668 403.326C213.8 407.382 214.038 411.464 214.184 411.728C214.21 412.085 214.435 412.415 214.831 412.64L217.409 414.04C217.409 414.04 217.951 414.344 217.991 414.357C218.242 414.463 221.005 415.863 221.256 415.811C221.626 415.943 222.062 415.943 222.485 415.969C222.499 415.969 222.525 415.969 222.538 415.969C222.856 415.969 223.358 415.784 223.583 415.665L224.68 414.991C225.024 414.793 225.235 414.489 225.275 414.146C225.314 413.776 225.129 413.419 224.772 413.168C224.838 412.997 220.912 409.945 220.661 409.799L220.476 409.654C220.185 409.482 219.696 409.337 219.326 409.337C219.22 409.337 218.705 407.54 218.374 405.44C218.176 404.158 217.792 402.758 217.488 401.384C217.039 399.363 216.51 397.421 216.285 396.086C216.061 394.831 215.796 394.131 215.743 394.157L213.8 395.069L213.813 395.056Z",
    fill: "#8789C6"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.52,
    d: "M214.348 396.694C214.057 396.866 214.057 400.552 214.176 404.264C214.295 407.976 214.533 411.715 214.692 411.966C214.718 412.283 214.93 412.587 215.287 412.798L217.746 414.133C217.746 414.133 218.248 414.41 218.301 414.437C218.578 414.555 221.143 415.824 221.421 415.771C221.777 415.89 222.187 415.863 222.584 415.903C222.597 415.903 222.61 415.903 222.637 415.903C222.928 415.903 223.417 415.718 223.628 415.599L224.673 414.965C225.003 414.78 225.201 414.489 225.228 414.186C225.267 413.842 225.109 413.512 224.792 413.274C224.871 413.089 221.275 410.275 221.011 410.117L220.839 409.984C220.575 409.839 220.112 409.681 219.768 409.681C219.676 409.681 219.134 408.003 218.816 406.1C218.618 404.911 218.221 403.643 217.917 402.375C217.468 400.525 216.913 398.781 216.688 397.579C216.476 396.443 216.199 395.822 216.146 395.848L214.335 396.694H214.348Z",
    fill: "#8385C2"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.57,
    d: "M214.864 398.319C214.56 398.491 214.56 401.833 214.665 405.202C214.771 408.571 214.996 411.953 215.181 412.204C215.207 412.495 215.406 412.772 215.736 412.957L218.076 414.212C218.076 414.212 218.552 414.476 218.605 414.503C218.909 414.622 221.288 415.784 221.592 415.718C221.936 415.824 222.32 415.784 222.69 415.811C222.703 415.811 222.716 415.811 222.729 415.811C222.994 415.811 223.483 415.626 223.668 415.52L224.659 414.912C224.963 414.741 225.149 414.476 225.188 414.186C225.228 413.869 225.082 413.565 224.805 413.34C224.884 413.142 221.645 410.566 221.341 410.394L221.183 410.275C220.945 410.143 220.495 409.985 220.191 409.985C220.112 409.985 219.543 408.426 219.239 406.721C219.041 405.638 218.645 404.476 218.327 403.339C217.865 401.675 217.296 400.116 217.071 399.046C216.847 397.976 216.582 397.487 216.529 397.513L214.864 398.306V398.319Z",
    fill: "#7F80BF"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.62,
    d: "M215.377 399.957C215.073 400.129 215.059 403.128 215.152 406.14C215.245 409.165 215.469 412.191 215.668 412.442C215.694 412.706 215.879 412.957 216.17 413.129L218.378 414.318C218.378 414.318 218.827 414.569 218.88 414.582C219.21 414.714 221.392 415.745 221.722 415.679C222.053 415.771 222.41 415.705 222.766 415.745C222.766 415.745 222.793 415.745 222.806 415.745C223.044 415.745 223.52 415.546 223.692 415.454L224.644 414.886C224.921 414.727 225.093 414.49 225.133 414.225C225.172 413.935 225.053 413.657 224.815 413.459C224.908 413.248 222 410.909 221.669 410.724L221.537 410.619C221.326 410.5 220.902 410.354 220.625 410.354C220.546 410.354 219.964 408.914 219.673 407.395C219.488 406.404 219.065 405.361 218.734 404.357C218.259 402.864 217.677 401.503 217.465 400.565C217.254 399.627 216.963 399.217 216.923 399.244L215.39 399.97L215.377 399.957Z",
    fill: "#7B7CBC"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.67,
    d: "M215.905 401.596C215.601 401.767 215.561 404.423 215.653 407.091C215.733 409.76 215.957 412.455 216.156 412.693C216.182 412.931 216.354 413.142 216.618 413.301L218.707 414.41C218.707 414.41 219.117 414.635 219.183 414.661C219.54 414.807 221.523 415.718 221.88 415.652C222.184 415.731 222.528 415.652 222.858 415.679C222.858 415.679 222.884 415.679 222.898 415.679C223.096 415.679 223.585 415.48 223.731 415.401L224.629 414.873C224.881 414.727 225.039 414.516 225.092 414.278C225.145 414.014 225.039 413.763 224.828 413.578C224.933 413.34 222.356 411.253 222.012 411.055L221.893 410.962C221.708 410.857 221.298 410.711 221.06 410.711C220.994 410.711 220.386 409.39 220.108 408.069C219.923 407.171 219.487 406.259 219.157 405.361C218.667 404.053 218.073 402.877 217.861 402.071C217.65 401.265 217.359 400.922 217.319 400.948L215.918 401.609L215.905 401.596Z",
    fill: "#7777B9"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.71,
    d: "M216.42 403.234C216.116 403.405 216.063 405.717 216.142 408.043C216.222 410.368 216.42 412.706 216.645 412.957C216.671 413.169 216.817 413.353 217.055 413.486L219.024 414.516C219.024 414.516 219.408 414.727 219.474 414.754C219.857 414.912 221.655 415.705 222.025 415.626C222.316 415.679 222.633 415.586 222.937 415.626H222.964C223.135 415.626 223.611 415.428 223.73 415.348L224.576 414.846C224.801 414.714 224.96 414.516 224.999 414.305C225.052 414.067 224.973 413.842 224.801 413.671C224.907 413.42 222.673 411.57 222.303 411.345L222.197 411.266C222.038 411.174 221.655 411.028 221.443 411.028C221.391 411.028 220.756 409.826 220.492 408.69C220.307 407.884 219.857 407.091 219.527 406.325C219.037 405.202 218.562 404.159 218.205 403.538C218.139 402.851 217.702 402.6 217.663 402.613L216.394 403.221L216.42 403.234Z",
    fill: "#7373B6"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M216.952 404.872C216.648 405.044 216.582 407.012 216.648 408.98C216.714 410.962 216.913 412.957 217.151 413.195C217.177 413.367 217.309 413.538 217.521 413.657L219.358 414.622C219.424 414.661 219.702 414.807 219.781 414.846C220.191 415.018 221.791 415.678 222.201 415.599C222.478 415.639 222.769 415.52 223.06 415.56C223.06 415.56 223.073 415.56 223.086 415.56C223.232 415.56 223.694 415.348 223.8 415.295L224.593 414.833C224.805 414.714 224.937 414.542 224.99 414.357C225.043 414.146 224.99 413.948 224.844 413.789C224.963 413.525 223.06 411.913 222.663 411.676L222.571 411.609C222.438 411.53 222.068 411.385 221.896 411.385C221.844 411.385 221.196 410.302 220.945 409.364C220.76 408.65 220.297 407.99 219.953 407.329C219.451 406.378 218.962 405.532 218.605 405.044C218.552 404.462 218.089 404.304 218.076 404.317L216.939 404.859L216.952 404.872Z",
    fill: "#6F6EB3"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.81,
    d: "M217.463 406.497C217.159 406.668 217.08 408.293 217.132 409.918C217.185 411.557 217.384 413.195 217.635 413.433C217.674 413.578 217.78 413.723 217.952 413.816L219.671 414.701C219.737 414.741 219.988 414.873 220.067 414.899C220.49 415.071 221.905 415.626 222.341 415.533C222.605 415.56 222.87 415.414 223.134 415.467C223.134 415.467 223.147 415.467 223.16 415.467C223.279 415.467 223.742 415.256 223.821 415.203L224.562 414.78C224.747 414.674 224.866 414.529 224.919 414.357C224.972 414.172 224.945 414.001 224.839 413.855C224.958 413.578 223.412 412.204 222.975 411.953L222.896 411.9C222.79 411.834 222.447 411.702 222.301 411.702C222.262 411.702 221.429 410.764 221.363 409.998C221.072 409.416 220.702 408.835 220.358 408.307C219.856 407.54 219.353 406.867 218.996 406.523C218.943 406.061 218.481 405.982 218.468 405.995L217.476 406.47L217.463 406.497Z",
    fill: "#6B6AB0"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.86,
    d: "M217.991 408.135C217.687 408.307 217.594 409.575 217.634 410.869C217.673 412.151 217.858 413.459 218.123 413.683C218.162 413.802 218.255 413.908 218.4 413.987L220 414.806C220.079 414.846 220.278 414.965 220.37 414.991C220.82 415.176 222.049 415.599 222.498 415.507C222.75 415.507 222.988 415.361 223.226 415.401C223.226 415.401 223.226 415.401 223.239 415.401C223.331 415.401 223.781 415.19 223.847 415.15L224.547 414.767C224.706 414.674 224.825 414.542 224.878 414.41C224.944 414.252 224.931 414.106 224.865 413.974C224.997 413.67 223.781 412.547 223.331 412.283L223.278 412.243C223.199 412.204 222.869 412.058 222.763 412.058C222.736 412.058 221.877 411.239 221.824 410.658C221.52 410.183 221.163 409.72 220.806 409.311C220.291 408.716 219.775 408.24 219.418 408.029C219.379 407.686 218.903 407.699 218.89 407.699L218.03 408.122L217.991 408.135Z",
    fill: "#6765AC"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M218.512 409.773C218.208 409.945 218.102 410.87 218.129 411.808C218.155 412.746 218.34 413.697 218.618 413.921C218.658 414.014 218.737 414.093 218.843 414.159L220.31 414.899C220.389 414.952 220.561 415.031 220.641 415.071C221.117 415.269 222.148 415.573 222.637 415.467C222.875 415.467 223.099 415.414 223.311 415.335C223.364 415.335 223.827 415.11 223.866 415.097L224.514 414.74C224.646 414.661 224.752 414.556 224.805 414.45C224.871 414.318 224.884 414.199 224.844 414.08C224.977 413.763 224.104 412.878 223.628 412.6L223.589 412.574C223.589 412.574 223.218 412.402 223.152 412.402C223.139 412.402 222.24 411.702 222.214 411.319C221.91 410.936 221.54 410.592 221.169 410.302C220.641 409.892 220.125 409.588 219.755 409.522C219.728 409.297 219.239 409.39 219.226 409.39L218.499 409.747L218.512 409.773Z",
    fill: "#6361A9"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.95,
    d: "M219.038 411.411C218.734 411.583 218.602 412.164 218.628 412.759C218.642 413.353 218.853 413.908 219.117 414.172C219.17 414.225 219.223 414.291 219.302 414.331L220.651 415.005C220.73 415.057 220.862 415.123 220.955 415.163C221.457 415.374 222.29 415.546 222.806 415.441C223.03 415.414 223.229 415.361 223.414 415.269C223.44 415.269 223.89 415.044 223.916 415.031L224.511 414.714C224.63 414.648 224.709 414.569 224.775 414.476C224.841 414.37 224.881 414.278 224.881 414.172C225.027 413.842 224.485 413.195 223.982 412.904H223.956C223.956 412.904 223.638 412.732 223.599 412.732C223.599 412.732 222.673 412.151 222.66 411.953C222.356 411.675 221.973 411.451 221.603 411.279C221.074 411.041 220.545 410.936 220.162 411.015C220.162 410.896 219.633 411.081 219.633 411.094L219.038 411.398V411.411Z",
    fill: "#5F5CA6"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M223.492 415.203L224.483 414.687C225.131 414.318 225.052 413.657 224.298 413.221L223.069 412.627C222.315 412.191 221.178 412.151 220.531 412.521L219.539 413.036C218.891 413.406 218.971 414.067 219.724 414.503L220.954 415.097C221.707 415.533 222.844 415.573 223.492 415.203Z",
    fill: "#5B58A3"
  }))), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M217.823 316.119C220.982 317.401 228.028 331.748 228.57 335.077C229.112 338.42 225.821 349.993 225.821 349.993C225.821 349.993 226.177 349.477 224.684 349.755C221.815 350.27 222.198 351.38 222.198 351.38L221.498 337.482L213.5 325.658C213.5 325.658 214.677 314.851 217.823 316.132V316.119Z",
    fill: "url(#paint95_linear_2253_1261)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M213.49 325.644C213.49 325.644 213.952 323.055 215.169 319.964C218.54 324.218 223.523 334.39 223.973 337.191C224.33 339.384 223.14 343.532 222.082 347.905L221.474 337.455L213.477 325.631L213.49 325.644Z",
    fill: "#CED3F4"
  }))), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M214.88 407.038V410.975C214.88 412.23 221.437 415.903 222.587 416.009C223.737 416.114 226.725 414.807 225.205 413.499C223.685 412.191 220.38 409.364 220.38 407.633C220.38 405.902 214.867 407.052 214.867 407.052L214.88 407.038Z",
    fill: "#4E0070"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M215.951 406.854C215.951 407.712 215.884 408.981 215.884 409.654C215.884 410.909 221.556 414.727 222.719 414.833C223.393 414.899 225.006 414.093 225.178 413.433C225.191 413.433 225.217 413.459 225.231 413.472C226.751 414.78 223.763 416.088 222.613 415.982C221.463 415.877 214.906 412.204 214.906 410.949V407.025C214.906 407.025 215.342 406.933 215.977 406.84L215.951 406.854Z",
    fill: "#CED3F4"
  }))), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M234.63 394.963C234.63 394.963 233.678 398.345 233.189 399.6C232.687 400.842 238.12 403.881 240.063 404.726C242.006 405.572 245.351 403.828 243.897 402.784C242.443 401.741 239.362 399.151 239.614 397.302C239.865 395.465 234.63 394.963 234.63 394.963Z",
    fill: "#4E0070"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M233.186 399.587C233.689 398.345 234.627 394.95 234.627 394.95C234.627 394.95 235.077 394.99 235.698 395.096C235.421 395.981 234.879 398.002 234.773 398.9C234.601 400.261 239.069 402.745 240.854 403.524C241.898 403.973 243.365 403.617 244.145 403.062C244.754 404.106 241.819 405.493 240.047 404.713C238.104 403.868 232.671 400.829 233.173 399.587H233.186Z",
    fill: "#CED3F4"
  }))), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M218.43 347.839C218.43 347.839 231.98 353.124 239.859 357.497C247.738 361.883 249.879 364.234 249.919 367.405C249.959 371.368 239.872 398.253 239.872 398.253C239.872 398.253 238.339 398.848 236.686 398.253C233.077 396.958 233.897 395.862 233.897 395.862L238.074 370.153L203.492 358.501L218.443 347.839H218.43Z",
    fill: "url(#paint96_linear_2253_1261)"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M225.783 348.526C225.783 348.526 226.391 351.116 226.576 352.014C226.761 352.899 225.849 356.612 224.527 357.18C223.218 357.748 221.539 354.194 221.539 354.194L222.279 348.87L225.769 348.526H225.783Z",
    fill: "#FFD4C0"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M209.341 354.313L211.033 353.11L238.728 367.88C239.971 368.541 240.632 369.928 240.367 371.302L235.291 397.645C233.308 396.628 233.877 395.848 233.877 395.848L238.054 370.14L210.756 360.945L209.328 354.313H209.341Z",
    fill: "#CED3F4"
  }))), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M210.861 351.063C210.861 351.063 221.661 369.334 222.97 372.782C224.556 376.943 220.894 408.254 220.894 408.254C220.894 408.254 219.758 409.298 217.338 409.39C214.919 409.483 214.205 408.584 214.205 408.584C214.205 408.584 211.892 378.991 211.601 377.3C211.297 375.609 200.1 369.4 196.98 366.678C191.19 361.605 195.487 347.853 195.487 347.853L210.874 351.076L210.861 351.063Z",
    fill: "url(#paint97_linear_2253_1261)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M194.653 351.195L199.491 354.101C199.491 364.115 202.452 365.133 208.824 370.021C213.821 373.852 214.509 375.028 214.509 380.946C214.509 385.768 215.117 402.996 215.341 409.192C214.495 408.954 214.191 408.584 214.191 408.584C214.191 408.584 211.878 378.991 211.587 377.3C211.283 375.609 200.086 369.4 196.966 366.678C192.987 363.191 193.767 355.607 194.653 351.208V351.195Z",
    fill: "#CED3F4"
  }))), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M201.923 307.479C202.015 307.149 202.055 306.792 202.148 306.449C203.205 302.485 206.589 299.381 210.648 298.733C217.39 297.663 220.985 301.389 220.814 307.968C220.708 311.865 218.527 314.759 216.226 317.903C213.04 322.249 211.52 325.354 210.687 329.04C209.67 333.584 206.113 335.725 201.579 336.742C192.55 338.75 184.976 330.836 185.332 320.717C192.365 320.928 200.033 314.534 201.923 307.492V307.479Z",
    fill: "url(#paint98_linear_2253_1261)"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M208.217 314.111C205.6 314.666 202.401 314.256 204.78 321.073C206.684 326.53 204.833 348.183 206.314 358.421C206.684 360.971 212.58 361.671 212.58 361.671C212.58 361.671 217.709 337.389 217.643 330.202C217.577 323.029 216.123 316.304 216.123 316.304L208.217 314.098V314.111Z",
    fill: "white"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M212.75 313.913C212.75 313.913 215.909 314.006 218.21 316.344C219.862 318.022 220.06 322.963 219.77 326.067C219.584 328.062 218.302 337.759 218.011 342.74C217.773 346.69 219.135 358.461 219.003 360.601C218.844 363.177 214.098 364.3 213.609 362.979C213.12 361.658 212.948 351.829 213.226 346.677C213.424 343.123 215.434 328.326 215.024 319.369C214.839 315.261 212.75 313.926 212.75 313.926V313.913Z",
    fill: "url(#paint99_linear_2253_1261)"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M207.294 314.072C207.294 314.072 203.407 314.917 204.333 317.837C205.258 320.756 207.822 322.91 209.7 329.819C211.854 337.772 212.7 358.712 211.365 362.781C210.466 365.542 191.391 366.533 191.391 360.998C191.391 350.455 193.863 351.499 194.206 342.343C194.603 331.682 193.545 325.512 194.484 322.989C195.872 319.224 199.785 317.573 203.605 315.591C204.822 314.957 205.972 314.362 207.294 314.058V314.072Z",
    fill: "url(#paint100_linear_2253_1261)"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M214.55 308.932C214.709 307.757 213.189 306.568 211.166 306.277C209.13 305.986 207.359 306.713 207.174 307.889L205.257 316.45C205.059 317.876 206.87 319.303 209.315 319.66C211.761 320.017 213.916 319.131 214.114 317.705L214.55 308.932Z",
    fill: "#FFD4C0"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M207.832 312.063C207.409 310.729 207.197 308.708 207.395 306.779C208.122 306.105 209.497 305.775 211.031 305.986C213.133 306.29 214.706 307.519 214.547 308.747C214.547 308.747 214.098 317.837 214.084 317.85C214.045 318.18 213.886 318.471 213.661 318.722C210.912 317.652 208.559 314.375 207.832 312.05V312.063Z",
    fill: "#F1D5BE"
  }))), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M218.12 303.252C219.891 306.541 216.956 316.278 213.559 316.318C210.161 316.357 207.637 312.803 206.777 310.055C205.918 307.307 205.892 301.521 208.853 300.121C211.814 298.72 216.322 299.922 218.12 303.265V303.252Z",
    fill: "#FFD4C0"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M194.471 323.002C194.563 322.765 194.682 322.553 194.801 322.329L196.308 322.448L202.548 330.506L200.935 341.353C201.173 345.052 206.421 347.469 211.987 352.886C207.307 351.102 202.283 349.187 201.94 349.042C200.644 348.487 199.534 349.504 199.534 349.504L197.868 364.763C194.286 364.3 191.391 363.151 191.391 360.998C191.391 350.455 193.863 351.499 194.206 342.344C194.603 331.682 193.545 325.513 194.484 322.989L194.471 323.002Z",
    fill: "#CED3F4"
  }))), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M219.609 303.939C220.257 306.33 219.741 304.665 216.026 304.454C214.691 304.375 213.99 307.757 213.118 307.585C211.69 307.294 210.329 308.179 209.998 309.606C209.906 309.963 209.8 310.214 209.681 310.24C209.192 310.32 208.861 307.717 207.804 308.126C206.746 308.536 206.495 314.058 205.609 314.706C204.71 315.353 205.451 311.376 205.451 308.774C205.451 306.171 204.829 299.843 210.619 299.434C216.41 299.024 219.093 301.97 219.635 303.952L219.609 303.939Z",
    fill: "url(#paint101_linear_2253_1261)"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M209.66 310.24C209.66 310.24 213.401 309.91 214.987 307.558C216.574 305.22 216.706 304.665 216.706 304.665C216.706 304.665 216.296 307.426 217.882 309.21C219.469 311.007 219.945 309.831 219.945 309.831C219.945 309.831 221.531 302.736 216.904 302.314C212.291 301.904 209.594 306.383 209.594 306.383L209.647 310.227L209.66 310.24Z",
    fill: "url(#paint102_linear_2253_1261)"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M199.885 363.508V369.175L198.18 370.127V364.565L199.885 363.508Z",
    fill: "url(#paint103_linear_2253_1261)"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M189.323 356.704V362.358L187.617 363.323V357.748L189.323 356.704Z",
    fill: "url(#paint104_linear_2253_1261)"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M191.173 369.902L189.323 362.358L187.617 363.323L189.468 370.946L191.173 369.902Z",
    fill: "url(#paint105_linear_2253_1261)"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M191.169 369.902L194.09 371.593L192.266 372.478L189.477 370.933L191.169 369.902Z",
    fill: "url(#paint106_linear_2253_1261)"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M187.008 358.065L186.969 363.719L189.018 371.646L192.204 373.416L198.179 370.127V364.565L197.254 364.036V369.532L192.27 372.478L189.48 370.933L187.683 363.389L187.841 358.316L187.008 358.065Z",
    fill: "url(#paint107_linear_2253_1261)"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M204.854 367.141C203.717 367.814 202.303 367.814 201.166 367.141C198.152 365.357 188.62 359.822 186.889 358.884C184.522 357.589 183.504 357.721 181.918 357.404C181.64 357.351 181.521 357.232 181.521 357.06C181.521 356.915 181.455 356.783 181.614 356.585C182.301 355.726 184.403 355.7 185.593 355.356C186.664 355.052 188.052 354.749 189.453 355.356C190.524 355.819 201.8 361.196 205.33 363.296C205.713 363.534 206.163 363.666 206.163 364.076C206.163 364.102 206.163 365.793 206.163 365.819C206.136 366.176 205.938 366.533 205.581 366.744L204.88 367.154L204.854 367.141Z",
    fill: "url(#paint108_linear_2253_1261)"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M204.857 365.727C203.721 366.401 202.306 366.401 201.169 365.727C198.155 363.944 188.624 358.408 186.892 357.47C184.526 356.175 183.508 357.563 181.922 357.232C180.348 356.902 183.825 354.445 185.597 353.943C186.667 353.639 188.055 353.335 189.457 353.943C190.527 354.405 202.055 361.182 205.584 363.283C206.351 363.745 206.351 364.868 205.584 365.317L204.884 365.727H204.857Z",
    fill: "url(#paint109_linear_2253_1261)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M181.853 357.179C183.426 357.51 184.457 356.109 186.824 357.417C188.556 358.368 198.087 363.904 201.101 365.674C202.238 366.348 203.652 366.348 204.789 365.674L205.49 365.265C205.873 365.04 206.071 364.657 206.071 364.261C206.217 364.749 206.032 365.317 205.543 365.621L204.842 366.031C203.705 366.705 202.291 366.705 201.154 366.031C198.14 364.247 188.608 358.712 186.877 357.774C184.51 356.479 183.492 357.563 181.906 357.245C181.549 357.166 181.457 357.285 181.549 357.034C181.615 357.1 181.708 357.166 181.866 357.193L181.853 357.179Z",
    fill: "url(#paint110_radial_2253_1261)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.01,
    d: "M228.479 361.83C232.273 359.624 236.503 359.888 240.284 362.121L285.931 391.991L291.959 395.941L253.913 417.423L236.543 427.225L215.868 437.979L166.308 405.176L164.14 403.749C161.575 402.243 161.906 398.346 164.484 396.853L210.157 371.223L228.466 361.87L228.479 361.83Z",
    fill: "#7C7DBD"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.01,
    d: "M229.966 362.781C233.655 360.628 237.607 360.984 241.295 363.151L285.025 392.638L290.802 396.536L253.219 417.753L236.06 427.437L215.636 437.741L168.271 405.295L166.195 403.881C163.697 402.415 164.146 398.557 166.645 397.104L211.842 371.738L229.966 362.794V362.781Z",
    fill: "#7B7CBC"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.02,
    d: "M231.442 363.745C235.038 361.658 238.713 362.094 242.295 364.208L284.109 393.312L289.634 397.156L252.514 418.109L235.567 427.674L215.394 437.53L170.209 405.453L168.226 404.053C165.794 402.626 166.349 398.808 168.782 397.394L213.503 372.293L231.429 363.759L231.442 363.745Z",
    fill: "#7B7BBC"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.02,
    d: "M232.909 364.697C236.399 362.662 239.797 363.191 243.287 365.238L283.183 393.959L288.458 397.751L251.8 418.44L235.064 427.886L215.142 437.292L172.152 405.585L170.275 404.198C167.909 402.811 168.57 399.032 170.936 397.645L215.182 372.808L232.922 364.697H232.909Z",
    fill: "#7A7ABB"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.03,
    d: "M234.39 365.661C237.787 363.693 240.894 364.3 244.278 366.295L282.257 394.633L287.281 398.372L251.073 418.81L234.548 428.137L214.878 437.094L174.069 405.757L172.284 404.396C169.998 403.049 170.764 399.297 173.064 397.962L216.834 373.39L234.376 365.688L234.39 365.661Z",
    fill: "#7979BA"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.03,
    d: "M235.875 366.612C239.166 364.697 242.009 365.397 245.287 367.326L281.35 395.281L286.122 398.967L250.377 419.14L234.064 428.348L214.644 436.856L176.03 405.889L174.338 404.542C172.117 403.234 172.99 399.521 175.224 398.227L218.531 373.918L235.888 366.626L235.875 366.612Z",
    fill: "#7878BA"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.03,
    d: "M237.35 367.577C240.549 365.714 243.1 366.507 246.286 368.383L280.419 395.954L284.94 399.601L249.657 419.51L233.556 428.599L214.388 436.658L177.955 406.048L176.355 404.713C174.2 403.445 175.179 399.772 177.347 398.517L220.178 374.473L237.35 367.59V367.577Z",
    fill: "#7777B9"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.04,
    d: "M238.819 368.541C241.912 366.745 244.199 367.616 247.279 369.426L279.495 396.615L283.752 400.208L248.932 419.853L233.042 428.824L214.125 436.433L179.886 406.193L178.379 404.872C176.291 403.643 177.388 400.01 179.476 398.782L221.832 375.001L238.806 368.541H238.819Z",
    fill: "#7676B8"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.04,
    d: "M240.299 369.492C243.287 367.748 245.296 368.713 248.284 370.47L278.583 397.275L282.589 400.816L248.218 420.21L232.54 429.061L213.874 436.222L181.816 406.351L180.402 405.057C178.379 403.868 179.582 400.261 181.605 399.085L223.484 375.569L240.273 369.519L240.299 369.492Z",
    fill: "#7575B7"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.04,
    d: "M241.779 370.457C244.675 368.779 246.406 369.823 249.288 371.514L277.67 397.936L281.425 401.424L247.517 420.553L232.037 429.286L213.622 435.997L183.759 406.497L182.45 405.215C180.494 404.066 181.803 400.499 183.772 399.363L225.176 376.111L241.779 370.47V370.457Z",
    fill: "#7474B7"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M243.261 371.408C246.05 369.783 247.504 370.919 250.293 372.557L276.759 398.596L280.262 402.031L246.817 420.897L231.548 429.511L213.385 435.773L185.703 406.629L184.487 405.361C182.596 404.251 184.011 400.723 185.915 399.627L226.855 376.653L243.261 371.421V371.408Z",
    fill: "#7473B6"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M244.729 372.372C247.426 370.8 248.602 372.016 251.286 373.601L275.834 399.257L279.086 402.639L246.104 421.24L231.047 429.735L213.134 435.548L187.647 406.774L186.523 405.519C184.699 404.449 186.233 400.961 188.057 399.891L228.522 377.181L244.742 372.372H244.729Z",
    fill: "#7372B5"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M246.206 373.324C248.797 371.818 249.696 373.112 252.287 374.632L274.919 399.904L277.92 403.234L245.387 421.584L230.541 429.96L212.88 435.324L189.574 406.92L188.543 405.691C186.785 404.66 188.424 401.212 190.182 400.182L230.171 377.736L246.206 373.337V373.324Z",
    fill: "#7271B5"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.06,
    d: "M247.689 374.288C250.187 372.835 250.809 374.222 253.294 375.688L274.009 400.578L276.759 403.868L244.688 421.954L230.054 430.211L212.644 435.125L191.519 407.091L190.581 405.876C188.889 404.885 190.634 401.463 192.326 400.486L231.839 378.304L247.676 374.314L247.689 374.288Z",
    fill: "#7170B4"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.06,
    d: "M249.175 375.253C251.567 373.865 251.911 375.332 254.304 376.732L273.102 401.239L275.587 404.476L243.98 422.298L229.557 430.436L212.398 434.901L193.468 407.237L192.622 406.035C191.009 405.083 192.86 401.701 194.473 400.763L233.51 378.846L249.162 375.266L249.175 375.253Z",
    fill: "#706FB3"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.07,
    d: "M250.648 376.203C252.948 374.869 253.015 376.428 255.302 377.776L272.17 401.899L274.404 405.083L243.259 422.641L229.048 430.66L212.14 434.676L195.391 407.369L194.65 406.18C193.104 405.268 195.06 401.926 196.62 401.014L235.195 379.361L250.661 376.203H250.648Z",
    fill: "#6F6EB3"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.07,
    d: "M252.117 377.168C254.312 375.887 254.1 377.538 256.295 378.819L271.246 402.56L273.229 405.691L242.533 422.998L228.534 430.898L211.877 434.465L197.323 407.527L196.675 406.365C195.194 405.493 197.256 402.19 198.75 401.318L236.849 379.929L252.117 377.181V377.168Z",
    fill: "#6E6DB2"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.07,
    d: "M253.603 378.119C255.705 376.904 255.216 378.634 257.304 379.863L270.339 403.22L272.07 406.299L241.837 423.341L228.036 431.122L211.631 434.24L199.257 407.673L198.702 406.523C197.288 405.691 199.456 402.415 200.883 401.595L238.506 380.471L253.59 378.132L253.603 378.119Z",
    fill: "#6D6CB1"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M255.079 379.084C257.075 377.921 256.308 379.744 258.305 380.907L269.422 403.881L270.903 406.906L241.133 423.685L227.543 431.347L211.389 434.016L201.21 407.818L200.747 406.682C199.399 405.889 201.686 402.652 203.034 401.873L240.181 381.013L255.079 379.084Z",
    fill: "#6D6CB1"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M256.558 380.035C258.448 378.925 257.417 380.841 259.307 381.951L268.508 404.542L269.737 407.514L240.43 424.028L227.052 431.572L211.149 433.791L203.151 407.963L202.781 406.841C201.498 406.087 203.891 402.89 205.173 402.137L241.858 381.541L256.558 380.035Z",
    fill: "#6C6BB0"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M258.031 380.999C259.829 379.956 258.507 381.951 260.305 382.994L267.589 405.202L268.567 408.135L239.709 424.398L226.542 431.809L210.891 433.58L205.087 408.109L204.81 407.012C203.593 406.299 206.092 403.141 207.308 402.428L243.516 382.096L258.031 380.999Z",
    fill: "#6B6AAF"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.09,
    d: "M259.507 381.964C261.199 380.973 259.613 383.06 261.305 384.051L266.672 405.876L267.386 408.756L238.99 424.755L226.035 432.047L210.634 433.368L207.012 408.267L206.84 407.184C205.69 406.51 208.308 403.392 209.458 402.718L245.19 382.651L259.507 381.964Z",
    fill: "#6A69AF"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.09,
    d: "M260.989 382.915C262.588 381.99 260.711 384.157 262.311 385.081L265.761 406.523L266.224 409.35L238.291 425.085L225.547 432.258L210.398 433.13L208.97 408.399L208.891 407.329C207.807 406.695 210.53 403.603 211.614 402.983L246.87 383.192L261.002 382.915H260.989Z",
    fill: "#6968AE"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M262.474 383.879C263.967 383.007 261.826 385.253 263.32 386.138L264.853 407.197L265.065 409.971L237.595 425.442L225.062 432.496L210.164 432.919L210.918 408.558V407.501C209.913 406.906 212.742 403.855 213.76 403.26L248.54 383.734L262.487 383.879H262.474Z",
    fill: "#6867AD"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M263.948 384.831C265.349 384.011 262.916 386.35 264.318 387.169L263.934 407.831L263.895 410.553L236.874 425.772L224.553 432.708L209.906 432.681L212.854 408.69L212.96 407.659C212.021 407.105 214.956 404.092 215.895 403.537L250.212 384.276L263.961 384.831H263.948Z",
    fill: "#6766AD"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M265.421 385.795C266.717 385.042 264.02 387.46 265.316 388.226L263.002 408.505L262.711 411.174L236.154 426.129L224.044 432.946L209.648 432.47L214.778 408.835L214.976 407.818C214.103 407.303 217.144 404.33 218.016 403.815L251.858 384.817L265.421 385.782V385.795Z",
    fill: "#6665AC"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M266.901 386.746C268.104 386.046 265.116 388.556 266.306 389.256L262.076 409.152L261.534 411.768L235.438 426.459L223.528 433.157L209.383 432.232L216.706 408.967L216.997 407.963C216.191 407.488 219.337 404.542 220.157 404.079L253.523 385.346L266.901 386.72V386.746Z",
    fill: "#6664AB"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M268.377 387.711C269.474 387.076 266.222 389.666 267.306 390.313L261.159 409.826L260.366 412.402L234.734 426.829L223.034 433.408L209.141 432.034L218.645 409.139L219.042 408.148C218.302 407.712 221.554 404.806 222.307 404.37L255.197 385.901L268.377 387.697V387.711Z",
    fill: "#6563AB"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M269.857 388.675C270.848 388.094 267.318 390.776 268.31 391.357L260.246 410.487L259.188 413.01L234.005 427.186L222.518 433.646L208.875 431.823L220.574 409.298L221.063 408.333C220.389 407.937 223.76 405.07 224.434 404.674L256.849 386.469L269.843 388.675H269.857Z",
    fill: "#6462AA"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M271.325 389.626C272.224 389.098 268.417 391.872 269.302 392.4L259.322 411.147L258.013 413.618L233.293 427.529L222.016 433.87L208.625 431.598L222.505 409.443L223.087 408.492C222.479 408.135 225.956 405.308 226.564 404.951L258.515 387.01L271.325 389.626Z",
    fill: "#6361A9"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M272.809 390.591C273.602 390.128 269.518 392.982 270.311 393.444L258.413 411.808L256.853 414.225L232.596 427.872L221.531 434.095L208.391 431.373L224.466 409.575L225.14 408.637C224.598 408.32 228.18 405.532 228.722 405.215L260.198 387.539L272.809 390.564V390.591Z",
    fill: "#6260A8"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M274.286 391.542C274.986 391.132 270.624 394.078 271.311 394.488L257.497 412.468L255.686 414.833L231.891 428.216L221.037 434.32L208.148 431.149L226.405 409.72L227.171 408.796C226.695 408.518 230.397 405.757 230.86 405.48L261.859 388.067L274.286 391.515V391.542Z",
    fill: "#615FA8"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.13,
    d: "M275.767 392.506C276.362 392.163 271.722 395.188 272.317 395.531L256.586 413.129L254.524 415.441L231.178 428.573L220.536 434.557L207.898 430.937L228.349 409.879L229.208 408.98C228.798 408.743 232.606 406.021 233.015 405.783L263.539 388.635L275.781 392.493L275.767 392.506Z",
    fill: "#605EA7"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.13,
    d: "M277.251 393.457C277.754 393.167 272.823 396.285 273.325 396.575L255.677 413.789L253.364 416.062L230.481 428.929L220.051 434.795L207.664 430.726L230.296 410.037L231.261 409.152C230.917 408.954 234.83 406.272 235.174 406.074L265.222 389.19L277.265 393.457H277.251Z",
    fill: "#5F5DA6"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.14,
    d: "M278.715 394.422C279.112 394.184 273.917 397.381 274.313 397.619L254.735 414.45L252.17 416.669L229.75 429.273L219.518 435.02L207.383 430.502L232.209 410.183L233.267 409.311C233.002 409.152 237.008 406.51 237.285 406.352L266.871 389.732L278.728 394.409L278.715 394.422Z",
    fill: "#5F5CA6"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.14,
    d: "M280.197 395.386C280.501 395.214 275.015 398.491 275.319 398.676L253.824 415.124L250.995 417.29L229.038 429.629L219.017 435.257L207.133 430.29L234.14 410.328L235.29 409.469C235.092 409.35 239.217 406.735 239.415 406.629L268.524 390.287L280.197 395.386Z",
    fill: "#5E5BA5"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.14,
    d: "M281.679 396.337C281.877 396.219 276.127 399.587 276.325 399.706L252.913 415.771L249.833 417.885L228.325 429.973L218.516 435.482L206.883 430.065L236.085 410.473L237.327 409.641C237.195 409.562 241.425 406.986 241.558 406.906L270.191 390.828L281.665 396.337H281.679Z",
    fill: "#5D5AA4"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M283.155 397.302C283.261 397.249 277.219 400.697 277.325 400.763L251.997 416.445L248.665 418.506L227.62 430.33L218.023 435.72L206.641 429.854L238.024 410.632L239.359 409.813C239.293 409.773 243.629 407.237 243.695 407.197L271.852 391.383L283.142 397.302H283.155Z",
    fill: "#5C59A4"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M284.624 398.253L251.073 417.105L217.521 435.944L206.391 429.643L239.955 410.777L273.532 391.925L284.624 398.253Z",
    fill: "#5B58A3"
  }))), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M217.231 437.318L207.898 431.638V427.688L217.231 433.368V437.318Z",
    fill: "url(#paint111_linear_2253_1261)"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M287.557 397.724L217.203 437.318V433.368L287.557 393.801V397.724Z",
    fill: "url(#paint112_linear_2253_1261)"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M217.236 399.151L178.305 376.547V372.597L217.236 395.201V399.151Z",
    fill: "#CED3F4"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M287.557 359.558L217.203 399.151V395.201L287.557 355.634V359.558Z",
    fill: "#AFB6E5"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M217.234 434.069L207.848 428.533L196.148 386.006L217.234 398.451V434.069Z",
    fill: "#CED3F4"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M287.557 394.475L217.203 434.068V398.451L287.557 358.884V394.475Z",
    fill: "#AFB6E5"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M287.564 355.634L217.21 395.201L178.305 372.597L248.698 333.016L287.564 355.634Z",
    fill: "url(#paint113_linear_2253_1261)"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.09,
    d: "M227.766 347.813L202.543 362.371C201.71 362.847 201.234 363.613 201.234 364.446C201.234 365.357 201.816 366.216 202.821 366.797L213.291 372.835C213.291 372.835 213.912 373.191 213.925 373.191C214.771 373.654 215.815 373.892 216.847 373.839C217.666 373.839 218.592 373.561 219.186 373.218L244.237 358.765C245.07 358.289 245.546 357.523 245.546 356.691C245.546 355.779 244.964 354.92 243.96 354.339L233.001 348.011C232.736 347.852 232.366 347.681 232.062 347.575C231.467 347.364 230.806 347.245 230.132 347.245C229.233 347.245 228.414 347.43 227.779 347.799L227.766 347.813Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M227.809 347.971L202.586 362.53C201.793 362.992 201.344 363.706 201.344 364.498C201.344 365.37 201.899 366.176 202.864 366.731L213.387 372.808C213.387 372.808 213.982 373.152 214.034 373.165C214.907 373.614 215.978 373.826 216.969 373.733C217.709 373.733 218.741 373.363 219.269 373.059L244.135 358.712C244.928 358.25 245.378 357.536 245.378 356.743C245.378 355.872 244.823 355.066 243.858 354.511L232.978 348.236C232.74 348.103 232.317 347.892 232.039 347.8C231.445 347.588 230.797 347.456 230.136 347.456C229.25 347.456 228.43 347.628 227.796 347.998L227.809 347.971Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.27,
    d: "M227.845 348.143L202.622 362.702C201.855 363.138 201.432 363.825 201.446 364.578C201.446 365.397 201.974 366.163 202.9 366.692L213.475 372.795C213.475 372.795 214.057 373.125 214.136 373.152C215.022 373.588 216.119 373.773 217.097 373.641C217.758 373.641 218.882 373.191 219.358 372.927L244.052 358.672C244.819 358.236 245.242 357.549 245.229 356.796C245.229 355.977 244.7 355.211 243.774 354.683L232.974 348.447C232.763 348.328 232.287 348.09 232.049 347.998C231.467 347.786 230.819 347.641 230.158 347.628C229.286 347.615 228.466 347.786 227.845 348.143Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.36,
    d: "M227.873 348.302L202.65 362.86C201.923 363.283 201.526 363.93 201.539 364.63C201.553 365.397 202.055 366.123 202.927 366.625L213.569 372.769C213.648 372.821 214.138 373.086 214.23 373.112C215.142 373.535 216.266 373.693 217.218 373.522C217.799 373.522 219.016 372.993 219.439 372.755L243.961 358.606C244.688 358.183 245.084 357.536 245.071 356.836C245.058 356.07 244.556 355.343 243.683 354.841L232.949 348.645C232.764 348.539 232.248 348.275 232.037 348.196C231.455 347.984 230.821 347.826 230.16 347.813C229.3 347.786 228.481 347.958 227.873 348.315V348.302Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M227.909 348.46L202.686 363.019C201.986 363.415 201.616 364.023 201.642 364.683C201.655 365.397 202.131 366.084 202.964 366.573L213.658 372.742C213.764 372.795 214.214 373.046 214.333 373.086C215.271 373.508 216.408 373.627 217.347 373.416C217.836 373.416 219.158 372.808 219.515 372.597L243.865 358.553C244.566 358.157 244.936 357.549 244.909 356.889C244.896 356.175 244.42 355.488 243.587 355L232.932 348.856C232.774 348.764 232.205 348.473 232.02 348.394C231.452 348.169 230.817 348.011 230.156 347.985C229.31 347.958 228.504 348.117 227.896 348.46H227.909Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.55,
    d: "M227.941 348.619L202.718 363.177C202.057 363.561 201.714 364.129 201.727 364.75C201.753 365.41 202.19 366.057 202.996 366.52L213.743 372.729C213.862 372.795 214.285 373.02 214.431 373.073C215.383 373.482 216.559 373.575 217.471 373.324C217.881 373.324 219.309 372.623 219.6 372.452L243.778 358.501C244.439 358.118 244.783 357.549 244.77 356.929C244.743 356.268 244.307 355.621 243.501 355.158L232.925 349.055C232.793 348.975 232.171 348.645 232.026 348.592C231.458 348.368 230.823 348.196 230.188 348.156C229.342 348.117 228.549 348.275 227.941 348.619Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.64,
    d: "M227.978 348.777L202.755 363.336C202.134 363.693 201.803 364.234 201.83 364.802C201.856 365.423 202.279 366.018 203.033 366.454L213.846 372.689C213.992 372.769 214.375 372.967 214.534 373.02C215.512 373.416 216.702 373.482 217.6 373.191C217.931 373.191 219.451 372.412 219.689 372.28L243.683 358.435C244.304 358.078 244.634 357.536 244.608 356.968C244.581 356.347 244.158 355.753 243.405 355.317L232.909 349.266C232.803 349.2 232.142 348.843 232.023 348.804C231.468 348.579 230.833 348.394 230.199 348.354C229.366 348.315 228.573 348.46 227.978 348.804V348.777Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.73,
    d: "M228.006 348.949L202.783 363.508C202.188 363.851 201.897 364.34 201.924 364.868C201.95 365.436 202.347 365.991 203.06 366.401L213.927 372.676C214.085 372.769 214.442 372.94 214.627 373.006C215.632 373.39 216.848 373.429 217.708 373.086C217.959 373.086 219.572 372.227 219.757 372.121L243.578 358.382C244.173 358.038 244.464 357.549 244.437 357.021C244.411 356.453 244.014 355.898 243.301 355.488L232.884 349.477C232.804 349.438 232.09 349.041 231.998 349.002C231.443 348.777 230.821 348.579 230.187 348.526C229.367 348.473 228.574 348.619 227.992 348.949H228.006Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.82,
    d: "M228.043 349.107L202.82 363.666C202.265 363.983 201.988 364.446 202.027 364.934C202.054 365.45 202.437 365.965 203.098 366.348L214.017 372.65C214.202 372.755 214.52 372.914 214.731 372.98C215.762 373.35 216.992 373.363 217.838 372.98C217.996 372.98 219.728 372.042 219.847 371.963L243.497 358.316C244.052 357.998 244.33 357.536 244.29 357.047C244.263 356.532 243.88 356.017 243.219 355.634L232.881 349.662C232.881 349.662 232.062 349.213 232.009 349.187C231.467 348.949 230.846 348.737 230.211 348.698C229.405 348.645 228.612 348.777 228.043 349.107Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.91,
    d: "M228.071 349.266L202.849 363.825C202.32 364.129 202.082 364.551 202.121 364.987C202.161 365.45 202.505 365.925 203.126 366.282L214.112 372.623C214.31 372.742 214.601 372.874 214.825 372.941C215.87 373.297 217.139 373.284 217.958 372.861C218.038 372.861 219.862 371.831 219.928 371.804L243.406 358.263C243.935 357.959 244.173 357.536 244.133 357.1C244.093 356.638 243.75 356.162 243.128 355.806L232.87 349.887C232.87 349.887 232.037 349.411 232.011 349.398C231.469 349.16 230.861 348.936 230.239 348.883C229.446 348.817 228.653 348.949 228.098 349.266H228.071Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.092 372.756L243.315 358.197C244.307 357.629 244.188 356.625 243.037 355.951L231.999 349.583C230.849 348.923 229.104 348.843 228.113 349.425L202.89 363.983C201.898 364.565 202.017 365.555 203.168 366.229L214.206 372.597C215.356 373.258 217.101 373.337 218.092 372.756Z",
    fill: "black"
  }))), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M218.094 372.729L243.317 358.17C243.766 357.919 243.978 357.576 243.991 357.219V355.964C243.991 355.528 243.66 356.281 243.039 355.924L232.001 349.557C230.851 348.896 229.106 348.817 228.114 349.398L202.891 363.957C202.561 364.155 202.323 363.336 202.231 363.587C202.204 363.679 202.231 364.815 202.231 364.908C202.231 365.357 202.548 365.833 203.182 366.189L214.221 372.557C215.371 373.218 217.116 373.297 218.107 372.716L218.094 372.729Z",
    fill: "#858FD6"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M218.092 371.5L243.315 356.942C244.307 356.36 244.188 355.37 243.037 354.696L231.999 348.328C230.849 347.667 229.104 347.588 228.113 348.169L202.89 362.728C201.898 363.296 202.017 364.3 203.168 364.974L214.206 371.342C215.356 372.002 217.101 372.082 218.092 371.5Z",
    fill: "#CED3F4"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M216.401 371.382C216.969 371.382 217.485 371.263 217.842 371.065L243.065 356.506C243.223 356.413 243.488 356.228 243.488 355.964C243.488 355.7 243.223 355.383 242.787 355.132L231.749 348.764C231.22 348.46 230.506 348.289 229.805 348.289C229.237 348.289 228.735 348.407 228.365 348.606L203.142 363.164C202.983 363.257 202.719 363.442 202.719 363.706C202.719 363.97 202.983 364.287 203.419 364.538L214.458 370.906C214.986 371.21 215.7 371.382 216.401 371.382Z",
    fill: "#AFB6E5"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M216.851 369.268L239.549 356.176C239.999 355.911 239.946 355.449 239.417 355.158L230.89 350.244C230.362 349.94 229.569 349.913 229.119 350.164L206.421 363.257C205.972 363.521 206.025 363.983 206.553 364.274L215.08 369.189C215.609 369.492 216.402 369.519 216.851 369.268Z",
    fill: "#858FD6"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M215.542 368.607C215.727 368.713 216.031 368.713 216.216 368.607L217.671 367.762C217.856 367.656 217.856 367.484 217.671 367.379C217.485 367.273 217.181 367.273 216.996 367.379L215.542 368.224C215.357 368.33 215.357 368.501 215.542 368.607ZM218.027 367.167C218.213 367.273 218.517 367.273 218.702 367.167L219.389 366.771C219.574 366.665 219.574 366.493 219.389 366.388C219.204 366.282 218.9 366.282 218.715 366.388L218.027 366.784C217.842 366.89 217.842 367.061 218.027 367.167ZM219.746 366.176C219.931 366.282 220.235 366.282 220.42 366.176L221.108 365.78C221.293 365.674 221.293 365.503 221.108 365.397C220.923 365.291 220.619 365.291 220.433 365.397L219.746 365.793C219.561 365.899 219.561 366.071 219.746 366.176ZM221.465 365.185C221.65 365.291 221.954 365.291 222.139 365.185L222.826 364.789C223.011 364.683 223.011 364.512 222.826 364.406C222.641 364.3 222.337 364.3 222.152 364.406L221.465 364.802C221.279 364.908 221.279 365.08 221.465 365.185ZM223.183 364.195C223.368 364.3 223.672 364.3 223.857 364.195L224.545 363.798C224.73 363.693 224.73 363.521 224.545 363.415C224.36 363.309 224.056 363.309 223.87 363.415L223.183 363.812C222.998 363.917 222.998 364.089 223.183 364.195ZM224.902 363.204C225.087 363.309 225.391 363.309 225.576 363.204L226.263 362.807C226.448 362.702 226.448 362.53 226.263 362.424C226.078 362.319 225.774 362.319 225.589 362.424L224.902 362.821C224.717 362.926 224.717 363.098 224.902 363.204ZM226.62 362.213C226.805 362.319 227.109 362.319 227.294 362.213L227.982 361.817C228.167 361.711 228.167 361.539 227.982 361.433C227.797 361.328 227.493 361.328 227.308 361.433L226.62 361.83C226.435 361.936 226.435 362.107 226.62 362.213ZM228.339 361.222C228.524 361.328 228.828 361.328 229.013 361.222L229.7 360.826C229.885 360.72 229.885 360.548 229.7 360.443C229.515 360.337 229.211 360.337 229.026 360.443L228.339 360.839C228.154 360.945 228.154 361.116 228.339 361.222ZM230.057 360.231C230.242 360.337 230.546 360.337 230.731 360.231L231.419 359.835C231.604 359.729 231.604 359.558 231.419 359.452C231.234 359.346 230.93 359.346 230.745 359.452L230.057 359.848C229.872 359.954 229.872 360.126 230.057 360.231ZM231.776 359.24C231.961 359.346 232.265 359.346 232.45 359.24L233.137 358.844C233.322 358.738 233.322 358.567 233.137 358.461C232.952 358.355 232.648 358.355 232.463 358.461L231.776 358.857C231.591 358.963 231.591 359.135 231.776 359.24ZM233.494 358.25C233.679 358.355 233.983 358.355 234.168 358.25L234.856 357.853C235.041 357.748 235.041 357.576 234.856 357.47C234.671 357.364 234.367 357.364 234.182 357.47L233.494 357.866C233.309 357.972 233.309 358.144 233.494 358.25ZM235.213 357.259C235.398 357.364 235.702 357.364 235.887 357.259L236.574 356.862C236.759 356.757 236.759 356.585 236.574 356.479C236.389 356.374 236.085 356.374 235.9 356.479L235.213 356.876C235.028 356.981 235.028 357.153 235.213 357.259ZM236.971 356.242C237.156 356.347 237.46 356.347 237.645 356.242L238.333 355.845C238.518 355.739 238.518 355.568 238.333 355.462C238.148 355.356 237.843 355.356 237.658 355.462L236.971 355.858C236.786 355.964 236.786 356.136 236.971 356.242ZM213.916 367.748L214.511 368.092C214.723 368.211 215.066 368.211 215.265 368.092L215.859 367.748C216.071 367.63 216.071 367.431 215.859 367.312L215.265 366.969C215.053 366.85 214.709 366.85 214.511 366.969L213.916 367.312C213.705 367.431 213.705 367.63 213.916 367.748ZM216.243 365.965L215.648 366.308C215.436 366.427 215.436 366.625 215.648 366.744L216.243 367.088C216.454 367.207 216.798 367.207 216.996 367.088L217.591 366.744C217.803 366.625 217.803 366.427 217.591 366.308L216.996 365.965C216.785 365.846 216.441 365.846 216.243 365.965ZM217.367 365.754L217.961 366.097C218.173 366.216 218.517 366.216 218.715 366.097L219.31 365.754C219.521 365.635 219.521 365.436 219.31 365.318L218.715 364.974C218.503 364.855 218.16 364.855 217.961 364.974L217.367 365.318C217.155 365.436 217.155 365.635 217.367 365.754ZM219.085 364.763L219.68 365.106C219.891 365.225 220.235 365.225 220.433 365.106L221.028 364.763C221.24 364.644 221.24 364.446 221.028 364.327L220.433 363.983C220.222 363.864 219.878 363.864 219.68 363.983L219.085 364.327C218.874 364.446 218.874 364.644 219.085 364.763ZM222.76 363.323L222.165 362.979C221.954 362.86 221.61 362.86 221.412 362.979L220.817 363.323C220.605 363.442 220.605 363.64 220.817 363.759L221.412 364.102C221.623 364.221 221.967 364.221 222.165 364.102L222.76 363.759C222.972 363.64 222.972 363.442 222.76 363.323ZM224.479 362.332L223.884 361.988C223.672 361.869 223.328 361.869 223.13 361.988L222.535 362.332C222.324 362.451 222.324 362.649 222.535 362.768L223.13 363.111C223.342 363.23 223.685 363.23 223.884 363.111L224.479 362.768C224.69 362.649 224.69 362.451 224.479 362.332ZM226.197 361.341L225.602 360.998C225.391 360.879 225.047 360.879 224.849 360.998L224.254 361.341C224.042 361.46 224.042 361.658 224.254 361.777L224.849 362.12C225.06 362.239 225.404 362.239 225.602 362.12L226.197 361.777C226.409 361.658 226.409 361.46 226.197 361.341ZM227.916 360.35L227.321 360.007C227.109 359.888 226.766 359.888 226.567 360.007L225.972 360.35C225.761 360.469 225.761 360.667 225.972 360.786L226.567 361.13C226.779 361.249 227.122 361.249 227.321 361.13L227.916 360.786C228.127 360.667 228.127 360.469 227.916 360.35ZM229.634 359.359L229.039 359.016C228.828 358.897 228.484 358.897 228.286 359.016L227.691 359.359C227.479 359.478 227.479 359.676 227.691 359.795L228.286 360.139C228.497 360.258 228.841 360.258 229.039 360.139L229.634 359.795C229.846 359.676 229.846 359.478 229.634 359.359ZM231.353 358.369L230.758 358.025C230.546 357.906 230.203 357.906 230.004 358.025L229.409 358.369C229.198 358.487 229.198 358.686 229.409 358.804L230.004 359.148C230.216 359.267 230.56 359.267 230.758 359.148L231.353 358.804C231.564 358.686 231.564 358.487 231.353 358.369ZM231.128 357.814L231.723 358.157C231.934 358.276 232.278 358.276 232.476 358.157L233.071 357.814C233.283 357.695 233.283 357.497 233.071 357.378L232.476 357.034C232.265 356.915 231.921 356.915 231.723 357.034L231.128 357.378C230.916 357.497 230.916 357.695 231.128 357.814ZM234.803 356.374L234.208 356.03C233.997 355.911 233.653 355.911 233.455 356.03L232.86 356.374C232.648 356.493 232.648 356.691 232.86 356.81L233.455 357.153C233.666 357.272 234.01 357.272 234.208 357.153L234.803 356.81C235.015 356.691 235.015 356.493 234.803 356.374ZM237.328 354.92L236.733 354.577C236.522 354.458 236.178 354.458 235.98 354.577L234.618 355.356C234.406 355.475 234.406 355.673 234.618 355.792L235.213 356.136C235.424 356.255 235.768 356.255 235.966 356.136L237.328 355.356C237.539 355.237 237.539 355.039 237.328 354.92ZM212.277 366.85L212.872 367.194C213.083 367.312 213.427 367.312 213.625 367.194L214.987 366.414C215.199 366.295 215.199 366.097 214.987 365.978L214.392 365.635C214.181 365.516 213.837 365.516 213.639 365.635L212.277 366.414C212.065 366.533 212.065 366.731 212.277 366.85ZM214.762 365.41L215.357 365.754C215.569 365.872 215.912 365.872 216.111 365.754L216.706 365.41C216.917 365.291 216.917 365.093 216.706 364.974L216.111 364.631C215.899 364.512 215.555 364.512 215.357 364.631L214.762 364.974C214.551 365.093 214.551 365.291 214.762 365.41ZM216.494 363.97C216.283 364.089 216.283 364.287 216.494 364.406L217.089 364.75C217.3 364.868 217.644 364.868 217.842 364.75L218.437 364.406C218.649 364.287 218.649 364.089 218.437 363.97L217.842 363.627C217.631 363.508 217.287 363.508 217.089 363.627L216.494 363.97ZM218.213 362.979C218.001 363.098 218.001 363.296 218.213 363.415L218.807 363.759C219.019 363.878 219.363 363.878 219.561 363.759L220.156 363.415C220.367 363.296 220.367 363.098 220.156 362.979L219.561 362.636C219.349 362.517 219.006 362.517 218.807 362.636L218.213 362.979ZM221.293 362.768L221.888 362.424C222.099 362.305 222.099 362.107 221.888 361.988L221.293 361.645C221.081 361.526 220.737 361.526 220.539 361.645L219.944 361.988C219.733 362.107 219.733 362.305 219.944 362.424L220.539 362.768C220.751 362.887 221.094 362.887 221.293 362.768ZM222.985 361.79L223.659 361.407C223.844 361.301 223.844 361.116 223.659 361.011L222.998 360.628C222.813 360.522 222.496 360.522 222.311 360.628L221.636 361.011C221.451 361.116 221.451 361.301 221.636 361.407L222.297 361.79C222.482 361.896 222.8 361.896 222.985 361.79ZM224.703 360.799L225.378 360.416C225.563 360.311 225.563 360.126 225.378 360.02L224.717 359.637C224.531 359.531 224.214 359.531 224.029 359.637L223.355 360.02C223.17 360.126 223.17 360.311 223.355 360.416L224.016 360.799C224.201 360.905 224.518 360.905 224.703 360.799ZM226.422 359.809L227.096 359.425C227.281 359.32 227.281 359.135 227.096 359.029L226.435 358.646C226.25 358.54 225.933 358.54 225.748 358.646L225.073 359.029C224.888 359.135 224.888 359.32 225.073 359.425L225.734 359.809C225.92 359.914 226.237 359.914 226.422 359.809ZM228.14 358.818L228.815 358.435C229 358.329 229 358.144 228.815 358.038L228.154 357.655C227.969 357.549 227.651 357.549 227.466 357.655L226.792 358.038C226.607 358.144 226.607 358.329 226.792 358.435L227.453 358.818C227.638 358.923 227.955 358.923 228.14 358.818ZM229.859 357.827L230.533 357.444C230.718 357.338 230.718 357.153 230.533 357.047L229.872 356.664C229.687 356.559 229.37 356.559 229.185 356.664L228.511 357.047C228.325 357.153 228.325 357.338 228.511 357.444L229.172 357.827C229.357 357.933 229.674 357.933 229.859 357.827ZM230.903 355.66L230.229 356.043C230.044 356.149 230.044 356.334 230.229 356.44L230.89 356.823C231.075 356.928 231.392 356.928 231.577 356.823L232.252 356.44C232.437 356.334 232.437 356.149 232.252 356.043L231.591 355.66C231.406 355.555 231.088 355.555 230.903 355.66ZM232.622 354.669L231.948 355.052C231.763 355.158 231.763 355.343 231.948 355.449L232.609 355.832C232.794 355.938 233.111 355.938 233.296 355.832L233.97 355.449C234.155 355.343 234.155 355.158 233.97 355.052L233.309 354.669C233.124 354.564 232.807 354.564 232.622 354.669ZM235.742 354.035L235.081 353.652C234.896 353.546 234.578 353.546 234.393 353.652L233.719 354.035C233.534 354.141 233.534 354.326 233.719 354.432L234.38 354.815C234.565 354.92 234.882 354.92 235.067 354.815L235.742 354.432C235.927 354.326 235.927 354.141 235.742 354.035ZM210.611 365.925L211.272 366.308C211.457 366.414 211.775 366.414 211.96 366.308L214.128 365.067C214.313 364.961 214.313 364.776 214.128 364.67L213.467 364.287C213.282 364.181 212.964 364.181 212.779 364.287L210.611 365.529C210.426 365.635 210.426 365.82 210.611 365.925ZM213.824 364.063L214.485 364.446C214.67 364.551 214.987 364.551 215.172 364.446L215.846 364.063C216.031 363.957 216.031 363.772 215.846 363.666L215.185 363.283C215 363.177 214.683 363.177 214.498 363.283L213.824 363.666C213.639 363.772 213.639 363.957 213.824 364.063ZM215.542 363.072L216.203 363.455C216.388 363.56 216.706 363.56 216.891 363.455L217.565 363.072C217.75 362.966 217.75 362.781 217.565 362.675L216.904 362.292C216.719 362.187 216.401 362.187 216.216 362.292L215.542 362.675C215.357 362.781 215.357 362.966 215.542 363.072ZM217.261 362.081L217.922 362.464C218.107 362.57 218.424 362.57 218.609 362.464L219.283 362.081C219.468 361.975 219.468 361.79 219.283 361.685L218.622 361.301C218.437 361.196 218.12 361.196 217.935 361.301L217.261 361.685C217.076 361.79 217.076 361.975 217.261 362.081ZM219.653 360.297L218.979 360.68C218.794 360.786 218.794 360.971 218.979 361.077L219.64 361.46C219.825 361.566 220.143 361.566 220.328 361.46L221.002 361.077C221.187 360.971 221.187 360.786 221.002 360.68L220.341 360.297C220.156 360.192 219.839 360.192 219.653 360.297ZM221.385 359.306L220.711 359.69C220.526 359.795 220.526 359.98 220.711 360.086L221.372 360.469C221.557 360.575 221.874 360.575 222.059 360.469L222.734 360.086C222.919 359.98 222.919 359.795 222.734 359.69L222.073 359.306C221.888 359.201 221.57 359.201 221.385 359.306ZM223.117 358.316L222.443 358.699C222.258 358.804 222.258 358.989 222.443 359.095L223.104 359.478C223.289 359.584 223.606 359.584 223.791 359.478L224.465 359.095C224.65 358.989 224.65 358.804 224.465 358.699L223.804 358.316C223.619 358.21 223.302 358.21 223.117 358.316ZM224.849 357.325L224.175 357.708C223.989 357.814 223.989 357.999 224.175 358.104L224.836 358.487C225.021 358.593 225.338 358.593 225.523 358.487L226.197 358.104C226.382 357.999 226.382 357.814 226.197 357.708L225.536 357.325C225.351 357.219 225.034 357.219 224.849 357.325ZM226.567 356.334L225.893 356.717C225.708 356.823 225.708 357.008 225.893 357.113L226.554 357.497C226.739 357.602 227.056 357.602 227.241 357.497L227.916 357.113C228.101 357.008 228.101 356.823 227.916 356.717L227.255 356.334C227.07 356.228 226.752 356.228 226.567 356.334ZM228.286 355.343L227.612 355.726C227.427 355.832 227.427 356.017 227.612 356.123L228.273 356.506C228.458 356.611 228.775 356.611 228.96 356.506L229.634 356.123C229.819 356.017 229.819 355.832 229.634 355.726L228.973 355.343C228.788 355.237 228.471 355.237 228.286 355.343ZM229.343 355.132L230.004 355.515C230.189 355.621 230.507 355.621 230.692 355.515L231.366 355.132C231.551 355.026 231.551 354.841 231.366 354.735L230.705 354.352C230.52 354.247 230.203 354.247 230.018 354.352L229.343 354.735C229.158 354.841 229.158 355.026 229.343 355.132ZM234.129 353.137L233.468 352.754C233.283 352.648 232.966 352.648 232.78 352.754L231.075 353.731C230.89 353.837 230.89 354.022 231.075 354.128L231.736 354.511C231.921 354.617 232.238 354.617 232.424 354.511L234.129 353.533C234.314 353.428 234.314 353.243 234.129 353.137ZM209.012 365.027L209.593 365.357C209.805 365.476 210.149 365.476 210.373 365.357L213.44 363.587C213.652 363.468 213.652 363.257 213.44 363.138L212.859 362.807C212.647 362.689 212.303 362.689 212.079 362.807L209.012 364.578C208.8 364.697 208.8 364.908 209.012 365.027ZM213.229 362.596L213.81 362.926C214.022 363.045 214.366 363.045 214.59 362.926L215.172 362.596C215.384 362.477 215.384 362.266 215.172 362.147L214.59 361.817C214.379 361.698 214.035 361.698 213.81 361.817L213.229 362.147C213.017 362.266 213.017 362.477 213.229 362.596ZM214.947 361.605L215.529 361.936C215.741 362.054 216.084 362.054 216.309 361.936L216.891 361.605C217.102 361.486 217.102 361.275 216.891 361.156L216.309 360.826C216.097 360.707 215.754 360.707 215.529 360.826L214.947 361.156C214.736 361.275 214.736 361.486 214.947 361.605ZM216.666 360.614L217.248 360.945C217.459 361.064 217.803 361.064 218.027 360.945L218.609 360.614C218.821 360.496 218.821 360.284 218.609 360.165L218.027 359.835C217.816 359.716 217.472 359.716 217.248 359.835L216.666 360.165C216.454 360.284 216.454 360.496 216.666 360.614ZM218.384 359.624L218.966 359.954C219.178 360.073 219.521 360.073 219.746 359.954L220.328 359.624C220.539 359.505 220.539 359.293 220.328 359.174L219.746 358.844C219.535 358.725 219.191 358.725 218.966 358.844L218.384 359.174C218.173 359.293 218.173 359.505 218.384 359.624ZM220.103 358.633L220.685 358.963C220.896 359.082 221.24 359.082 221.465 358.963L222.046 358.633C222.258 358.514 222.258 358.302 222.046 358.184L221.465 357.853C221.253 357.734 220.909 357.734 220.685 357.853L220.103 358.184C219.891 358.302 219.891 358.514 220.103 358.633ZM221.821 357.642L222.403 357.972C222.615 358.091 222.958 358.091 223.183 357.972L223.765 357.642C223.976 357.523 223.976 357.312 223.765 357.193L223.183 356.862C222.972 356.744 222.628 356.744 222.403 356.862L221.821 357.193C221.61 357.312 221.61 357.523 221.821 357.642ZM223.54 356.651L224.122 356.981C224.333 357.1 224.677 357.1 224.902 356.981L225.483 356.651C225.695 356.532 225.695 356.321 225.483 356.202L224.902 355.872C224.69 355.753 224.346 355.753 224.122 355.872L223.54 356.202C223.328 356.321 223.328 356.532 223.54 356.651ZM225.259 355.66L225.84 355.991C226.052 356.109 226.395 356.109 226.62 355.991L227.202 355.66C227.413 355.541 227.413 355.33 227.202 355.211L226.62 354.881C226.409 354.762 226.065 354.762 225.84 354.881L225.259 355.211C225.047 355.33 225.047 355.541 225.259 355.66ZM226.977 354.669L227.559 355C227.77 355.119 228.114 355.119 228.339 355L228.92 354.669C229.132 354.55 229.132 354.339 228.92 354.22L228.339 353.89C228.127 353.771 227.783 353.771 227.559 353.89L226.977 354.22C226.766 354.339 226.766 354.55 226.977 354.669ZM228.696 353.679L229.277 354.009C229.489 354.128 229.832 354.128 230.057 354.009L230.639 353.679C230.85 353.56 230.85 353.348 230.639 353.229L230.057 352.899C229.846 352.78 229.502 352.78 229.277 352.899L228.696 353.229C228.484 353.348 228.484 353.56 228.696 353.679ZM232.397 352.212L231.815 351.882C231.604 351.763 231.26 351.763 231.035 351.882L230.454 352.212C230.242 352.331 230.242 352.542 230.454 352.661L231.035 352.992C231.247 353.11 231.591 353.11 231.815 352.992L232.397 352.661C232.609 352.542 232.609 352.331 232.397 352.212ZM210.056 363.257L209.474 362.926C209.263 362.807 208.919 362.807 208.695 362.926L207.346 363.706C207.135 363.825 207.135 364.036 207.346 364.155L207.928 364.485C208.139 364.604 208.483 364.604 208.708 364.485L210.056 363.706C210.268 363.587 210.268 363.376 210.056 363.257ZM211.775 362.266L211.193 361.936C210.981 361.817 210.638 361.817 210.413 361.936L209.831 362.266C209.62 362.385 209.62 362.596 209.831 362.715L210.413 363.045C210.625 363.164 210.968 363.164 211.193 363.045L211.775 362.715C211.986 362.596 211.986 362.385 211.775 362.266ZM213.493 361.275L212.912 360.945C212.7 360.826 212.356 360.826 212.132 360.945L211.55 361.275C211.338 361.394 211.338 361.605 211.55 361.724L212.132 362.054C212.343 362.173 212.687 362.173 212.912 362.054L213.493 361.724C213.705 361.605 213.705 361.394 213.493 361.275ZM225.563 354.313L224.981 353.982C224.769 353.863 224.426 353.863 224.201 353.982L213.268 360.284C213.057 360.403 213.057 360.614 213.268 360.733L213.85 361.064C214.062 361.182 214.405 361.182 214.63 361.064L225.563 354.762C225.774 354.643 225.774 354.432 225.563 354.313ZM227.281 353.322L226.699 352.992C226.488 352.873 226.144 352.873 225.92 352.992L225.338 353.322C225.126 353.441 225.126 353.652 225.338 353.771L225.92 354.101C226.131 354.22 226.475 354.22 226.699 354.101L227.281 353.771C227.493 353.652 227.493 353.441 227.281 353.322ZM229 352.331L228.418 352.001C228.206 351.882 227.863 351.882 227.638 352.001L227.056 352.331C226.845 352.45 226.845 352.661 227.056 352.78L227.638 353.11C227.85 353.229 228.193 353.229 228.418 353.11L229 352.78C229.211 352.661 229.211 352.45 229 352.331ZM230.758 351.314L230.176 350.983C229.965 350.865 229.621 350.865 229.396 350.983L228.815 351.314C228.603 351.433 228.603 351.644 228.815 351.763L229.396 352.093C229.608 352.212 229.951 352.212 230.176 352.093L230.758 351.763C230.969 351.644 230.969 351.433 230.758 351.314Z",
    fill: "#E5E9FF"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.15
  }, _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.09,
    d: "M236.787 362.9L227.348 368.422C227.348 368.422 227.282 368.462 227.269 368.462C226.528 368.898 226.198 369.585 226.238 370.324C226.277 371.064 226.846 371.923 227.652 372.399L235.293 379.744C236.02 380.167 236.959 380.378 237.844 380.325C238.545 380.325 239.338 380.074 239.84 379.784L253.84 371.579C254.554 371.17 254.964 370.523 254.95 369.809C254.95 369.03 254.461 368.29 253.602 367.801L241.268 363.058C241.03 362.926 240.7 362.781 240.435 362.688C239.933 362.517 239.378 362.424 238.809 362.411C238.043 362.411 237.342 362.569 236.787 362.886V362.9Z",
    fill: "#9FA5D0"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M236.853 362.913L227.415 368.449C227.415 368.449 227.349 368.488 227.335 368.488C226.595 368.924 226.357 369.611 226.436 370.351C226.516 371.025 227.137 371.949 227.864 372.372L235.36 379.652C236.113 380.088 237.105 380.286 237.99 380.193C238.625 380.193 239.484 379.876 239.947 379.612L253.801 371.421C254.488 371.025 254.872 370.417 254.858 369.73C254.858 368.99 254.382 368.29 253.563 367.814L241.295 363.098C241.084 362.979 240.7 362.821 240.462 362.741C239.96 362.57 239.418 362.464 238.85 362.451C238.096 362.451 237.395 362.596 236.853 362.913Z",
    fill: "#8F95BB"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.27,
    d: "M236.904 362.926L227.452 368.462C227.452 368.462 227.386 368.501 227.373 368.501C226.632 368.95 226.355 369.664 226.606 370.364C226.606 370.958 227.399 371.976 228.047 372.346L235.41 379.559C236.19 380.008 237.234 380.193 238.12 380.048C238.689 380.048 239.627 379.651 240.024 379.414L253.732 371.236C254.38 370.853 254.75 370.271 254.737 369.637C254.737 368.937 254.274 368.277 253.494 367.827L241.306 363.137C241.121 363.032 240.685 362.86 240.473 362.781C239.984 362.609 239.429 362.49 238.874 362.477C238.12 362.464 237.433 362.609 236.891 362.913L236.904 362.926Z",
    fill: "#7F84A7"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.36,
    d: "M236.961 362.926L227.509 368.462C227.509 368.462 227.443 368.501 227.43 368.514C226.676 368.964 226.465 369.703 226.808 370.377C226.808 370.906 227.694 371.989 228.263 372.319L235.48 379.466C236.287 379.929 237.384 380.101 238.256 379.916C238.746 379.916 239.777 379.44 240.12 379.229L253.684 371.051C254.305 370.694 254.649 370.139 254.635 369.532C254.635 368.871 254.199 368.25 253.446 367.827L241.337 363.177C241.178 363.085 240.689 362.9 240.504 362.82C240.015 362.635 239.473 362.517 238.917 362.49C238.177 362.464 237.49 362.609 236.961 362.913V362.926Z",
    fill: "#6F7492"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M237.012 362.939L227.547 368.475C227.547 368.475 227.48 368.514 227.467 368.528C226.714 368.99 226.542 369.73 226.978 370.39C226.978 370.839 227.956 372.002 228.446 372.279L235.531 379.374C236.364 379.849 237.514 380.008 238.387 379.783C238.81 379.783 239.907 379.229 240.211 379.057L253.642 370.892C254.237 370.549 254.554 370.034 254.541 369.465C254.528 368.858 254.118 368.263 253.404 367.854L241.361 363.23C241.216 363.151 240.687 362.939 240.528 362.886C240.039 362.701 239.51 362.569 238.955 362.543C238.228 362.516 237.527 362.649 237.012 362.952V362.939Z",
    fill: "#5F637D"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.55,
    d: "M237.067 362.952L227.602 368.501C227.602 368.501 227.536 368.541 227.523 368.554C226.769 369.016 226.65 369.769 227.166 370.417C227.166 370.787 228.237 372.029 228.633 372.266L235.573 379.295C236.433 379.783 237.636 379.929 238.508 379.651C238.865 379.651 240.042 379.017 240.293 378.872L253.578 370.721C254.147 370.39 254.438 369.902 254.424 369.373C254.411 368.805 254.028 368.25 253.34 367.867L241.377 363.27C241.258 363.203 240.676 362.979 240.544 362.926C240.068 362.741 239.539 362.596 238.984 362.569C238.257 362.53 237.569 362.662 237.054 362.966L237.067 362.952Z",
    fill: "#505368"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.64,
    d: "M237.117 362.952L227.638 368.501C227.638 368.501 227.572 368.541 227.559 368.554C226.806 369.03 226.74 369.796 227.348 370.417C227.348 370.721 228.511 372.042 228.828 372.227L235.636 379.189C236.522 379.691 237.778 379.823 238.65 379.506C238.928 379.506 240.184 378.793 240.395 378.687L253.535 370.536C254.077 370.232 254.342 369.769 254.329 369.281C254.302 368.752 253.945 368.237 253.298 367.867L241.413 363.296C241.321 363.243 240.686 363.005 240.58 362.966C240.104 362.781 239.576 362.622 239.034 362.583C238.32 362.543 237.632 362.662 237.13 362.966L237.117 362.952Z",
    fill: "#404253"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.73,
    d: "M237.17 362.966L227.691 368.514C227.691 368.514 227.625 368.554 227.612 368.567C226.858 369.043 226.845 369.822 227.532 370.43C227.532 370.655 228.788 372.055 229.026 372.2L235.689 379.097C236.601 379.625 237.923 379.731 238.782 379.374C238.994 379.374 240.329 378.595 240.488 378.502L253.482 370.364C253.985 370.073 254.236 369.651 254.223 369.201C254.196 368.713 253.852 368.237 253.244 367.894L241.426 363.349C241.36 363.309 240.686 363.045 240.607 363.019C240.144 362.82 239.615 362.662 239.073 362.622C238.372 362.569 237.685 362.702 237.183 362.979L237.17 362.966Z",
    fill: "#30323E"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.82,
    d: "M237.221 362.979L227.73 368.541C227.73 368.541 227.664 368.581 227.651 368.594C226.897 369.083 226.923 369.875 227.703 370.457C227.703 370.602 229.052 372.082 229.21 372.174L235.741 379.004C236.679 379.546 238.054 379.638 238.914 379.229C239.059 379.229 240.473 378.37 240.566 378.304L253.415 370.179C253.891 369.902 254.116 369.519 254.09 369.096C254.063 368.66 253.746 368.224 253.177 367.88L241.438 363.362C241.438 363.362 240.672 363.058 240.619 363.032C240.156 362.834 239.641 362.662 239.099 362.622C238.398 362.57 237.724 362.688 237.235 362.966L237.221 362.979Z",
    fill: "#20212A"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.91,
    d: "M237.272 362.992L227.781 368.554C227.781 368.554 227.715 368.594 227.688 368.607C226.935 369.096 227.014 369.902 227.873 370.47C227.873 370.549 229.301 372.108 229.394 372.148L235.779 378.912C236.73 379.467 238.171 379.546 239.017 379.097C239.083 379.097 240.577 378.159 240.63 378.132L253.347 370.007C253.797 369.743 254.008 369.387 253.969 369.017C253.942 368.62 253.638 368.224 253.109 367.907L241.45 363.428C241.45 363.428 240.657 363.124 240.63 363.111C240.167 362.913 239.665 362.728 239.123 362.675C238.436 362.622 237.761 362.728 237.272 363.006V362.992Z",
    fill: "#101115"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M239.166 378.951L253.311 369.822C254.157 369.334 254.051 368.475 253.073 367.907L240.66 363.138C239.681 362.569 238.188 362.503 237.342 363.005L227.837 368.567C226.991 369.056 227.097 369.915 228.075 370.483L235.848 378.819C236.826 379.387 238.32 379.453 239.166 378.951Z",
    fill: "black"
  }))), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M239.165 378.925L253.31 370.721C253.693 370.496 253.878 370.206 253.878 369.902V367.92C253.878 367.55 253.6 368.197 253.058 367.894L240.645 363.124C239.667 362.556 238.173 362.49 237.327 362.992L227.822 368.554C227.532 368.713 227.333 368.026 227.254 368.237C227.227 368.316 227.254 370.206 227.254 370.285C227.254 370.668 227.518 371.064 228.074 371.381L235.847 378.793C236.825 379.361 238.319 379.427 239.165 378.925Z",
    fill: "#858FD6"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M239.166 376.97L253.311 368.765C254.157 368.277 254.051 367.418 253.073 366.85L240.66 362.081C239.681 361.513 238.188 361.447 237.342 361.949L227.837 367.51C226.991 367.999 227.097 368.858 228.075 369.426L235.848 376.838C236.826 377.406 238.32 377.472 239.166 376.97Z",
    fill: "#CED3F4"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M228.06 369.241L235.833 376.653C236.812 377.221 238.305 377.287 239.151 376.785L253.296 368.581C253.653 368.383 253.838 368.105 253.865 367.828C253.904 368.171 253.719 368.515 253.296 368.766L239.151 377.036C238.305 377.525 236.812 377.472 235.833 376.904L228.06 369.426C227.479 369.096 227.214 368.66 227.254 368.264C227.294 368.607 227.571 368.964 228.06 369.254V369.241Z",
    fill: "#CED3F4"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M225.031 382.32L262.562 360.641C264.478 359.531 266.038 356.558 266.038 354.009V325.327C266.038 322.764 264.478 321.602 262.562 322.698L225.031 344.378C223.115 345.488 221.555 348.46 221.555 351.01V379.691C221.555 382.254 223.115 383.43 225.031 382.32Z",
    fill: "url(#paint114_linear_2253_1261)"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M223.435 343.453L260.965 321.774C261.719 321.338 262.433 321.258 263.001 321.47C263.067 321.496 264.654 322.421 264.72 322.461C264.125 322.17 263.371 322.223 262.552 322.698L225.022 344.378C223.105 345.488 221.545 348.46 221.545 351.01V379.691C221.545 381.29 222.153 382.347 223.078 382.651C222.999 382.651 222.906 382.624 222.774 382.545C222.735 382.518 221.069 381.528 221.016 381.488C220.355 381.026 219.945 380.074 219.945 378.767V350.085C219.945 347.522 221.505 344.563 223.422 343.453H223.435Z",
    fill: "url(#paint115_linear_2253_1261)"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M223.461 343.466L260.991 321.787C261.745 321.351 262.459 321.272 263.027 321.483C263.093 321.509 264.653 322.408 264.719 322.447C264.124 322.157 263.371 322.21 262.551 322.685L225.021 344.365C223.104 345.474 221.544 348.447 221.544 350.997V379.678C221.544 381.277 222.152 382.333 223.078 382.637C222.998 382.637 222.906 382.611 222.774 382.532C222.734 382.505 221.095 381.528 221.055 381.501C220.394 381.039 219.984 380.088 219.984 378.78V350.098C219.984 347.535 221.544 344.576 223.461 343.466Z",
    fill: "url(#paint116_linear_2253_1261)"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M223.5 343.493L261.03 321.813C261.784 321.377 262.498 321.298 263.066 321.509C263.132 321.536 264.666 322.421 264.732 322.46C264.137 322.17 263.383 322.223 262.564 322.698L225.034 344.378C223.117 345.488 221.557 348.46 221.557 351.01V379.691C221.557 381.29 222.165 382.347 223.09 382.65C223.011 382.65 222.919 382.624 222.786 382.545C222.747 382.518 221.134 381.554 221.094 381.528C220.433 381.065 220.023 380.114 220.023 378.806V350.125C220.023 347.562 221.583 344.602 223.5 343.493Z",
    fill: "url(#paint117_linear_2253_1261)"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M223.531 343.506L261.062 321.827C261.815 321.391 262.529 321.311 263.097 321.523C263.163 321.549 264.67 322.408 264.737 322.447C264.142 322.157 263.388 322.21 262.569 322.685L225.038 344.365C223.122 345.475 221.562 348.447 221.562 350.997V379.678C221.562 381.277 222.17 382.334 223.095 382.637C223.016 382.637 222.923 382.611 222.791 382.532C222.751 382.505 221.165 381.567 221.125 381.541C220.464 381.079 220.055 380.127 220.055 378.819V350.138C220.055 347.575 221.615 344.616 223.531 343.506Z",
    fill: "url(#paint118_linear_2253_1261)"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M223.555 343.532L261.085 321.853C261.838 321.417 262.552 321.338 263.121 321.549C263.187 321.575 264.654 322.421 264.734 322.461C264.139 322.17 263.385 322.223 262.566 322.698L225.035 344.378C223.119 345.488 221.559 348.46 221.559 351.01V379.691C221.559 381.29 222.167 382.347 223.092 382.651C223.013 382.651 222.92 382.624 222.788 382.545C222.748 382.519 221.202 381.594 221.149 381.567C220.488 381.105 220.078 380.154 220.078 378.846V350.164C220.078 347.601 221.638 344.642 223.555 343.532Z",
    fill: "url(#paint119_linear_2253_1261)"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M223.578 343.546L261.108 321.866C261.862 321.43 262.576 321.351 263.144 321.562C263.21 321.589 264.651 322.408 264.717 322.447C264.122 322.157 263.369 322.21 262.549 322.685L225.019 344.365C223.102 345.474 221.542 348.447 221.542 350.997V379.678C221.542 381.277 222.151 382.334 223.076 382.637C222.997 382.637 222.904 382.611 222.772 382.532C222.732 382.505 221.212 381.607 221.172 381.581C220.511 381.118 220.102 380.167 220.102 378.859V350.178C220.102 347.615 221.661 344.655 223.578 343.546Z",
    fill: "url(#paint120_linear_2253_1261)"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M223.617 343.559L261.147 321.879C261.901 321.443 262.615 321.364 263.183 321.575C263.249 321.602 264.664 322.408 264.73 322.447C264.135 322.157 263.382 322.21 262.562 322.685L225.032 344.365C223.115 345.474 221.555 348.447 221.555 350.997V379.678C221.555 381.277 222.163 382.334 223.089 382.637C223.009 382.637 222.917 382.611 222.785 382.532C222.745 382.505 221.251 381.62 221.211 381.594C220.55 381.131 220.141 380.18 220.141 378.872V350.191C220.141 347.628 221.701 344.669 223.617 343.559Z",
    fill: "url(#paint121_linear_2253_1261)"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M223.649 343.585L261.179 321.906C261.932 321.47 262.646 321.39 263.215 321.602C263.281 321.628 264.669 322.421 264.735 322.447C264.14 322.157 263.386 322.21 262.567 322.685L225.037 344.365C223.12 345.474 221.56 348.447 221.56 350.997V379.678C221.56 381.277 222.168 382.333 223.093 382.637C223.014 382.637 222.922 382.611 222.789 382.532C222.75 382.505 221.282 381.646 221.243 381.62C220.582 381.158 220.172 380.206 220.172 378.899V350.217C220.172 347.654 221.732 344.695 223.649 343.585Z",
    fill: "url(#paint122_linear_2253_1261)"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M223.672 343.598L261.202 321.919C261.956 321.483 262.67 321.404 263.238 321.615C263.304 321.641 264.666 322.408 264.732 322.447C264.137 322.157 263.383 322.209 262.564 322.685L225.034 344.365C223.117 345.474 221.557 348.447 221.557 350.997V379.678C221.557 381.277 222.165 382.333 223.09 382.637C223.011 382.637 222.919 382.611 222.786 382.532C222.747 382.505 221.306 381.66 221.266 381.633C220.605 381.171 220.195 380.22 220.195 378.912V350.23C220.195 347.667 221.755 344.708 223.672 343.598Z",
    fill: "url(#paint123_linear_2253_1261)"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M223.703 343.625L261.233 321.945C261.987 321.509 262.701 321.43 263.269 321.641C263.335 321.668 264.657 322.421 264.737 322.447C264.142 322.157 263.388 322.209 262.569 322.685L225.038 344.365C223.122 345.474 221.562 348.447 221.562 350.997V379.678C221.562 381.276 222.17 382.333 223.095 382.637C223.016 382.637 222.923 382.611 222.791 382.532C222.751 382.505 221.35 381.686 221.297 381.646C220.636 381.184 220.227 380.233 220.227 378.925V350.243C220.227 347.681 221.786 344.721 223.703 343.612V343.625Z",
    fill: "url(#paint124_linear_2253_1261)"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M223.727 343.638L261.257 321.959C262.01 321.523 262.724 321.443 263.293 321.655C263.359 321.681 264.654 322.408 264.72 322.447C264.125 322.157 263.372 322.21 262.552 322.685L225.022 344.365C223.105 345.474 221.546 348.447 221.546 350.997V379.678C221.546 381.277 222.154 382.334 223.079 382.637C223 382.637 222.907 382.611 222.775 382.532C222.735 382.505 221.36 381.699 221.321 381.673C220.66 381.211 220.25 380.259 220.25 378.952V350.27C220.25 347.707 221.81 344.748 223.727 343.638Z",
    fill: "url(#paint125_linear_2253_1261)"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M223.766 343.665L261.296 321.985C262.049 321.549 262.763 321.47 263.332 321.681C263.398 321.708 264.667 322.421 264.733 322.461C264.138 322.17 263.385 322.223 262.565 322.698L225.035 344.378C223.118 345.488 221.558 348.46 221.558 351.01V379.691C221.558 381.29 222.166 382.347 223.092 382.651C223.012 382.651 222.92 382.624 222.788 382.545C222.748 382.519 221.399 381.739 221.36 381.699C220.699 381.237 220.289 380.286 220.289 378.978V350.297C220.289 347.734 221.849 344.774 223.766 343.665Z",
    fill: "url(#paint126_linear_2253_1261)"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M223.789 343.678L261.319 321.998C262.073 321.562 262.787 321.483 263.355 321.694C263.421 321.721 264.664 322.408 264.73 322.447C264.135 322.157 263.382 322.21 262.562 322.685L225.032 344.365C223.115 345.474 221.555 348.447 221.555 350.997V379.678C221.555 381.277 222.163 382.334 223.089 382.637C223.009 382.637 222.917 382.611 222.785 382.532C222.745 382.505 221.423 381.739 221.383 381.713C220.722 381.25 220.312 380.299 220.312 378.991V350.31C220.312 347.747 221.872 344.787 223.789 343.678Z",
    fill: "url(#paint127_linear_2253_1261)"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M223.82 343.704L261.351 322.025C262.104 321.589 262.818 321.509 263.386 321.721C263.453 321.747 264.655 322.421 264.735 322.461C264.14 322.17 263.386 322.223 262.567 322.698L225.037 344.378C223.12 345.488 221.56 348.46 221.56 351.01V379.691C221.56 381.29 222.168 382.347 223.093 382.651C223.014 382.651 222.922 382.624 222.789 382.545C222.75 382.518 221.454 381.779 221.415 381.739C220.754 381.277 220.344 380.325 220.344 379.017V350.336C220.344 347.773 221.904 344.814 223.82 343.704Z",
    fill: "url(#paint128_linear_2253_1261)"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M223.842 343.717L261.372 322.038C262.125 321.602 262.839 321.523 263.407 321.734C263.474 321.76 264.65 322.408 264.716 322.447C264.121 322.157 263.368 322.209 262.548 322.685L225.018 344.365C223.101 345.474 221.541 348.447 221.541 350.997V379.678C221.541 381.277 222.149 382.333 223.075 382.637C222.995 382.637 222.903 382.611 222.771 382.532C222.731 382.505 221.475 381.779 221.422 381.752C220.761 381.29 220.352 380.339 220.352 379.031V350.349C220.352 347.786 221.911 344.827 223.828 343.717H223.842Z",
    fill: "url(#paint129_linear_2253_1261)"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M223.875 343.744L261.405 322.064C262.159 321.628 262.873 321.549 263.441 321.76C263.507 321.787 264.657 322.421 264.723 322.46C264.129 322.17 263.375 322.223 262.555 322.698L225.025 344.378C223.108 345.487 221.549 348.46 221.549 351.01V379.691C221.549 381.29 222.157 382.347 223.082 382.65C223.003 382.65 222.91 382.624 222.778 382.545C222.738 382.518 221.509 381.805 221.469 381.779C220.808 381.316 220.398 380.365 220.398 379.057V350.376C220.398 347.813 221.958 344.853 223.875 343.744Z",
    fill: "url(#paint130_linear_2253_1261)"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M223.914 343.757L261.444 322.078C262.198 321.642 262.912 321.562 263.48 321.774C263.546 321.8 264.67 322.408 264.736 322.447C264.141 322.157 263.388 322.21 262.568 322.685L225.038 344.365C223.121 345.474 221.561 348.447 221.561 350.997V379.678C221.561 381.277 222.169 382.334 223.095 382.637C223.015 382.637 222.923 382.611 222.791 382.532C222.751 382.505 221.548 381.818 221.508 381.792C220.847 381.33 220.438 380.378 220.438 379.07V350.389C220.438 347.826 221.997 344.867 223.914 343.757Z",
    fill: "url(#paint131_linear_2253_1261)"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M223.938 343.77L261.468 322.091C262.221 321.655 262.935 321.575 263.504 321.787C263.57 321.813 264.667 322.408 264.733 322.447C264.138 322.157 263.385 322.21 262.565 322.685L225.035 344.365C223.118 345.474 221.558 348.447 221.558 350.997V379.678C221.558 381.277 222.166 382.334 223.092 382.637C223.012 382.637 222.92 382.611 222.788 382.532C222.748 382.505 221.571 381.832 221.532 381.805C220.871 381.343 220.461 380.392 220.461 379.084V350.402C220.461 347.839 222.021 344.88 223.938 343.77Z",
    fill: "url(#paint132_linear_2253_1261)"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M223.961 343.797L261.491 322.117C262.245 321.681 262.959 321.602 263.527 321.813C263.593 321.84 264.651 322.408 264.73 322.447C264.135 322.157 263.382 322.21 262.562 322.685L225.032 344.365C223.115 345.474 221.555 348.447 221.555 350.997V379.678C221.555 381.277 222.163 382.334 223.089 382.637C223.009 382.637 222.917 382.611 222.785 382.532C222.745 382.505 221.595 381.858 221.555 381.831C220.894 381.369 220.484 380.418 220.484 379.11V350.429C220.484 347.866 222.044 344.906 223.961 343.797Z",
    fill: "url(#paint133_linear_2253_1261)"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M223.992 343.81L261.522 322.13C262.276 321.694 262.99 321.615 263.558 321.826C263.624 321.853 264.655 322.408 264.722 322.447C264.127 322.157 263.373 322.21 262.554 322.685L225.023 344.365C223.107 345.474 221.547 348.447 221.547 350.997V379.678C221.547 381.277 222.155 382.333 223.08 382.637C223.001 382.637 222.908 382.611 222.776 382.532C222.736 382.505 221.626 381.871 221.586 381.845C220.925 381.382 220.516 380.431 220.516 379.123V350.442C220.516 347.879 222.076 344.92 223.992 343.81Z",
    fill: "url(#paint134_linear_2253_1261)"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M224.031 343.836L261.562 322.157C262.315 321.721 263.029 321.641 263.597 321.853C263.663 321.879 264.668 322.421 264.734 322.447C264.139 322.157 263.386 322.209 262.566 322.685L225.036 344.365C223.119 345.474 221.559 348.447 221.559 350.997V379.678C221.559 381.277 222.167 382.333 223.093 382.637C223.014 382.637 222.921 382.611 222.789 382.532C222.749 382.505 221.665 381.897 221.625 381.871C220.964 381.409 220.555 380.457 220.555 379.15V350.468C220.555 347.905 222.115 344.946 224.031 343.836Z",
    fill: "url(#paint135_linear_2253_1261)"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M224.055 343.849L261.585 322.17C262.338 321.734 263.052 321.655 263.621 321.866C263.687 321.892 264.665 322.408 264.731 322.447C264.136 322.157 263.383 322.209 262.563 322.685L225.033 344.365C223.116 345.474 221.556 348.447 221.556 350.997V379.678C221.556 381.277 222.164 382.333 223.09 382.637C223.011 382.637 222.918 382.611 222.786 382.532C222.746 382.505 221.689 381.911 221.649 381.884C220.988 381.422 220.578 380.471 220.578 379.163V350.481C220.578 347.918 222.138 344.959 224.055 343.849Z",
    fill: "url(#paint136_linear_2253_1261)"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M211.458 352.516C211.458 352.516 212.291 352.899 213.441 352.912C214.591 352.926 215.107 352.41 216.72 352.569C218.385 352.728 220.606 355.039 219.416 356.308C218.584 357.193 216.825 356.519 215.477 356.532C214.895 356.532 213.772 356.849 213.19 356.915C211.26 357.127 209.211 355.026 209.211 355.026L211.445 352.516H211.458Z",
    fill: "#FFD4C0"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M198.555 319.092C196.493 318.484 194.021 321.919 193.016 328.551C192.012 335.183 187.953 343.638 189.328 346.135C190.703 348.632 210.453 356.308 210.453 356.308C210.453 356.308 210.506 355.304 211.312 353.982C212.119 352.661 212.581 352.595 212.581 352.595L197.511 342.528C197.511 342.528 201.636 334.972 202.971 328.511C204.16 322.765 202.059 320.109 198.569 319.092H198.555Z",
    fill: "url(#paint137_linear_2253_1261)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.01,
    d: "M465.257 498.446L512.358 530.14C513.284 530.682 513.786 531.58 514.064 532.491C514.592 534.196 513.773 536.336 512.015 537.353L461.477 565.77L450.029 571.623C446.063 573.935 440.656 573.591 436.703 571.266L390.078 539.771L427.688 518.501L442.824 509.94L465.257 498.446Z",
    fill: "#7C7DBD"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.02,
    d: "M465.397 498.83L510.449 530.153C511.361 530.682 511.797 531.58 512.062 532.465C512.577 534.13 511.705 536.244 509.986 537.234L459.99 565.348L448.674 570.936C444.814 573.182 439.368 572.733 435.521 570.474L390.984 539.335L428.224 518.276L443.215 509.795L465.397 498.83Z",
    fill: "#7B7CBC"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.02,
    d: "M465.547 499.199L508.536 530.14C509.422 530.655 509.805 531.554 510.07 532.412C510.572 534.037 509.647 536.138 507.981 537.102L458.527 564.912L447.343 570.236C443.589 572.416 438.103 571.874 434.362 569.668L391.914 538.873L428.77 518.025L443.602 509.636L465.547 499.199Z",
    fill: "#7B7BBC"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.03,
    d: "M465.692 499.569L506.619 530.14C507.478 530.642 507.809 531.527 508.06 532.373C508.549 533.945 507.558 536.032 505.945 536.983L457.046 564.476L445.995 569.536C442.346 571.663 436.82 571.002 433.172 568.862L392.812 538.41L429.298 517.788L443.985 509.491L465.692 499.596V499.569Z",
    fill: "#7A7ABB"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.03,
    d: "M465.836 499.939L504.715 530.14C505.548 530.629 505.825 531.514 506.077 532.333C506.552 533.865 505.508 535.94 503.935 536.851L455.578 564.04L444.646 568.835C441.103 570.896 435.537 570.13 431.995 568.056L393.711 537.948L429.813 517.536L444.342 509.319L465.81 499.952L465.836 499.939Z",
    fill: "#7979BA"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.04,
    d: "M465.978 500.322L502.795 530.14C503.601 530.615 503.826 531.501 504.064 532.293C504.526 533.773 503.429 535.834 501.909 536.732L454.107 563.617L443.307 568.148C439.857 570.156 434.265 569.271 430.828 567.25L394.633 537.485L430.352 517.285L444.735 509.161L465.965 500.322H465.978Z",
    fill: "#7878BA"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.04,
    d: "M466.128 500.692L500.895 530.14C501.675 530.602 501.847 531.488 502.085 532.254C502.535 533.694 501.385 535.742 499.904 536.6L452.644 563.168L441.976 567.435C438.632 569.377 433 568.386 429.669 566.431L395.562 537.01L430.911 517.035L445.136 508.989L466.128 500.679V500.692Z",
    fill: "#7777B9"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M466.275 501.062L498.98 530.14C499.734 530.589 499.853 531.474 500.078 532.214C500.514 533.615 499.311 535.649 497.87 536.481L451.166 562.745L440.63 566.748C437.391 568.637 431.72 567.541 428.494 565.638L396.477 536.561L431.442 516.797L445.508 508.844L466.262 501.075L466.275 501.062Z",
    fill: "#7676B8"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M466.417 501.432L497.073 530.127C497.814 530.563 497.867 531.448 498.091 532.161C498.514 533.509 497.245 535.53 495.87 536.336L449.708 562.296L439.304 566.021C436.171 567.845 430.46 566.642 427.341 564.806L397.398 536.085L431.994 516.532L445.914 508.672L466.431 501.432H466.417Z",
    fill: "#7575B7"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.06,
    d: "M466.562 501.802L495.156 530.127C495.87 530.55 495.87 531.435 496.081 532.122C496.491 533.43 495.169 535.438 493.834 536.217L448.227 561.86L437.942 565.321C434.915 567.078 429.164 565.77 426.15 564L398.297 535.623L432.509 516.281L446.27 508.5L466.549 501.789L466.562 501.802Z",
    fill: "#7474B7"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.06,
    d: "M466.71 502.185L493.254 530.127C493.942 530.536 493.889 531.421 494.1 532.082C494.497 533.337 493.122 535.332 491.827 536.085L446.761 561.424L436.609 564.621C433.687 566.325 427.897 564.898 424.976 563.194L399.211 535.16L433.053 516.044L446.669 508.355L466.71 502.172V502.185Z",
    fill: "#7473B6"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.07,
    d: "M466.852 502.555L491.334 530.127C491.995 530.51 491.889 531.408 492.088 532.056C492.471 533.271 491.043 535.253 489.801 535.979L445.291 561.015L435.27 563.947C432.454 565.586 426.625 564.053 423.809 562.402L400.133 534.711L433.591 515.806L447.049 508.196L466.852 502.555Z",
    fill: "#7372B5"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.07,
    d: "M466.999 502.925L489.432 530.127C490.067 530.497 489.908 531.395 490.107 532.016C490.477 533.192 488.996 535.16 487.793 535.86L443.825 560.592L433.937 563.26C431.227 564.846 425.358 563.208 422.648 561.609L401.047 534.262L434.135 515.568L447.447 508.051L467.012 502.938L466.999 502.925Z",
    fill: "#7271B5"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M467.146 503.295L487.517 530.114C488.126 530.47 487.914 531.355 488.099 531.963C488.456 533.086 486.923 535.041 485.759 535.715L442.346 560.129L432.59 562.534C429.986 564.053 424.077 562.309 421.473 560.777L401.961 533.773L434.666 515.291L447.819 507.866L467.146 503.282V503.295Z",
    fill: "#7170B4"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M467.294 503.665L485.603 530.114C486.184 530.457 485.92 531.342 486.105 531.923C486.435 533.007 484.849 534.949 483.752 535.596L440.881 559.707L431.244 561.847C428.746 563.3 422.797 561.45 420.298 559.984L402.875 533.337L435.21 515.079L448.218 507.734L467.307 503.678L467.294 503.665Z",
    fill: "#706FB3"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.09,
    d: "M467.436 504.048L483.695 530.127C484.264 530.457 483.933 531.342 484.105 531.897C484.423 532.927 482.783 534.856 481.726 535.477L439.41 559.284L429.905 561.16C427.499 562.56 421.524 560.592 419.131 559.191L403.797 532.888L435.748 514.841L448.598 507.588L467.449 504.074L467.436 504.048Z",
    fill: "#6F6EB3"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.09,
    d: "M467.58 504.418L481.778 530.114C482.32 530.431 481.937 531.316 482.109 531.844C482.413 532.835 480.721 534.751 479.703 535.345L437.929 558.835L428.556 560.446C426.256 561.781 420.241 559.707 417.954 558.372L404.695 532.412L436.277 514.577L448.981 507.404L467.594 504.418H467.58Z",
    fill: "#6E6DB2"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M467.725 504.788L479.874 530.114C480.39 530.417 479.953 531.303 480.112 531.805C480.403 532.756 478.658 534.658 477.68 535.213L436.448 558.399L427.208 559.746C425.013 561.028 418.959 558.848 416.764 557.553L405.594 531.937L436.792 514.326L449.337 507.245L467.712 504.788H467.725Z",
    fill: "#6D6CB1"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M467.873 505.158L477.959 530.114C478.448 530.404 477.959 531.289 478.105 531.765C478.382 532.663 476.584 534.553 475.659 535.094L434.983 557.976L425.861 559.046C423.772 560.261 417.678 557.976 415.59 556.747L406.508 531.474L437.336 514.075L449.722 507.073L467.846 505.145L467.873 505.158Z",
    fill: "#6D6CB1"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M468.015 505.528L476.052 530.1C476.515 530.378 475.973 531.263 476.118 531.712C476.383 532.571 474.532 534.447 473.646 534.962L433.512 557.527L424.522 558.333C422.54 559.482 416.406 557.091 414.423 555.928L407.43 530.999L437.874 513.811L450.115 506.902L468.001 505.514L468.015 505.528Z",
    fill: "#6C6BB0"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M468.16 505.911L474.135 530.113C474.571 530.378 473.976 531.263 474.108 531.686C474.359 532.491 472.443 534.354 471.61 534.843L432.031 557.104L423.174 557.645C421.296 558.742 415.123 556.232 413.246 555.135L408.328 530.563L438.402 513.586L450.485 506.769L468.133 505.911H468.16Z",
    fill: "#6B6AAF"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M468.312 506.281L472.238 530.114C472.648 530.365 472 531.25 472.132 531.646C472.37 532.412 470.4 534.262 469.62 534.724L430.583 556.681L421.858 556.959C420.087 557.989 413.874 555.373 412.102 554.343L409.273 530.114L438.964 513.362L450.902 506.624L468.312 506.294V506.281Z",
    fill: "#6A69AF"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M468.451 506.651L470.315 530.1C470.712 530.325 469.998 531.223 470.117 531.606C470.342 532.333 468.319 534.169 467.579 534.592L429.097 556.232H420.504C418.838 557.223 412.586 554.501 410.92 553.524L410.18 529.638L439.501 513.098L451.279 506.452L468.451 506.651Z",
    fill: "#6968AE"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.13,
    d: "M468.595 507.021L468.41 530.1C468.78 530.312 468.014 531.197 468.133 531.567C468.344 532.241 466.269 534.064 465.568 534.473L427.628 555.809L419.154 555.558C417.595 556.47 411.302 553.643 409.742 552.718L411.091 529.176L440.028 512.847L451.661 506.281L468.595 507.021Z",
    fill: "#6867AD"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.13,
    d: "M468.745 507.404L466.498 530.113C466.842 530.312 466.022 531.197 466.128 531.54C466.326 532.174 464.198 533.984 463.55 534.354L426.165 555.386L417.824 554.871C416.357 555.717 410.038 552.784 408.57 551.925L412.007 528.726L440.575 512.609L452.049 506.135L468.745 507.404Z",
    fill: "#6766AD"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.14,
    d: "M468.903 507.773L464.594 530.1C464.911 530.285 464.052 531.17 464.144 531.487C464.329 532.069 462.135 533.866 461.54 534.222L424.697 554.951L416.488 554.171C415.126 554.964 408.768 551.912 407.406 551.119L412.919 528.264L441.103 512.371L452.432 505.99L468.89 507.787L468.903 507.773Z",
    fill: "#6665AC"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.14,
    d: "M469.048 508.144L462.689 530.101C462.98 530.272 462.068 531.157 462.147 531.448C462.319 531.99 460.072 533.773 459.517 534.09L423.229 554.502L415.152 553.458C413.896 554.184 407.498 551.027 406.242 550.3L413.843 527.789L441.657 512.107L452.828 505.805L469.048 508.13V508.144Z",
    fill: "#6664AB"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M469.19 508.513L460.769 530.1C461.034 530.259 460.069 531.144 460.148 531.408C460.307 531.897 458.007 533.681 457.504 533.971L421.759 554.079L413.801 552.771C412.65 553.444 406.213 550.181 405.062 549.507L414.752 527.352L442.183 511.882L453.208 505.673L469.19 508.54V508.513Z",
    fill: "#6563AB"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M469.343 508.883L458.873 530.087C459.124 530.232 458.093 531.117 458.159 531.355C458.304 531.804 455.951 533.561 455.489 533.839L420.298 553.642L412.472 552.057C411.428 552.665 404.951 549.296 403.906 548.688L415.685 526.877L442.745 511.618L453.612 505.488L469.356 508.883H469.343Z",
    fill: "#6462AA"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M469.485 509.266L456.953 530.1C457.178 530.232 456.094 531.118 456.16 531.329C456.292 531.738 453.886 533.482 453.463 533.72L418.815 553.207L411.121 551.357C410.182 551.899 403.665 548.424 402.727 547.869L416.581 526.401L443.258 511.367L453.965 505.329L469.472 509.253L469.485 509.266Z",
    fill: "#6361A9"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M469.63 509.636L455.049 530.1C455.247 530.219 454.11 531.104 454.163 531.289C454.269 531.646 451.823 533.377 451.453 533.601L417.347 552.784L409.785 550.67C408.952 551.159 402.395 547.565 401.562 547.077L417.505 525.952L443.812 511.129L454.374 505.171L469.643 509.623L469.63 509.636Z",
    fill: "#6260A8"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.17,
    d: "M469.772 510.006L453.129 530.087C453.3 530.193 452.111 531.078 452.164 531.236C452.256 531.553 449.744 533.271 449.427 533.456L415.876 552.335L408.447 549.957C407.72 550.379 401.123 546.68 400.383 546.257L418.414 525.476L444.338 510.865L454.741 504.999L469.772 509.993V510.006Z",
    fill: "#615FA8"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.17,
    d: "M469.92 510.376L451.227 530.087C451.373 530.18 450.13 531.065 450.17 531.197C450.249 531.461 447.684 533.178 447.407 533.337L414.398 551.899L407.087 549.256C406.466 549.626 399.83 545.822 399.195 545.452L419.315 525.014L444.869 510.627L455.127 504.854L469.92 510.376Z",
    fill: "#605EA7"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M470.067 510.746L449.312 530.074C449.431 530.14 448.136 531.025 448.175 531.157C448.241 531.382 445.624 533.073 445.399 533.205L412.945 551.463L405.767 548.556C405.251 548.86 398.576 544.95 398.047 544.646L420.242 524.565L445.412 510.389L455.512 504.695L470.067 510.746Z",
    fill: "#5F5DA6"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M470.209 511.129L447.405 530.087C447.498 530.14 446.149 531.025 446.176 531.131C446.229 531.316 443.558 532.994 443.373 533.099L411.461 551.053L404.416 547.883C403.992 548.12 397.29 544.104 396.867 543.866L421.151 524.129L445.951 510.165L455.905 504.563L470.222 511.142L470.209 511.129Z",
    fill: "#5F5CA6"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.19,
    d: "M470.354 511.499L445.488 530.087C445.567 530.127 444.153 531.012 444.179 531.091C444.219 531.223 441.495 532.888 441.35 532.981L409.993 550.617L403.08 547.183C402.762 547.368 396.02 543.232 395.703 543.047L422.076 523.653L446.492 509.901L456.288 504.378L470.367 511.499H470.354Z",
    fill: "#5E5BA5"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.19,
    d: "M470.504 511.869L443.576 530.074C443.576 530.074 442.161 530.986 442.174 531.038C442.201 531.131 439.425 532.782 439.332 532.835L408.517 550.168L401.736 546.469C401.524 546.588 394.743 542.347 394.531 542.228L422.993 523.178L447.039 509.649L456.689 504.22L470.517 511.869H470.504Z",
    fill: "#5D5AA4"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M470.648 512.239L441.671 530.074C441.671 530.074 440.177 530.972 440.191 530.999C440.204 531.038 437.362 532.69 437.322 532.716L407.063 549.745L400.4 545.782C400.294 545.848 393.473 541.502 393.367 541.436L423.904 522.729L447.567 509.412L457.059 504.074L470.648 512.252V512.239Z",
    fill: "#5C59A4"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M470.796 512.609L438.184 530.959L405.584 549.309L392.18 540.616L424.805 522.266L457.444 503.903L470.796 512.609Z",
    fill: "#5B58A3"
  }))), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M401.326 547.063L391.57 541.132V536.997L401.326 542.942V547.063Z",
    fill: "url(#paint138_linear_2253_1261)"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M469.919 508.381L401.297 547.063V542.941L469.919 504.286V508.381Z",
    fill: "url(#paint139_linear_2253_1261)"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M401.322 543.681L391.5 537.882L391.632 499.437L413.682 512.463L401.322 543.681Z",
    fill: "#CED3F4"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M469.919 504.999L401.297 543.681L413.657 512.463L482.266 473.808L469.919 504.999Z",
    fill: "#AFB6E5"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M461.104 527.802L451.599 533.073L436.251 541.105C434.599 541.964 433.541 543.444 433.502 545.121C433.449 546.997 434.546 548.873 436.648 550.194L442.663 553.629C442.663 553.629 448.903 557.196 448.982 557.196C450.608 558.187 452.63 558.795 454.653 558.874C456.372 558.967 458.024 558.57 459.267 557.923L466.26 553.537L479.215 545.861C480.867 545.002 481.898 543.536 481.964 541.858C482.017 540.709 481.634 539.559 480.775 538.516C480.259 537.882 479.453 537.142 478.66 536.64C478.607 536.613 471.402 528.634 471.323 528.621C469.723 527.63 467.74 527.022 465.718 526.916C463.96 526.824 462.373 527.115 461.104 527.775V527.802Z",
    fill: "#ABB2E2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M460.923 528.198L451.709 533.509L436.573 541.237C435 542.056 433.876 543.496 433.797 545.082C433.691 546.918 434.696 548.781 436.811 550.115L442.72 553.484C442.839 553.55 448.788 556.932 448.933 556.945C450.546 557.897 452.529 558.465 454.512 558.517C456.151 558.61 457.803 558.108 458.98 557.487L465.775 553.114L478.545 545.782C480.118 544.963 481.175 543.549 481.321 541.964C481.426 540.814 481.083 539.652 480.171 538.582C479.668 537.987 478.769 537.129 478.003 536.653C477.897 536.587 470.97 528.991 470.838 528.964C469.278 528.013 467.348 527.445 465.391 527.339C463.686 527.26 462.139 527.537 460.923 528.171V528.198Z",
    fill: "#A7ADDF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.14,
    d: "M460.726 528.581L451.803 533.931L436.878 541.369C435.397 542.149 434.194 543.549 434.062 545.042C433.917 546.839 434.816 548.701 436.944 550.036L442.734 553.339C442.906 553.444 448.63 556.668 448.855 556.681C450.454 557.593 452.411 558.108 454.341 558.147C455.887 558.24 457.553 557.632 458.663 557.051L465.26 552.691L477.858 545.702C479.339 544.923 480.462 543.562 480.661 542.069C480.806 540.92 480.515 539.757 479.55 538.648C479.074 538.093 478.056 537.115 477.329 536.666C477.171 536.574 470.535 529.347 470.336 529.321C468.816 528.422 466.952 527.867 465.062 527.775C463.409 527.696 461.915 527.973 460.739 528.594L460.726 528.581Z",
    fill: "#A3A9DC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.19,
    d: "M460.537 528.977L451.905 534.368L437.192 541.502C435.79 542.228 434.521 543.589 434.349 545.016C434.151 546.786 434.957 548.622 437.086 549.957L442.77 553.18C443.008 553.326 448.494 556.391 448.785 556.417C450.371 557.276 452.288 557.765 454.165 557.778C455.633 557.857 457.298 557.157 458.356 556.602L464.754 552.242L477.181 545.597C478.582 544.87 479.758 543.549 479.996 542.149C480.195 540.986 479.943 539.824 478.925 538.674C478.463 538.159 477.339 537.063 476.652 536.627C476.44 536.495 470.095 529.651 469.817 529.612C468.337 528.753 466.526 528.238 464.701 528.158C463.115 528.092 461.661 528.357 460.511 528.951L460.537 528.977Z",
    fill: "#9FA4D8"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.24,
    d: "M460.336 529.374L451.982 534.804L437.48 541.634C436.158 542.321 434.809 543.642 434.611 544.976C434.36 546.72 435.061 548.53 437.215 549.877L442.794 553.035C443.085 553.207 448.346 556.126 448.716 556.166C450.289 556.985 452.18 557.434 454.004 557.421C455.379 557.5 457.058 556.694 458.049 556.179L464.249 551.833L476.504 545.531C477.826 544.844 479.346 543.615 479.346 542.268C479.848 541.171 479.399 539.929 478.315 538.754C477.879 538.265 476.636 537.063 476.001 536.653C475.737 536.495 469.682 530.021 469.339 529.981C467.898 529.162 466.153 528.674 464.395 528.607C462.861 528.541 461.46 528.819 460.349 529.387L460.336 529.374Z",
    fill: "#9BA0D5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M460.145 529.77L452.081 535.239L437.791 541.779C436.548 542.426 434.896 543.695 434.896 544.95C434.287 546.588 435.2 548.464 437.368 549.811L442.84 552.889C443.197 553.101 448.221 555.862 448.657 555.902C450.217 556.681 452.068 557.091 453.839 557.051C455.135 557.13 456.813 556.205 457.739 555.73L463.74 551.397L475.81 545.438C477.052 544.791 478.678 543.628 478.678 542.36C479.287 541.277 478.824 540.022 477.687 538.793C477.264 538.344 475.916 537.023 475.321 536.64C474.99 536.442 469.227 530.351 468.83 530.298C467.429 529.532 465.75 529.07 464.045 529.004C462.564 528.951 461.216 529.215 460.145 529.757V529.77Z",
    fill: "#979BD2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M459.958 530.153L452.185 535.662L438.106 541.898C436.956 542.505 435.184 543.721 435.184 544.897C434.484 546.495 435.343 548.358 437.511 549.719L442.865 552.731C443.275 552.982 448.073 555.585 448.589 555.637C450.135 556.377 451.96 556.747 453.678 556.681C454.881 556.747 456.573 555.73 457.433 555.281L463.236 550.947L475.134 545.333C476.284 544.725 478.029 543.615 478.029 542.453C478.729 541.369 478.267 540.101 477.077 538.846C476.68 538.436 475.213 536.983 474.658 536.64C474.274 536.415 468.801 530.695 468.326 530.629C466.964 529.902 465.338 529.479 463.712 529.426C462.284 529.387 460.989 529.638 459.958 530.153Z",
    fill: "#9397CF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.38,
    d: "M459.76 530.549L452.277 536.098L438.41 542.043C437.339 542.598 435.462 543.787 435.462 544.87C434.656 546.416 435.462 548.292 437.657 549.653L442.905 552.586C443.368 552.863 447.941 555.32 448.523 555.373C450.07 556.06 451.841 556.404 453.52 556.311C454.644 556.377 456.336 555.254 457.129 554.845L462.747 550.525L474.473 545.253C475.544 544.699 477.394 543.642 477.381 542.558C478.188 541.488 477.725 540.207 476.456 538.899C476.086 538.516 474.499 536.957 473.984 536.64C473.548 536.376 468.366 531.038 467.824 530.972C466.502 530.298 464.942 529.889 463.369 529.849C461.994 529.81 460.751 530.061 459.746 530.563L459.76 530.549Z",
    fill: "#8F92CC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M459.573 530.946L452.382 536.534L438.726 542.175C437.734 542.69 435.751 543.827 435.751 544.831C434.853 546.324 435.619 548.2 437.814 549.573L442.956 552.44C443.485 552.757 447.821 555.056 448.482 555.122C450.015 555.77 451.76 556.073 453.373 555.954C454.404 556.007 456.11 554.792 456.85 554.409L462.27 550.102L473.81 545.174C474.802 544.659 476.745 543.668 476.745 542.664C477.644 541.607 477.181 540.299 475.859 538.965C475.516 538.621 473.81 536.944 473.334 536.64C472.845 536.349 467.954 531.382 467.346 531.302C466.064 530.668 464.557 530.298 463.063 530.272C461.754 530.246 460.551 530.483 459.586 530.959L459.573 530.946Z",
    fill: "#8B8EC9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.48,
    d: "M459.378 531.342L452.477 536.97L439.033 542.308C438.121 542.783 436.032 543.866 436.032 544.791C435.028 546.244 435.741 548.12 437.949 549.481L442.986 552.269C443.567 552.625 447.679 554.766 448.406 554.845C449.926 555.453 451.631 555.717 453.204 555.572C454.156 555.624 455.848 554.303 456.536 553.947L461.757 549.653L473.126 545.069C474.038 544.593 476.087 543.668 476.087 542.743C477.092 541.7 476.616 540.379 475.241 539.005C474.924 538.688 473.1 536.904 472.663 536.627C472.121 536.296 467.508 531.712 466.834 531.62C465.604 531.025 464.15 530.695 462.709 530.669C461.453 530.655 460.303 530.88 459.378 531.342Z",
    fill: "#8789C6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.52,
    d: "M459.19 531.725L452.567 537.393L439.334 542.439C438.515 542.875 436.307 543.919 436.307 544.751C435.196 546.152 435.871 548.028 438.091 549.402L443.009 552.123C443.657 552.52 447.53 554.514 448.337 554.581C449.844 555.135 451.522 555.373 453.03 555.201C453.889 555.254 455.594 553.828 456.215 553.51L461.239 549.217L472.436 544.976C473.255 544.54 475.423 543.668 475.423 542.836C476.534 541.805 476.058 540.458 474.617 539.044C474.326 538.754 472.383 536.864 471.986 536.613C471.391 536.257 467.069 532.042 466.328 531.95C465.139 531.408 463.751 531.091 462.376 531.078C461.173 531.078 460.075 531.289 459.177 531.725H459.19Z",
    fill: "#8385C2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.57,
    d: "M458.994 532.121L452.662 537.815L439.641 542.558C438.901 542.941 436.587 543.945 436.587 544.698C435.384 546.046 436.005 547.935 438.24 549.309L443.051 551.965C443.752 552.387 447.401 554.237 448.273 554.316C449.767 554.831 451.406 555.03 452.874 554.831C453.654 554.871 455.359 553.352 455.914 553.061L460.739 548.781L471.751 544.883C472.491 544.5 474.765 543.681 474.765 542.928C475.968 541.911 475.492 540.55 473.998 539.097C473.734 538.846 471.672 536.838 471.315 536.613C470.667 536.217 466.635 532.386 465.829 532.28C464.679 531.778 463.343 531.5 462.035 531.5C460.885 531.5 459.84 531.712 458.981 532.135L458.994 532.121Z",
    fill: "#7F80BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.62,
    d: "M458.808 532.518L452.766 538.251L439.957 542.704C439.296 543.047 436.877 544.012 436.877 544.685C435.568 545.993 436.15 547.869 438.397 549.256L443.103 551.833C443.87 552.295 447.28 553.986 448.232 554.065C449.713 554.541 451.326 554.699 452.74 554.475C453.427 554.514 455.146 552.889 455.648 552.638L460.275 548.371L471.115 544.804C471.776 544.461 474.142 543.708 474.142 543.034C475.451 542.03 474.975 540.656 473.415 539.15C473.177 538.925 470.996 536.811 470.679 536.613C469.978 536.191 466.237 532.729 465.351 532.624C464.241 532.161 462.972 531.923 461.729 531.923C460.632 531.923 459.627 532.135 458.821 532.531L458.808 532.518Z",
    fill: "#7B7CBC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.67,
    d: "M458.605 532.901L452.854 538.674L440.256 542.823C439.674 543.126 437.136 544.038 437.136 544.632C435.735 545.888 436.251 547.777 438.511 549.164L443.111 551.674C443.931 552.176 447.117 553.709 448.135 553.801C449.602 554.237 451.175 554.356 452.537 554.105C453.145 554.144 454.864 552.414 455.3 552.189L459.728 547.922L470.396 544.699C470.978 544.395 473.45 543.708 473.45 543.113C474.851 542.109 474.376 540.722 472.763 539.19C472.551 538.991 470.264 536.772 469.973 536.587C469.22 536.125 465.756 533.046 464.818 532.927C463.747 532.518 462.531 532.293 461.354 532.306C460.31 532.32 459.358 532.518 458.591 532.888L458.605 532.901Z",
    fill: "#7777B9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.71,
    d: "M458.424 533.297L452.965 539.11L440.578 542.968C440.089 543.232 437.432 544.104 437.432 544.606C435.925 545.822 436.401 547.698 438.675 549.098L443.156 551.529C444.028 552.057 446.99 553.444 448.087 553.55C449.541 553.933 451.088 554.026 452.396 553.735C452.912 553.761 454.644 551.938 455.014 551.74L459.244 547.486L469.727 544.606C470.216 544.342 472.807 543.708 472.807 543.206C474.314 542.215 473.838 540.815 472.16 539.242C471.974 539.071 469.569 536.745 469.331 536.587C468.524 536.098 465.352 533.39 464.347 533.258C463.316 532.888 462.166 532.703 461.055 532.729C460.077 532.756 459.165 532.941 458.424 533.297Z",
    fill: "#7373B6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M458.228 533.694L453.059 539.546L440.897 543.1C440.487 543.311 437.724 544.144 437.724 544.567C436.125 545.729 436.548 547.618 438.835 549.019L443.211 551.383C444.149 551.952 446.872 553.18 448.049 553.286C449.49 553.629 450.997 553.669 452.253 553.365C452.689 553.392 454.421 551.463 454.725 551.304L458.757 547.063L469.068 544.527C469.478 544.316 472.174 543.734 472.174 543.311C473.774 542.334 473.298 540.907 471.553 539.295C471.408 539.163 468.87 536.706 468.671 536.587C467.812 536.059 464.93 533.733 463.846 533.601C462.855 533.284 461.771 533.112 460.713 533.152C459.788 533.179 458.928 533.363 458.228 533.694Z",
    fill: "#6F6EB3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.81,
    d: "M458.043 534.09L453.152 539.982L441.202 543.232C440.871 543.404 438.002 544.197 438.002 544.527C436.297 545.637 436.681 547.526 438.968 548.926L443.237 551.212C444.229 551.819 446.727 552.89 447.97 553.008C449.398 553.312 450.878 553.312 452.081 552.982C452.425 552.995 454.17 550.974 454.408 550.842L458.242 546.601L468.381 544.408C468.711 544.236 471.501 543.721 471.501 543.378C473.206 542.413 472.73 540.973 470.919 539.322C470.8 539.216 468.143 536.653 467.984 536.561C467.059 536.006 464.481 534.05 463.331 533.905C462.379 533.628 461.348 533.496 460.37 533.535C459.497 533.575 458.691 533.747 458.03 534.064L458.043 534.09Z",
    fill: "#6B6AB0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.86,
    d: "M457.839 534.473L453.238 540.405L441.5 543.364C441.248 543.496 438.274 544.236 438.274 544.487C436.463 545.557 436.807 547.446 439.107 548.847L443.271 551.066C444.329 551.7 446.602 552.625 447.911 552.744C449.325 552.995 450.766 552.969 451.93 552.612C452.194 552.625 453.939 550.498 454.124 550.406L457.76 546.178L467.714 544.329C467.965 544.196 470.86 543.747 470.86 543.483C472.671 542.532 472.182 541.079 470.318 539.374C470.226 539.295 467.449 536.626 467.33 536.547C466.352 535.953 464.052 534.381 462.849 534.235C461.937 533.997 460.972 533.905 460.046 533.958C459.227 534.011 458.473 534.169 457.852 534.46L457.839 534.473Z",
    fill: "#6765AC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M457.659 534.869L453.349 540.841L441.822 543.496C441.663 543.589 438.57 544.289 438.57 544.448C436.666 545.465 436.944 547.354 439.27 548.768L443.315 550.921C444.426 551.595 446.475 552.361 447.85 552.493C449.251 552.704 450.666 552.638 451.763 552.255C451.935 552.255 453.693 550.036 453.812 549.97L457.249 545.755L467.031 544.249C467.19 544.157 470.204 543.761 470.204 543.602C472.108 542.664 471.632 541.184 469.702 539.454C469.636 539.401 466.74 536.627 466.661 536.574C465.63 535.953 463.621 534.751 462.338 534.592C461.466 534.407 460.567 534.328 459.708 534.394C458.941 534.447 458.24 534.605 457.645 534.883L457.659 534.869Z",
    fill: "#6361A9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.95,
    d: "M457.459 535.266L453.441 541.277L442.125 543.642C442.045 543.681 438.846 544.342 438.846 544.421C436.837 545.386 437.075 547.288 439.402 548.702L443.341 550.776C444.518 551.489 446.329 552.11 447.783 552.242C449.171 552.414 450.546 552.308 451.603 551.899C451.696 551.899 453.441 549.573 453.507 549.534L456.746 545.319L466.356 544.157C466.435 544.117 469.555 543.774 469.555 543.695C471.565 542.757 471.366 540.907 469.093 539.507C469.066 539.48 466.039 536.6 465.999 536.574C464.915 535.913 463.197 535.094 461.848 534.922C461.015 534.777 460.169 534.737 459.376 534.803C458.662 534.869 458.015 535.015 457.459 535.266Z",
    fill: "#5F5CA6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.433 551.529L456.245 544.897L468.896 543.8C470.998 542.875 470.813 540.986 468.473 539.559L465.327 536.574C462.987 535.16 459.378 534.751 457.263 535.675L453.535 541.726L439.126 544.408C437.024 545.333 437.209 547.222 439.549 548.649L443.383 550.657C445.723 552.07 449.331 552.48 451.447 551.555L451.433 551.529Z",
    fill: "#5B58A3"
  }))), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M467.501 540.55C467.501 540.55 468.241 542.756 467.329 543.232C466.417 543.708 464.989 543.972 463.839 543.47C462.689 542.968 462.213 542.452 460.997 542.452C459.781 542.452 455.035 540.114 454.123 538.965C453.211 537.815 454.123 536.494 456.397 536.666C458.671 536.838 461.923 537.102 462.504 537.313C463.086 537.512 467.514 540.563 467.514 540.563L467.501 540.55Z",
    fill: "#4E0070"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M467.501 540.55C467.501 540.55 468.241 542.756 467.329 543.232C466.417 543.708 464.989 543.972 463.839 543.47C462.689 542.968 462.213 542.452 460.997 542.452C459.781 542.452 455.035 540.114 454.123 538.965C453.211 537.815 454.123 536.494 456.397 536.666C458.671 536.838 461.923 537.102 462.504 537.313C463.086 537.512 467.514 540.563 467.514 540.563L467.501 540.55Z",
    fill: "#CED3F4"
  }))), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M466.485 542.175C464.357 542.426 463.669 541.832 461.699 541.435C459.73 541.026 454.138 538.767 454.244 537.511C454.349 536.256 455.632 536.521 456.716 536.626C457.8 536.732 461.263 536.97 461.528 536.97C461.792 536.97 467.423 539.506 467.423 539.506C467.423 539.506 467.833 541.329 467.463 541.607C467.093 541.884 467.053 542.109 466.485 542.188V542.175Z",
    fill: "#4E0070"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M478.145 496.002C478.145 496.002 469.737 501.538 469.671 510.098C469.592 518.659 468.627 540.418 467.714 541.277C466.802 542.136 464.396 542.122 463.088 541.171C460.973 539.612 460.206 538.185 460.153 537.393C460.047 535.847 456.888 511.578 457.39 503.374C457.892 495.17 464.674 494.126 467.767 494.232C470.861 494.338 478.158 496.002 478.158 496.002H478.145Z",
    fill: "url(#paint140_linear_2253_1261)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M464.212 507.337C464.212 507.337 462.824 528.726 467.742 541.224C468.654 539.903 469.606 518.554 469.672 510.085C469.672 509.2 469.791 508.368 469.962 507.549L464.212 507.324V507.337Z",
    fill: "#D1D3D4"
  }))), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M451.882 548.517C451.882 548.517 452.662 550.815 451.711 551.318C450.759 551.82 449.265 552.097 448.062 551.569C446.859 551.04 446.357 550.512 445.088 550.512C443.819 550.512 438.861 548.068 437.896 546.865C436.944 545.663 437.896 544.289 440.262 544.461C442.629 544.633 446.039 544.923 446.634 545.135C447.242 545.346 451.869 548.53 451.869 548.53L451.882 548.517Z",
    fill: "#4E0070"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M451.882 548.517C451.882 548.517 452.662 550.815 451.711 551.318C450.759 551.82 449.265 552.097 448.062 551.569C446.859 551.04 446.357 550.512 445.088 550.512C443.819 550.512 438.861 548.068 437.896 546.865C436.944 545.663 437.896 544.289 440.262 544.461C442.629 544.633 446.039 544.923 446.634 545.135C447.242 545.346 451.869 548.53 451.869 548.53L451.882 548.517Z",
    fill: "#CED3F4"
  }))), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M450.824 550.208C448.603 550.472 447.889 549.851 445.827 549.428C443.778 549.006 437.935 546.641 438.04 545.333C438.146 544.025 439.495 544.302 440.618 544.408C441.755 544.514 445.364 544.765 445.642 544.765C445.919 544.765 451.802 547.42 451.802 547.42C451.802 547.42 452.225 549.336 451.842 549.613C451.458 549.891 451.419 550.142 450.81 550.221L450.824 550.208Z",
    fill: "#4E0070"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M463.003 501.987C463.003 501.987 454.225 507.76 454.146 516.704C454.066 525.648 453.049 548.371 452.097 549.27C451.145 550.168 448.633 550.155 447.272 549.151C445.051 547.526 444.258 546.02 444.205 545.201C444.099 543.576 440.794 518.237 441.323 509.676C441.852 501.115 448.924 500.018 452.163 500.124C455.388 500.243 463.016 501.974 463.016 501.974L463.003 501.987Z",
    fill: "url(#paint141_linear_2253_1261)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M448.444 513.824C448.444 513.824 447.003 536.164 452.133 549.217C453.084 547.83 454.076 525.543 454.155 516.704C454.155 515.779 454.287 514.908 454.459 514.062L448.457 513.837L448.444 513.824Z",
    fill: "#D1D3D4"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M475.939 577C496.374 577 512.94 569.05 512.94 559.244C512.94 549.438 496.374 541.488 475.939 541.488C455.504 541.488 438.938 549.438 438.938 559.244C438.938 569.05 455.504 577 475.939 577Z",
    fill: "url(#paint142_radial_2253_1261)"
  }), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M494.391 569.099C494.391 569.535 494.536 569.839 494.787 569.985L496.083 570.711C496.334 570.857 496.175 570.526 496.559 570.315C497.339 569.866 497.96 568.782 497.96 567.897C497.96 567.461 498.37 567.448 498.119 567.303L496.783 566.576C496.519 566.431 496.175 566.457 495.792 566.682C495.012 567.131 494.391 568.214 494.391 569.099Z",
    fill: "url(#paint143_linear_2253_1261)"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M495.719 569.839C495.719 570.725 496.353 571.081 497.12 570.645C497.9 570.196 498.521 569.113 498.521 568.228C498.521 567.343 497.887 566.986 497.12 567.422C496.34 567.871 495.719 568.954 495.719 569.839Z",
    fill: "url(#paint144_linear_2253_1261)"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M494.023 569.166C494.023 568.122 494.751 566.867 495.663 566.338C496.112 566.087 496.509 566.048 496.813 566.206L498.293 567.012C498.293 567.012 498.373 567.065 498.373 567.092C498.069 566.854 497.632 566.854 497.13 567.144C496.231 567.673 495.491 568.928 495.491 569.972L494.023 569.152V569.166Z",
    fill: "url(#paint145_linear_2253_1261)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M497.052 567.395C497.422 567.184 497.766 567.158 498.017 567.277C497.779 567.21 497.488 567.263 497.184 567.435C496.404 567.884 495.783 568.968 495.783 569.853C495.783 570.315 495.955 570.632 496.232 570.764C495.889 570.672 495.664 570.328 495.664 569.8C495.664 568.915 496.299 567.831 497.065 567.382L497.052 567.395Z",
    fill: "url(#paint146_radial_2253_1261)"
  }), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M464.344 572.296C464.344 572.732 464.489 573.036 464.74 573.182L466.036 573.908C466.287 574.054 466.128 573.723 466.512 573.512C467.292 573.063 467.913 571.979 467.913 571.094C467.913 570.658 468.323 570.645 468.072 570.5L466.736 569.773C466.485 569.641 466.142 569.667 465.758 569.879C464.978 570.328 464.357 571.411 464.357 572.296H464.344Z",
    fill: "url(#paint147_linear_2253_1261)"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M465.672 573.037C465.672 573.922 466.306 574.278 467.073 573.842C467.853 573.393 468.474 572.31 468.474 571.425C468.474 570.54 467.84 570.183 467.073 570.619C466.293 571.068 465.672 572.151 465.672 573.037Z",
    fill: "url(#paint148_linear_2253_1261)"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M463.977 572.363C463.977 571.319 464.704 570.064 465.616 569.535C466.065 569.284 466.462 569.245 466.766 569.403L468.246 570.209C468.246 570.209 468.326 570.262 468.326 570.289C468.022 570.051 467.585 570.051 467.083 570.341C466.184 570.87 465.444 572.125 465.444 573.169L463.977 572.349V572.363Z",
    fill: "url(#paint149_linear_2253_1261)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M467.005 570.579C467.375 570.368 467.719 570.341 467.97 570.46C467.732 570.394 467.441 570.447 467.137 570.619C466.357 571.068 465.736 572.151 465.736 573.036C465.736 573.499 465.908 573.816 466.186 573.948C465.842 573.855 465.617 573.512 465.617 572.983C465.617 572.098 466.252 571.015 467.018 570.566L467.005 570.579Z",
    fill: "url(#paint150_radial_2253_1261)"
  }), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M450.859 555.598C450.859 556.034 451.005 556.338 451.256 556.483L452.538 557.21C452.803 557.355 452.631 557.038 453.027 556.813C453.807 556.364 454.429 555.281 454.429 554.396C454.429 553.96 454.838 553.947 454.587 553.801L453.252 553.075C452.988 552.929 452.644 552.956 452.261 553.18C451.481 553.63 450.859 554.713 450.859 555.598Z",
    fill: "url(#paint151_linear_2253_1261)"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M452.188 556.338C452.188 557.223 452.822 557.58 453.589 557.144C454.355 556.708 454.99 555.611 454.99 554.726C454.99 553.841 454.355 553.484 453.589 553.92C452.809 554.369 452.188 555.453 452.188 556.338Z",
    fill: "url(#paint152_linear_2253_1261)"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M450.492 555.651C450.492 554.607 451.219 553.352 452.131 552.824C452.581 552.573 452.977 552.533 453.282 552.691L454.749 553.497C454.815 553.537 454.828 553.563 454.841 553.59C454.537 553.352 454.101 553.352 453.599 553.643C452.7 554.171 451.96 555.426 451.96 556.47L450.492 555.651Z",
    fill: "url(#paint153_linear_2253_1261)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M453.521 553.881C453.891 553.669 454.235 553.643 454.486 553.762C454.248 553.696 453.957 553.748 453.653 553.92C452.873 554.369 452.252 555.453 452.252 556.338C452.252 556.8 452.424 557.117 452.701 557.249C452.358 557.157 452.133 556.813 452.133 556.285C452.133 555.4 452.767 554.316 453.534 553.867L453.521 553.881Z",
    fill: "url(#paint154_radial_2253_1261)"
  }), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M472.133 540.96C472.133 541.396 472.278 541.7 472.529 541.845L473.825 542.572C474.076 542.717 473.917 542.387 474.301 542.175C475.081 541.726 475.702 540.643 475.702 539.758C475.702 539.322 476.112 539.308 475.861 539.163L474.526 538.437C474.261 538.291 473.917 538.318 473.534 538.542C472.754 538.991 472.133 540.075 472.133 540.96Z",
    fill: "url(#paint155_linear_2253_1261)"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M473.469 541.7C473.469 542.585 474.103 542.941 474.87 542.505C475.65 542.056 476.271 540.973 476.271 540.088C476.271 539.203 475.637 538.846 474.87 539.282C474.09 539.731 473.469 540.814 473.469 541.7Z",
    fill: "url(#paint156_linear_2253_1261)"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M471.773 541.013C471.773 539.969 472.501 538.714 473.413 538.185C473.862 537.934 474.259 537.895 474.563 538.053L476.043 538.859C476.043 538.859 476.123 538.912 476.123 538.938C475.819 538.701 475.382 538.701 474.88 538.991C473.981 539.52 473.241 540.775 473.241 541.818L471.773 540.999V541.013Z",
    fill: "url(#paint157_linear_2253_1261)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M474.802 539.242C475.172 539.031 475.516 539.004 475.767 539.123C475.529 539.057 475.238 539.11 474.934 539.282C474.154 539.731 473.533 540.814 473.533 541.699C473.533 542.162 473.705 542.479 473.982 542.611C473.639 542.518 473.414 542.175 473.414 541.647C473.414 540.761 474.049 539.678 474.815 539.229L474.802 539.242Z",
    fill: "url(#paint158_radial_2253_1261)"
  }), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M498.789 550.895C498.789 551.331 498.934 551.635 499.186 551.78L500.481 552.507C500.732 552.652 500.574 552.322 500.957 552.11C501.737 551.661 502.358 550.578 502.358 549.693C502.358 549.257 502.768 549.244 502.517 549.098L501.182 548.372C500.917 548.226 500.574 548.253 500.19 548.477C499.41 548.926 498.789 550.01 498.789 550.895Z",
    fill: "url(#paint159_linear_2253_1261)"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M500.117 551.635C500.117 552.52 500.752 552.876 501.518 552.441C502.298 551.991 502.92 550.908 502.92 550.023C502.92 549.138 502.285 548.781 501.518 549.217C500.739 549.666 500.117 550.749 500.117 551.635Z",
    fill: "url(#paint160_linear_2253_1261)"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M498.422 550.961C498.422 549.917 499.149 548.662 500.061 548.134C500.511 547.883 500.907 547.843 501.211 548.002L502.679 548.807C502.679 548.807 502.758 548.873 502.771 548.9C502.467 548.662 502.031 548.662 501.528 548.953C500.63 549.481 499.889 550.736 499.889 551.78L498.422 550.961Z",
    fill: "url(#paint161_linear_2253_1261)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M501.451 549.177C501.821 548.966 502.164 548.939 502.416 549.058C502.178 548.992 501.887 549.045 501.583 549.217C500.803 549.666 500.181 550.749 500.181 551.634C500.181 552.097 500.353 552.414 500.631 552.546C500.287 552.454 500.062 552.11 500.062 551.582C500.062 550.696 500.697 549.613 501.464 549.164L501.451 549.177Z",
    fill: "url(#paint162_radial_2253_1261)"
  }), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M495.49 565.52H497.592V566.788C497.592 567.131 497.116 567.409 496.534 567.409C495.952 567.409 495.477 567.131 495.477 566.801V565.533L495.49 565.52Z",
    fill: "url(#paint163_linear_2253_1261)"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M495.492 565.533C495.492 565.876 495.968 566.14 496.55 566.14C497.131 566.14 497.607 565.863 497.607 565.533C497.607 565.202 497.131 564.925 496.55 564.925C495.968 564.925 495.492 565.202 495.492 565.533Z",
    fill: "url(#paint164_linear_2253_1261)"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M499.591 547.645H501.693V548.913C501.693 549.256 501.217 549.534 500.636 549.534C500.054 549.534 499.578 549.256 499.578 548.926V547.658L499.591 547.645Z",
    fill: "url(#paint165_linear_2253_1261)"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M499.586 547.645C499.586 547.988 500.062 548.253 500.643 548.253C501.225 548.253 501.701 547.975 501.701 547.645C501.701 547.315 501.225 547.037 500.643 547.037C500.062 547.037 499.586 547.315 499.586 547.645Z",
    fill: "url(#paint166_linear_2253_1261)"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M473.099 537.974H475.201V539.242C475.201 539.586 474.725 539.863 474.144 539.863C473.562 539.863 473.086 539.586 473.086 539.256V537.987L473.099 537.974Z",
    fill: "url(#paint167_linear_2253_1261)"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M474.144 538.582C474.728 538.582 475.201 538.31 475.201 537.974C475.201 537.639 474.728 537.366 474.144 537.366C473.559 537.366 473.086 537.639 473.086 537.974C473.086 538.31 473.559 538.582 474.144 538.582Z",
    fill: "url(#paint168_linear_2253_1261)"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M451.56 552.295H453.662V553.563C453.662 553.907 453.186 554.184 452.604 554.184C452.023 554.184 451.547 553.907 451.547 553.576V552.308L451.56 552.295Z",
    fill: "url(#paint169_linear_2253_1261)"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M451.562 552.308C451.562 552.652 452.038 552.916 452.62 552.916C453.202 552.916 453.678 552.638 453.678 552.308C453.678 551.978 453.202 551.7 452.62 551.7C452.038 551.7 451.562 551.978 451.562 552.308Z",
    fill: "url(#paint170_linear_2253_1261)"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M465.084 568.835H467.185V570.104C467.185 570.447 466.71 570.725 466.128 570.725C465.546 570.725 465.07 570.447 465.07 570.117V568.849L465.084 568.835Z",
    fill: "url(#paint171_linear_2253_1261)"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M465.086 568.835C465.086 569.179 465.562 569.443 466.144 569.443C466.725 569.443 467.201 569.166 467.201 568.835C467.201 568.505 466.725 568.228 466.144 568.228C465.562 568.228 465.086 568.505 465.086 568.835Z",
    fill: "url(#paint172_linear_2253_1261)"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M475.318 551.489L456.176 550.551C454.59 550.551 453.07 551.212 451.959 552.361C451.629 552.665 451.311 553.154 451.708 553.312L451.814 553.22C452.964 552.189 454.471 551.648 456.018 551.714L475.225 554.383L467.823 563.208C466.884 564.555 466.144 566.022 465.615 567.58L465.232 568.703C465.152 569.641 466.461 569.906 466.725 569.126C467.426 567.118 468.51 565.612 469.885 563.987L478.491 555.334L491.472 561.926C493.442 563.141 495.108 564.423 496.35 566.365C496.773 567.118 497.804 566.656 497.54 565.678L497.302 565.268C496.231 563.459 494.79 561.9 493.098 560.671L481.121 553.814L498.505 547.724C499.364 547.513 500.25 547.566 501.056 547.856C501.466 548.002 501.929 548.054 501.585 547.711C500.567 546.773 499.166 546.377 497.804 546.641L479.456 551.067L474.895 538.12C474.67 537.525 473.15 537.67 473.243 538.265L475.331 551.463L475.318 551.489Z",
    fill: "#979ED1"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M475.792 550.049L456.161 550.115C454.574 550.115 453.054 550.776 451.944 551.925C451.613 552.229 451.296 552.718 451.692 552.876L451.798 552.784C452.948 551.753 454.455 551.212 456.002 551.278L475.21 552.15L467.807 562.771C466.868 564.119 466.128 565.585 465.599 567.144L465.216 568.267C465.137 569.205 466.445 569.47 466.71 568.69C467.41 566.682 468.494 564.819 469.869 563.194L478.475 553.114L491.457 561.133C493.426 562.349 495.092 563.987 496.335 565.942C496.758 566.695 497.789 566.233 497.524 565.255L497.286 564.846C496.216 563.036 494.775 561.477 493.083 560.248L481.106 551.608L498.489 547.314C499.375 547.09 500.314 547.156 501.147 547.486C501.53 547.631 501.926 547.645 501.57 547.301C500.552 546.363 499.15 545.967 497.789 546.231L479.44 549.719L475.329 538.886L474.879 537.71C474.655 537.115 473.134 537.261 473.227 537.855L473.531 539.295L475.792 550.062V550.049Z",
    fill: "url(#paint173_linear_2253_1261)"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M475.266 547.605H481.69V551.476V551.502C481.69 552.533 480.249 553.365 478.478 553.365C476.707 553.365 475.266 552.533 475.266 551.502V551.476V547.605Z",
    fill: "url(#paint174_linear_2253_1261)"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M475.266 547.618C475.266 548.649 476.707 549.481 478.478 549.481C480.249 549.481 481.69 548.649 481.69 547.618C481.69 546.588 480.249 545.755 478.478 545.755C476.707 545.755 475.266 546.588 475.266 547.618Z",
    fill: "#E5E9FF"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M475.742 533.905H481.215V546.879V546.905C481.215 547.79 479.986 548.504 478.479 548.504C476.972 548.504 475.742 547.79 475.742 546.905V546.879V533.905Z",
    fill: "url(#paint175_linear_2253_1261)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M475.742 527.788H481.215V540.762V540.788C481.215 541.673 479.986 542.387 478.479 542.387C476.972 542.387 475.742 541.673 475.742 540.788V540.762V527.788Z",
    fill: "url(#paint176_linear_2253_1261)"
  }), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M502.27 526.599C498.899 528.607 487.967 535.147 484.728 536.851C476.571 541.145 468.032 534.631 462.215 531.315C456.398 527.986 448.625 522.081 455.01 518.157C459.955 515.119 468.732 509.847 472.619 508.183C476.505 506.518 485.653 509.425 494.933 514.418C504.227 519.412 506.712 523.983 502.283 526.612L502.27 526.599Z",
    fill: "url(#paint177_linear_2253_1261)"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M502.031 526.467C498.686 528.449 487.846 534.935 484.647 536.626C476.57 540.88 468.11 534.433 462.333 531.144C456.569 527.854 448.862 521.988 455.194 518.104C460.099 515.092 468.797 509.861 472.644 508.222C476.491 506.571 485.559 509.464 494.76 514.405C503.961 519.346 506.433 523.878 502.044 526.48L502.031 526.467Z",
    fill: "url(#paint178_linear_2253_1261)"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M501.796 526.321C498.478 528.29 487.744 534.711 484.571 536.388C476.56 540.603 468.179 534.209 462.468 530.945C456.757 527.682 449.13 521.883 455.396 518.025C460.247 515.039 468.866 509.86 472.687 508.235C476.494 506.597 485.483 509.464 494.605 514.352C503.726 519.254 506.172 523.732 501.822 526.321H501.796Z",
    fill: "url(#paint179_linear_2253_1261)"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M501.572 526.19C498.294 528.132 487.652 534.5 484.506 536.164C476.574 540.339 468.272 534.011 462.601 530.774C456.943 527.537 449.382 521.79 455.595 517.972C460.407 515.013 468.947 509.887 472.727 508.275C476.508 506.664 485.405 509.491 494.434 514.339C503.463 519.188 505.895 523.64 501.585 526.203L501.572 526.19Z",
    fill: "url(#paint180_linear_2253_1261)"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M501.335 526.044C498.083 527.973 487.547 534.275 484.428 535.926C476.575 540.061 468.339 533.799 462.734 530.589C457.129 527.379 449.634 521.685 455.794 517.906C460.553 514.973 469.014 509.9 472.755 508.289C476.496 506.69 485.313 509.491 494.263 514.3C503.213 519.108 505.618 523.508 501.349 526.044H501.335Z",
    fill: "url(#paint181_linear_2253_1261)"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M501.096 525.899C497.87 527.815 487.44 534.05 484.346 535.689C476.56 539.797 468.417 533.575 462.852 530.404C457.299 527.233 449.883 521.592 455.964 517.84C460.684 514.934 469.065 509.9 472.766 508.315C476.468 506.73 485.206 509.504 494.076 514.26C502.946 519.016 505.326 523.389 501.096 525.899Z",
    fill: "url(#paint182_linear_2253_1261)"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "M500.866 525.767C497.681 527.656 487.343 533.839 484.276 535.464C476.569 539.533 468.492 533.377 462.993 530.232C457.493 527.088 450.143 521.5 456.171 517.787C460.851 514.907 469.153 509.927 472.815 508.355C476.49 506.782 485.135 509.53 493.913 514.247C502.691 518.963 505.057 523.283 500.853 525.767H500.866Z",
    fill: "url(#paint183_linear_2253_1261)"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M500.629 525.622C497.47 527.498 487.238 533.614 484.197 535.213C476.57 539.242 468.559 533.139 463.112 530.021C457.666 526.903 450.395 521.381 456.357 517.695C460.984 514.841 469.207 509.914 472.842 508.355C476.477 506.796 485.043 509.517 493.742 514.194C502.44 518.857 504.78 523.151 500.616 525.608L500.629 525.622Z",
    fill: "url(#paint184_linear_2253_1261)"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "M500.392 525.489C497.259 527.352 487.12 533.416 484.119 534.988C476.558 538.978 468.639 532.94 463.246 529.849C457.852 526.771 450.647 521.288 456.557 517.642C461.144 514.815 469.287 509.94 472.883 508.394C476.478 506.848 484.965 509.557 493.584 514.18C502.19 518.804 504.517 523.045 500.392 525.489Z",
    fill: "url(#paint185_linear_2253_1261)"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "M500.169 525.344C497.075 527.18 487.028 533.191 484.054 534.75C476.572 538.7 468.719 532.716 463.379 529.664C458.038 526.612 450.9 521.182 456.756 517.576C461.29 514.775 469.354 509.94 472.923 508.42C476.493 506.888 484.887 509.57 493.413 514.141C501.94 518.725 504.227 522.913 500.155 525.331L500.169 525.344Z",
    fill: "url(#paint186_linear_2253_1261)"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "M499.934 525.199C496.867 527.022 486.926 532.967 483.978 534.513C476.562 538.423 468.802 532.504 463.514 529.479C458.226 526.454 451.167 521.09 456.957 517.51C461.452 514.749 469.436 509.953 472.966 508.447C476.496 506.941 484.811 509.583 493.258 514.115C501.705 518.646 503.966 522.807 499.934 525.199Z",
    fill: "url(#paint187_linear_2253_1261)"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "M499.694 525.067C496.654 526.863 486.819 532.756 483.897 534.288C476.56 538.159 468.867 532.293 463.632 529.308C458.397 526.322 451.404 520.998 457.141 517.457C461.596 514.722 469.488 509.98 472.991 508.474C476.481 506.981 484.717 509.596 493.072 514.088C501.426 518.58 503.674 522.689 499.681 525.054L499.694 525.067Z",
    fill: "url(#paint188_linear_2253_1261)"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "M499.468 524.921C496.467 526.705 486.724 532.531 483.842 534.05C476.585 537.881 468.97 532.082 463.788 529.109C458.606 526.15 451.679 520.879 457.364 517.391C461.766 514.683 469.592 509.979 473.042 508.5C476.506 507.02 484.649 509.609 492.924 514.048C501.2 518.487 503.42 522.57 499.468 524.908V524.921Z",
    fill: "url(#paint189_linear_2253_1261)"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "M499.231 524.789C496.256 526.56 486.619 532.32 483.764 533.826C476.572 537.617 469.037 531.87 463.908 528.938C458.779 526.005 451.931 520.8 457.55 517.338C461.912 514.656 469.645 510.006 473.069 508.54C476.493 507.073 484.557 509.636 492.753 514.035C500.949 518.435 503.144 522.464 499.231 524.789Z",
    fill: "url(#paint190_linear_2253_1261)"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "M498.994 524.644C496.046 526.388 486.514 532.095 483.686 533.588C476.573 537.34 469.118 531.659 464.041 528.753C458.965 525.846 452.183 520.694 457.749 517.272C462.058 514.617 469.726 510.019 473.11 508.566C476.494 507.113 484.479 509.649 492.582 514.009C500.686 518.355 502.867 522.345 498.994 524.644Z",
    fill: "url(#paint191_linear_2253_1261)"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "M498.77 524.512C495.862 526.242 486.41 531.884 483.62 533.363C476.574 537.076 469.198 531.448 464.175 528.581C459.151 525.714 452.436 520.601 457.948 517.219C462.218 514.59 469.806 510.046 473.151 508.606C476.508 507.166 484.4 509.689 492.425 513.996C500.449 518.303 502.604 522.253 498.77 524.525V524.512Z",
    fill: "url(#paint192_linear_2253_1261)"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "M498.527 524.366C495.645 526.071 486.299 531.659 483.536 533.125C476.57 536.798 469.273 531.236 464.302 528.396C459.332 525.555 452.695 520.509 458.142 517.153C462.359 514.551 469.868 510.046 473.186 508.632C476.504 507.205 484.316 509.702 492.261 513.956C500.193 518.223 502.335 522.121 498.541 524.366H498.527Z",
    fill: "url(#paint193_linear_2253_1261)"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "M498.288 524.221C495.433 525.912 486.192 531.448 483.456 532.888C476.568 536.521 469.337 531.012 464.42 528.211C459.502 525.397 452.932 520.403 458.326 517.087C462.503 514.511 469.932 510.059 473.211 508.659C476.489 507.258 484.222 509.715 492.075 513.93C499.927 518.144 502.042 522.015 498.288 524.234V524.221Z",
    fill: "url(#paint194_linear_2253_1261)"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "M498.067 524.089C495.251 525.767 486.103 531.236 483.393 532.663C476.572 536.257 469.433 530.814 464.569 528.026C459.704 525.252 453.2 520.311 458.54 517.021C462.678 514.471 470.015 510.072 473.267 508.685C476.519 507.298 484.16 509.729 491.933 513.903C499.706 518.078 501.781 521.896 498.08 524.102L498.067 524.089Z",
    fill: "url(#paint195_linear_2253_1261)"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "M497.83 523.944C495.04 525.595 485.998 531.012 483.315 532.425C476.573 535.979 469.5 530.589 464.688 527.841C459.876 525.093 453.452 520.205 458.726 516.955C462.811 514.432 470.082 510.085 473.294 508.698C476.507 507.324 484.068 509.728 491.762 513.85C499.442 517.972 501.505 521.751 497.843 523.93L497.83 523.944Z",
    fill: "url(#paint196_linear_2253_1261)"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "M497.593 523.812C494.83 525.45 485.893 530.8 483.236 532.201C476.56 535.715 469.581 530.391 464.822 527.669C460.062 524.948 453.704 520.113 458.926 516.902C462.971 514.419 470.149 510.098 473.322 508.738C476.494 507.377 483.977 509.755 491.578 513.837C499.179 517.92 501.215 521.658 497.593 523.812Z",
    fill: "url(#paint197_linear_2253_1261)"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "M497.363 523.666C494.64 525.291 485.796 530.576 483.165 531.963C476.569 535.437 469.655 530.166 464.949 527.484C460.243 524.789 453.964 520.02 459.119 516.836C463.112 514.379 470.224 510.112 473.357 508.764C476.503 507.417 483.893 509.768 491.414 513.811C498.923 517.84 500.946 521.539 497.363 523.68V523.666Z",
    fill: "url(#paint198_linear_2253_1261)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "M502.27 526.599C498.899 528.607 487.967 535.147 484.728 536.851C476.571 541.145 468.032 534.631 462.215 531.315C456.398 527.986 448.625 522.081 455.01 518.157C459.955 515.119 468.732 509.847 472.619 508.183C476.505 506.518 485.653 509.425 494.933 514.418C504.227 519.412 506.712 523.983 502.283 526.612L502.27 526.599Z",
    fill: "url(#paint199_linear_2253_1261)"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    d: "M502.27 526.599C498.899 528.607 487.967 535.147 484.728 536.851C476.571 541.145 468.032 534.631 462.215 531.315C456.398 527.986 448.625 522.081 455.01 518.157C459.955 515.119 468.732 509.847 472.619 508.183C476.505 506.518 485.653 509.425 494.933 514.418C504.227 519.412 506.712 523.983 502.283 526.612L502.27 526.599Z",
    fill: "url(#paint200_linear_2253_1261)"
  }))), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    d: "M496.1 520.337L485.141 525.992L488.3 521.117L496.1 520.337Z",
    fill: "url(#paint201_linear_2253_1261)"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    d: "M492.036 501.96C489.908 501.075 478.235 494.747 474.705 495.778C469.219 497.363 458.617 507.8 458.617 507.8C458.617 507.8 482.835 528.779 496.108 520.35C506.459 513.758 492.036 501.974 492.036 501.974V501.96Z",
    fill: "url(#paint202_linear_2253_1261)"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    d: "M481.066 507.615C478.951 506.73 466.776 501.577 463.101 501.855C454.641 502.515 449.617 513.864 449.617 513.864C449.617 513.864 474.073 532.082 485.125 525.992C501.292 517.087 481.053 507.615 481.053 507.615H481.066Z",
    fill: "url(#paint203_linear_2253_1261)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    d: "M461.156 521.117C463.47 522.16 474.627 526.784 481.646 522.464C484.647 520.615 484.938 511.406 484.938 511.406L497.457 507.906C500.088 511.803 501.634 516.81 496.095 520.324C494.218 521.526 487.37 524.737 485.136 525.978C479.082 529.308 469.022 525.371 461.156 521.103V521.117Z",
    fill: "#D1D3D4"
  }))), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    d: "M432.208 523.521L391.492 499.887V495.751L432.208 519.386V523.521Z",
    fill: "#CED3F4"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    d: "M500.802 484.839L432.18 523.521V519.386L500.802 480.73V484.839Z",
    fill: "#AFB6E5"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    d: "M500.804 480.73L432.182 519.386L391.492 495.751L460.141 457.069L500.804 480.73Z",
    fill: "url(#paint204_linear_2253_1261)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.15
  }, _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.09,
    d: "M436.573 476.846L427.16 482.355C427.16 482.355 427.094 482.395 427.081 482.395C426.341 482.831 426.01 483.518 426.05 484.244C426.09 484.971 426.632 485.843 427.438 486.318L432.382 492.303C433.109 492.726 434.035 492.924 434.92 492.884C435.621 492.884 436.401 492.633 436.903 492.343L450.85 484.165C451.564 483.755 451.96 483.108 451.96 482.408C451.96 481.628 451.471 480.889 450.612 480.4L441.001 476.991C440.777 476.859 440.459 476.727 440.195 476.635C439.679 476.463 439.111 476.357 438.542 476.344C437.776 476.344 437.075 476.503 436.533 476.82L436.573 476.846Z",
    fill: "#9FA5D0"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M436.624 476.859L427.212 482.368C427.212 482.368 427.145 482.408 427.132 482.408C426.392 482.844 426.154 483.531 426.233 484.258C426.313 484.931 426.881 485.883 427.608 486.292L432.433 492.211C433.187 492.647 434.165 492.832 435.051 492.752C435.685 492.752 436.544 492.435 436.994 492.171L450.808 484.007C451.482 483.61 451.866 483.003 451.866 482.329C451.866 481.589 451.39 480.889 450.57 480.413L441.039 477.031C440.841 476.912 440.471 476.767 440.246 476.688C439.744 476.503 439.175 476.397 438.607 476.384C437.853 476.384 437.153 476.529 436.624 476.846V476.859Z",
    fill: "#8F95BB"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.27,
    d: "M436.677 476.859L427.251 482.368C427.251 482.368 427.185 482.408 427.172 482.408C426.431 482.857 426.154 483.57 426.418 484.257C426.418 484.852 427.132 485.896 427.78 486.266L432.486 492.105C433.266 492.554 434.297 492.726 435.183 492.594C435.751 492.594 436.69 492.197 437.086 491.96L450.755 483.808C451.403 483.438 451.76 482.857 451.76 482.223C451.76 481.523 451.311 480.862 450.517 480.4L441.052 477.044C440.867 476.939 440.457 476.78 440.259 476.714C439.757 476.529 439.201 476.41 438.633 476.397C437.893 476.384 437.192 476.529 436.663 476.833L436.677 476.859Z",
    fill: "#7F84A7"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.36,
    d: "M436.729 476.873L427.303 482.395C427.303 482.395 427.237 482.434 427.224 482.448C426.484 482.897 426.259 483.623 426.603 484.297C426.603 484.826 427.383 485.949 427.951 486.279L432.551 492.039C433.358 492.501 434.455 492.66 435.328 492.488C435.817 492.488 436.835 492.013 437.191 491.814L450.715 483.663C451.323 483.306 451.667 482.765 451.667 482.17C451.667 481.51 451.244 480.889 450.477 480.453L441.078 477.124C440.919 477.031 440.457 476.859 440.285 476.793C439.796 476.608 439.241 476.476 438.685 476.463C437.945 476.437 437.258 476.582 436.742 476.886L436.729 476.873Z",
    fill: "#6F7492"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M436.781 476.886L427.342 482.408C427.342 482.408 427.276 482.448 427.263 482.461C426.523 482.923 426.351 483.663 426.774 484.31C426.774 484.76 427.633 485.975 428.109 486.252L432.59 491.946C433.423 492.422 434.573 492.567 435.446 492.356C435.869 492.356 436.966 491.801 437.27 491.629L450.648 483.491C451.23 483.161 451.547 482.646 451.547 482.091C451.547 481.47 451.137 480.875 450.41 480.466L441.09 477.163C440.958 477.084 440.456 476.899 440.297 476.846C439.808 476.661 439.266 476.516 438.711 476.489C437.984 476.463 437.296 476.595 436.781 476.899V476.886Z",
    fill: "#5F637D"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.55,
    d: "M436.838 476.899L427.399 482.421C427.399 482.421 427.333 482.461 427.32 482.474C426.566 482.936 426.447 483.689 426.963 484.324C426.963 484.693 427.888 486.001 428.298 486.239L432.66 491.854C433.519 492.343 434.722 492.475 435.582 492.211C435.939 492.211 437.102 491.576 437.353 491.431L450.599 483.306C451.154 482.989 451.445 482.514 451.445 481.998C451.445 481.417 451.062 480.862 450.361 480.466L441.107 477.19C440.988 477.123 440.446 476.925 440.314 476.872C439.825 476.688 439.296 476.529 438.741 476.503C438.027 476.476 437.34 476.608 436.838 476.899Z",
    fill: "#505368"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.64,
    d: "M436.887 476.899L427.435 482.434C427.435 482.434 427.369 482.474 427.356 482.487C426.603 482.963 426.536 483.729 427.145 484.337C427.145 484.641 428.136 486.028 428.466 486.213L432.723 491.748C433.596 492.25 434.865 492.369 435.724 492.065C436.002 492.065 437.257 491.365 437.456 491.246L450.556 483.121C451.072 482.817 451.349 482.381 451.349 481.906C451.349 481.377 450.979 480.849 450.318 480.466L441.144 477.216C441.051 477.163 440.457 476.952 440.351 476.912C439.875 476.714 439.333 476.555 438.791 476.529C438.09 476.489 437.403 476.621 436.901 476.912L436.887 476.899Z",
    fill: "#404253"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.73,
    d: "M436.94 476.912L427.488 482.448C427.488 482.448 427.422 482.487 427.409 482.5C426.655 482.976 426.642 483.755 427.329 484.35C427.329 484.575 428.387 486.054 428.638 486.199L432.776 491.656C433.675 492.171 434.997 492.277 435.856 491.92C436.067 491.92 437.403 491.14 437.548 491.048L450.503 482.936C450.992 482.659 451.243 482.249 451.243 481.813C451.243 481.325 450.9 480.836 450.265 480.466L441.157 477.229C441.091 477.189 440.443 476.965 440.364 476.925C439.888 476.727 439.359 476.555 438.817 476.529C438.116 476.489 437.442 476.608 436.953 476.886L436.94 476.912Z",
    fill: "#30323E"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.82,
    d: "M437.003 476.925L427.538 482.461C427.538 482.461 427.471 482.5 427.458 482.514C426.705 483.002 426.744 483.782 427.511 484.376C427.511 484.522 428.635 486.094 428.807 486.186L432.825 491.576C433.751 492.118 435.126 492.197 435.985 491.801C436.13 491.801 437.531 490.942 437.637 490.889L450.447 482.791C450.91 482.527 451.134 482.157 451.121 481.761C451.121 481.311 450.791 480.849 450.209 480.519L441.167 477.308C441.167 477.308 440.427 477.031 440.374 477.018C439.911 476.82 439.382 476.635 438.84 476.595C438.153 476.542 437.479 476.661 436.989 476.938L437.003 476.925Z",
    fill: "#20212A"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.91,
    d: "M437.058 476.939L427.593 482.487C427.593 482.487 427.527 482.527 427.501 482.54C426.747 483.029 426.826 483.835 427.686 484.403C427.686 484.482 428.889 486.134 428.968 486.186L432.868 491.497C433.82 492.052 435.247 492.118 436.107 491.682C436.173 491.682 437.666 490.744 437.719 490.718L450.384 482.619C450.807 482.368 451.018 482.038 451.005 481.681C451.005 481.272 450.701 480.849 450.146 480.532L441.183 477.348C441.183 477.348 440.416 477.071 440.403 477.057C439.94 476.859 439.425 476.661 438.883 476.622C438.208 476.569 437.534 476.674 437.058 476.952V476.939Z",
    fill: "#101115"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    d: "M436.237 491.524L450.329 482.421C451.175 481.932 451.069 481.074 450.091 480.506L440.415 477.071C439.436 476.503 437.956 476.45 437.096 476.939L427.618 482.487C426.772 482.976 426.878 483.835 427.856 484.403L432.919 491.392C433.897 491.96 435.378 492.012 436.237 491.524Z",
    fill: "black"
  }))), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    d: "M436.238 491.497L450.33 483.32C450.714 483.095 450.899 482.804 450.899 482.5V480.532C450.899 480.149 450.621 480.796 450.092 480.492L440.416 477.057C439.437 476.489 437.957 476.437 437.098 476.925L427.619 482.474C427.342 482.633 427.13 481.946 427.051 482.17C427.024 482.249 427.051 484.139 427.051 484.205C427.051 484.588 427.315 484.984 427.857 485.301L432.92 491.365C433.899 491.933 435.379 491.986 436.238 491.497Z",
    fill: "#858FD6"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    d: "M436.237 489.542L450.329 481.364C451.175 480.875 451.069 480.017 450.091 479.449L440.415 476.014C439.436 475.446 437.956 475.393 437.096 475.882L427.618 481.43C426.772 481.919 426.878 482.778 427.856 483.346L432.919 489.41C433.897 489.978 435.378 490.031 436.237 489.542Z",
    fill: "#AFB6E5"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M427.634 481.43L437.112 475.882C437.958 475.393 439.439 475.459 440.43 476.014L446.657 478.405C446.657 478.405 446.538 478.497 446.458 478.537L432.366 486.715C432.168 486.834 431.943 486.913 431.692 486.966L427.872 483.319C426.893 482.751 426.788 481.893 427.634 481.404V481.43Z",
    fill: "url(#paint205_linear_2253_1261)"
  }), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    d: "M427.873 483.161L432.936 489.225C433.914 489.793 435.394 489.846 436.254 489.357L450.346 481.179C450.703 480.981 450.888 480.704 450.914 480.426C450.954 480.77 450.769 481.113 450.346 481.351L436.254 489.595C435.408 490.084 433.927 490.018 432.936 489.463L427.873 483.333C427.304 483.002 427.027 482.566 427.066 482.17C427.106 482.514 427.383 482.87 427.873 483.148V483.161Z",
    fill: "#CED3F4"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    d: "M418.37 491.695L457.618 469.025C459.628 467.862 461.254 464.758 461.254 462.089V432.087C461.254 429.418 459.628 428.189 457.618 429.339L418.37 452.009C416.36 453.172 414.734 456.276 414.734 458.945V488.947C414.734 491.616 416.36 492.845 418.37 491.695Z",
    fill: "url(#paint206_linear_2253_1261)"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    d: "M417.889 489.595L456.596 467.255C458.209 466.224 459.213 464.177 459.213 462.076V431.875C459.213 431.373 458.671 431.07 458.248 431.321C458.196 431.347 458.156 431.373 458.129 431.387L419.383 453.766C417.466 454.876 416.766 456.844 416.766 458.945V489.053C416.766 489.582 417.347 489.925 417.81 489.661C417.85 489.635 417.876 489.621 417.889 489.608V489.595Z",
    fill: "url(#paint207_linear_2253_1261)"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    d: "M416.766 458.945V489.053C416.766 489.582 417.347 489.925 417.81 489.661C417.85 489.635 417.876 489.621 417.889 489.608L456.596 467.268C458.209 466.238 459.213 464.19 459.213 462.089V431.889C459.213 431.387 458.671 431.083 458.248 431.334C458.196 431.36 458.156 431.387 458.129 431.4L419.383 453.779C417.466 454.889 416.766 456.858 416.766 458.958V458.945ZM417.175 458.945C417.175 457.386 417.598 455.272 419.581 454.123L458.447 431.677C458.447 431.677 458.526 431.638 458.566 431.638C458.685 431.638 458.804 431.73 458.804 431.875V462.076C458.804 464.071 457.852 465.973 456.398 466.898L417.612 489.291C417.612 489.291 417.519 489.331 417.466 489.331C417.334 489.331 417.175 489.225 417.175 489.04V458.932V458.945Z",
    fill: "#AFB6E5"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    d: "M416.69 451.032L455.952 428.361C456.745 427.899 457.485 427.82 458.08 428.044C458.16 428.071 459.812 429.035 459.878 429.075C459.257 428.771 458.477 428.824 457.618 429.326L418.369 451.996C416.36 453.159 414.734 456.263 414.734 458.932V488.934C414.734 490.599 415.368 491.709 416.333 492.026C416.254 492.026 416.161 491.999 416.016 491.92C415.976 491.894 414.231 490.85 414.178 490.824C413.491 490.335 413.055 489.344 413.055 487.97V457.967C413.055 455.299 414.681 452.181 416.69 451.032Z",
    fill: "url(#paint208_linear_2253_1261)"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    d: "M416.716 451.058L455.978 428.388C456.771 427.925 457.511 427.846 458.106 428.07C458.185 428.097 459.811 429.035 459.878 429.075C459.256 428.771 458.476 428.824 457.617 429.326L418.368 451.996C416.359 453.158 414.733 456.263 414.733 458.932V488.934C414.733 490.599 415.367 491.709 416.333 492.026C416.253 492.026 416.161 491.999 416.015 491.92C415.976 491.894 414.257 490.876 414.217 490.837C413.53 490.348 413.094 489.357 413.094 487.983V457.981C413.094 455.312 414.72 452.194 416.729 451.045L416.716 451.058Z",
    fill: "url(#paint209_linear_2253_1261)"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    d: "M416.755 451.071L456.017 428.401C456.81 427.938 457.55 427.859 458.145 428.084C458.224 428.11 459.811 429.035 459.89 429.074C459.269 428.771 458.489 428.823 457.63 429.326L418.381 451.996C416.372 453.158 414.746 456.263 414.746 458.932V488.934C414.746 490.599 415.38 491.709 416.345 492.026C416.266 492.026 416.173 491.999 416.028 491.92C415.988 491.894 414.296 490.889 414.256 490.863C413.569 490.374 413.133 489.383 413.133 488.009V458.007C413.133 455.338 414.759 452.22 416.768 451.071H416.755Z",
    fill: "url(#paint210_linear_2253_1261)"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    d: "M416.784 451.097L456.046 428.427C456.839 427.965 457.579 427.885 458.174 428.11C458.253 428.136 459.813 429.035 459.879 429.074C459.258 428.771 458.478 428.823 457.619 429.325L418.37 451.996C416.361 453.158 414.735 456.263 414.735 458.932V488.934C414.735 490.599 415.369 491.709 416.334 492.026C416.255 492.026 416.162 491.999 416.017 491.92C415.977 491.893 414.325 490.916 414.272 490.876C413.585 490.387 413.148 489.397 413.148 488.023V458.02C413.148 455.351 414.774 452.234 416.784 451.084V451.097Z",
    fill: "url(#paint211_linear_2253_1261)"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    d: "M416.81 451.111L456.072 428.44C456.865 427.978 457.605 427.899 458.2 428.123C458.279 428.15 459.813 429.035 459.879 429.074C459.257 428.771 458.477 428.823 457.618 429.325L418.37 451.996C416.36 453.158 414.734 456.263 414.734 458.932V488.934C414.734 490.599 415.369 491.708 416.334 492.026C416.254 492.026 416.162 491.999 416.016 491.92C415.977 491.893 414.351 490.929 414.311 490.903C413.624 490.414 413.188 489.423 413.188 488.049V458.046C413.188 455.378 414.813 452.26 416.823 451.111H416.81Z",
    fill: "url(#paint212_linear_2253_1261)"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    d: "M416.849 451.137L456.111 428.467C456.904 428.004 457.644 427.925 458.239 428.15C458.318 428.176 459.812 429.035 459.891 429.075C459.27 428.771 458.49 428.824 457.631 429.326L418.382 451.996C416.373 453.159 414.747 456.263 414.747 458.932V488.934C414.747 490.599 415.381 491.709 416.346 492.026C416.267 492.026 416.175 491.999 416.029 491.92C415.989 491.894 414.39 490.956 414.35 490.916C413.663 490.427 413.227 489.436 413.227 488.062V458.06C413.227 455.391 414.853 452.273 416.862 451.124L416.849 451.137Z",
    fill: "url(#paint213_linear_2253_1261)"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    d: "M416.872 451.15L456.134 428.48C456.927 428.018 457.667 427.938 458.262 428.163C458.342 428.189 459.809 429.035 459.888 429.075C459.267 428.771 458.487 428.824 457.628 429.326L418.379 451.996C416.37 453.159 414.744 456.263 414.744 458.932V488.934C414.744 490.599 415.378 491.709 416.343 492.026C416.264 492.026 416.171 491.999 416.026 491.92C415.986 491.894 414.427 490.969 414.374 490.942C413.686 490.454 413.25 489.463 413.25 488.089V458.086C413.25 455.418 414.876 452.3 416.885 451.15H416.872Z",
    fill: "url(#paint214_linear_2253_1261)"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    d: "M416.903 451.177L456.165 428.506C456.958 428.044 457.699 427.965 458.294 428.189C458.373 428.216 459.814 429.035 459.88 429.075C459.259 428.771 458.479 428.824 457.619 429.326L418.371 451.996C416.361 453.158 414.735 456.263 414.735 458.932V488.934C414.735 490.599 415.37 491.709 416.335 492.026C416.256 492.026 416.163 491.999 416.018 491.92C415.978 491.894 414.445 490.995 414.405 490.956C413.718 490.467 413.281 489.476 413.281 488.102V458.099C413.281 455.431 414.907 452.313 416.917 451.164L416.903 451.177Z",
    fill: "url(#paint215_linear_2253_1261)"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    d: "M416.942 451.19L456.204 428.52C456.998 428.057 457.738 427.978 458.333 428.203C458.412 428.229 459.813 429.035 459.893 429.075C459.271 428.771 458.491 428.824 457.632 429.326L418.383 451.996C416.374 453.159 414.748 456.263 414.748 458.932V488.934C414.748 490.599 415.383 491.709 416.348 492.026C416.268 492.026 416.176 491.999 416.03 491.92C415.991 491.894 414.484 491.009 414.444 490.982C413.757 490.493 413.32 489.503 413.32 488.129V458.126C413.32 455.457 414.946 452.34 416.956 451.19H416.942Z",
    fill: "url(#paint216_linear_2253_1261)"
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    d: "M416.966 451.217L456.228 428.546C457.021 428.084 457.761 428.005 458.356 428.229C458.435 428.256 459.81 429.035 459.89 429.075C459.268 428.771 458.488 428.824 457.629 429.326L418.38 451.996C416.371 453.159 414.745 456.263 414.745 458.932V488.934C414.745 490.599 415.38 491.709 416.345 492.026C416.265 492.026 416.173 491.999 416.027 491.92C415.988 491.894 414.52 491.035 414.467 490.995C413.78 490.507 413.344 489.516 413.344 488.142V458.139C413.344 455.471 414.97 452.353 416.979 451.203L416.966 451.217Z",
    fill: "url(#paint217_linear_2253_1261)"
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    d: "M416.997 451.23L456.259 428.559C457.052 428.097 457.792 428.018 458.387 428.242C458.467 428.269 459.815 429.035 459.881 429.075C459.26 428.771 458.48 428.824 457.621 429.326L418.372 451.996C416.363 453.159 414.737 456.263 414.737 458.932V488.934C414.737 490.599 415.371 491.709 416.336 492.026C416.257 492.026 416.164 491.999 416.019 491.92C415.979 491.894 414.538 491.048 414.499 491.022C413.811 490.533 413.375 489.542 413.375 488.168V458.166C413.375 455.497 415.001 452.379 417.01 451.23H416.997Z",
    fill: "url(#paint218_linear_2253_1261)"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    d: "M417.036 451.256L456.298 428.586C457.091 428.123 457.832 428.044 458.426 428.269C458.506 428.295 459.828 429.035 459.894 429.075C459.272 428.771 458.493 428.824 457.633 429.326L418.385 451.996C416.375 453.159 414.749 456.263 414.749 458.932V488.934C414.749 490.599 415.384 491.709 416.349 492.026C416.269 492.026 416.177 491.999 416.032 491.92C415.992 491.894 414.577 491.075 414.538 491.035C413.85 490.546 413.414 489.555 413.414 488.181V458.179C413.414 455.51 415.04 452.392 417.049 451.243L417.036 451.256Z",
    fill: "url(#paint219_linear_2253_1261)"
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    d: "M417.06 451.269L456.322 428.599C457.115 428.137 457.855 428.057 458.45 428.282C458.529 428.308 459.811 429.035 459.891 429.075C459.269 428.771 458.49 428.824 457.63 429.326L418.382 451.996C416.372 453.159 414.746 456.263 414.746 458.932V488.934C414.746 490.599 415.381 491.709 416.346 492.026C416.266 492.026 416.174 491.999 416.029 491.92C415.989 491.894 414.614 491.088 414.561 491.061C413.874 490.572 413.438 489.582 413.438 488.208V458.205C413.438 455.537 415.063 452.419 417.073 451.269H417.06Z",
    fill: "url(#paint220_linear_2253_1261)"
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    d: "M417.083 451.296L456.345 428.625C457.138 428.163 457.878 428.084 458.473 428.308C458.553 428.335 459.808 429.035 459.875 429.074C459.253 428.771 458.473 428.823 457.614 429.326L418.365 451.996C416.356 453.158 414.73 456.263 414.73 458.932V488.934C414.73 490.599 415.365 491.709 416.33 492.026C416.25 492.026 416.158 491.999 416.012 491.92C415.973 491.894 414.624 491.114 414.585 491.088C413.897 490.599 413.461 489.608 413.461 488.234V458.232C413.461 455.563 415.087 452.445 417.096 451.296H417.083Z",
    fill: "url(#paint221_linear_2253_1261)"
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    d: "M417.13 451.309L456.392 428.639C457.185 428.176 457.925 428.097 458.52 428.321C458.599 428.348 459.829 429.035 459.895 429.074C459.274 428.771 458.494 428.823 457.634 429.325L418.386 451.996C416.376 453.158 414.75 456.263 414.75 458.932V488.934C414.75 490.599 415.385 491.709 416.35 492.026C416.271 492.026 416.178 491.999 416.033 491.92C415.993 491.893 414.671 491.127 414.631 491.101C413.944 490.612 413.508 489.621 413.508 488.247V458.245C413.508 455.576 415.134 452.458 417.143 451.309H417.13Z",
    fill: "url(#paint222_linear_2253_1261)"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    d: "M417.153 451.335L456.415 428.665C457.208 428.202 457.949 428.123 458.544 428.348C458.623 428.374 459.813 429.035 459.892 429.074C459.271 428.771 458.491 428.823 457.631 429.325L418.383 451.996C416.373 453.158 414.747 456.263 414.747 458.932V488.934C414.747 490.599 415.382 491.709 416.347 492.026C416.268 492.026 416.175 491.999 416.03 491.92C415.99 491.893 414.695 491.154 414.655 491.127C413.968 490.638 413.531 489.648 413.531 488.274V458.271C413.531 455.602 415.157 452.485 417.167 451.335H417.153Z",
    fill: "url(#paint223_linear_2253_1261)"
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    d: "M417.182 451.348L456.444 428.678C457.237 428.216 457.978 428.136 458.572 428.361C458.652 428.387 459.815 429.035 459.881 429.074C459.26 428.771 458.48 428.823 457.621 429.325L418.372 451.996C416.363 453.158 414.737 456.263 414.737 458.932V488.934C414.737 490.599 415.371 491.708 416.336 492.026C416.257 492.026 416.164 491.999 416.019 491.92C415.979 491.893 414.723 491.167 414.671 491.14C413.983 490.652 413.547 489.661 413.547 488.287V458.284C413.547 455.616 415.173 452.498 417.182 451.348Z",
    fill: "url(#paint224_linear_2253_1261)"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    d: "M417.216 451.375L456.478 428.705C457.271 428.242 458.011 428.163 458.606 428.388C458.685 428.414 459.822 429.035 459.888 429.075C459.267 428.771 458.487 428.824 457.628 429.326L418.379 451.996C416.37 453.159 414.744 456.263 414.744 458.932V488.934C414.744 490.599 415.378 491.709 416.343 492.026C416.264 492.026 416.172 491.999 416.026 491.92C415.986 491.894 414.757 491.193 414.717 491.167C414.03 490.678 413.594 489.687 413.594 488.313V458.311C413.594 455.642 415.22 452.524 417.229 451.375H417.216Z",
    fill: "url(#paint225_linear_2253_1261)"
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    d: "M417.247 451.401L456.509 428.731C457.302 428.269 458.042 428.189 458.637 428.414C458.717 428.44 459.814 429.048 459.893 429.088C459.272 428.784 458.492 428.837 457.633 429.339L418.384 452.009C416.375 453.172 414.749 456.276 414.749 458.945V488.947C414.749 490.612 415.383 491.722 416.348 492.039C416.269 492.039 416.176 492.012 416.031 491.933C415.991 491.907 414.788 491.22 414.749 491.193C414.061 490.705 413.625 489.714 413.625 488.34V458.337C413.625 455.669 415.251 452.551 417.26 451.401H417.247Z",
    fill: "url(#paint226_linear_2253_1261)"
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    d: "M417.268 451.415L456.53 428.744C457.323 428.282 458.064 428.203 458.658 428.427C458.738 428.454 459.808 429.035 459.875 429.075C459.253 428.771 458.473 428.824 457.614 429.326L418.365 451.996C416.356 453.159 414.73 456.263 414.73 458.932V488.934C414.73 490.599 415.365 491.709 416.33 492.026C416.25 492.026 416.158 491.999 416.012 491.92C415.973 491.894 414.809 491.233 414.756 491.207C414.069 490.718 413.633 489.727 413.633 488.353V458.351C413.633 455.682 415.259 452.564 417.268 451.415Z",
    fill: "url(#paint227_linear_2253_1261)"
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    d: "M417.302 451.441L456.564 428.771C457.357 428.308 458.097 428.229 458.692 428.454C458.771 428.48 459.816 429.035 459.882 429.075C459.26 428.771 458.481 428.824 457.621 429.326L418.373 451.996C416.363 453.159 414.737 456.263 414.737 458.932V488.934C414.737 490.599 415.372 491.709 416.337 492.026C416.257 492.026 416.165 491.999 416.02 491.92C415.98 491.894 414.843 491.26 414.803 491.22C414.116 490.731 413.68 489.74 413.68 488.366V458.364C413.68 455.695 415.306 452.577 417.315 451.428L417.302 451.441Z",
    fill: "url(#paint228_linear_2253_1261)"
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    d: "M417.341 451.454L456.603 428.784C457.396 428.322 458.136 428.242 458.731 428.467C458.81 428.493 459.815 429.035 459.894 429.075C459.273 428.771 458.493 428.824 457.634 429.326L418.385 451.996C416.376 453.159 414.75 456.263 414.75 458.932V488.934C414.75 490.599 415.384 491.709 416.349 492.026C416.27 492.026 416.178 491.999 416.032 491.92C415.993 491.894 414.882 491.273 414.842 491.246C414.155 490.758 413.719 489.767 413.719 488.393V458.39C413.719 455.722 415.345 452.604 417.354 451.454H417.341Z",
    fill: "url(#paint229_linear_2253_1261)"
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    d: "M418.188 451.916L457.436 429.246C458.256 428.771 459.009 428.705 459.631 428.969C459.115 428.889 458.52 429.008 457.873 429.378L418.611 452.049C416.601 453.211 414.975 456.316 414.975 458.984V488.987C414.975 490.559 415.544 491.629 416.416 492.012C415.293 491.841 414.539 490.678 414.539 488.855V458.852C414.539 456.184 416.165 453.066 418.174 451.916H418.188Z",
    fill: "white"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.09,
    d: "M460.516 480.783L434.143 496.002C433.27 496.504 432.781 497.297 432.781 498.169C432.781 499.12 433.389 500.018 434.434 500.626L445.379 506.941C445.379 506.941 446.027 507.311 446.054 507.311C446.939 507.8 448.037 508.038 449.107 507.998C449.967 507.998 450.945 507.707 451.553 507.351L477.741 492.237C478.613 491.735 479.102 490.942 479.102 490.07C479.102 489.106 478.494 488.221 477.45 487.613L465.989 480.994C465.711 480.836 465.328 480.651 464.997 480.545C464.376 480.334 463.675 480.202 462.988 480.202C462.049 480.202 461.19 480.4 460.516 480.783Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M460.551 480.955L434.179 496.174C433.346 496.663 432.87 497.403 432.883 498.235C432.883 499.147 433.465 499.992 434.469 500.573L445.481 506.928C445.481 506.928 446.116 507.285 446.155 507.298C447.068 507.774 448.191 507.985 449.236 507.892C450.016 507.892 451.086 507.509 451.642 507.192L477.644 492.184C478.477 491.696 478.953 490.956 478.94 490.123C478.94 489.212 478.358 488.366 477.353 487.785L465.971 481.219C465.72 481.074 465.284 480.862 464.993 480.757C464.372 480.532 463.684 480.4 462.997 480.387C462.072 480.374 461.212 480.572 460.551 480.942V480.955Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.27,
    d: "M460.579 481.113L434.206 496.333C433.413 496.795 432.964 497.509 432.977 498.288C432.977 499.147 433.532 499.953 434.497 500.507L445.562 506.888C445.562 506.888 446.17 507.232 446.249 507.258C447.175 507.721 448.325 507.906 449.356 507.774C450.043 507.774 451.233 507.298 451.722 507.007L477.54 492.105C478.333 491.643 478.782 490.929 478.769 490.15C478.769 489.291 478.214 488.485 477.249 487.93L465.946 481.404C465.722 481.272 465.232 481.034 464.981 480.942C464.373 480.717 463.686 480.572 462.998 480.559C462.086 480.532 461.24 480.717 460.579 481.1V481.113Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.36,
    d: "M460.615 481.285L434.242 496.504C433.475 496.94 433.065 497.614 433.078 498.354C433.092 499.16 433.62 499.913 434.533 500.441L445.663 506.862C445.743 506.915 446.258 507.192 446.364 507.232C447.316 507.681 448.492 507.839 449.484 507.654C450.092 507.654 451.387 507.086 451.81 506.835L477.443 492.052C478.21 491.616 478.62 490.942 478.606 490.203C478.593 489.397 478.064 488.644 477.152 488.115L465.929 481.642C465.731 481.523 465.189 481.259 464.964 481.166C464.356 480.941 463.682 480.783 463.007 480.757C462.108 480.73 461.262 480.902 460.615 481.285Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M460.658 481.457L434.285 496.676C433.558 497.099 433.175 497.733 433.188 498.42C433.201 499.173 433.703 499.886 434.576 500.388L445.76 506.849C445.865 506.915 446.341 507.166 446.46 507.205C447.438 507.641 448.628 507.773 449.606 507.549C450.122 507.549 451.523 506.901 451.893 506.677L477.341 491.999C478.068 491.577 478.451 490.942 478.438 490.255C478.425 489.502 477.923 488.789 477.05 488.287L465.906 481.866C465.734 481.774 465.139 481.457 464.954 481.391C464.359 481.166 463.685 480.994 463.011 480.968C462.125 480.928 461.279 481.1 460.645 481.47L460.658 481.457Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.55,
    d: "M460.687 481.629L434.314 496.848C433.626 497.244 433.256 497.839 433.283 498.486C433.309 499.186 433.772 499.847 434.605 500.336L445.854 506.822C445.986 506.901 446.423 507.126 446.568 507.179C447.573 507.602 448.789 507.707 449.741 507.443C450.177 507.443 451.684 506.703 451.988 506.518L477.251 491.946C477.938 491.55 478.308 490.956 478.282 490.308C478.255 489.608 477.793 488.947 476.96 488.459L465.908 482.078C465.763 481.998 465.128 481.655 464.97 481.589C464.375 481.351 463.714 481.166 463.04 481.14C462.154 481.1 461.321 481.259 460.7 481.629H460.687Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.64,
    d: "M460.722 481.787L434.349 497.007C433.688 497.39 433.358 497.945 433.384 498.539C433.411 499.186 433.847 499.807 434.64 500.27L445.943 506.796C446.088 506.875 446.498 507.087 446.67 507.153C447.701 507.562 448.944 507.628 449.869 507.324C450.213 507.324 451.839 506.492 452.077 506.347L477.141 491.881C477.802 491.497 478.132 490.943 478.106 490.348C478.079 489.701 477.643 489.08 476.85 488.617L465.878 482.289C465.772 482.223 465.071 481.853 464.952 481.8C464.371 481.563 463.71 481.365 463.049 481.325C462.176 481.272 461.344 481.431 460.735 481.787H460.722Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.73,
    d: "M460.75 481.959L434.377 497.178C433.756 497.535 433.452 498.05 433.478 498.605C433.505 499.2 433.928 499.781 434.668 500.204L446.037 506.756C446.209 506.849 446.579 507.034 446.764 507.1C447.808 507.496 449.077 507.536 449.989 507.192C450.254 507.192 451.972 506.268 452.157 506.162L477.036 491.801C477.658 491.445 477.962 490.929 477.935 490.375C477.909 489.78 477.486 489.199 476.746 488.776L465.853 482.487C465.773 482.435 465.02 482.025 464.927 481.985C464.346 481.748 463.698 481.536 463.037 481.497C462.178 481.444 461.345 481.589 460.737 481.946L460.75 481.959Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.82,
    d: "M460.793 482.131L434.42 497.35C433.839 497.68 433.561 498.169 433.588 498.671C433.627 499.213 434.011 499.741 434.711 500.151L446.133 506.743C446.318 506.849 446.649 507.007 446.873 507.087C447.944 507.47 449.24 507.483 450.125 507.087C450.297 507.087 452.135 506.083 452.254 506.003L476.948 491.748C477.529 491.418 477.807 490.929 477.78 490.427C477.741 489.886 477.357 489.357 476.657 488.948L465.843 482.712C465.843 482.712 464.997 482.236 464.931 482.21C464.363 481.959 463.715 481.748 463.054 481.695C462.208 481.629 461.375 481.774 460.78 482.117L460.793 482.131Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.91,
    d: "M460.831 482.302L434.458 497.522C433.916 497.839 433.652 498.275 433.691 498.737C433.731 499.226 434.088 499.715 434.749 500.098L446.237 506.73C446.448 506.849 446.739 506.994 446.99 507.073C448.087 507.443 449.409 507.43 450.269 506.994C450.361 506.994 452.304 505.898 452.357 505.858L476.866 491.722C477.408 491.405 477.673 490.969 477.633 490.507C477.593 490.018 477.236 489.529 476.575 489.146L465.841 482.95C465.841 482.95 464.969 482.448 464.942 482.435C464.374 482.184 463.739 481.959 463.078 481.906C462.245 481.84 461.426 481.972 460.831 482.316V482.302Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.384 506.862L476.757 491.643C477.801 491.048 477.669 489.991 476.466 489.304L464.925 482.646C463.722 481.946 461.898 481.88 460.867 482.474L434.494 497.693C433.45 498.288 433.582 499.345 434.785 500.032L446.325 506.69C447.528 507.39 449.353 507.456 450.384 506.862Z",
    fill: "black"
  }))), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    d: "M450.386 506.835L476.759 491.616C477.221 491.352 477.459 490.995 477.459 490.612V489.304C477.459 488.855 477.116 489.635 476.468 489.265L464.927 482.606C463.724 481.906 461.9 481.84 460.869 482.434L434.496 497.654C434.152 497.852 433.901 497.006 433.809 497.271C433.782 497.363 433.809 498.552 433.809 498.645C433.809 499.107 434.139 499.609 434.8 499.992L446.341 506.651C447.544 507.351 449.368 507.417 450.399 506.822L450.386 506.835Z",
    fill: "#858FD6"
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    d: "M450.384 505.554L476.757 490.335C477.801 489.74 477.669 488.683 476.466 487.996L464.925 481.338C463.722 480.638 461.898 480.572 460.867 481.166L434.494 496.385C433.45 496.98 433.582 498.037 434.785 498.724L446.325 505.382C447.528 506.082 449.353 506.148 450.384 505.554Z",
    fill: "#CED3F4"
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    d: "M448.616 505.435C449.211 505.435 449.74 505.316 450.123 505.105L476.496 489.886C476.655 489.793 476.932 489.595 476.932 489.318C476.932 489.04 476.655 488.71 476.205 488.446L464.664 481.787C464.109 481.47 463.369 481.285 462.629 481.285C462.034 481.285 461.505 481.404 461.122 481.615L434.749 496.835C434.59 496.927 434.312 497.125 434.312 497.403C434.312 497.68 434.59 498.01 435.04 498.275L446.58 504.933C447.135 505.25 447.876 505.435 448.616 505.435Z",
    fill: "#AFB6E5"
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    d: "M449.087 503.216L472.829 489.516C473.305 489.238 473.239 488.763 472.697 488.445L463.787 483.306C463.232 482.989 462.412 482.95 461.936 483.227L438.194 496.927C437.718 497.204 437.784 497.68 438.326 497.997L447.236 503.136C447.792 503.453 448.611 503.493 449.087 503.216Z",
    fill: "#858FD6"
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    d: "M463.262 483.901C463.064 483.795 462.76 483.795 462.562 483.901L461.041 484.773C460.843 484.879 460.843 485.064 461.041 485.169C461.24 485.275 461.544 485.275 461.742 485.169L463.262 484.297C463.461 484.192 463.461 484.007 463.262 483.888V483.901ZM460.658 485.407C460.46 485.301 460.156 485.301 459.957 485.407L459.23 485.817C459.032 485.922 459.032 486.107 459.23 486.226C459.429 486.332 459.733 486.332 459.931 486.226L460.658 485.817C460.856 485.711 460.856 485.526 460.658 485.407ZM458.86 486.451C458.662 486.345 458.358 486.345 458.16 486.451L457.433 486.86C457.234 486.966 457.234 487.151 457.433 487.27C457.631 487.376 457.935 487.376 458.133 487.27L458.86 486.86C459.059 486.755 459.059 486.57 458.86 486.451ZM457.062 487.494C456.864 487.389 456.56 487.389 456.362 487.494L455.635 487.904C455.436 488.01 455.436 488.195 455.635 488.314C455.833 488.419 456.137 488.419 456.335 488.314L457.062 487.904C457.261 487.798 457.261 487.613 457.062 487.494ZM455.265 488.538C455.066 488.432 454.762 488.432 454.564 488.538L453.837 488.948C453.639 489.053 453.639 489.238 453.837 489.357C454.035 489.463 454.339 489.463 454.537 489.357L455.265 488.948C455.463 488.842 455.463 488.657 455.265 488.538ZM453.467 489.582C453.268 489.476 452.964 489.476 452.766 489.582L452.039 489.991C451.841 490.097 451.841 490.282 452.039 490.401C452.237 490.507 452.541 490.507 452.74 490.401L453.467 489.991C453.665 489.886 453.665 489.701 453.467 489.582ZM451.669 490.626C451.471 490.52 451.166 490.52 450.968 490.626L450.241 491.035C450.043 491.141 450.043 491.326 450.241 491.445C450.439 491.55 450.743 491.55 450.942 491.445L451.669 491.035C451.867 490.929 451.867 490.744 451.669 490.626ZM449.871 491.669C449.673 491.564 449.369 491.564 449.17 491.669L448.443 492.079C448.245 492.184 448.245 492.369 448.443 492.488C448.642 492.594 448.946 492.594 449.144 492.488L449.871 492.079C450.069 491.973 450.069 491.788 449.871 491.669ZM448.073 492.713C447.875 492.607 447.571 492.607 447.372 492.713L446.645 493.122C446.447 493.228 446.447 493.413 446.645 493.532C446.844 493.638 447.148 493.638 447.346 493.532L448.073 493.122C448.271 493.017 448.271 492.832 448.073 492.713ZM446.275 493.757C446.077 493.651 445.773 493.651 445.575 493.757L444.848 494.166C444.649 494.272 444.649 494.457 444.848 494.576C445.046 494.681 445.35 494.681 445.548 494.576L446.275 494.166C446.474 494.06 446.474 493.875 446.275 493.757ZM444.477 494.8C444.279 494.695 443.975 494.695 443.777 494.8L443.05 495.21C442.851 495.315 442.851 495.5 443.05 495.619C443.248 495.725 443.552 495.725 443.75 495.619L444.477 495.21C444.676 495.104 444.676 494.919 444.477 494.8ZM442.68 495.844C442.481 495.738 442.177 495.738 441.979 495.844L441.252 496.253C441.054 496.359 441.054 496.544 441.252 496.663C441.45 496.769 441.754 496.769 441.952 496.663L442.68 496.253C442.878 496.148 442.878 495.963 442.68 495.844ZM440.842 496.901C440.644 496.795 440.34 496.795 440.141 496.901L439.414 497.31C439.216 497.416 439.216 497.601 439.414 497.72C439.613 497.826 439.917 497.826 440.115 497.72L440.842 497.31C441.04 497.205 441.04 497.02 440.842 496.901ZM464.954 484.865L464.333 484.509C464.108 484.377 463.765 484.377 463.54 484.509L462.919 484.865C462.694 484.998 462.694 485.196 462.919 485.328L463.54 485.685C463.765 485.817 464.108 485.803 464.333 485.685L464.954 485.328C465.179 485.196 465.179 484.998 464.954 484.865ZM462.522 486.728L463.143 486.372C463.368 486.239 463.368 486.041 463.143 485.909L462.522 485.552C462.297 485.42 461.954 485.42 461.729 485.552L461.108 485.909C460.883 486.041 460.883 486.239 461.108 486.372L461.729 486.728C461.954 486.86 462.297 486.847 462.522 486.728ZM461.345 486.953L460.724 486.596C460.499 486.464 460.156 486.464 459.931 486.596L459.31 486.953C459.085 487.085 459.085 487.283 459.31 487.415L459.931 487.772C460.156 487.904 460.499 487.904 460.724 487.772L461.345 487.415C461.57 487.283 461.57 487.085 461.345 486.953ZM459.548 487.997L458.926 487.64C458.702 487.508 458.358 487.508 458.133 487.64L457.512 487.997C457.287 488.129 457.287 488.327 457.512 488.459L458.133 488.816C458.358 488.948 458.702 488.948 458.926 488.816L459.548 488.459C459.772 488.327 459.772 488.129 459.548 487.997ZM455.701 489.503L456.322 489.859C456.547 489.991 456.891 489.991 457.115 489.859L457.737 489.503C457.961 489.37 457.961 489.172 457.737 489.04L457.115 488.683C456.891 488.551 456.547 488.551 456.322 488.683L455.701 489.04C455.476 489.172 455.476 489.37 455.701 489.503ZM453.903 490.546L454.524 490.903C454.749 491.035 455.093 491.035 455.317 490.903L455.939 490.546C456.163 490.414 456.163 490.216 455.939 490.084L455.317 489.727C455.093 489.595 454.749 489.595 454.524 489.727L453.903 490.084C453.678 490.216 453.678 490.414 453.903 490.546ZM452.105 491.59L452.726 491.947C452.951 492.079 453.295 492.079 453.52 491.947L454.141 491.59C454.366 491.458 454.366 491.26 454.141 491.128L453.52 490.771C453.295 490.639 452.951 490.639 452.726 490.771L452.105 491.128C451.88 491.26 451.88 491.458 452.105 491.59ZM450.307 492.634L450.929 492.99C451.153 493.122 451.497 493.122 451.722 492.99L452.343 492.634C452.568 492.501 452.568 492.303 452.343 492.171L451.722 491.815C451.497 491.682 451.153 491.682 450.929 491.815L450.307 492.171C450.082 492.303 450.082 492.501 450.307 492.634ZM448.509 493.677L449.131 494.034C449.355 494.166 449.699 494.166 449.924 494.034L450.545 493.677C450.77 493.545 450.77 493.347 450.545 493.215L449.924 492.858C449.699 492.726 449.355 492.726 449.131 492.858L448.509 493.215C448.285 493.347 448.285 493.545 448.509 493.677ZM446.712 494.721L447.333 495.078C447.558 495.21 447.901 495.21 448.126 495.078L448.747 494.721C448.972 494.589 448.972 494.391 448.747 494.259L448.126 493.902C447.901 493.77 447.558 493.77 447.333 493.902L446.712 494.259C446.487 494.391 446.487 494.589 446.712 494.721ZM446.949 495.302L446.328 494.946C446.103 494.813 445.76 494.813 445.535 494.946L444.914 495.302C444.689 495.434 444.689 495.633 444.914 495.765L445.535 496.121C445.76 496.253 446.103 496.253 446.328 496.121L446.949 495.765C447.174 495.633 447.174 495.434 446.949 495.302ZM443.103 496.808L443.724 497.165C443.949 497.297 444.292 497.297 444.517 497.165L445.138 496.808C445.363 496.676 445.363 496.478 445.138 496.346L444.517 495.989C444.292 495.857 443.949 495.857 443.724 495.989L443.103 496.346C442.878 496.478 442.878 496.676 443.103 496.808ZM440.459 498.328L441.08 498.684C441.305 498.816 441.648 498.816 441.873 498.684L443.301 497.865C443.526 497.733 443.526 497.535 443.301 497.403L442.68 497.046C442.455 496.914 442.111 496.914 441.886 497.046L440.459 497.865C440.234 497.997 440.234 498.195 440.459 498.328ZM466.66 485.856L466.038 485.5C465.814 485.367 465.47 485.381 465.245 485.5L463.818 486.319C463.593 486.451 463.593 486.649 463.818 486.781L464.439 487.138C464.664 487.27 465.007 487.27 465.232 487.138L466.66 486.319C466.884 486.187 466.884 485.988 466.66 485.856ZM464.055 487.362L463.434 487.006C463.209 486.874 462.866 486.874 462.641 487.006L462.02 487.362C461.795 487.494 461.795 487.693 462.02 487.825L462.641 488.181C462.866 488.314 463.209 488.314 463.434 488.181L464.055 487.825C464.28 487.693 464.28 487.494 464.055 487.362ZM462.244 488.868C462.469 488.736 462.469 488.538 462.244 488.406L461.623 488.049C461.398 487.917 461.055 487.917 460.83 488.049L460.209 488.406C459.984 488.538 459.984 488.736 460.209 488.868L460.83 489.225C461.055 489.357 461.398 489.357 461.623 489.225L462.244 488.868ZM460.447 489.912C460.671 489.78 460.671 489.582 460.447 489.45L459.825 489.093C459.601 488.961 459.257 488.961 459.032 489.093L458.411 489.45C458.186 489.582 458.186 489.78 458.411 489.912L459.032 490.269C459.257 490.401 459.601 490.401 459.825 490.269L460.447 489.912ZM457.234 490.137L456.613 490.493C456.388 490.626 456.388 490.824 456.613 490.956L457.234 491.312C457.459 491.445 457.803 491.445 458.027 491.312L458.649 490.956C458.873 490.824 458.873 490.626 458.649 490.493L458.027 490.137C457.803 490.005 457.459 490.005 457.234 490.137ZM455.463 491.154L454.762 491.563C454.564 491.682 454.564 491.867 454.762 491.973L455.463 492.369C455.661 492.488 455.978 492.488 456.177 492.369L456.877 491.96C457.076 491.841 457.076 491.656 456.877 491.55L456.177 491.154C455.978 491.035 455.661 491.035 455.463 491.154ZM453.665 492.198L452.964 492.607C452.766 492.726 452.766 492.911 452.964 493.017L453.665 493.413C453.863 493.532 454.181 493.532 454.379 493.413L455.079 493.004C455.278 492.885 455.278 492.7 455.079 492.594L454.379 492.198C454.181 492.079 453.863 492.079 453.665 492.198ZM451.867 493.241L451.166 493.651C450.968 493.77 450.968 493.955 451.166 494.06L451.867 494.457C452.065 494.576 452.383 494.576 452.581 494.457L453.282 494.047C453.48 493.928 453.48 493.743 453.282 493.638L452.581 493.241C452.383 493.122 452.065 493.122 451.867 493.241ZM450.069 494.285L449.369 494.695C449.17 494.813 449.17 494.998 449.369 495.104L450.069 495.5C450.268 495.619 450.585 495.619 450.783 495.5L451.484 495.091C451.682 494.972 451.682 494.787 451.484 494.681L450.783 494.285C450.585 494.166 450.268 494.166 450.069 494.285ZM448.271 495.329L447.571 495.738C447.372 495.857 447.372 496.042 447.571 496.148L448.271 496.544C448.47 496.663 448.787 496.663 448.985 496.544L449.686 496.135C449.884 496.016 449.884 495.831 449.686 495.725L448.985 495.329C448.787 495.21 448.47 495.21 448.271 495.329ZM447.174 497.588L447.875 497.178C448.073 497.059 448.073 496.874 447.875 496.769L447.174 496.372C446.976 496.253 446.659 496.253 446.46 496.372L445.76 496.782C445.561 496.901 445.561 497.086 445.76 497.191L446.46 497.588C446.659 497.707 446.976 497.707 447.174 497.588ZM445.376 498.631L446.077 498.222C446.275 498.103 446.275 497.918 446.077 497.812L445.376 497.416C445.178 497.297 444.861 497.297 444.662 497.416L443.962 497.826C443.764 497.944 443.764 498.129 443.962 498.235L444.662 498.631C444.861 498.75 445.178 498.75 445.376 498.631ZM442.124 499.292L442.825 499.688C443.023 499.807 443.341 499.807 443.539 499.688L444.239 499.279C444.438 499.16 444.438 498.975 444.239 498.869L443.539 498.473C443.341 498.354 443.023 498.354 442.825 498.473L442.124 498.882C441.926 499.001 441.926 499.186 442.124 499.292ZM468.405 486.86L467.704 486.464C467.506 486.345 467.188 486.345 466.99 486.464L464.73 487.772C464.531 487.891 464.531 488.076 464.73 488.181L465.43 488.578C465.629 488.697 465.946 488.697 466.144 488.578L468.405 487.27C468.603 487.151 468.603 486.966 468.405 486.86ZM465.034 488.802L464.333 488.406C464.135 488.287 463.818 488.287 463.619 488.406L462.919 488.816C462.72 488.934 462.72 489.119 462.919 489.225L463.619 489.621C463.818 489.74 464.135 489.74 464.333 489.621L465.034 489.212C465.232 489.093 465.232 488.908 465.034 488.802ZM463.236 489.846L462.535 489.45C462.337 489.331 462.02 489.331 461.821 489.45L461.121 489.859C460.922 489.978 460.922 490.163 461.121 490.269L461.821 490.665C462.02 490.784 462.337 490.784 462.535 490.665L463.236 490.256C463.434 490.137 463.434 489.952 463.236 489.846ZM461.438 490.89L460.737 490.493C460.539 490.374 460.222 490.374 460.024 490.493L459.323 490.903C459.125 491.022 459.125 491.207 459.323 491.312L460.024 491.709C460.222 491.828 460.539 491.828 460.737 491.709L461.438 491.299C461.636 491.18 461.636 490.995 461.438 490.89ZM458.926 492.752L459.627 492.343C459.825 492.224 459.825 492.039 459.627 491.933L458.926 491.537C458.728 491.418 458.411 491.418 458.212 491.537L457.512 491.947C457.314 492.066 457.314 492.25 457.512 492.356L458.212 492.752C458.411 492.871 458.728 492.871 458.926 492.752ZM457.128 493.796L457.829 493.387C458.027 493.268 458.027 493.083 457.829 492.977L457.128 492.581C456.93 492.462 456.613 492.462 456.415 492.581L455.714 492.99C455.516 493.109 455.516 493.294 455.714 493.4L456.415 493.796C456.613 493.915 456.93 493.915 457.128 493.796ZM455.331 494.84L456.031 494.43C456.23 494.311 456.23 494.126 456.031 494.021L455.331 493.624C455.132 493.506 454.815 493.506 454.617 493.624L453.916 494.034C453.718 494.153 453.718 494.338 453.916 494.444L454.617 494.84C454.815 494.959 455.132 494.959 455.331 494.84ZM453.533 495.884L454.233 495.474C454.432 495.355 454.432 495.17 454.233 495.064L453.533 494.668C453.334 494.549 453.017 494.549 452.819 494.668L452.118 495.078C451.92 495.197 451.92 495.382 452.118 495.487L452.819 495.884C453.017 496.002 453.334 496.002 453.533 495.884ZM451.735 496.927L452.436 496.518C452.634 496.399 452.634 496.214 452.436 496.108L451.735 495.712C451.537 495.593 451.219 495.593 451.021 495.712L450.32 496.121C450.122 496.24 450.122 496.425 450.32 496.531L451.021 496.927C451.219 497.046 451.537 497.046 451.735 496.927ZM449.937 497.971L450.638 497.561C450.836 497.442 450.836 497.258 450.638 497.152L449.937 496.755C449.739 496.637 449.421 496.637 449.223 496.755L448.523 497.165C448.324 497.284 448.324 497.469 448.523 497.575L449.223 497.971C449.421 498.09 449.739 498.09 449.937 497.971ZM448.84 498.195L448.139 497.799C447.941 497.68 447.624 497.68 447.425 497.799L446.725 498.209C446.526 498.328 446.526 498.513 446.725 498.618L447.425 499.015C447.624 499.134 447.941 499.134 448.139 499.015L448.84 498.605C449.038 498.486 449.038 498.301 448.84 498.195ZM443.843 500.283L444.544 500.679C444.742 500.798 445.059 500.798 445.257 500.679L447.042 499.649C447.24 499.53 447.24 499.345 447.042 499.239L446.341 498.843C446.143 498.724 445.826 498.724 445.628 498.843L443.843 499.873C443.645 499.992 443.645 500.177 443.843 500.283ZM470.11 487.851L469.502 487.508C469.277 487.376 468.92 487.376 468.696 487.508L465.483 489.357C465.258 489.489 465.258 489.701 465.483 489.82L466.091 490.163C466.316 490.295 466.673 490.295 466.898 490.163L470.11 488.314C470.335 488.181 470.335 487.97 470.11 487.851ZM465.708 490.388L465.1 490.044C464.875 489.912 464.518 489.912 464.293 490.044L463.685 490.401C463.461 490.533 463.461 490.744 463.685 490.863L464.293 491.207C464.518 491.339 464.875 491.339 465.1 491.207L465.708 490.85C465.933 490.718 465.933 490.507 465.708 490.388ZM463.91 491.431L463.302 491.088C463.077 490.956 462.72 490.956 462.496 491.088L461.887 491.445C461.663 491.577 461.663 491.788 461.887 491.907L462.496 492.25C462.72 492.383 463.077 492.383 463.302 492.25L463.91 491.894C464.135 491.762 464.135 491.55 463.91 491.431ZM462.112 492.475L461.504 492.132C461.279 491.999 460.922 491.999 460.698 492.132L460.09 492.488C459.865 492.62 459.865 492.832 460.09 492.951L460.698 493.294C460.922 493.426 461.279 493.426 461.504 493.294L462.112 492.937C462.337 492.805 462.337 492.594 462.112 492.475ZM460.314 493.519L459.706 493.175C459.482 493.043 459.125 493.043 458.9 493.175L458.292 493.532C458.067 493.664 458.067 493.875 458.292 493.994L458.9 494.338C459.125 494.47 459.482 494.47 459.706 494.338L460.314 493.981C460.539 493.849 460.539 493.638 460.314 493.519ZM458.517 494.562L457.908 494.219C457.684 494.087 457.327 494.087 457.102 494.219L456.494 494.576C456.269 494.708 456.269 494.919 456.494 495.038L457.102 495.382C457.327 495.514 457.684 495.514 457.908 495.382L458.517 495.025C458.741 494.893 458.741 494.681 458.517 494.562ZM456.719 495.606L456.111 495.263C455.886 495.131 455.529 495.131 455.304 495.263L454.696 495.619C454.471 495.751 454.471 495.963 454.696 496.082L455.304 496.425C455.529 496.557 455.886 496.557 456.111 496.425L456.719 496.069C456.943 495.936 456.943 495.725 456.719 495.606ZM454.921 496.65L454.313 496.306C454.088 496.174 453.731 496.174 453.506 496.306L452.898 496.663C452.673 496.795 452.673 497.006 452.898 497.125L453.506 497.469C453.731 497.601 454.088 497.601 454.313 497.469L454.921 497.112C455.146 496.98 455.146 496.769 454.921 496.65ZM453.123 497.693L452.515 497.35C452.29 497.218 451.933 497.218 451.708 497.35L451.1 497.707C450.876 497.839 450.876 498.05 451.1 498.169L451.708 498.513C451.933 498.645 452.29 498.645 452.515 498.513L453.123 498.156C453.348 498.024 453.348 497.812 453.123 497.693ZM451.325 498.737L450.717 498.394C450.492 498.262 450.135 498.262 449.911 498.394L449.303 498.75C449.078 498.882 449.078 499.094 449.303 499.213L449.911 499.556C450.135 499.688 450.492 499.688 450.717 499.556L451.325 499.2C451.55 499.067 451.55 498.856 451.325 498.737ZM449.527 499.781L448.919 499.437C448.694 499.305 448.338 499.305 448.113 499.437L447.505 499.794C447.28 499.926 447.28 500.138 447.505 500.256L448.113 500.6C448.338 500.732 448.694 500.732 448.919 500.6L449.527 500.243C449.752 500.111 449.752 499.9 449.527 499.781ZM445.654 501.313L446.262 501.657C446.487 501.789 446.844 501.789 447.068 501.657L447.677 501.3C447.901 501.168 447.901 500.957 447.677 500.838L447.068 500.494C446.844 500.362 446.487 500.362 446.262 500.494L445.654 500.851C445.429 500.983 445.429 501.194 445.654 501.313ZM469.013 489.767L469.621 490.11C469.846 490.242 470.203 490.242 470.427 490.11L471.842 489.304C472.066 489.172 472.066 488.961 471.842 488.842L471.234 488.498C471.009 488.366 470.652 488.366 470.427 488.498L469.013 489.304C468.788 489.437 468.788 489.648 469.013 489.767ZM467.215 490.81L467.823 491.154C468.048 491.286 468.405 491.286 468.629 491.154L469.238 490.797C469.462 490.665 469.462 490.454 469.238 490.335L468.629 489.991C468.405 489.859 468.048 489.859 467.823 489.991L467.215 490.348C466.99 490.48 466.99 490.692 467.215 490.81ZM465.417 491.854L466.025 492.198C466.25 492.33 466.607 492.33 466.832 492.198L467.44 491.841C467.664 491.709 467.664 491.497 467.44 491.379L466.832 491.035C466.607 490.903 466.25 490.903 466.025 491.035L465.417 491.392C465.192 491.524 465.192 491.735 465.417 491.854ZM452.792 499.147L453.401 499.49C453.625 499.622 453.982 499.622 454.207 499.49L465.642 492.898C465.867 492.766 465.867 492.554 465.642 492.435L465.034 492.092C464.809 491.96 464.452 491.96 464.227 492.092L452.792 498.684C452.568 498.816 452.568 499.028 452.792 499.147ZM450.995 500.19L451.603 500.534C451.827 500.666 452.184 500.666 452.409 500.534L453.017 500.177C453.242 500.045 453.242 499.834 453.017 499.715L452.409 499.371C452.184 499.239 451.827 499.239 451.603 499.371L450.995 499.728C450.77 499.86 450.77 500.071 450.995 500.19ZM449.197 501.234L449.805 501.578C450.03 501.71 450.387 501.71 450.611 501.578L451.219 501.221C451.444 501.089 451.444 500.877 451.219 500.758L450.611 500.415C450.387 500.283 450.03 500.283 449.805 500.415L449.197 500.772C448.972 500.904 448.972 501.115 449.197 501.234ZM447.359 502.291L447.967 502.634C448.192 502.767 448.549 502.767 448.774 502.634L449.382 502.278C449.607 502.146 449.607 501.934 449.382 501.815L448.774 501.472C448.549 501.34 448.192 501.34 447.967 501.472L447.359 501.829C447.135 501.961 447.135 502.172 447.359 502.291Z",
    fill: "#E5E9FF"
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    d: "M491.172 471.443C495.152 470.703 497.505 472.936 498.827 477.692C500.677 484.403 504.709 497.138 501.616 499.9C498.271 502.885 475.111 500.203 475.111 500.203C475.111 500.203 474.252 497.429 474.41 495.157C474.569 492.884 475.917 492.184 475.917 492.184C475.917 492.184 487.524 492.435 492.19 491.999C492.917 491.933 489.93 487.613 488.41 481.153C487.233 476.093 487.326 472.169 491.172 471.443Z",
    fill: "url(#paint230_linear_2253_1261)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    d: "M491.172 471.443C495.152 470.703 497.505 472.936 498.827 477.692C500.677 484.403 504.709 497.138 501.616 499.9C498.271 502.885 475.111 500.203 475.111 500.203C475.111 500.203 474.252 497.429 474.41 495.157C474.569 492.884 475.917 492.184 475.917 492.184C475.917 492.184 487.524 492.435 492.19 491.999C492.917 491.933 489.93 487.613 488.41 481.153C487.233 476.093 487.326 472.169 491.172 471.443Z",
    fill: "#CED3F4"
  }))), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    d: "M487.061 471.298C487.061 471.298 489.005 470.69 491.358 470.69C493.711 470.69 496.95 472.355 497.967 476.595C498.946 480.651 498.708 486.781 499.078 493.03C500.294 514.089 504.273 516.216 497.875 519.637C493.565 521.936 487.114 526.124 482.025 525.847C479.553 525.714 475.878 522.028 474.119 519.783C471.859 516.903 471.925 516.453 471.119 506.611C470.246 495.87 468.488 486.068 470.603 482.778C474.172 477.229 487.048 471.298 487.048 471.298H487.061Z",
    fill: "url(#paint231_linear_2253_1261)"
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    d: "M479.036 476.054C479.34 477.573 482.024 478.299 485.038 477.692C488.038 477.084 490.233 475.367 489.929 473.847C489.625 472.328 486.941 471.601 483.927 472.209C480.926 472.817 478.732 474.534 479.036 476.054Z",
    fill: "white"
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    d: "M489.026 473.332C489.225 473.636 489.132 474.045 488.973 474.376C488.669 475.01 487.096 476.503 484.77 476.899C482.417 477.295 481.081 476.899 480.42 476.635C480.077 476.489 479.826 476.199 479.707 475.842L478.689 472.711C478.689 472.711 476.217 473.279 475.318 472.46C474.419 471.641 469.898 460.174 472.951 456.607C476.005 453.04 483.91 452.564 486.065 457.769C488.22 462.961 486.263 466.29 486.263 467.585C486.263 468.642 488.246 472.077 489.026 473.332Z",
    fill: "#FFD4C0"
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    d: "M486.45 468.51C486.45 468.51 483.766 469.924 482.51 469.791C480.263 469.54 479.523 464.573 477.897 463.688C476.932 463.159 476.323 464.058 476.561 464.93C476.746 465.643 476.667 466.172 476.403 466.304C476.152 466.436 474.023 462.38 474.023 462.38C474.023 462.38 467.863 460.98 468.418 457.954C469.37 452.709 484.387 448.944 486.595 456.554C488.816 464.203 487.692 467.915 486.45 468.523V468.51Z",
    fill: "url(#paint232_linear_2253_1261)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    d: "M474.115 519.782C471.854 516.902 471.92 516.453 471.114 506.611C470.413 498.063 469.17 490.136 469.752 485.579L478.596 485.975C478.596 485.975 484.056 498.156 483.567 509.953C483.342 515.409 480.447 515.026 480.447 515.026L482.443 525.859C482.297 525.859 482.152 525.859 482.007 525.859C479.535 525.727 475.86 522.041 474.101 519.795L474.115 519.782Z",
    fill: "#CED3F4"
  }))), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    d: "M455.955 503.136C455.426 502.489 454.223 501.009 453.576 500.6C452.928 500.204 451.315 499.768 451.104 500.322C450.892 500.877 452.055 501.009 452.426 501.485C452.796 501.961 453.377 502.515 453.457 503.018C453.536 503.52 455.955 503.136 455.955 503.136Z",
    fill: "#FFD4C0"
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    d: "M456.653 507.932C456.653 507.932 453.031 507.786 451.035 507.337C449.964 507.1 449.29 506.849 447.955 505.369C447.333 504.682 446.95 504.101 447.228 503.691C447.36 503.506 447.677 503.968 447.677 503.968C447.677 503.968 446.725 502.687 447.016 502.145C447.307 501.604 447.889 502.74 447.889 502.74C447.889 502.74 446.977 501.392 447.294 500.877C447.611 500.349 448.761 502.04 448.761 502.04C448.761 502.04 448.127 501.207 448.312 500.732C448.497 500.256 448.788 500.401 449.316 500.864C449.938 501.406 450.757 502.092 452.238 502.41C453.811 502.74 455.04 502.159 455.979 503.083C456.918 504.008 458.623 504.153 458.623 504.153L456.666 507.932H456.653Z",
    fill: "#FFD4C0"
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    d: "M447.634 503.942C447.634 503.942 447.621 503.929 447.608 503.903L447.661 503.982C447.661 503.982 448.454 505.21 449.67 505.779C450.728 506.267 456.002 506.399 457.443 506.426L456.65 507.958C456.65 507.958 453.028 507.813 451.032 507.364C449.961 507.126 449.287 506.875 447.952 505.395C447.33 504.708 446.947 504.127 447.225 503.718C447.33 503.559 447.568 503.863 447.648 503.955L447.634 503.942Z",
    fill: "url(#paint233_radial_2253_1261)"
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    d: "M472.632 482.276C475.699 481.985 478.608 483.769 480.458 489.806C482.494 496.465 483.895 510.733 480.405 512.979C476.638 515.409 454.561 508.289 454.561 508.289C454.561 508.289 454.125 506.386 454.588 504.391C455.037 502.397 456.174 502.449 456.174 502.449C456.174 502.449 467.635 503.427 472.315 503.718C473.042 503.757 471.879 498.645 470.411 492.013C469.288 486.939 468.733 482.646 472.632 482.276Z",
    fill: "url(#paint234_linear_2253_1261)"
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    d: "M478.422 498.301V532.042C478.422 535.676 481.013 537.155 484.186 535.332L501.873 525.12C505.046 523.283 507.637 518.818 507.637 515.172V481.431C507.637 478.802 503.182 471.905 502.653 470.941C501.199 468.325 497.445 468.034 493.029 470.584C488.614 473.134 484.847 477.758 483.406 482.051C482.877 483.624 478.422 495.672 478.422 498.301Z",
    fill: "url(#paint235_linear_2253_1261)"
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    d: "M479.929 531.646V497.905C479.929 495.276 484.384 483.227 484.913 481.655C486.367 477.374 490.121 472.737 494.536 470.188C495.462 469.659 496.334 469.276 497.18 468.985C495.911 469.223 494.51 469.725 493.029 470.584C488.614 473.134 484.847 477.758 483.406 482.051C482.877 483.623 478.422 495.672 478.422 498.301V532.042C478.422 535.385 480.616 536.904 483.432 535.702C481.37 535.873 479.916 534.367 479.916 531.646H479.929Z",
    fill: "#AFB6E5"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M478.422 498.301V532.042C478.422 535.676 481.013 537.155 484.186 535.332L501.873 525.12C505.046 523.283 507.637 518.818 507.637 515.172V481.431C507.637 478.802 503.182 471.905 502.653 470.941C501.199 468.325 497.445 468.034 493.029 470.584C488.614 473.134 484.847 477.758 483.406 482.051C482.877 483.624 478.422 495.672 478.422 498.301Z",
    fill: "url(#paint236_linear_2253_1261)"
  }), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    d: "M498.059 485.341C497.583 485.447 497.08 485.592 496.578 485.764L496.605 485.922C497.107 485.698 497.596 485.513 498.072 485.341H498.059Z",
    fill: "#AFB6E5"
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    d: "M472.771 523.296V529.228L471 530.232V524.406L472.771 523.296Z",
    fill: "url(#paint237_linear_2253_1261)"
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    d: "M461.73 516.176V522.108L459.945 523.112V517.286L461.73 516.176Z",
    fill: "url(#paint238_linear_2253_1261)"
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    d: "M463.66 529.981L461.73 522.107L459.945 523.111L461.875 531.078L463.66 529.981Z",
    fill: "url(#paint239_linear_2253_1261)"
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    d: "M463.662 529.981L466.716 531.765L464.812 532.69L461.891 531.065L463.662 529.981Z",
    fill: "url(#paint240_linear_2253_1261)"
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    d: "M459.3 517.603L459.273 523.521L461.402 531.818L464.746 533.654L470.999 530.232V524.406L470.021 523.851V529.598L464.812 532.69L461.891 531.065L460.014 523.164L460.172 517.867L459.3 517.603Z",
    fill: "url(#paint241_linear_2253_1261)"
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    d: "M477.961 527.088C476.772 527.788 475.291 527.788 474.101 527.088C470.955 525.225 460.974 519.439 459.163 518.448C456.691 517.087 455.62 517.232 453.968 516.889C453.677 516.836 453.558 516.704 453.545 516.532C453.545 516.374 453.479 516.241 453.637 516.03C454.351 515.132 456.559 515.105 457.802 514.749C458.925 514.418 460.379 514.115 461.834 514.749C462.957 515.237 474.749 520.852 478.437 523.058C478.847 523.296 479.31 523.455 479.31 523.864C479.31 523.891 479.31 525.661 479.31 525.687C479.283 526.071 479.072 526.427 478.702 526.652L477.975 527.075L477.961 527.088Z",
    fill: "url(#paint242_linear_2253_1261)"
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    d: "M477.959 525.622C476.769 526.322 475.289 526.322 474.099 525.622C470.953 523.759 460.972 517.972 459.161 516.981C456.689 515.621 455.618 517.074 453.966 516.744C452.313 516.4 455.962 513.837 457.799 513.296C458.923 512.965 460.377 512.661 461.831 513.296C462.955 513.784 475.011 520.866 478.699 523.072C479.506 523.561 479.506 524.723 478.699 525.199L477.972 525.622H477.959Z",
    fill: "url(#paint243_linear_2253_1261)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M453.911 516.678C455.564 517.021 456.635 515.555 459.107 516.915C460.918 517.906 470.885 523.693 474.045 525.555C475.234 526.256 476.715 526.256 477.905 525.555L478.632 525.133C479.028 524.895 479.24 524.485 479.24 524.076C479.385 524.591 479.2 525.186 478.685 525.489L477.958 525.912C476.768 526.612 475.287 526.612 474.098 525.912C470.951 524.049 460.971 518.263 459.16 517.272C456.688 515.911 455.617 517.061 453.964 516.717C453.594 516.638 453.502 516.757 453.581 516.506C453.647 516.572 453.74 516.638 453.911 516.678Z",
    fill: "url(#paint244_radial_2253_1261)"
  }), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    d: "M455.489 442.55L457.393 441.414V440.093L455.489 441.229V442.55ZM449.475 446.011L454.551 443.105V441.784L449.475 444.69V446.011ZM453.771 440.489L455.542 439.485V438.164L453.771 439.168V440.489ZM450.532 441.044V442.365L452.832 441.044V439.723L450.532 441.044ZM449.593 441.586L447.373 442.867V444.188L449.593 442.907V441.586ZM448.536 445.232L447.386 445.893V447.214L448.536 446.553V445.232ZM452.832 451.864L447.373 455.008V456.329L452.832 453.185V451.864ZM450.942 449.909L447.373 451.97V453.291L450.942 451.23V449.909ZM449.937 447.452L447.373 448.931V450.252L449.937 448.773V447.452ZM453.943 445.14L450.876 446.91V448.231L453.943 446.461V445.14ZM456.058 449.988L453.758 451.309V452.63L456.058 451.309V449.988ZM449.461 464.23L454.538 461.323V460.002L449.461 462.909V464.23ZM456.825 455.629L453.758 457.4V458.721L456.825 456.95V455.629ZM451.312 460.134L452.819 459.262V457.941L451.312 458.813V460.134ZM450.373 459.355L447.359 461.085V462.407L450.373 460.676V459.355ZM448.523 463.45L447.373 464.111V465.432L448.523 464.771V463.45ZM447.373 468.47L449.937 466.991V465.67L447.373 467.149V468.47ZM450.995 455.946L447.373 458.034V459.355L450.995 457.267V455.946ZM450.876 466.449L453.943 464.679V463.358L450.876 465.128V466.449Z",
    fill: "url(#paint245_linear_2253_1261)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M438.091 463.714C436.954 464.058 435.937 464.005 435.13 463.582C434.641 463.331 434.654 462.419 435.13 461.587C435.751 460.517 436.294 459.315 436.65 458.152C437.166 457.69 437.814 456.765 437.814 456.052C437.814 455.338 437.496 454.902 437.06 454.995C436.928 452.035 435.87 450.067 432.288 452.128C428.706 454.189 427.648 457.386 427.516 460.504C427.093 460.9 426.762 461.693 426.762 462.419C426.762 463.146 427.41 463.318 427.926 463.186C428.282 463.939 428.824 464.52 429.446 464.877C429.922 465.154 429.935 466.039 429.446 466.872C428.639 468.232 427.608 469.461 426.485 470.425C424.978 471.707 423.867 473.9 423.867 475.749V478.96C423.867 479.581 424.303 479.832 424.845 479.515L439.731 470.927C440.273 470.61 440.709 469.857 440.709 469.236V466.026C440.709 464.177 439.585 463.265 438.091 463.727V463.714Z",
    fill: "url(#paint246_linear_2253_1261)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    d: "M455.776 263.513H455.75V253.419C467.013 259.919 476.809 272.602 481.753 287.055L473.874 286.909C470.595 277.345 463.721 268.097 455.776 263.513Z",
    fill: "url(#paint247_linear_2253_1261)"
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    d: "M481.755 287.055L473.876 286.91C475.185 290.728 475.912 294.585 475.912 298.231C475.912 310.993 466.896 316.119 455.766 309.712C454.444 308.946 453.148 308.047 451.905 307.057C449.447 305.088 447.133 302.684 445.084 300.028C440.828 294.506 437.642 287.834 436.32 281.361C435.87 279.194 435.632 277.067 435.632 274.993C435.632 262.244 444.635 257.105 455.752 263.499V253.419C439.77 244.198 426.828 251.583 426.828 269.907C426.828 273.13 427.079 275.522 427.82 279.062C429.763 288.508 434.059 297.65 440.431 305.894C443.617 310.016 446.552 313.041 450.24 315.987C465.918 328.538 481.107 325.552 484.161 309.316C485.417 302.644 484.637 295.484 481.768 287.055H481.755Z",
    fill: "url(#paint248_linear_2253_1261)"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M503.673 320.743C505.074 320.704 506.026 319.568 506.026 317.639C506.026 314.851 504.056 311.456 501.624 310.042C499.191 308.642 497.222 309.765 497.222 312.552C497.222 314.495 498.174 316.714 499.575 318.379L492.516 314.31L501.624 343.718L510.732 324.826L503.673 320.757V320.743Z",
    fill: "url(#paint249_linear_2253_1261)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M510.732 309.91L502.681 283.911C504.598 284.479 506.026 283.316 506.026 280.938C506.026 278.151 504.056 274.755 501.624 273.342C499.191 271.941 497.222 273.064 497.222 275.852C497.222 278.217 498.649 281.031 500.566 282.682L492.516 299.381L510.732 309.897V309.91Z",
    fill: "url(#paint250_linear_2253_1261)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    d: "M455.776 350.851H455.75V340.758C467.013 347.258 476.809 359.941 481.753 374.394L473.874 374.248C470.595 364.683 463.721 355.436 455.776 350.851Z",
    fill: "url(#paint251_linear_2253_1261)"
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    d: "M455.779 397.038C466.896 403.458 475.912 398.319 475.912 385.557C475.912 381.924 475.172 378.053 473.876 374.235L481.755 374.381C484.637 382.809 485.404 389.97 484.148 396.641C481.094 412.865 465.918 415.85 450.227 403.313L451.905 394.382C453.161 395.386 454.444 396.285 455.766 397.038H455.779Z",
    fill: "url(#paint252_linear_2253_1261)"
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    d: "M451.902 394.382L450.223 403.313C446.535 400.367 443.6 397.342 440.414 393.22L445.081 387.354C447.13 390.023 449.443 392.414 451.902 394.382Z",
    fill: "url(#paint253_linear_2253_1261)"
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    d: "M445.083 387.341L440.416 393.206C434.044 384.963 429.748 375.82 427.805 366.375L436.318 368.673C437.64 375.147 440.826 381.818 445.083 387.341Z",
    fill: "url(#paint254_linear_2253_1261)"
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    d: "M455.75 340.745V350.825C444.632 344.431 435.63 349.57 435.63 362.319C435.63 364.38 435.868 366.52 436.317 368.687L427.804 366.388C427.077 362.847 426.812 360.456 426.812 357.232C426.812 338.909 439.768 331.524 455.737 340.745H455.75Z",
    fill: "url(#paint255_linear_2253_1261)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    d: "M492.664 357.047L491.289 356.255V355.185C491.659 355.396 491.963 355.541 492.201 355.594C492.426 355.647 492.611 355.634 492.743 355.541C492.875 355.449 492.994 355.277 493.1 355.013L493.986 355.528V365.172L492.664 364.406V357.047Z",
    fill: "url(#paint256_linear_2253_1261)"
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    d: "M495.99 365.846C495.633 365.238 495.461 364.538 495.461 363.772V362.913C495.461 362.438 495.527 362.068 495.659 361.83C495.791 361.579 496.016 361.46 496.32 361.447V361.42C496.043 361.09 495.831 360.72 495.699 360.337C495.567 359.954 495.501 359.518 495.501 359.042V358.646C495.501 357.88 495.672 357.391 496.016 357.18C496.36 356.968 496.862 357.061 497.51 357.431C498.158 357.8 498.66 358.302 499.004 358.91C499.347 359.518 499.519 360.205 499.519 360.984V361.381C499.519 362.292 499.242 362.781 498.7 362.808V362.834C499.004 363.191 499.228 363.574 499.361 363.983C499.493 364.393 499.559 364.829 499.559 365.304V366.163C499.559 366.929 499.374 367.418 499.03 367.63C498.673 367.828 498.158 367.748 497.497 367.365C496.836 366.982 496.32 366.48 495.963 365.872L495.99 365.846ZM498.263 365.304V364.38C498.263 363.653 498.012 363.151 497.523 362.86C497.034 362.57 496.783 362.794 496.783 363.521V364.446C496.783 365.172 497.034 365.674 497.523 365.965C498.026 366.256 498.263 366.031 498.263 365.304ZM498.211 360.932V360.178C498.211 359.531 497.973 359.082 497.51 358.818C497.047 358.554 496.809 358.738 496.809 359.386V360.139C496.809 360.786 497.047 361.235 497.51 361.5C497.973 361.764 498.211 361.579 498.211 360.932Z",
    fill: "url(#paint257_linear_2253_1261)"
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    d: "M500.219 363.257L502.863 364.776V366.15L500.219 364.631V363.257Z",
    fill: "url(#paint258_linear_2253_1261)"
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    d: "M503.63 369.691C503.63 369.004 503.723 368.462 503.921 368.092C504.12 367.709 504.463 367.365 504.952 367.062C505.441 366.744 505.772 366.427 505.97 366.124C506.155 365.806 506.248 365.423 506.248 364.961C506.248 364.551 506.195 364.234 506.076 363.997C505.957 363.772 505.785 363.587 505.56 363.455C505.111 363.191 504.873 363.376 504.873 364.01V365.04L503.617 364.314V363.376C503.617 362.596 503.789 362.094 504.12 361.87C504.45 361.645 504.939 361.724 505.587 362.094C506.221 362.464 506.711 362.953 507.054 363.561C507.385 364.168 507.557 364.868 507.557 365.648C507.557 366.229 507.438 366.744 507.186 367.154C506.949 367.577 506.526 367.973 505.917 368.356C505.521 368.607 505.256 368.845 505.124 369.056C504.992 369.281 504.926 369.558 504.926 369.889V370.1L507.438 371.553V372.927L503.617 370.721V369.677L503.63 369.691Z",
    fill: "url(#paint259_linear_2253_1261)"
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    d: "M508.932 373.297C508.602 372.69 508.43 371.989 508.43 371.21V370.457L509.672 371.183V372.055C509.672 372.676 509.897 373.125 510.36 373.39C510.809 373.654 511.047 373.469 511.047 372.848V370.681C511.047 370.047 510.822 369.598 510.36 369.334C509.91 369.07 509.672 369.255 509.672 369.889V369.968L508.43 369.255L508.668 364.01L512.144 366.018V367.392L509.844 366.057L509.738 368.29H509.765C510.016 367.973 510.386 367.96 510.902 368.264C511.378 368.541 511.748 368.938 511.999 369.453C512.25 369.968 512.369 370.589 512.369 371.302V373.482C512.369 374.262 512.197 374.764 511.867 374.988C511.536 375.213 511.047 375.134 510.399 374.764C509.765 374.394 509.276 373.905 508.932 373.297Z",
    fill: "url(#paint260_linear_2253_1261)"
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    d: "M490.794 378.793C490.794 378.106 490.887 377.564 491.085 377.194C491.284 376.811 491.627 376.468 492.116 376.164C492.606 375.847 492.936 375.53 493.134 375.226C493.319 374.909 493.412 374.526 493.412 374.063C493.412 373.654 493.359 373.337 493.24 373.099C493.121 372.874 492.949 372.689 492.725 372.557C492.275 372.293 492.037 372.478 492.037 373.112V374.143L490.781 373.416V372.478C490.781 371.698 490.953 371.196 491.284 370.972C491.614 370.747 492.103 370.827 492.751 371.196C493.385 371.566 493.875 372.055 494.218 372.663C494.549 373.271 494.721 373.971 494.721 374.75C494.721 375.332 494.602 375.847 494.351 376.256C494.113 376.679 493.69 377.075 493.081 377.459C492.685 377.71 492.42 377.947 492.288 378.159C492.156 378.37 492.09 378.661 492.09 378.991V379.202L494.602 380.656V382.03L490.781 379.823V378.78L490.794 378.793Z",
    fill: "url(#paint261_linear_2253_1261)"
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    d: "M496.08 382.413C495.75 381.805 495.578 381.105 495.578 380.326V379.573L496.821 380.299V381.171C496.821 381.792 497.045 382.241 497.508 382.505C497.958 382.77 498.196 382.585 498.196 381.964V379.797C498.196 379.163 497.971 378.714 497.508 378.45C497.045 378.185 496.821 378.37 496.821 379.004V379.084L495.578 378.37L495.816 373.125L499.293 375.134V376.508L496.993 375.173L496.887 377.406H496.913C497.164 377.089 497.548 377.076 498.05 377.379C498.526 377.657 498.896 378.053 499.147 378.582C499.399 379.097 499.518 379.718 499.518 380.431V382.611C499.518 383.391 499.346 383.893 499.015 384.117C498.685 384.342 498.196 384.262 497.548 383.893C496.913 383.523 496.424 383.034 496.08 382.426V382.413Z",
    fill: "url(#paint262_linear_2253_1261)"
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    d: "M500.219 379.784L502.863 381.303V382.677L500.219 381.158V379.784Z",
    fill: "url(#paint263_linear_2253_1261)"
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    d: "M504.065 387.024C503.734 386.416 503.562 385.729 503.562 384.963V384.183L504.818 384.91V385.769C504.818 386.403 505.043 386.852 505.506 387.116C505.73 387.248 505.902 387.262 506.021 387.169C506.14 387.077 506.193 386.826 506.193 386.429V385.65C506.193 385.214 506.127 384.857 505.995 384.593C505.863 384.329 505.638 384.104 505.334 383.932L504.884 383.681V382.307L505.36 382.585C505.625 382.743 505.823 382.77 505.955 382.69C506.087 382.611 506.154 382.387 506.154 382.017V381.317C506.154 380.986 506.087 380.709 505.968 380.484C505.849 380.26 505.691 380.088 505.493 379.969C505.07 379.718 504.858 379.903 504.858 380.497V381.132L503.615 380.405V379.89C503.615 379.123 503.787 378.621 504.118 378.397C504.448 378.172 504.924 378.252 505.559 378.608C506.193 378.978 506.669 379.454 507 380.048C507.33 380.643 507.489 381.33 507.489 382.096V382.439C507.489 382.968 507.409 383.338 507.264 383.562C507.105 383.787 506.881 383.88 506.55 383.84V383.866C506.894 384.21 507.145 384.593 507.29 385.016C507.449 385.438 507.515 385.901 507.515 386.416V387.275C507.515 388.041 507.343 388.543 507.013 388.754C506.682 388.966 506.193 388.887 505.545 388.517C504.898 388.147 504.409 387.658 504.078 387.05L504.065 387.024Z",
    fill: "url(#paint264_linear_2253_1261)"
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    d: "M508.932 389.824C508.602 389.217 508.43 388.516 508.43 387.737V386.984L509.672 387.711V388.582C509.672 389.203 509.897 389.653 510.36 389.917C510.809 390.181 511.047 389.996 511.047 389.375V387.209C511.047 386.574 510.822 386.125 510.36 385.861C509.91 385.597 509.672 385.782 509.672 386.416V386.495L508.43 385.769L508.668 380.524L512.144 382.532V383.906L509.844 382.571L509.738 384.804H509.765C510.016 384.487 510.386 384.474 510.902 384.778C511.378 385.055 511.748 385.451 511.999 385.967C512.25 386.482 512.369 387.103 512.369 387.816V389.996C512.369 390.776 512.197 391.278 511.867 391.502C511.536 391.727 511.047 391.647 510.399 391.278C509.765 390.908 509.276 390.419 508.932 389.811V389.824Z",
    fill: "url(#paint265_linear_2253_1261)"
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    d: "M491.221 396.139C490.891 395.532 490.719 394.845 490.719 394.078V393.299L491.975 394.025V394.884C491.975 395.518 492.199 395.967 492.662 396.232C492.887 396.364 493.059 396.377 493.178 396.285C493.297 396.192 493.349 395.941 493.349 395.545V394.765C493.349 394.329 493.283 393.973 493.151 393.708C493.019 393.444 492.794 393.22 492.49 393.048L492.041 392.797V391.423L492.517 391.7C492.781 391.859 492.979 391.885 493.111 391.806C493.244 391.727 493.31 391.502 493.31 391.132V390.432C493.31 390.102 493.244 389.824 493.125 389.6C493.006 389.375 492.847 389.203 492.649 389.084C492.226 388.833 492.014 389.018 492.014 389.613V390.247L490.758 389.52V389.005C490.758 388.239 490.93 387.737 491.261 387.512C491.591 387.288 492.067 387.367 492.702 387.724C493.336 388.094 493.812 388.569 494.143 389.164C494.473 389.758 494.632 390.445 494.632 391.211V391.555C494.632 392.083 494.552 392.453 494.407 392.678C494.262 392.902 494.024 392.995 493.693 392.955V392.982C494.037 393.325 494.288 393.708 494.433 394.131C494.579 394.554 494.658 395.016 494.658 395.532V396.39C494.658 397.156 494.486 397.659 494.156 397.87C493.825 398.081 493.336 398.002 492.688 397.632C492.041 397.262 491.552 396.773 491.221 396.166V396.139Z",
    fill: "url(#paint266_linear_2253_1261)"
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    d: "M496.08 398.94C495.75 398.332 495.578 397.632 495.578 396.853V396.1L496.821 396.826V397.698C496.821 398.319 497.045 398.768 497.508 399.033C497.958 399.297 498.196 399.112 498.196 398.491V396.324C498.196 395.69 497.971 395.241 497.508 394.977C497.045 394.712 496.821 394.897 496.821 395.532V395.611L495.578 394.884L495.816 389.639L499.293 391.648V393.021L496.993 391.687L496.887 393.92H496.913C497.164 393.603 497.548 393.59 498.05 393.893C498.526 394.171 498.896 394.567 499.147 395.082C499.399 395.598 499.518 396.219 499.518 396.932V399.112C499.518 399.891 499.346 400.393 499.015 400.618C498.685 400.842 498.196 400.763 497.548 400.393C496.913 400.023 496.424 399.535 496.08 398.927V398.94Z",
    fill: "url(#paint267_linear_2253_1261)"
  })), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    d: "M500.219 396.311L502.863 397.83V399.204L500.219 397.685V396.311Z",
    fill: "url(#paint268_linear_2253_1261)"
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    d: "M505.869 403.326L503.344 401.873V400.499L505.75 395.373L507.191 396.205V402.718L507.812 403.075V404.449L507.191 404.092V405.836L505.869 405.07V403.326ZM505.869 401.952V398.187H505.842L504.547 401.186L505.869 401.952Z",
    fill: "url(#paint269_linear_2253_1261)"
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    d: "M508.932 406.351C508.602 405.744 508.43 405.044 508.43 404.264V403.511L509.672 404.238V405.11C509.672 405.73 509.897 406.18 510.36 406.444C510.809 406.708 511.047 406.523 511.047 405.902V403.736C511.047 403.101 510.822 402.652 510.36 402.388C509.91 402.124 509.672 402.309 509.672 402.943V403.022L508.43 402.296L508.668 397.051L512.144 399.059V400.433L509.844 399.099L509.738 401.331H509.765C510.016 401.014 510.386 401.001 510.902 401.305C511.378 401.582 511.748 401.979 511.999 402.494C512.25 403.009 512.369 403.63 512.369 404.343V406.523C512.369 407.303 512.197 407.805 511.867 408.029C511.536 408.254 511.047 408.175 510.399 407.805C509.765 407.435 509.276 406.946 508.932 406.338V406.351Z",
    fill: "url(#paint270_linear_2253_1261)"
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    d: "M493.017 412.429L490.492 410.975V409.602L492.898 404.476L494.339 405.308V411.821L494.96 412.178V413.552L494.339 413.195V414.939L493.017 414.173V412.429ZM493.017 411.055V407.29H492.991L491.695 410.289L493.017 411.055Z",
    fill: "url(#paint271_linear_2253_1261)"
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    d: "M496.08 415.454C495.75 414.846 495.578 414.146 495.578 413.367V412.614L496.821 413.34V414.212C496.821 414.833 497.045 415.282 497.508 415.546C497.958 415.811 498.196 415.626 498.196 415.005V412.838C498.196 412.204 497.971 411.755 497.508 411.491C497.045 411.226 496.821 411.411 496.821 412.045V412.125L495.578 411.398L495.816 406.153L499.293 408.161V409.535L496.993 408.201L496.887 410.434H496.913C497.164 410.117 497.548 410.103 498.05 410.407C498.526 410.685 498.896 411.081 499.147 411.596C499.399 412.112 499.518 412.732 499.518 413.446V415.626C499.518 416.405 499.346 416.907 499.015 417.132C498.685 417.356 498.196 417.277 497.548 416.907C496.913 416.537 496.424 416.048 496.08 415.441V415.454Z",
    fill: "url(#paint272_linear_2253_1261)"
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    d: "M500.219 412.825L502.863 414.344V415.718L500.219 414.199V412.825Z",
    fill: "url(#paint273_linear_2253_1261)"
  })), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    d: "M504.125 420.091C503.781 419.47 503.609 418.77 503.609 418.004V413.023C503.609 411.358 504.284 410.909 505.632 411.676C506.266 412.045 506.756 412.534 507.099 413.142C507.43 413.75 507.602 414.45 507.602 415.229V415.414L506.359 414.688V414.41C506.359 413.776 506.134 413.327 505.672 413.063C505.42 412.917 505.235 412.904 505.116 413.01C504.997 413.116 504.931 413.393 504.931 413.829V415.679H504.958C505.196 415.269 505.592 415.216 506.161 415.546C506.637 415.824 507.007 416.22 507.258 416.749C507.509 417.264 507.628 417.885 507.628 418.598V420.316C507.628 421.082 507.456 421.584 507.113 421.808C506.769 422.033 506.266 421.954 505.619 421.584C504.971 421.214 504.469 420.712 504.125 420.091ZM506.293 419.668V417.964C506.293 417.33 506.068 416.881 505.605 416.617C505.156 416.352 504.918 416.537 504.918 417.171V418.876C504.918 419.497 505.143 419.946 505.605 420.21C506.055 420.474 506.293 420.289 506.293 419.668Z",
    fill: "url(#paint274_linear_2253_1261)"
  })), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    d: "M508.932 422.866C508.602 422.258 508.43 421.558 508.43 420.778V420.025L509.672 420.752V421.624C509.672 422.245 509.897 422.694 510.36 422.958C510.809 423.222 511.047 423.037 511.047 422.416V420.25C511.047 419.616 510.822 419.166 510.36 418.902C509.91 418.638 509.672 418.823 509.672 419.457V419.536L508.43 418.81L508.668 413.565L512.144 415.573V416.947L509.844 415.613L509.738 417.845H509.765C510.016 417.528 510.386 417.515 510.902 417.819C511.378 418.096 511.748 418.493 511.999 419.008C512.25 419.523 512.369 420.144 512.369 420.858V423.037C512.369 423.817 512.197 424.319 511.867 424.543C511.536 424.768 511.047 424.689 510.399 424.319C509.765 423.949 509.276 423.46 508.932 422.852V422.866Z",
    fill: "url(#paint275_linear_2253_1261)"
  })), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    d: "M491.273 429.194C490.93 428.573 490.758 427.872 490.758 427.106V422.126C490.758 420.461 491.432 420.012 492.78 420.778C493.415 421.148 493.904 421.637 494.248 422.245C494.578 422.852 494.75 423.552 494.75 424.332V424.517L493.507 423.79V423.513C493.507 422.879 493.283 422.429 492.82 422.165C492.569 422.02 492.384 422.007 492.265 422.112C492.146 422.218 492.08 422.496 492.08 422.931V424.781H492.106C492.344 424.372 492.741 424.319 493.309 424.649C493.785 424.926 494.155 425.323 494.406 425.838C494.658 426.353 494.777 426.974 494.777 427.688V429.405C494.777 430.171 494.605 430.673 494.261 430.898C493.917 431.122 493.415 431.043 492.767 430.673C492.119 430.303 491.617 429.801 491.273 429.18V429.194ZM493.441 428.771V427.067C493.441 426.432 493.217 425.983 492.754 425.719C492.305 425.455 492.067 425.64 492.067 426.274V427.978C492.067 428.599 492.291 429.048 492.754 429.312C493.217 429.577 493.441 429.392 493.441 428.771Z",
    fill: "url(#paint276_linear_2253_1261)"
  })), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    d: "M496.08 431.981C495.75 431.373 495.578 430.673 495.578 429.894V429.141L496.821 429.867V430.739C496.821 431.36 497.045 431.809 497.508 432.074C497.958 432.338 498.196 432.153 498.196 431.532V429.365C498.196 428.731 497.971 428.282 497.508 428.018C497.045 427.754 496.821 427.938 496.821 428.573V428.652L495.578 427.925L495.816 422.68L499.293 424.689V426.062L496.993 424.728L496.887 426.961H496.913C497.164 426.644 497.548 426.631 498.05 426.934C498.526 427.212 498.896 427.608 499.147 428.123C499.399 428.639 499.518 429.26 499.518 429.973V432.153C499.518 432.932 499.346 433.434 499.015 433.659C498.685 433.883 498.196 433.804 497.548 433.434C496.913 433.064 496.424 432.576 496.08 431.968V431.981Z",
    fill: "url(#paint277_linear_2253_1261)"
  })), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    d: "M501.863 431.519L500.25 430.594V429.524L501.863 430.449V428.586L502.801 429.128V430.99L504.414 431.915V432.985L502.801 432.06V433.95L501.863 433.408V431.519Z",
    fill: "url(#paint278_linear_2253_1261)"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M425.996 304.48L275.492 217.432V138.971L293.788 170.427L328.555 173.016L362.357 228.358L383.733 229.89L425.996 304.48Z",
    fill: "url(#paint279_linear_2253_1261)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M425.996 304.48L275.492 217.432V184.021L293.788 215.477L339.99 214.024L382.874 270.184L405.506 261.716L425.996 304.48Z",
    fill: "url(#paint280_linear_2253_1261)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M377.429 316.991L370.886 313.213V363.693L377.429 367.471V316.991ZM386.855 300.847L380.311 297.069V369.057L386.855 372.835V300.861V300.847ZM396.558 325.367L390.014 321.589V374.592L396.558 378.37V325.367ZM351.466 279.736V352.278L358.01 356.057V283.514L351.466 279.736ZM367.726 300.596L361.183 296.818V357.814L367.726 361.592V300.596ZM406.089 345.831L399.546 342.053V380.128L406.089 383.906V345.831ZM415.422 369.228L408.879 365.45V385.571L415.422 389.349V369.228ZM348.307 272.721L341.763 268.942V346.413L348.307 350.191V272.721ZM322.344 288.099V334.998L328.887 338.777V291.877L322.344 288.099ZM338.604 264.622L332.06 260.844V340.547L338.604 344.325V264.622Z",
    fill: "url(#paint281_linear_2253_1261)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M377.429 341.022L370.886 337.244V363.693L377.429 367.471V341.022ZM386.855 317.824L380.311 314.045V369.043L386.855 372.822V317.824ZM396.558 338.46L390.014 334.681V374.592L396.558 378.37V338.46ZM351.466 289.552V352.278L358.01 356.057V293.33L351.466 289.552ZM367.726 320.453L361.183 316.674V357.827L367.726 361.605V320.453ZM348.307 276.446L341.763 272.668V346.439L348.307 350.217V276.446ZM322.344 307.625V335.025L328.887 338.803V311.403L322.344 307.625ZM338.604 294.929L332.06 291.15V340.56L338.604 344.338V294.929ZM406.089 356.387L399.546 352.609V380.114L406.089 383.893V356.387ZM415.422 374.975L408.879 371.197V385.57L415.422 389.349V374.975Z",
    fill: "url(#paint282_linear_2253_1261)"
  }), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    d: "M263.527 522.425C263.329 522.425 263.117 522.372 262.945 522.266L247.254 513.402C246.884 513.19 246.659 512.794 246.646 512.371C246.646 511.948 246.87 511.552 247.241 511.341L305.763 477.573L293.522 470.505L233.81 504.96C233.439 505.171 232.99 505.171 232.62 504.96L221.04 498.275C220.669 498.063 220.445 497.667 220.445 497.244C220.445 496.822 220.669 496.425 221.04 496.214L252.145 478.26L239.904 471.192L207.609 489.833C207.225 490.057 206.763 490.044 206.379 489.806L192.657 481.232C192.3 481.008 192.089 480.625 192.102 480.202C192.102 479.779 192.327 479.396 192.697 479.198L282.219 427.12L256.653 413.552C256.071 413.248 255.847 412.521 256.164 411.94C256.468 411.359 257.195 411.134 257.777 411.451L285.233 426.023C285.617 426.221 285.855 426.618 285.868 427.053C285.868 427.489 285.656 427.886 285.273 428.097L195.605 480.268L207.053 487.415L239.322 468.801C239.692 468.589 240.142 468.589 240.512 468.801L255.133 477.243C255.503 477.454 255.728 477.85 255.728 478.273C255.728 478.696 255.503 479.092 255.133 479.304L224.027 497.258L233.228 502.568L292.94 468.114C293.311 467.902 293.76 467.902 294.13 468.114L308.751 476.556C309.121 476.767 309.346 477.163 309.346 477.586C309.346 478.009 309.121 478.405 308.751 478.617L250.255 512.371L263.527 519.875L380.956 451.494C381.326 451.283 381.775 451.283 382.146 451.494L396.502 459.778H397.044C397.705 459.778 398.234 460.306 398.234 460.967C398.234 461.627 397.705 462.155 397.044 462.155H396.185C395.973 462.155 395.775 462.103 395.59 461.997L381.564 453.899L264.135 522.279C263.95 522.385 263.739 522.438 263.54 522.438L263.527 522.425Z",
    fill: "url(#paint283_linear_2253_1261)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M372.092 351.141C401.754 333.812 401.453 278.143 371.419 226.8C341.386 175.457 292.994 147.883 263.332 165.212C233.671 182.541 233.972 238.21 264.005 289.553C294.038 340.896 342.431 368.47 372.092 351.141Z",
    fill: "url(#paint284_radial_2253_1261)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.7,
    d: "M398.5 474.983C412.846 474.983 424.476 468.075 424.476 459.553C424.476 451.031 412.846 444.122 398.5 444.122C384.153 444.122 372.523 451.031 372.523 459.553C372.523 468.075 384.153 474.983 398.5 474.983Z",
    fill: "url(#paint285_radial_2253_1261)"
  }), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    d: "M405.546 448.785C408.666 454.559 406.498 461.772 400.721 464.89C394.944 468.008 387.726 465.841 384.607 460.068C381.487 454.295 383.655 447.081 389.432 443.963C395.209 440.846 402.427 443.012 405.546 448.785Z",
    fill: "url(#paint286_linear_2253_1261)"
  })), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    d: "M358.377 356.743L332.625 370.602L380.559 458.707C380.559 458.707 380.585 458.773 380.612 458.813C382.846 462.948 390.421 463.199 397.519 459.368C404.632 455.536 408.584 449.076 406.35 444.941C406.337 444.901 406.31 444.875 406.284 444.835L358.35 356.73L358.377 356.743Z",
    fill: "url(#paint287_linear_2253_1261)"
  })), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    d: "M358.417 356.796C360.651 360.931 356.699 367.392 349.587 371.223C342.475 375.054 334.9 374.803 332.679 370.668C330.445 366.533 334.397 360.073 341.509 356.242C348.622 352.41 356.196 352.661 358.417 356.796Z",
    fill: "url(#paint288_linear_2253_1261)"
  })), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    d: "M343.269 341.498L327.961 349.742L337.109 366.401C337.109 366.401 337.122 366.44 337.135 366.467C338.457 368.924 342.965 369.083 347.195 366.797C351.426 364.525 353.779 360.68 352.443 358.223C352.443 358.197 352.417 358.183 352.404 358.157L343.256 341.498H343.269Z",
    fill: "url(#paint289_linear_2253_1261)"
  })), _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    d: "M327.836 329.846V307.202C327.836 299.843 323.394 291.098 317.405 286.011C314.061 283.171 310.967 279.736 308.271 275.971L280.325 259.853C277.628 260.514 274.535 260.368 271.19 259.364C268.625 258.585 266.338 258.809 264.58 259.893C262.227 261.333 252.828 265.27 252.828 269.471L260.76 291.164C260.76 293.634 262.505 296.646 264.66 297.901L315.779 338.169C316.639 338.658 325.549 332.726 326.196 332.554C327.175 332.303 327.822 331.352 327.822 329.859L327.836 329.846Z",
    fill: "url(#paint290_linear_2253_1261)"
  })), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    d: "M313.351 257.25C314.527 256.867 315.334 255.639 315.559 253.802C316.008 250.077 315.003 248.174 313.285 246.576C312.782 234.197 308.552 221.475 294.302 213.257C280.051 205.04 275.821 212.874 275.318 224.672C273.613 224.289 272.503 225.729 273.045 229.269C273.521 232.321 274.895 235.412 276.958 237.222C278.372 241.899 280.567 246.721 283.052 251.001C284.942 254.265 285.022 257.752 283.091 258.783C282.259 259.232 281.36 259.562 280.421 259.813C286.502 270.29 291.42 281.387 298.743 281.532C300.647 281.572 306.583 276.724 308.169 275.825C307.296 274.597 306.464 273.315 305.684 272.02C303.727 268.771 303.648 265.085 305.551 264.001C307.785 262.72 309.517 260.883 310.932 258.281L313.351 257.25Z",
    fill: "url(#paint291_linear_2253_1261)"
  })), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    d: "M294.315 311.535L306.516 289.922L315.981 283.963L308.288 275.138L298.941 281.096L294.315 307.942L281.293 262.376L280.342 259.021L272.635 258.955L263.672 264.503L294.315 311.535Z",
    fill: "#5277F7"
  })), _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    d: "M275.332 224.685C277.897 226.165 278.796 230.538 278.796 230.538C278.796 230.538 278.915 226.759 278.915 224.024C278.915 221.29 279.999 210.721 288.01 219.255C296.153 227.935 303.979 251.16 303.992 252.085C303.992 252.494 313.299 246.615 313.299 246.615V234.54C313.299 227.816 306.2 211.025 290.165 207.748C283.396 206.361 279.708 206.189 277.699 207.801C277.368 208.065 268.604 213.244 268.366 213.601C266.647 216.151 275.332 216.322 275.332 224.711V224.685Z",
    fill: "url(#paint292_linear_2253_1261)"
  })), _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    d: "M308.21 291.6C304.826 288.72 301.693 285.258 298.983 281.427C291.316 285.787 278.903 278.626 271.236 265.415C268.526 266.115 265.392 265.957 262.008 264.939C256.033 263.13 251.578 266.736 251.578 274.095V296.739C251.578 299.209 253.323 302.221 255.478 303.476L314.714 337.654C316.869 338.895 318.614 337.905 318.614 335.434V312.79C318.614 305.432 314.172 296.686 308.184 291.6H308.21Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    d: "M318.998 334.959V312.315C318.998 304.956 314.556 296.21 308.567 291.124C305.223 288.284 302.13 284.849 299.433 281.083L285.46 313.16L271.487 264.966C268.79 265.626 265.697 265.481 262.352 264.477C256.377 262.667 251.922 266.274 251.922 273.632V296.276C251.922 298.747 253.667 301.759 255.835 303.014L315.071 337.191C317.226 338.433 318.971 337.442 318.971 334.972L318.998 334.959Z",
    fill: "white"
  }))), _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    d: "M318.638 335.434V312.79C318.638 305.432 314.196 296.686 308.208 291.6C304.863 288.759 301.77 285.324 299.073 281.559L285.1 313.636L271.127 265.441C268.431 266.102 265.337 265.957 261.993 264.953C256.017 263.143 251.562 266.749 251.562 274.108V296.752C251.562 299.222 253.307 302.235 255.462 303.49L314.699 337.667C316.854 338.909 318.599 337.918 318.599 335.447L318.638 335.434Z",
    fill: "url(#paint293_linear_2253_1261)"
  })), _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    d: "M285.117 317.123L306.784 289.552L299.09 280.727L298.125 282.986L285.117 313.53L272.096 267.965L271.144 264.609L263.438 264.543L285.117 317.123Z",
    fill: "#66CCFF"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M299.474 281.427C298.601 280.198 297.768 278.917 296.988 277.622C295.032 274.372 294.952 270.686 296.856 269.603C299.341 268.176 301.523 265.89 302.95 262.852C305.026 263.42 306.546 262.046 306.863 259.417C307.313 255.691 306.308 253.789 304.589 252.191C304.087 239.812 299.857 227.089 285.606 218.872C271.356 210.655 267.125 218.489 266.623 230.286C264.918 229.903 263.807 231.343 264.349 234.884C264.825 237.936 266.2 241.027 268.262 242.85C269.677 247.527 271.871 252.349 274.356 256.629C276.247 259.893 276.326 263.38 274.396 264.411C273.563 264.86 272.664 265.19 271.726 265.441C279.393 278.652 291.806 285.813 299.474 281.453V281.427Z",
    fill: "url(#paint294_radial_2253_1261)"
  }), _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    d: "M298.981 281.427C298.109 280.198 297.276 278.917 296.496 277.622C294.54 274.372 294.46 270.686 296.364 269.603C298.849 268.176 301.03 265.89 302.458 262.852C304.534 263.42 306.054 262.046 306.371 259.417C306.82 255.691 305.816 253.789 304.097 252.191C303.595 239.812 299.365 227.089 285.114 218.872C270.863 210.655 266.633 218.489 266.131 230.286C264.426 229.903 263.315 231.343 263.857 234.884C264.333 237.936 265.708 241.027 267.77 242.85C269.185 247.527 271.379 252.349 273.864 256.629C275.755 259.893 275.834 263.38 273.904 264.411C273.071 264.86 272.172 265.19 271.234 265.441C278.901 278.652 291.314 285.813 298.981 281.453V281.427Z",
    fill: "url(#paint295_linear_2253_1261)"
  })), _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    d: "M266.133 230.273C268.698 231.753 269.597 236.126 269.597 236.126C269.597 236.126 269.716 232.347 269.716 229.613C269.716 226.878 270.8 216.309 278.811 224.844C286.954 233.523 288.619 237.645 293.537 239.508C297.635 241.067 300.676 242.969 300.676 246.536C300.676 250.103 300.715 252.428 300.715 252.428C300.715 252.428 302.553 250.962 304.099 252.177V240.102C304.099 233.378 297.001 216.587 280.965 213.31C265.287 210.1 266.133 213.389 266.133 230.273Z",
    fill: "url(#paint296_linear_2253_1261)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M281.57 213.072C274.128 211.553 270.413 211.487 268.562 213.654C270.559 211.989 274.247 212.148 281.095 213.548C297.13 216.838 304.229 233.616 304.229 240.34V251.662C304.387 251.728 304.546 251.821 304.705 251.94V239.865C304.705 233.14 297.606 216.349 281.57 213.072Z",
    fill: "url(#paint297_radial_2253_1261)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2253_1261",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 222,
    y: 184,
    width: 132,
    height: 169
  }, _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    d: "M334.899 348.007C360.281 333.178 360.02 285.536 334.317 241.594C308.613 197.653 267.199 174.052 241.817 188.88C216.436 203.709 216.696 251.352 242.4 295.293C268.104 339.235 309.518 362.836 334.899 348.007Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2253_1261)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M335.34 350.707C361.063 335.68 360.797 287.396 334.747 242.862C308.696 198.329 266.726 174.409 241.004 189.437C215.282 204.464 215.548 252.748 241.598 297.282C267.648 341.815 309.618 365.735 335.34 350.707Z",
    fill: "url(#paint298_linear_2253_1261)"
  }))), _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
    d: "M298.015 342.211C259.837 320.188 228.903 266.842 228.903 223.073C228.903 205.489 233.9 192.132 242.348 183.862C226.26 189.094 215.922 205.661 215.922 230.947C215.922 274.715 246.869 328.062 285.033 350.085C307.877 363.257 328.116 362.239 340.701 349.926C328.949 353.745 314.116 351.512 298.002 342.224L298.015 342.211Z",
    fill: "url(#paint299_linear_2253_1261)"
  })), _path479 || (_path479 = /*#__PURE__*/React.createElement("path", {
    d: "M325.736 328.828V306.911C325.736 299.79 321.44 291.335 315.65 286.407C312.411 283.66 309.423 280.344 306.819 276.684L279.785 261.082C277.181 261.729 274.18 261.584 270.954 260.606C268.469 259.853 266.262 260.064 264.556 261.121C262.269 262.522 253.188 266.326 253.188 270.396L260.868 291.388C260.868 293.779 262.56 296.699 264.649 297.901L314.103 336.861C314.923 337.336 323.555 331.59 324.176 331.431C325.128 331.193 325.749 330.268 325.749 328.815L325.736 328.828Z",
    fill: "url(#paint300_linear_2253_1261)"
  })), _path480 || (_path480 = /*#__PURE__*/React.createElement("path", {
    d: "M311.727 258.598C312.864 258.228 313.657 257.039 313.869 255.269C314.305 251.662 313.327 249.826 311.674 248.28C311.185 236.297 307.087 223.998 293.299 216.045C279.511 208.092 275.413 215.675 274.924 227.089C273.272 226.719 272.201 228.107 272.73 231.541C273.179 234.501 274.514 237.486 276.524 239.244C277.899 243.775 280.014 248.425 282.42 252.574C284.244 255.731 284.323 259.113 282.459 260.104C281.653 260.527 280.794 260.857 279.882 261.095C285.764 271.228 290.523 281.968 297.609 282.114C299.46 282.153 305.197 277.463 306.73 276.591C305.884 275.402 305.078 274.174 304.324 272.906C302.434 269.761 302.355 266.194 304.192 265.137C306.347 263.896 308.026 262.112 309.387 259.602L311.727 258.598Z",
    fill: "url(#paint301_linear_2253_1261)"
  })), _path481 || (_path481 = /*#__PURE__*/React.createElement("path", {
    d: "M293.3 311.112L305.105 290.212L314.266 284.439L306.823 275.905L297.781 281.665L293.3 307.638L280.715 263.552L279.776 260.302L272.334 260.236L263.648 265.613L293.3 311.112Z",
    fill: "#5277F7"
  })), _path482 || (_path482 = /*#__PURE__*/React.createElement("path", {
    d: "M274.939 227.076C277.425 228.516 278.297 232.73 278.297 232.73C278.297 232.73 278.416 229.084 278.416 226.429C278.416 223.773 279.474 213.548 287.22 221.818C295.099 230.207 302.674 252.693 302.687 253.578C302.687 253.974 311.69 248.28 311.69 248.28V236.601C311.69 230.088 304.815 213.852 289.309 210.668C282.752 209.32 279.183 209.162 277.24 210.721C276.922 210.972 268.449 215.979 268.211 216.335C266.545 218.806 274.953 218.964 274.953 227.089L274.939 227.076Z",
    fill: "url(#paint302_linear_2253_1261)"
  })), _path483 || (_path483 = /*#__PURE__*/React.createElement("path", {
    d: "M306.758 291.824C303.493 289.036 300.452 285.681 297.835 281.982C290.419 286.209 278.402 279.273 270.986 266.485C268.356 267.159 265.328 267.013 262.063 266.023C256.273 264.279 251.977 267.766 251.977 274.887V296.805C251.977 299.196 253.669 302.115 255.757 303.318L313.077 336.385C315.166 337.587 316.858 336.623 316.858 334.232V312.314C316.858 305.194 312.561 296.738 306.771 291.811L306.758 291.824Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path484 || (_path484 = /*#__PURE__*/React.createElement("path", {
    d: "M317.186 333.769V311.852C317.186 304.731 312.89 296.276 307.099 291.348C303.861 288.6 300.873 285.284 298.269 281.625L284.745 312.658L271.222 266.023C268.618 266.67 265.617 266.525 262.391 265.547C256.601 263.803 252.305 267.291 252.305 274.412V296.329C252.305 298.72 253.997 301.64 256.085 302.842L313.405 335.91C315.494 337.112 317.186 336.147 317.186 333.756V333.769Z",
    fill: "white"
  }))), _path485 || (_path485 = /*#__PURE__*/React.createElement("path", {
    d: "M316.842 334.245V312.328C316.842 305.207 312.546 296.752 306.756 291.824C303.517 289.076 300.529 285.76 297.925 282.1L284.402 313.133L270.878 266.498C268.274 267.145 265.273 267 262.047 266.023C256.257 264.279 251.961 267.766 251.961 274.887V296.805C251.961 299.196 253.653 302.115 255.742 303.318L313.061 336.385C315.15 337.587 316.842 336.623 316.842 334.232V334.245Z",
    fill: "url(#paint303_linear_2253_1261)"
  })), _path486 || (_path486 = /*#__PURE__*/React.createElement("path", {
    d: "M284.404 316.529L305.37 289.842L297.914 281.308L296.989 283.488L284.404 313.041L271.805 268.955L270.88 265.705L263.438 265.639L284.404 316.529Z",
    fill: "#66CCFF"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M298.28 281.982C297.434 280.793 296.627 279.564 295.874 278.296C293.983 275.151 293.904 271.584 295.742 270.528C298.147 269.154 300.263 266.934 301.637 263.988C303.634 264.543 305.127 263.209 305.431 260.659C305.868 257.052 304.889 255.216 303.237 253.67C302.748 241.688 298.65 229.388 284.862 221.435C271.074 213.482 266.976 221.065 266.487 232.479C264.834 232.109 263.764 233.497 264.292 236.932C264.742 239.891 266.077 242.877 268.086 244.634C269.461 249.165 271.576 253.815 273.982 257.964C275.807 261.121 275.886 264.503 274.022 265.494C273.216 265.917 272.356 266.247 271.444 266.485C278.86 279.26 290.877 286.196 298.293 281.982H298.28Z",
    fill: "url(#paint304_radial_2253_1261)"
  }), _path487 || (_path487 = /*#__PURE__*/React.createElement("path", {
    d: "M297.819 281.982C296.973 280.793 296.166 279.564 295.413 278.296C293.522 275.151 293.443 271.584 295.281 270.528C297.687 269.154 299.802 266.934 301.176 263.988C303.173 264.543 304.666 263.209 304.97 260.659C305.407 257.052 304.428 255.216 302.776 253.67C302.287 241.688 298.189 229.388 284.401 221.435C270.613 213.482 266.528 221.065 266.026 232.479C264.373 232.109 263.303 233.497 263.831 236.932C264.281 239.891 265.616 242.877 267.625 244.634C269 249.165 271.115 253.815 273.521 257.964C275.346 261.121 275.425 264.503 273.561 265.494C272.755 265.917 271.895 266.247 270.983 266.485C278.399 279.26 290.416 286.196 297.832 281.982H297.819Z",
    fill: "url(#paint305_linear_2253_1261)"
  })), _path488 || (_path488 = /*#__PURE__*/React.createElement("path", {
    d: "M266.023 232.48C268.509 233.92 269.381 238.134 269.381 238.134C269.381 238.134 269.5 234.488 269.5 231.832C269.5 229.177 270.558 218.951 278.304 227.221C286.183 235.611 287.796 239.6 292.542 241.41C296.508 242.916 299.442 244.766 299.442 248.214C299.442 251.662 299.482 253.921 299.482 253.921C299.482 253.921 301.267 252.508 302.76 253.683V242.005C302.76 235.492 295.886 219.255 280.38 216.071C265.204 212.967 266.023 216.151 266.023 232.48Z",
    fill: "url(#paint306_linear_2253_1261)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M280.968 215.847C273.776 214.367 270.181 214.314 268.383 216.415C270.313 214.803 273.882 214.961 280.505 216.322C296.012 219.506 302.886 235.743 302.886 242.256V253.208C303.044 253.274 303.203 253.353 303.348 253.472V241.793C303.348 235.28 296.474 219.044 280.968 215.86V215.847Z",
    fill: "url(#paint307_radial_2253_1261)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.3,
    d: "M334.899 348.007C360.281 333.178 360.02 285.536 334.317 241.594C308.613 197.653 267.199 174.052 241.817 188.88C216.436 203.709 216.696 251.352 242.4 295.293C268.104 339.235 309.518 362.836 334.899 348.007Z",
    fill: "url(#paint308_radial_2253_1261)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M334.899 348.007C360.281 333.178 360.02 285.536 334.317 241.594C308.613 197.653 267.199 174.052 241.817 188.88C216.436 203.709 216.696 251.352 242.4 295.293C268.104 339.235 309.518 362.836 334.899 348.007Z",
    fill: "url(#paint309_radial_2253_1261)"
  }), _path489 || (_path489 = /*#__PURE__*/React.createElement("path", {
    d: "M299.708 183.202C280.936 172.369 263.91 171.127 251.457 177.878C251.113 178.063 233.227 188.037 232.672 188.896C245.349 179.344 264.108 179.489 285.047 191.564C323.225 213.587 354.159 266.934 354.159 310.703C354.159 333.043 346.095 348.566 333.14 355.488C334.065 355.237 335.163 354.762 336.511 354.009C336.881 353.797 349.069 346.426 349.426 346.201C361.43 338.869 368.819 323.729 368.819 302.34C368.819 258.571 337.873 205.225 299.708 183.202Z",
    fill: "url(#paint310_linear_2253_1261)"
  })), _path490 || (_path490 = /*#__PURE__*/React.createElement("path", {
    d: "M285.049 191.565C246.871 169.542 215.938 187.165 215.938 230.947C215.938 274.729 246.884 328.062 285.049 350.085C323.214 372.108 354.16 354.485 354.16 310.703C354.16 266.921 323.214 213.588 285.049 191.565ZM284.56 344.84C249.317 324.508 220.749 275.257 220.749 234.844C220.749 194.431 249.317 178.155 284.56 198.487C319.803 218.819 348.37 268.07 348.37 308.483C348.37 348.896 319.803 365.172 284.56 344.84Z",
    fill: "url(#paint311_linear_2253_1261)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M288.364 189.9C270.068 179.344 253.438 177.917 241.078 184.1C252.606 180.877 269.553 182.621 285.046 191.565C323.224 213.588 354.158 266.934 354.158 310.703C354.158 333.492 343.106 349.834 329.675 356.545C346.543 351.829 357.476 335.051 357.476 309.038C357.476 265.27 326.529 211.923 288.364 189.9Z",
    fill: "url(#paint312_radial_2253_1261)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5,
    d: "M279.231 245.717C290.745 234.21 303.119 224.381 315.902 216.282C307.534 206.995 298.214 199.108 288.379 193.427C252.25 172.58 222.969 189.266 222.969 230.696C222.969 251.53 230.385 274.649 242.335 295.14C251.549 277.846 263.91 261.015 279.231 245.704V245.717Z",
    fill: "url(#paint313_radial_2253_1261)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M368.992 330.461C378.197 321.262 378.197 306.347 368.992 297.148C359.788 287.949 344.864 287.949 335.659 297.148C326.454 306.347 326.454 321.262 335.659 330.461C344.864 339.66 359.788 339.66 368.992 330.461Z",
    fill: "url(#paint314_radial_2253_1261)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M328.216 211.737C331.231 199.081 323.408 186.38 310.745 183.367C298.081 180.354 285.371 188.172 282.357 200.827C279.342 213.483 287.164 226.185 299.828 229.197C312.492 232.21 325.201 224.393 328.216 211.737Z",
    fill: "url(#paint315_radial_2253_1261)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2253_1261",
    x: 0,
    y: 0,
    width: 713,
    height: 684,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 27.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2253_1261"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2253_1261",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2253_1261",
    x1: 316.803,
    y1: 445.972,
    x2: 557.432,
    y2: 563.301,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4F759"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#90ED6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#35D5A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#00C7C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#2D9BE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#5277F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#5A76F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#7273F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#9970F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BB6DF3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2253_1261",
    x1: 78.8262,
    y1: 225.53,
    x2: 663.715,
    y2: 353.965,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#B5BCE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#C7CDF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#E5E9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#F4F6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2253_1261",
    x1: 283.584,
    y1: 122.444,
    x2: 530.031,
    y2: 493.253,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#273B98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#2E2BA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#361CAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#440B88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E0070"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2253_1261",
    x1: 348.507,
    y1: 73.5759,
    x2: 548.382,
    y2: 474.265,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3BAE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#B7BDE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#BAC0E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3BAE7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2253_1261",
    x1: 348.427,
    y1: 73.6551,
    x2: 548.289,
    y2: 474.305,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4BBE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#B9BEEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#BCC2EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#B2B8E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#B2B8E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#B3B9E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4BBE8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2253_1261",
    x1: 348.348,
    y1: 73.7212,
    x2: 548.197,
    y2: 474.358,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B5BCE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#BAC0EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#BDC3EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#B4BBE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#B4BBE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#B7BDE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5BCE8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2253_1261",
    x1: 348.269,
    y1: 73.7872,
    x2: 548.091,
    y2: 474.397,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B7BDE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#BCC1EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#BFC5EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#B7BDE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#B7BDE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#BAC0E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B7BDE9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2253_1261",
    x1: 348.178,
    y1: 73.8533,
    x2: 548.001,
    y2: 474.45,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B8BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#BDC3EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#C1C6EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#B9C0EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#B9C0EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#BEC4EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B8BFE9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2253_1261",
    x1: 348.097,
    y1: 73.9326,
    x2: 547.906,
    y2: 474.503,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9C0EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#BFC4ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#C2C8ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#BCC2EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#BCC2EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#C2C7EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B9C0EA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2253_1261",
    x1: 348.017,
    y1: 73.9986,
    x2: 547.813,
    y2: 474.543,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BAC1EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#C0C6ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#C4C9EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#BEC4EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#BEC5EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#C6CBEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#B2B9E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BAC1EA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2253_1261",
    x1: 347.925,
    y1: 74.0647,
    x2: 547.721,
    y2: 474.596,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BCC2EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#C2C7EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#C6CBEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#C1C7ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C1C7EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#CACEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#B6BCE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#B9C0EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2EB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2253_1261",
    x1: 347.846,
    y1: 74.1439,
    x2: 547.628,
    y2: 474.635,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDC3EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#C4C9EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#C7CDF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#C3C9EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C4C9EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#CDD2EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#B9BFE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#B9C0EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDC3EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_2253_1261",
    x1: 347.766,
    y1: 74.21,
    x2: 547.536,
    y2: 474.688,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BEC4EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#C5CAEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#C9CEF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#C6CBF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C6CCF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#D0D4F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#D1D5F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#BDC3E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#B9C0EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BEC4EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_2253_1261",
    x1: 347.687,
    y1: 74.2761,
    x2: 547.43,
    y2: 474.728,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BFC5ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#C7CCF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#CBD0F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#C8CEF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C9CEF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#D3D7F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#D5D9F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#C1C6EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#B9C0EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC5ED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_2253_1261",
    x1: 347.597,
    y1: 74.3421,
    x2: 547.34,
    y2: 474.78,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C1C7ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#C8CDF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#CCD1F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#CBD0F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#CBD1F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#D5D8F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#D9DCF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#C5CAEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#B9C0E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C7ED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_2253_1261",
    x1: 347.515,
    y1: 74.4214,
    x2: 547.245,
    y2: 474.82,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C2C8EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#CACFF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#CED3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#CDD3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#CED3F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#D8DBF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#DDE0F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#C9CEED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#B9C0EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C2C8EE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_2253_1261",
    x1: 347.436,
    y1: 74.4874,
    x2: 547.152,
    y2: 474.873,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C3C9EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#CBD0F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#D0D4F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#D0D5F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#D0D6F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DADDF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#E1E3F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#CDD1EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#B9C0E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C3C9EE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_2253_1261",
    x1: 347.357,
    y1: 74.5535,
    x2: 547.06,
    y2: 474.912,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4CAEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#CDD2F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#D1D6F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#D2D7F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#D3D8F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DDE0F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#E4E7F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#D0D4EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#B9C0EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4CAEF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_2253_1261",
    x1: 347.264,
    y1: 74.6195,
    x2: 546.967,
    y2: 474.965,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6CBF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#CFD3F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#D3D8F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#D5DAF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#D6DAF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E0E2F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#E8EAF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#D4D8F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#B9BFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C6CBF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_2253_1261",
    x1: 347.187,
    y1: 74.6988,
    x2: 546.877,
    y2: 475.005,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C7CCF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#D0D5F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#D5D9F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#D7DCF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#D8DDF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#E2E5F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#ECEEF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#D8DBF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#B9BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7CCF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_2253_1261",
    x1: 347.105,
    y1: 74.7649,
    x2: 546.769,
    y2: 475.058,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C8CDF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#D2D6F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#D6DBF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#DADEF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#DBDFFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#E5E7FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F0F1FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#DCDFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#B9BFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C8CDF1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_2253_1261",
    x1: 347.013,
    y1: 74.8309,
    x2: 546.676,
    y2: 475.097,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C9CFF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#D3D8F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#D8DCF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#DCE1FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#DDE2FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#E7EAFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F4F5FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#E0E3F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#B9C0EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9CFF1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_2253_1261",
    x1: 346.933,
    y1: 74.897,
    x2: 546.584,
    y2: 475.15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBD0F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#D5D9F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#DADEF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#DFE3FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#E0E4FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#EAECFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F7F8FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#E3E5F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#B9C0EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBD0F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_2253_1261",
    x1: 346.854,
    y1: 74.9763,
    x2: 546.491,
    y2: 475.203,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCD1F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#D6DBF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#DBDFFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#E1E6FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#E2E7FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#ECEFFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FBFCFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#E7E9F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#B4BBE6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#B9C0E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CCD1F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_2253_1261",
    x1: 346.777,
    y1: 75.0423,
    x2: 546.401,
    y2: 475.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDD2F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#E5E9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#EFF1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#EBEDF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#B8BEE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#B9C0EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CDD2F3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_2253_1261",
    x1: 192.537,
    y1: 352.027,
    x2: 189.897,
    y2: 295.866,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#CED3F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5E9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_2253_1261",
    x1: 151.015,
    y1: 337.297,
    x2: 181.8,
    y2: 329.268,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#CED3F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_2253_1261",
    x1: 223.298,
    y1: 351.631,
    x2: 220.234,
    y2: 358.449,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#B5BCE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#C7CDF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#CED3F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#DDE2FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5E9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_2253_1261",
    x1: 213.304,
    y1: 344.761,
    x2: 209.408,
    y2: 351.118,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#B5BCE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#C7CDF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#CED3F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#DDE2FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5E9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_2253_1261",
    x1: 215.009,
    y1: 352.107,
    x2: 207.293,
    y2: 359.008,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#B5BCE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#C7CDF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#CED3F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#DDE2FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5E9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_2253_1261",
    x1: 216.141,
    y1: 354.207,
    x2: 214.187,
    y2: 360.576,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#B5BCE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#C7CDF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#CED3F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#DDE2FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5E9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_2253_1261",
    x1: 214.44,
    y1: 356.096,
    x2: 220.646,
    y2: 330.188,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#B5BCE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#C7CDF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#CED3F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#DDE2FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5E9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_2253_1261",
    x1: 216.488,
    y1: 350.019,
    x2: 218.535,
    y2: 339.476,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#CED3F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5E9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_2253_1261",
    x1: 223.828,
    y1: 358.805,
    x2: 207.503,
    y2: 335.253,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#CED3F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5E9FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint34_radial_2253_1261",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(220.537 350.323) rotate(180) scale(11.6464 11.639)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint35_radial_2253_1261",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(248.985 415.673) rotate(180) scale(35.204 16.858)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#B6BCE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#CBCFEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#ECEEF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_2253_1261",
    x1: 220.477,
    y1: 408.307,
    x2: 222.881,
    y2: 405.082,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#48077F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#663ECF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E0070"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_2253_1261",
    x1: 223.9,
    y1: 407.236,
    x2: 221.216,
    y2: 407.236,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#273B98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#2E2BA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#361CAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#440B88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E0070"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_2253_1261",
    x1: 220.215,
    y1: 407.844,
    x2: 222.685,
    y2: 404.527,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#48077F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#663ECF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E0070"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint39_radial_2253_1261",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(222.275 407.184) rotate(180) scale(1.45414 1.45322)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_2253_1261",
    x1: 191.756,
    y1: 411.358,
    x2: 194.16,
    y2: 408.133,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#48077F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#663ECF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E0070"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_2253_1261",
    x1: 195.173,
    y1: 410.288,
    x2: 192.49,
    y2: 410.288,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#273B98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#2E2BA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#361CAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#440B88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E0070"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_2253_1261",
    x1: 191.489,
    y1: 410.896,
    x2: 193.959,
    y2: 407.592,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#48077F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#663ECF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E0070"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint43_radial_2253_1261",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(193.549 410.249) rotate(180) scale(1.45414 1.45323)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_2253_1261",
    x1: 178.857,
    y1: 395.386,
    x2: 181.261,
    y2: 392.161,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#48077F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#663ECF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E0070"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_2253_1261",
    x1: 182.277,
    y1: 394.316,
    x2: 179.594,
    y2: 394.316,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#273B98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#2E2BA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#361CAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#440B88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E0070"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_2253_1261",
    x1: 178.606,
    y1: 394.937,
    x2: 181.076,
    y2: 391.619,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#48077F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#663ECF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E0070"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint47_radial_2253_1261",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(180.671 394.277) rotate(180) scale(1.45414 1.45323)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_2253_1261",
    x1: 199.211,
    y1: 381.396,
    x2: 201.602,
    y2: 378.171,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#48077F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#663ECF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E0070"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_2253_1261",
    x1: 202.621,
    y1: 380.325,
    x2: 199.938,
    y2: 380.325,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#273B98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#2E2BA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#361CAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#440B88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E0070"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_2253_1261",
    x1: 198.949,
    y1: 380.933,
    x2: 201.419,
    y2: 377.616,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#48077F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#663ECF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E0070"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint51_radial_2253_1261",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(201.009 380.273) rotate(180) scale(1.45414 1.45323)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_2253_1261",
    x1: 224.683,
    y1: 390.895,
    x2: 227.087,
    y2: 387.67,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#48077F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#663ECF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E0070"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_2253_1261",
    x1: 228.105,
    y1: 389.824,
    x2: 225.422,
    y2: 389.824,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#273B98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#2E2BA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#361CAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#440B88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E0070"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_2253_1261",
    x1: 224.434,
    y1: 390.432,
    x2: 226.904,
    y2: 387.128,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#48077F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#663ECF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E0070"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint55_radial_2253_1261",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(226.499 389.785) rotate(180) scale(1.45414 1.45323)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_2253_1261",
    x1: 223.009,
    y1: 404.779,
    x2: 221.026,
    y2: 404.779,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#48077F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#663ECF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E0070"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_2253_1261",
    x1: 222.811,
    y1: 403.419,
    x2: 221.225,
    y2: 404.344,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#273B98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#2E2BA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#361CAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#440B88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E0070"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_2253_1261",
    x1: 226.923,
    y1: 387.684,
    x2: 224.941,
    y2: 387.684,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#48077F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#663ECF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E0070"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_2253_1261",
    x1: 226.725,
    y1: 386.323,
    x2: 225.139,
    y2: 387.249,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#273B98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#2E2BA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#361CAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#440B88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E0070"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_2253_1261",
    x1: 201.587,
    y1: 378.436,
    x2: 199.605,
    y2: 378.436,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#48077F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#663ECF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E0070"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_2253_1261",
    x1: 201.389,
    y1: 377.089,
    x2: 199.79,
    y2: 378.001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#273B98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#2E2BA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#361CAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#440B88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E0070"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_2253_1261",
    x1: 181.009,
    y1: 392.136,
    x2: 179.026,
    y2: 392.136,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#48077F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#663ECF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E0070"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_2253_1261",
    x1: 180.811,
    y1: 390.776,
    x2: 179.212,
    y2: 391.701,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#273B98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#2E2BA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#361CAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#440B88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E0070"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_2253_1261",
    x1: 193.939,
    y1: 407.95,
    x2: 191.956,
    y2: 407.95,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#48077F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#663ECF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E0070"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_2253_1261",
    x1: 193.741,
    y1: 406.589,
    x2: 192.155,
    y2: 407.515,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#273B98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#2E2BA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#361CAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#440B88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E0070"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_2253_1261",
    x1: 2290.02,
    y1: -808.476,
    x2: 2255.3,
    y2: -788.415,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#B5BCE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#C7CDF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#CED3F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#DDE2FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5E9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear_2253_1261",
    x1: 207.777,
    y1: 389.494,
    x2: 201.736,
    y2: 389.494,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#BEC4EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#E5E9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#C1C7ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#BEC4EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#CED3F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#BEC4EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AFB6E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear_2253_1261",
    x1: 207.331,
    y1: 380.616,
    x2: 202.175,
    y2: 380.616,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#BEC4EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#E5E9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#C1C7ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#BEC4EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#CED3F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#BEC4EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AFB6E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint69_linear_2253_1261",
    x1: 204.74,
    y1: 374.671,
    x2: 204.74,
    y2: 380.96,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint70_linear_2253_1261",
    x1: 208.86,
    y1: 346.994,
    x2: 197.03,
    y2: 400.608,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#CED3F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5E9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint71_linear_2253_1261",
    x1: 210.141,
    y1: 347.72,
    x2: 194.071,
    y2: 397.995,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#CED3F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5E9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint72_linear_2253_1261",
    x1: 211.424,
    y1: 348.275,
    x2: 191.365,
    y2: 395.488,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#CED3F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5E9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint73_linear_2253_1261",
    x1: 212.853,
    y1: 348.5,
    x2: 188.764,
    y2: 393.259,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#CED3F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5E9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint74_linear_2253_1261",
    x1: 214.533,
    y1: 348.487,
    x2: 185.805,
    y2: 391.77,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#CED3F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5E9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint75_linear_2253_1261",
    x1: 216.353,
    y1: 348.553,
    x2: 182.55,
    y2: 390.493,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#CED3F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5E9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint76_linear_2253_1261",
    x1: 218.21,
    y1: 348.843,
    x2: 179.396,
    y2: 388.832,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#CED3F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5E9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint77_linear_2253_1261",
    x1: 220.014,
    y1: 349.425,
    x2: 176.493,
    y2: 386.668,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#CED3F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5E9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint78_linear_2253_1261",
    x1: 221.713,
    y1: 350.297,
    x2: 174.05,
    y2: 384.013,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#CED3F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5E9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint79_linear_2253_1261",
    x1: 223.207,
    y1: 351.459,
    x2: 172.13,
    y2: 380.922,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#CED3F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5E9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint80_linear_2253_1261",
    x1: 224.512,
    y1: 352.978,
    x2: 170.906,
    y2: 377.63,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#CED3F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5E9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint81_linear_2253_1261",
    x1: 225.481,
    y1: 354.656,
    x2: 170.297,
    y2: 374.072,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#CED3F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5E9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint82_linear_2253_1261",
    x1: 226.112,
    y1: 356.493,
    x2: 170.382,
    y2: 370.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#CED3F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5E9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint83_linear_2253_1261",
    x1: 226.401,
    y1: 358.435,
    x2: 171.105,
    y2: 367.006,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#CED3F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5E9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint84_linear_2253_1261",
    x1: 226.323,
    y1: 360.416,
    x2: 172.44,
    y2: 363.723,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#CED3F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5E9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint85_linear_2253_1261",
    x1: 225.874,
    y1: 362.358,
    x2: 174.291,
    y2: 360.758,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#CED3F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5E9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint86_linear_2253_1261",
    x1: 225.092,
    y1: 364.182,
    x2: 176.578,
    y2: 358.176,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#CED3F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5E9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint87_linear_2253_1261",
    x1: 224.012,
    y1: 365.833,
    x2: 179.201,
    y2: 356.018,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#CED3F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5E9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint88_linear_2253_1261",
    x1: 222.678,
    y1: 367.22,
    x2: 182.046,
    y2: 354.298,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#CED3F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5E9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint89_linear_2253_1261",
    x1: 221.157,
    y1: 368.277,
    x2: 185.035,
    y2: 353.002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#CED3F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5E9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint90_linear_2253_1261",
    x1: 219.558,
    y1: 368.951,
    x2: 188.118,
    y2: 352.077,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#CED3F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5E9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint91_linear_2253_1261",
    x1: 217.88,
    y1: 369.387,
    x2: 191.107,
    y2: 351.668,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#CED3F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5E9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint92_linear_2253_1261",
    x1: 196.54,
    y1: 379.348,
    x2: 202.152,
    y2: 368.789,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7A7FA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint93_linear_2253_1261",
    x1: 216.62,
    y1: 382.783,
    x2: 210.4,
    y2: 371.735,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#25054D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint94_radial_2253_1261",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(164.389 380.33) rotate(180) scale(25.6522 11.8166)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint95_linear_2253_1261",
    x1: 243.429,
    y1: 377.445,
    x2: 208.406,
    y2: 309.284,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#836DF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#BB6DF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#BE6DF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#CA6DEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#DC6DE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F36DD4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint96_linear_2253_1261",
    x1: 240.546,
    y1: 398.874,
    x2: 220.29,
    y2: 345.479,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#273B98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#2E2BA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#361CAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#440B88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E0070"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint97_linear_2253_1261",
    x1: 223.393,
    y1: 406.246,
    x2: 202.516,
    y2: 351.213,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#273B98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#2E2BA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#361CAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#440B88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E0070"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint98_linear_2253_1261",
    x1: 191.572,
    y1: 333.558,
    x2: 218.334,
    y2: 300.659,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#45108A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C1DC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint99_linear_2253_1261",
    x1: 218.17,
    y1: 360.231,
    x2: 214.183,
    y2: 313.001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#836DF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#BB6DF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#BE6DF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#CA6DEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#DC6DE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F36DD4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint100_linear_2253_1261",
    x1: 201.834,
    y1: 365.238,
    x2: 200.949,
    y2: 315.419,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#836DF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#BB6DF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#BE6DF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#CA6DEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#DC6DE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F36DD4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint101_linear_2253_1261",
    x1: 188.014,
    y1: 336.478,
    x2: 215.898,
    y2: 299.787,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#45108A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C1DC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint102_linear_2253_1261",
    x1: 191.972,
    y1: 335.777,
    x2: 219.171,
    y2: 302.72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#45108A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C1DC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint103_linear_2253_1261",
    x1: 200.493,
    y1: 363.64,
    x2: 197.429,
    y2: 370.458,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#B5BCE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#C7CDF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#CED3F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#DDE2FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5E9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint104_linear_2253_1261",
    x1: 190.499,
    y1: 356.757,
    x2: 186.603,
    y2: 363.127,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#B5BCE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#C7CDF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#CED3F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#DDE2FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5E9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint105_linear_2253_1261",
    x1: 192.204,
    y1: 364.115,
    x2: 184.488,
    y2: 371.003,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#B5BCE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#C7CDF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#CED3F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#DDE2FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5E9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint106_linear_2253_1261",
    x1: 193.337,
    y1: 366.216,
    x2: 191.382,
    y2: 372.585,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#B5BCE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#C7CDF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#CED3F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#DDE2FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5E9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint107_linear_2253_1261",
    x1: 191.635,
    y1: 368.105,
    x2: 197.841,
    y2: 342.197,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#B5BCE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#C7CDF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#CED3F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#DDE2FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5E9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint108_linear_2253_1261",
    x1: 193.683,
    y1: 362.015,
    x2: 195.73,
    y2: 351.485,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#CED3F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5E9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint109_linear_2253_1261",
    x1: 201.024,
    y1: 370.813,
    x2: 184.698,
    y2: 347.261,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#CED3F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5E9FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint110_radial_2253_1261",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(197.73 362.332) rotate(180) scale(11.6464 11.639)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint111_linear_2253_1261",
    x1: 176.066,
    y1: 389.521,
    x2: 219.354,
    y2: 440.556,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4F759"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#90ED6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#35D5A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#00C7C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#2D9BE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#5277F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#5A76F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#7273F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#9970F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BB6DF3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint112_linear_2253_1261",
    x1: 517.867,
    y1: 258.888,
    x2: 212.121,
    y2: 439.522,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4F759"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#90ED6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#35D5A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#00C7C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#2D9BE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#5277F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#5A76F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#7273F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#9970F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BB6DF3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint113_linear_2253_1261",
    x1: 192.053,
    y1: 286.249,
    x2: 235.991,
    y2: 370.044,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#B5BCE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#C7CDF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#E5E9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#F4F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7F6FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint114_linear_2253_1261",
    x1: 260.38,
    y1: 329.277,
    x2: 228.35,
    y2: 374.214,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#A0A6D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#A2A8D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#ABB2E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#AFB6E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint115_linear_2253_1261",
    x1: 252.095,
    y1: 315.842,
    x2: 219.093,
    y2: 381.993,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3BAE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#B7BDE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#BAC0E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3BAE7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint116_linear_2253_1261",
    x1: 305.355,
    y1: 314.838,
    x2: 261.61,
    y2: 374.479,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3BAE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#B7BDE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#BAC0E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#B1B7E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#B2B8E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#B2B9E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B6BDE8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint117_linear_2253_1261",
    x1: 251.47,
    y1: 314.019,
    x2: 199.073,
    y2: 363.964,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3BAE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#B7BDE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#BBC1E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#B2B9E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#B4BBE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#B5BCE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B9C0E9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint118_linear_2253_1261",
    x1: 312.148,
    y1: 315.261,
    x2: 255.177,
    y2: 352.618,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B2B9E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#B7BDE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#BBC1EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#B4BAE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#B7BDE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#B9BFE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDC3EA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint119_linear_2253_1261",
    x1: 249.905,
    y1: 317.295,
    x2: 192.347,
    y2: 343.03,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B2B9E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#B7BDE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#BBC1EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#B5BCE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#B9C0EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#BCC2E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0C5EB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint120_linear_2253_1261",
    x1: 320.058,
    y1: 320.109,
    x2: 265.565,
    y2: 335.732,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B2B9E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#B7BDE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#BCC2EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#B7BDE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#BCC2EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#BFC5EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C3C8EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint121_linear_2253_1261",
    x1: 240.981,
    y1: 323.914,
    x2: 189.953,
    y2: 332.756,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B2B9E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#B8BEE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#BCC2EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#B8BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#B8BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#BEC5EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#C2C7EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C6CBED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint122_linear_2253_1261",
    x1: 332.539,
    y1: 329.33,
    x2: 286.063,
    y2: 333.445,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B2B9E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#B8BEE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#BCC2EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#BAC0EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#BBC1EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#C1C7EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#C5CAED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CACEEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint123_linear_2253_1261",
    x1: 215.402,
    y1: 338.155,
    x2: 171.256,
    y2: 339.662,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#B8BEE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#BDC3EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#BBC1EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#BEC4EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#C4C9EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#C9CDEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CDD1EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint124_linear_2253_1261",
    x1: 379.648,
    y1: 348.962,
    x2: 338.73,
    y2: 349.078,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#B8BEE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#BDC3EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#BDC3EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#C0C6ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#C6CCF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#CCD0EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D0D4F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint125_linear_2253_1261",
    x1: 1.51835,
    y1: 397.46,
    x2: -41.5677,
    y2: 397.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#B8BEE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#BDC3EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#BEC4EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#C3C9EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#C9CEF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#CFD3F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3D7F1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint126_linear_2253_1261",
    x1: -19.6215,
    y1: 437.701,
    x2: 23.7111,
    y2: 437.214,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#B8BEEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#BEC4EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#C0C6ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#C5CBF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#CBD1F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#D2D6F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D9F1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint127_linear_2253_1261",
    x1: 307.408,
    y1: 389.494,
    x2: 349.343,
    y2: 387.401,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#B8BEEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#BEC4EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#C1C7EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#C8CEF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#CED3F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#D5D9F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DADCF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint128_linear_2253_1261",
    x1: 189.989,
    y1: 381.329,
    x2: 235.615,
    y2: 375.859,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#B8BEEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#BEC4EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#C3C9EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#CAD0F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#D0D6F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#D8DCF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDDFF3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint129_linear_2253_1261",
    x1: 253.929,
    y1: 379.295,
    x2: 301.743,
    y2: 368.863,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0B7E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#B8BEEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#BFC5EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#C4CAEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#CDD3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#D3D8F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#DCDFF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0E2F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint130_linear_2253_1261",
    x1: 210.861,
    y1: 379.453,
    x2: 261.645,
    y2: 360.873,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0B7E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#B8BEEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#BFC5ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#C6CBF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#D0D5F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#D6DAF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#DFE2F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4E5F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint131_linear_2253_1261",
    x1: 238.082,
    y1: 380.55,
    x2: 288.623,
    y2: 352.057,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0B7E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#B9BFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#BFC5ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#C7CDF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#D2D8F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#D8DDF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#E2E4F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7E8F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint132_linear_2253_1261",
    x1: 219.012,
    y1: 381.977,
    x2: 265.678,
    y2: 341.789,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0B7E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#B8BEE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#B9BFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#C0C6ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#C9CEF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#D5DAF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#DBDFFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#E5E7F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAEBF7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint133_linear_2253_1261",
    x1: 232.262,
    y1: 383.285,
    x2: 270.452,
    y2: 334.043,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0B7E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B7BDE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#B9BFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#C0C6ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#CAD0F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#D7DDF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#DDE2FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#E8EAF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint134_linear_2253_1261",
    x1: 226.324,
    y1: 384.236,
    x2: 253.488,
    y2: 329.563,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#B6BCE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#B9BFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#C0C6EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#CCD1F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DADFFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#E0E4FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#ECEDFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1F0F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint135_linear_2253_1261",
    x1: 233.03,
    y1: 384.632,
    x2: 249.598,
    y2: 328.958,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#B5BCE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#B9BFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#C1C7EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#CDD3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#CED4F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#DCE2FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#E2E7FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#EFF0FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4F3FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint136_linear_2253_1261",
    x1: 235.847,
    y1: 384.143,
    x2: 243.478,
    y2: 330.425,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#B5BCE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#C7CDF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#E5E9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#F4F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7F6FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint137_linear_2253_1261",
    x1: 208.629,
    y1: 389.032,
    x2: 193.379,
    y2: 310.765,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#836DF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#BB6DF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#BE6DF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#CA6DEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#DC6DE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F36DD4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint138_linear_2253_1261",
    x1: 389.389,
    y1: 503.916,
    x2: 406.751,
    y2: 597.732,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4F759"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#90ED6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#35D5A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#00C7C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#2D9BE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#5277F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#5A76F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#7273F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#9970F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BB6DF3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint139_linear_2253_1261",
    x1: 625.301,
    y1: 406.589,
    x2: 257.349,
    y2: 637.848,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4F759"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#90ED6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#35D5A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#00C7C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#2D9BE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#5277F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#5A76F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#7273F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#9970F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BB6DF3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint140_linear_2253_1261",
    x1: 474.668,
    y1: 525.225,
    x2: 447.301,
    y2: 484.321,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#273B98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#2E2BA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#361CAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#440B88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E0070"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint141_linear_2253_1261",
    x1: 459.381,
    y1: 532.505,
    x2: 430.785,
    y2: 489.79,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#273B98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#2E2BA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#361CAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#440B88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E0070"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint142_radial_2253_1261",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(521.344 576) rotate(180) scale(36.8284 17.6358)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#B6BCE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#CBCFEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#ECEEF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint143_linear_2253_1261",
    x1: 494.946,
    y1: 570.143,
    x2: 497.456,
    y2: 566.773,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#48077F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#663ECF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E0070"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint144_linear_2253_1261",
    x1: 498.534,
    y1: 569.034,
    x2: 495.719,
    y2: 569.034,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#273B98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#2E2BA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#361CAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#440B88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E0070"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint145_linear_2253_1261",
    x1: 494.671,
    y1: 569.668,
    x2: 497.26,
    y2: 566.205,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#48077F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#663ECF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E0070"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint146_radial_2253_1261",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(496.841 568.981) rotate(180) scale(1.52024 1.51929)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint147_linear_2253_1261",
    x1: 464.899,
    y1: 573.34,
    x2: 467.409,
    y2: 569.97,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#48077F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#663ECF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E0070"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint148_linear_2253_1261",
    x1: 468.488,
    y1: 572.231,
    x2: 465.685,
    y2: 572.231,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#273B98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#2E2BA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#361CAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#440B88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E0070"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint149_linear_2253_1261",
    x1: 464.638,
    y1: 572.865,
    x2: 467.213,
    y2: 569.402,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#48077F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#663ECF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E0070"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint150_radial_2253_1261",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(466.794 572.178) rotate(180) scale(1.52024 1.51929)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint151_linear_2253_1261",
    x1: 451.415,
    y1: 556.642,
    x2: 453.924,
    y2: 553.271,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#48077F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#663ECF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E0070"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint152_linear_2253_1261",
    x1: 455.003,
    y1: 555.532,
    x2: 452.201,
    y2: 555.532,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#273B98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#2E2BA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#361CAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#440B88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E0070"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint153_linear_2253_1261",
    x1: 451.153,
    y1: 556.166,
    x2: 453.729,
    y2: 552.703,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#48077F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#663ECF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E0070"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint154_radial_2253_1261",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(453.309 555.479) rotate(180) scale(1.52024 1.51927)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint155_linear_2253_1261",
    x1: 472.701,
    y1: 542.004,
    x2: 475.211,
    y2: 538.633,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#48077F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#663ECF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E0070"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint156_linear_2253_1261",
    x1: 476.285,
    y1: 540.894,
    x2: 473.469,
    y2: 540.894,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#273B98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#2E2BA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#361CAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#440B88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E0070"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint157_linear_2253_1261",
    x1: 472.421,
    y1: 541.528,
    x2: 475.01,
    y2: 538.065,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#48077F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#663ECF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E0070"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint158_radial_2253_1261",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(474.591 540.841) rotate(180) scale(1.52024 1.51929)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint159_linear_2253_1261",
    x1: 499.344,
    y1: 551.939,
    x2: 501.854,
    y2: 548.568,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#48077F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#663ECF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E0070"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint160_linear_2253_1261",
    x1: 502.933,
    y1: 550.829,
    x2: 500.13,
    y2: 550.829,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#273B98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#2E2BA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#361CAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#440B88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E0070"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint161_linear_2253_1261",
    x1: 499.083,
    y1: 551.463,
    x2: 501.659,
    y2: 548,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#48077F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#663ECF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E0070"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint162_radial_2253_1261",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(501.239 550.776) rotate(180) scale(1.52024 1.51929)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint163_linear_2253_1261",
    x1: 497.592,
    y1: 566.471,
    x2: 495.516,
    y2: 566.471,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#48077F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#663ECF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E0070"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint164_linear_2253_1261",
    x1: 497.383,
    y1: 565.044,
    x2: 495.717,
    y2: 566.009,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#273B98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#2E2BA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#361CAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#440B88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E0070"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint165_linear_2253_1261",
    x1: 501.693,
    y1: 548.596,
    x2: 499.618,
    y2: 548.596,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#48077F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#663ECF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E0070"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint166_linear_2253_1261",
    x1: 501.476,
    y1: 547.169,
    x2: 499.811,
    y2: 548.135,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#273B98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#2E2BA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#361CAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#440B88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E0070"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint167_linear_2253_1261",
    x1: 475.201,
    y1: 538.925,
    x2: 473.126,
    y2: 538.925,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#48077F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#663ECF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E0070"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint168_linear_2253_1261",
    x1: 474.99,
    y1: 537.499,
    x2: 473.324,
    y2: 538.464,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#273B98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#2E2BA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#361CAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#440B88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E0070"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint169_linear_2253_1261",
    x1: 453.662,
    y1: 553.246,
    x2: 451.587,
    y2: 553.246,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#48077F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#663ECF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E0070"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint170_linear_2253_1261",
    x1: 453.453,
    y1: 551.819,
    x2: 451.788,
    y2: 552.785,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#273B98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#2E2BA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#361CAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#440B88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E0070"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint171_linear_2253_1261",
    x1: 467.185,
    y1: 569.787,
    x2: 465.123,
    y2: 569.787,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#48077F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#663ECF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E0070"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint172_linear_2253_1261",
    x1: 466.99,
    y1: 568.36,
    x2: 465.311,
    y2: 569.325,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#273B98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#2E2BA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#361CAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#440B88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E0070"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint173_linear_2253_1261",
    x1: 2426.31,
    y1: -567.965,
    x2: 2389.98,
    y2: -546.979,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#B5BCE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#C7CDF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#CED3F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#DDE2FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5E9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint174_linear_2253_1261",
    x1: 481.664,
    y1: 550.485,
    x2: 475.345,
    y2: 550.485,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#BEC4EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#E5E9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#C1C7ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#BEC4EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#CED3F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#BEC4EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AFB6E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint175_linear_2253_1261",
    x1: 481.202,
    y1: 541.198,
    x2: 475.808,
    y2: 541.198,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#BEC4EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#E5E9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#C1C7ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#BEC4EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#CED3F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#BEC4EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AFB6E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint176_linear_2253_1261",
    x1: 478.492,
    y1: 534.975,
    x2: 478.492,
    y2: 541.554,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint177_linear_2253_1261",
    x1: 482.15,
    y1: 506.029,
    x2: 469.792,
    y2: 562.101,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#CED3F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5E9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint178_linear_2253_1261",
    x1: 483.497,
    y1: 506.796,
    x2: 466.688,
    y2: 559.369,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#CED3F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5E9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint179_linear_2253_1261",
    x1: 484.835,
    y1: 507.363,
    x2: 463.865,
    y2: 556.756,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#CED3F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5E9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint180_linear_2253_1261",
    x1: 486.343,
    y1: 507.602,
    x2: 461.132,
    y2: 554.422,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#CED3F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5E9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint181_linear_2253_1261",
    x1: 488.103,
    y1: 507.588,
    x2: 458.041,
    y2: 552.854,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#CED3F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5E9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint182_linear_2253_1261",
    x1: 489.991,
    y1: 507.654,
    x2: 454.643,
    y2: 551.524,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#CED3F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5E9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint183_linear_2253_1261",
    x1: 491.93,
    y1: 507.971,
    x2: 451.333,
    y2: 549.784,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#CED3F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5E9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint184_linear_2253_1261",
    x1: 493.821,
    y1: 508.579,
    x2: 448.318,
    y2: 547.528,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#CED3F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5E9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint185_linear_2253_1261",
    x1: 495.594,
    y1: 509.49,
    x2: 445.737,
    y2: 544.741,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#CED3F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5E9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint186_linear_2253_1261",
    x1: 497.155,
    y1: 510.693,
    x2: 443.738,
    y2: 541.504,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#CED3F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5E9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint187_linear_2253_1261",
    x1: 498.519,
    y1: 512.291,
    x2: 442.455,
    y2: 538.067,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#CED3F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5E9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint188_linear_2253_1261",
    x1: 499.536,
    y1: 514.035,
    x2: 441.828,
    y2: 534.351,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#CED3F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5E9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint189_linear_2253_1261",
    x1: 500.208,
    y1: 515.951,
    x2: 441.915,
    y2: 530.606,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#CED3F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5E9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint190_linear_2253_1261",
    x1: 500.5,
    y1: 517.986,
    x2: 442.679,
    y2: 526.954,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#CED3F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5E9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint191_linear_2253_1261",
    x1: 500.421,
    y1: 520.06,
    x2: 444.067,
    y2: 523.525,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#CED3F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5E9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint192_linear_2253_1261",
    x1: 499.96,
    y1: 522.094,
    x2: 446.011,
    y2: 520.427,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#CED3F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5E9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint193_linear_2253_1261",
    x1: 499.135,
    y1: 524.01,
    x2: 448.387,
    y2: 517.727,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#CED3F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5E9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint194_linear_2253_1261",
    x1: 497.997,
    y1: 525.727,
    x2: 451.124,
    y2: 515.463,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#CED3F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5E9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint195_linear_2253_1261",
    x1: 496.599,
    y1: 527.181,
    x2: 454.104,
    y2: 513.677,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#CED3F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5E9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint196_linear_2253_1261",
    x1: 495.014,
    y1: 528.29,
    x2: 457.24,
    y2: 512.314,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#CED3F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5E9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint197_linear_2253_1261",
    x1: 493.349,
    y1: 528.99,
    x2: 460.455,
    y2: 511.349,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#CED3F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5E9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint198_linear_2253_1261",
    x1: 491.586,
    y1: 529.453,
    x2: 463.585,
    y2: 510.915,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#CED3F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5E9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint199_linear_2253_1261",
    x1: 469.274,
    y1: 539.863,
    x2: 475.151,
    y2: 528.829,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7A7FA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint200_linear_2253_1261",
    x1: 490.267,
    y1: 543.457,
    x2: 483.769,
    y2: 531.906,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#25054D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint201_linear_2253_1261",
    x1: 490.481,
    y1: 522.874,
    x2: 481.726,
    y2: 504.149,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#273B98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#2E2BA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#361CAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#440B88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E0070"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint202_linear_2253_1261",
    x1: -3107.84,
    y1: -3370.78,
    x2: -3143.48,
    y2: -3409.37,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#273B98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#2E2BA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#361CAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#440B88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E0070"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint203_linear_2253_1261",
    x1: 482.626,
    y1: 527.815,
    x2: 433.245,
    y2: 474.913,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#273B98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#2E2BA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#361CAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#440B88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E0070"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint204_linear_2253_1261",
    x1: 403.495,
    y1: 406.999,
    x2: 449.335,
    y2: 494.414,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#B5BCE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#C7CDF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#E5E9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#F4F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7F6FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint205_linear_2253_1261",
    x1: 435.222,
    y1: 477.256,
    x2: 438.391,
    y2: 483.44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#4D5A96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#6A75A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#979EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#BCC1D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#D9DCE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#EEEFF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#FAFBFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint206_linear_2253_1261",
    x1: 493.232,
    y1: 448.389,
    x2: 392.227,
    y2: 470.571,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#B5BCE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#C7CDF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#E5E9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#F4F6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint207_linear_2253_1261",
    x1: 457.257,
    y1: 431.466,
    x2: 415.969,
    y2: 493.596,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#273B98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#2E2BA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#361CAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#440B88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E0070"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint208_linear_2253_1261",
    x1: 446.659,
    y1: 422.152,
    x2: 412.151,
    y2: 491.356,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3BAE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#B7BDE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#BAC0E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3BAE7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint209_linear_2253_1261",
    x1: 446.671,
    y1: 422.165,
    x2: 412.164,
    y2: 491.356,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4BBE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#B9BEEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#BCC2EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#B2B8E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#B2B8E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#B3B9E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4BBE8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint210_linear_2253_1261",
    x1: 446.697,
    y1: 422.178,
    x2: 412.176,
    y2: 491.369,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B5BCE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#BAC0EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#BDC3EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#B4BBE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#B4BBE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#B7BDE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5BCE8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint211_linear_2253_1261",
    x1: 446.713,
    y1: 422.191,
    x2: 412.205,
    y2: 491.369,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B7BDE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#BCC1EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#BFC5EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#B7BDE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#B7BDE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#BAC0E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B7BDE9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint212_linear_2253_1261",
    x1: 446.725,
    y1: 422.205,
    x2: 412.218,
    y2: 491.382,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B8BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#BDC3EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#C1C6EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#B9C0EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#B9C0EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#BEC4EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B8BFE9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint213_linear_2253_1261",
    x1: 446.738,
    y1: 422.218,
    x2: 412.23,
    y2: 491.396,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9C0EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#BFC4ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#C2C8ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#BCC2EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#BCC2EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#C2C7EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B9C0EA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint214_linear_2253_1261",
    x1: 446.748,
    y1: 422.231,
    x2: 412.241,
    y2: 491.396,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BAC1EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#C0C6ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#C4C9EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#BEC4EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#BEC5EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#C6CBEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#B2B9E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BAC1EA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint215_linear_2253_1261",
    x1: 446.766,
    y1: 422.244,
    x2: 412.259,
    y2: 491.409,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BCC2EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#C2C7EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#C6CBEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#C1C7ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C1C7EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#CACEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#B6BCE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#B9C0EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC2EB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint216_linear_2253_1261",
    x1: 446.779,
    y1: 422.258,
    x2: 412.284,
    y2: 491.409,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDC3EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#C4C9EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#C7CDF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#C3C9EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C4C9EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#CDD2EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#B9BFE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#B9C0EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDC3EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint217_linear_2253_1261",
    x1: 446.789,
    y1: 422.271,
    x2: 412.295,
    y2: 491.422,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BEC4EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#C5CAEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#C9CEF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#C6CBF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C6CCF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#D0D4F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#D1D5F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#BDC3E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#B9C0EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BEC4EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint218_linear_2253_1261",
    x1: 446.807,
    y1: 422.271,
    x2: 412.313,
    y2: 491.435,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BFC5ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#C7CCF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#CBD0F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#C8CEF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C9CEF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#D3D7F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#D5D9F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#C1C6EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#B9C0EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC5ED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint219_linear_2253_1261",
    x1: 446.82,
    y1: 422.284,
    x2: 412.325,
    y2: 491.435,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C1C7ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#C8CDF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#CCD1F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#CBD0F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#CBD1F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#D5D8F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#D9DCF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#C5CAEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#B9C0E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C7ED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint220_linear_2253_1261",
    x1: 446.83,
    y1: 422.297,
    x2: 412.349,
    y2: 491.449,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C2C8EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#CACFF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#CED3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#CDD3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#CED3F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#D8DBF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#DDE0F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#C9CEED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#B9C0EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C2C8EE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint221_linear_2253_1261",
    x1: 446.84,
    y1: 422.31,
    x2: 412.359,
    y2: 491.449,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C3C9EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#CBD0F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#D0D4F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#D0D5F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#D0D6F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DADDF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#E1E3F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#CDD1EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#B9C0E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C3C9EE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint222_linear_2253_1261",
    x1: 446.874,
    y1: 422.324,
    x2: 412.379,
    y2: 491.462,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4CAEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#CDD2F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#D1D6F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#D2D7F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#D3D8F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DDE0F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#E4E7F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#D0D4EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#B9C0EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4CAEF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint223_linear_2253_1261",
    x1: 446.884,
    y1: 422.337,
    x2: 412.39,
    y2: 491.475,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6CBF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#CFD3F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#D3D8F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#D5DAF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#D6DAF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E0E2F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#E8EAF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#D4D8F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#B9BFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C6CBF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint224_linear_2253_1261",
    x1: 446.9,
    y1: 422.35,
    x2: 412.418,
    y2: 491.475,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C7CCF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#D0D5F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#D5D9F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#D7DCF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#D8DDF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#E2E5F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#ECEEF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#D8DBF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#B9BFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7CCF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint225_linear_2253_1261",
    x1: 446.907,
    y1: 422.363,
    x2: 412.426,
    y2: 491.488,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C8CDF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#D2D6F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#D6DBF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#DADEF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#DBDFFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#E5E7FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F0F1FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#DCDFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#B9BFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C8CDF1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint226_linear_2253_1261",
    x1: 446.925,
    y1: 422.376,
    x2: 412.444,
    y2: 491.501,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C9CFF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#D3D8F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#D8DCF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#DCE1FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#DDE2FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#E7EAFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F4F5FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#E0E3F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#B9C0EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9CFF1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint227_linear_2253_1261",
    x1: 446.933,
    y1: 422.39,
    x2: 412.451,
    y2: 491.502,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBD0F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#D5D9F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#DADEF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#DFE3FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#E0E4FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#EAECFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F7F8FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#E3E5F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#B9C0EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBD0F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint228_linear_2253_1261",
    x1: 446.953,
    y1: 422.403,
    x2: 412.472,
    y2: 491.515,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCD1F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#D6DBF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#DBDFFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#E1E6FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#E2E7FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#ECEFFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FBFCFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#E7E9F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#B4BBE6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#B9C0E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CCD1F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint229_linear_2253_1261",
    x1: 446.966,
    y1: 422.403,
    x2: 412.498,
    y2: 491.515,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDD2F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#E5E9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#EFF1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#EBEDF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#B8BEE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#B9C0EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CDD2F3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint230_linear_2253_1261",
    x1: -1230.63,
    y1: -1048.45,
    x2: -586.088,
    y2: -471.298,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4F759"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#90ED6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#35D5A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#00C7C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#2D9BE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#5277F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#5A76F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#7273F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#9970F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BB6DF3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint231_linear_2253_1261",
    x1: 700.715,
    y1: 363.97,
    x2: 290.622,
    y2: 622.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4F759"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#90ED6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#35D5A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#00C7C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#2D9BE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#5277F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#5A76F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#7273F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#9970F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BB6DF3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint232_linear_2253_1261",
    x1: 476.548,
    y1: 467.413,
    x2: 480.906,
    y2: 451.995,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#45108A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C1DC9"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint233_radial_2253_1261",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(452.486 501.274) rotate(180) scale(6.86091 6.85657)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#FEDFCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9B69E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint234_linear_2253_1261",
    x1: 697.879,
    y1: 364.049,
    x2: 287.777,
    y2: 611.406,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4F759"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#90ED6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#35D5A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#00C7C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#2D9BE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#5277F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#5A76F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#7273F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#9970F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BB6DF3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint235_linear_2253_1261",
    x1: 494.034,
    y1: 528.092,
    x2: 491.275,
    y2: 469.355,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#CED3F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5E9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint236_linear_2253_1261",
    x1: 453.966,
    y1: 508.21,
    x2: 492.83,
    y2: 502.006,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#CED3F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint237_linear_2253_1261",
    x1: 473.406,
    y1: 523.428,
    x2: 470.197,
    y2: 530.564,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#B5BCE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#C7CDF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#CED3F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#DDE2FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5E9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint238_linear_2253_1261",
    x1: 462.959,
    y1: 516.242,
    x2: 458.892,
    y2: 522.903,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#B5BCE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#C7CDF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#CED3F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#DDE2FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5E9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint239_linear_2253_1261",
    x1: 464.731,
    y1: 523.931,
    x2: 456.671,
    y2: 531.136,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#B5BCE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#C7CDF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#CED3F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#DDE2FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5E9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint240_linear_2253_1261",
    x1: 465.923,
    y1: 526.137,
    x2: 463.889,
    y2: 532.783,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#B5BCE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#C7CDF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#CED3F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#DDE2FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5E9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint241_linear_2253_1261",
    x1: 464.151,
    y1: 528.105,
    x2: 470.648,
    y2: 501.007,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#B5BCE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#C7CDF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#CED3F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#DDE2FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5E9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint242_linear_2253_1261",
    x1: 466.289,
    y1: 521.737,
    x2: 468.427,
    y2: 510.719,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#CED3F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5E9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint243_linear_2253_1261",
    x1: 473.953,
    y1: 530.932,
    x2: 456.888,
    y2: 506.31,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#CED3F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5E9FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint244_radial_2253_1261",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(470.515 522.068) rotate(180) scale(12.1884 12.1807)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint245_linear_2253_1261",
    x1: 466.303,
    y1: 435.667,
    x2: 441.429,
    y2: 464.496,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4F759"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#90ED6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#35D5A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#00C7C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#2D9BE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#5277F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#5A76F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#7273F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#9970F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BB6DF3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint246_linear_2253_1261",
    x1: 436.095,
    y1: 445.549,
    x2: 431.54,
    y2: 477.679,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#00C7C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#34008C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint247_linear_2253_1261",
    x1: 467.885,
    y1: 245.572,
    x2: 470.183,
    y2: 324.482,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#00C7C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#34008C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint248_linear_2253_1261",
    x1: 408.982,
    y1: 375.398,
    x2: 475.555,
    y2: 248.827,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#00C7C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#34008C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint249_linear_2253_1261",
    x1: 475.225,
    y1: 370.47,
    x2: 508.967,
    y2: 306.312,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#00C7C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#34008C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint250_linear_2253_1261",
    x1: 482.376,
    y1: 333.347,
    x2: 514.204,
    y2: 272.81,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#00C7C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#34008C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint251_linear_2253_1261",
    x1: 467.885,
    y1: 332.897,
    x2: 470.183,
    y2: 411.821,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#00C7C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#34008C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint252_linear_2253_1261",
    x1: 495.45,
    y1: 373.324,
    x2: 437.596,
    y2: 426.218,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#00C7C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#34008C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint253_linear_2253_1261",
    x1: 460.085,
    y1: 404.819,
    x2: 407.985,
    y2: 364.956,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#00C7C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#34008C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint254_linear_2253_1261",
    x1: 441.883,
    y1: 353.111,
    x2: 429.63,
    y2: 406.751,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#00C7C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#34008C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint255_linear_2253_1261",
    x1: 462.042,
    y1: 392.057,
    x2: 431.417,
    y2: 333.806,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#00C7C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#34008C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint256_linear_2253_1261",
    x1: 493.497,
    y1: 360.126,
    x2: 527.372,
    y2: 390.585,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#00C7C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#34008C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint257_linear_2253_1261",
    x1: 494.165,
    y1: 359.373,
    x2: 528.041,
    y2: 389.832,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#00C7C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#34008C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint258_linear_2253_1261",
    x1: 494.812,
    y1: 358.659,
    x2: 528.674,
    y2: 389.119,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#00C7C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#34008C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint259_linear_2253_1261",
    x1: 495.368,
    y1: 358.038,
    x2: 529.231,
    y2: 388.498,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#00C7C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#34008C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint260_linear_2253_1261",
    x1: 496.294,
    y1: 357.008,
    x2: 530.17,
    y2: 387.467,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#00C7C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#34008C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint261_linear_2253_1261",
    x1: 485.097,
    y1: 369.466,
    x2: 518.959,
    y2: 399.926,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#00C7C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#34008C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint262_linear_2253_1261",
    x1: 486.02,
    y1: 368.436,
    x2: 519.896,
    y2: 398.882,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#00C7C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#34008C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint263_linear_2253_1261",
    x1: 486.589,
    y1: 367.801,
    x2: 520.452,
    y2: 398.261,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#00C7C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#34008C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint264_linear_2253_1261",
    x1: 487.223,
    y1: 367.101,
    x2: 521.099,
    y2: 397.548,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#00C7C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#34008C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint265_linear_2253_1261",
    x1: 488.085,
    y1: 366.15,
    x2: 521.947,
    y2: 396.609,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#00C7C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#34008C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint266_linear_2253_1261",
    x1: 476.957,
    y1: 378.516,
    x2: 510.833,
    y2: 408.975,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#00C7C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#34008C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint267_linear_2253_1261",
    x1: 477.811,
    y1: 377.564,
    x2: 511.674,
    y2: 408.024,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#00C7C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#34008C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint268_linear_2253_1261",
    x1: 478.367,
    y1: 376.944,
    x2: 512.242,
    y2: 407.403,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#00C7C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#34008C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint269_linear_2253_1261",
    x1: 479.178,
    y1: 376.058,
    x2: 513.041,
    y2: 406.518,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#00C7C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#34008C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint270_linear_2253_1261",
    x1: 479.863,
    y1: 375.292,
    x2: 513.725,
    y2: 405.738,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#00C7C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#34008C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint271_linear_2253_1261",
    x1: 468.892,
    y1: 387.486,
    x2: 502.767,
    y2: 417.933,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#00C7C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#34008C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint272_linear_2253_1261",
    x1: 469.589,
    y1: 386.707,
    x2: 503.451,
    y2: 417.166,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#00C7C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#34008C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint273_linear_2253_1261",
    x1: 470.144,
    y1: 386.086,
    x2: 504.02,
    y2: 416.545,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#00C7C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#34008C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint274_linear_2253_1261",
    x1: 470.812,
    y1: 385.359,
    x2: 504.674,
    y2: 415.818,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#00C7C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#34008C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint275_linear_2253_1261",
    x1: 471.64,
    y1: 384.421,
    x2: 505.516,
    y2: 414.881,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#00C7C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#34008C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint276_linear_2253_1261",
    x1: 460.538,
    y1: 396.787,
    x2: 494.401,
    y2: 427.246,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#00C7C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#34008C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint277_linear_2253_1261",
    x1: 461.366,
    y1: 395.849,
    x2: 495.229,
    y2: 426.308,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#00C7C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#34008C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint278_linear_2253_1261",
    x1: 462.059,
    y1: 395.096,
    x2: 495.921,
    y2: 425.555,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#00C7C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#34008C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint279_linear_2253_1261",
    x1: 299.036,
    y1: 309.712,
    x2: 357.715,
    y2: 209.764,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#00C7C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#34008C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint280_linear_2253_1261",
    x1: 325.052,
    y1: 287.966,
    x2: 355.904,
    y2: 235.409,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#00C7C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#34008C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint281_linear_2253_1261",
    x1: 320.731,
    y1: 466.978,
    x2: 394.071,
    y2: 270.431,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#00C7C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#34008C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint282_linear_2253_1261",
    x1: 341.129,
    y1: 408.809,
    x2: 383.017,
    y2: 317.685,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#00C7C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#34008C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint283_linear_2253_1261",
    x1: 428.691,
    y1: 525.635,
    x2: 217.647,
    y2: 448.475,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4F759"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#90ED6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#35D5A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#00C7C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#2D9BE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#5277F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#5A76F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#7273F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#9970F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BB6DF3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint284_radial_2253_1261",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(330.504 260.141) scale(87.9889 87.9334)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#B5BBE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#C7CCED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#E5E7F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint285_radial_2253_1261",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(398.336 459.132) scale(26.0456 15.5067)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#4D5A96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#6A75A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#979EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#BCC1D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#D9DCE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#EEEFF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#FAFBFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint286_linear_2253_1261",
    x1: 388.321,
    y1: 429.365,
    x2: 414.888,
    y2: 527.968,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4F759"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#90ED6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#35D5A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#00C7C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#2D9BE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#5277F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#5A76F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#7273F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#9970F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BB6DF3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint287_linear_2253_1261",
    x1: 358.632,
    y1: 418.501,
    x2: 384.297,
    y2: 404.662,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3B3ABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#564BD7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#6152E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#4528C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#4221A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#3F1B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#3F1982"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#5E239E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#491C8B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint288_linear_2253_1261",
    x1: 350.525,
    y1: 343.281,
    x2: 343.131,
    y2: 373.656,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3B3ABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#3E33BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#4528C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#462ACA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#5947DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6152E3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint289_linear_2253_1261",
    x1: 333.778,
    y1: 360.347,
    x2: 348.972,
    y2: 352.154,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9BFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#E5E9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#DFE3FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#B9C0EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDC3EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint290_linear_2253_1261",
    x1: 272.3,
    y1: 262.258,
    x2: 322.873,
    y2: 341.329,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#407EEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#55A9EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#61C2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3863F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint291_linear_2253_1261",
    x1: 299.523,
    y1: 253.789,
    x2: 321.868,
    y2: 298.692,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#FF9E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FFAD73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#FFC17A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#FFAB72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FF9E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#FFBE78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE585"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint292_linear_2253_1261",
    x1: 307.72,
    y1: 249.35,
    x2: 280.843,
    y2: 205.461,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#45108A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#7C1DC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#8620DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#781CC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#511398"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint293_linear_2253_1261",
    x1: 315.082,
    y1: 294.242,
    x2: 205.937,
    y2: 322.296,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#61C2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3863F5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint294_radial_2253_1261",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(306.242 262.257) scale(11.8843 11.8768)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint295_linear_2253_1261",
    x1: 263.778,
    y1: 279.709,
    x2: 295.332,
    y2: 233.359,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#FF9E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FFAD72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#FFD580"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE585"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint296_linear_2253_1261",
    x1: 278.004,
    y1: 245.704,
    x2: 294.593,
    y2: 219.378,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#45108A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C1DC9"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint297_radial_2253_1261",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(286.62 231.951) scale(19.0625 19.0505)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint298_linear_2253_1261",
    x1: 230.165,
    y1: 192.577,
    x2: 389.186,
    y2: 405.293,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#273B98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#2E2BA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#361CAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#440B88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E0070"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint299_linear_2253_1261",
    x1: 231.798,
    y1: 194.669,
    x2: 303.649,
    y2: 361.163,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9DA6EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#E5E9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#DFE3FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#B9C0EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDC3EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint300_linear_2253_1261",
    x1: 271.999,
    y1: 263.433,
    x2: 320.933,
    y2: 339.941,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#407EEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#55A9EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#61C2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3863F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint301_linear_2253_1261",
    x1: 298.349,
    y1: 255.229,
    x2: 319.968,
    y2: 298.678,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#FF9E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FFAD73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#FFC17A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#FFAB72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FF9E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#FFBE78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE585"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint302_linear_2253_1261",
    x1: 306.283,
    y1: 250.949,
    x2: 280.264,
    y2: 208.487,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#45108A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#7C1DC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#8620DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#781CC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#511398"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint303_linear_2253_1261",
    x1: 313.405,
    y1: 294.374,
    x2: 207.79,
    y2: 321.528,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#61C2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3863F5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint304_radial_2253_1261",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(304.837 263.433) scale(11.501 11.4937)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint305_linear_2253_1261",
    x1: 263.765,
    y1: 280.317,
    x2: 294.276,
    y2: 235.474,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#FF9E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FFAD72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#FFD580"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE585"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint306_linear_2253_1261",
    x1: 277.524,
    y1: 247.421,
    x2: 293.558,
    y2: 221.941,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#45108A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C1DC9"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint307_radial_2253_1261",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(285.872 234.118) scale(18.4412 18.4296)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint308_radial_2253_1261",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(275.418 245.825) scale(93.6865 93.6274)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#66CCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5277F7"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint309_radial_2253_1261",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(275.061 246.538) scale(93.6865 93.6274)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#F8F9FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#E7EAF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CED3F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint310_linear_2253_1261",
    x1: 269.805,
    y1: 171.761,
    x2: 357.02,
    y2: 338.795,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9DA6EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#E5E9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#DFE3FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#B9C0EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDC3EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint311_linear_2253_1261",
    x1: 224.874,
    y1: 290.225,
    x2: 316.104,
    y2: 260.771,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AFB6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#B5BCE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#C7CDF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#E5E9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#F4F4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7F6FB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint312_radial_2253_1261",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(316.773 214.605) scale(74.6637 74.6166)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint313_radial_2253_1261",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(272.291 230.881) scale(51.1198 51.0875)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint314_radial_2253_1261",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(353.084 314.559) scale(17.225 17.2141)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#273B98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#23358A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#182560"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#0F173D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#080D22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#03050F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#000103"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint315_radial_2253_1261",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(306.058 207.02) scale(17.225 17.2141)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#836DF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#6554BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#4A3E8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#332B60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#211B3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#120F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#08060F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#020103"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2253_1261"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 401,
    height: 470,
    fill: "white",
    transform: "translate(156 107)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrmMangement);
export default __webpack_public_path__ + "static/media/crm-mangement.adf520ed7596601b6c2ec8b91791cc66.svg";
export { ForwardRef as ReactComponent };